// IMPORT:
const config = require(/*! ../config.js */"../config.js");
const Terrain = require(/*! ../libs/Terrain.js */"../libs/Terrain.js");
const Zone = require(/*! ../libs/Zone.js */"../libs/Zone.js");
const WEAPONS = require(/*! ../data/weapons.js */"./weapons.js");

// MODES:
var modes = [{
  id: "ffa",
  name: "Free for All",
  alias: "ffa"
}, {
  id: "tdm",
  name: "Team Deathmatch",
  endStats: ["sid", "name", "score", "kills", "deaths", "assists", "reward"],
  alias: "tdm",
  teams: true
}, {
  id: "point",
  name: "Hardpoint",
  alias: "point",
  endStats: ["sid", "name", "score", "kills", "deaths", "assists", "reward"],
  objective: true,
  teams: true,
  gameStart: function (game) {
    game.activeObjective = -1;
    game.nextObjective();
  }
}, {
  id: "ctf",
  name: "Capture the Flag",
  alias: "ctf",
  endStats: ["sid", "name", "score", "kills", "deaths", "caps", "reward"],
  onKill: function (game, player, doer) {
    game.dropFlag(player.flag);
  },
  flags: true,
  teams: true,
  noScoreC: true
}, {
  id: "bhop",
  name: "Parkour",
  endStats: ["sid", "name", "score", "deaths"],
  alias: "bhop",
  noKick: true,
  friendly: true
}, {
  id: "hide",
  name: "Hide & Seek",
  alias: "hide",
  endStats: ["sid", "name", "score", "found", "reward"],
  winCondition: function (game) {
    var hideCount = 0;
    for (var i = 0; i < game.players.list.length; ++i) {
      if (game.players.list[i].active && game.players.list[i].team == "hide") {
        hideCount++;
      }
    }
    return hideCount > 0 ? "hide" : "seek";
  },
  condition: function (game) {
    var hideCount = 0;
    for (var i = 0; i < game.players.list.length; ++i) {
      if (game.players.list[i].active && game.players.list[i].team == "hide") {
        hideCount++;
      }
    }
    return hideCount > 0;
  },
  minPlayers: 2,
  waitTimers: [{
    time: 10000,
    msg: "picking seeker in ",
    trigger: function (game) {
      game.pickSeeker();
    }
  }, {
    time: 45000,
    msg: "releasing seeker in ",
    trigger: function (game) {
      game.releaseSeeker();
    }
  }],
  spdMlt: {
    "hide": 0.8
  },
  killConv: true,
  noKick: true,
  showTeam: true,
  startTeam: "hide",
  convTeam: "seek",
  convWord: "found",
  noWeap: true,
  friendly: true,
  hideNames: true
}, {
  id: "infect",
  name: "Infected",
  alias: "infect",
  endStats: ["sid", "name", "score", "kills", "infected", "reward"],
  winCondition: function (game) {
    var survivorCount = 0;
    for (var i = 0; i < game.players.list.length; ++i) {
      if (game.players.list[i].active && game.players.list[i].team == "surv") {
        survivorCount++;
      }
    }
    return survivorCount > 0 ? "surv" : "inf";
  },
  condition: function (game) {
    var survivorCount = 0;
    for (var i = 0; i < game.players.list.length; ++i) {
      if (game.players.list[i].active && game.players.list[i].team == "surv") {
        survivorCount++;
      }
    }
    return survivorCount > 0;
    return true;
  },
  minPlayers: 2,
  waitTimers: [{
    time: 20000,
    msg: "infection in ",
    trigger: function (game) {
      game.infectRandom();
    }
  }],
  teamClass: {
    "inf": 9
  },
  spdMlt: {
    "inf": 1.15
  },
  killConv: true,
  noKick: true,
  startTeam: "surv",
  convWord: "infected",
  convTeam: "inf"
}, {
  id: "race",
  name: "Race",
  alias: "race",
  endStats: ["sid", "name", "score", "time"],
  gameTime: 0,
  showMS: true,
  timed: true,
  endSort: function (a, b) {
    if (a.score === b.score && a.gameTimer && b.gameTimer) {
      return a.gameTimer - b.gameTimer;
    }
    return b.score - a.score;
  },
  gameStart: function (game) {
    game.lockMove = true;
    game.targetScore = 0;
    for (var i = 0; i < game.map.manager.objects.length; ++i) {
      if (game.map.manager.objects[i].score) {
        game.targetScore += game.map.manager.objects[i].scoreP;
      }
    }
  },
  condition: function (game) {
    for (var i = 0; i < game.players.list.length; ++i) {
      if (game.players.list[i].score >= game.targetScore && !game.players.list[i].timer) {
        game.players.list[i].timer = game.lastTimer;
        game.players.list[i].gameTimer = game.gameTimer;
        if (!game.waitTimers) {
          game.waitTimers = [{
            time: 10000,
            contTime: true,
            msg: "race ends in ",
            trigger: function (game) {
              game.gameTimer = "skip";
            }
          }];
        }
      }
    }
    return true;
  },
  waitTimers: [{
    time: 15000,
    msg: "race starting in ",
    trigger: function (game) {
      game.lockMove = false;
    }
  }],
  noWeap: true,
  friendly: true
}, {
  id: "lms",
  name: "Last Man Standing",
  alias: "lms",
  endStats: ["sid", "name", "score", "kills", "deaths", "assists"],
  noRegen: true,
  noKick: true,
  teams: true,
  lives: 1,
  winCondition: function (game) {
    var t1C = 0;
    var t2C = 0;
    for (var i = 0; i < game.players.list.length; ++i) {
      if (game.players.list[i].lives > 0) {
        var tmpV = game.players.list[i].lives;
        if (game.players.list[i].team == 1) {
          t1C += tmpV;
        } else {
          t2C += tmpV;
        }
      }
    }
    return t1C > t2C ? 1 : 2;
  },
  gameTime: 300000
}, {
  id: "simon",
  name: "Simon Says",
  alias: "simon",
  endStats: ["sid", "name", "score", "reward"],
  condition: function (game) {
    var folloCnt = 0;
    for (var i = 0; i < game.players.list.length; ++i) {
      if (game.players.list[i].active && game.players.list[i].team == "foll") {
        folloCnt++;
      }
    }
    return folloCnt > 0;
    return true;
  },
  minPlayers: 3,
  waitTimers: [{
    time: 10000,
    msg: "starts in ",
    trigger: function (game) {
      game.pickSimon();
    }
  }],
  noKick: true,
  startTeam: "foll"
}, {
  id: "gun",
  name: "Gun Game",
  alias: "gun",
  endStats: ["sid", "name", "weapon", "kills", "deaths", "melees", "setbacks"],
  winCondition: function (game) {
    for (var i = 0; i < game.players.list.length; ++i) {
      if (game.players.list[i].killList.length >= game.mode.weaponOrder.length) {
        return game.players.list[i];
      }
    }
    return null;
  },
  condition: function (game) {
    for (var i = 0; i < game.players.list.length; ++i) {
      if (game.players.list[i].killList.length >= game.mode.weaponOrder.length) {
        return false;
      }
    }
    return true;
  },
  onKill: function (game, player, doer) {
    if (doer && doer != player) {
      if (game.weapons[doer.loadout[doer.weaponIndex]].melee) {
        game.decreaseWeapon(player);
      } else {
        game.increaseWeapon(doer);
      }
    } else {
      game.decreaseWeapon(player);
    }
  },
  killRes: function (doer) {
    return [doer ? doer.killList.length ? doer.killList[doer.killList.length - 1] : doer.loadout[doer.weaponIndex] : -1, doer ? 1 : -1];
  },
  startingLoadout: [2],
  keepLoadout: true,
  noKillRewards: true,
  noReward: true,
  noAssists: true,
  noStreaks: true,
  minPlayers: 2,
  noWeap: true,
  weaponOrder: [2, 10, 4, 11, 5, 3, 9, 1, 6, 0, 7, 8, 13]
}];
var rotationModes = [0, 1, 2, 3];
module.exports.modes = modes;

// MAP DATA:
// javascript-obfuscator:disable
var maps = [{
  "name": "Burg",
  "ambInd": 1,
  "modURL": "",
  "terrainSeed": "",
  "terrainWidth": 2048,
  "terrainHeight": 2048,
  "terrainMntMlt": 1,
  "terrainMntCol": "#a0a0a0",
  "terrainGrsCol": "#4a6904",
  "terrainDrtCol": "#8c6835",
  "skyDome": false,
  "skyDomeCol0": "#ffffff",
  "skyDomeCol1": "#7196a2",
  "skyDomeCol2": "#184452",
  "zone": false,
  "zoneSize": 500,
  "zoneSpeed": 1,
  "zoneCol0": "#c542d9",
  "zoneCol1": "#c542d9",
  "zoneCol2": "#c542d9",
  "sizeMlt": 2,
  "shadowR": 1024,
  "ambient": 8220268,
  "light": 16771304,
  "sky": 14141126,
  "fog": 13812161,
  "fogD": 918.7540927106669,
  "dthY": -100,
  "camPos": [11, 33, -217],
  "spawns": [[-80, 18, 35, 0], [177, 0, -188, 0], [215, 10, -504, 0, 1], [-169, 2, -514, 0, 2], [-328, 0, -255, 0], [-154, 0, -134, 0, 1], [-125, -28, -341, 0], [32, -28, -509, 0, 1], [331, 0, -227, 0, 2], [102, 0, -365, 0]],
  "ambO": 0.7,
  "ambS": 5,
  "modes": [0, 1],
  "shadScale": 170,
  "objects": [{
    "p": [-96, 16, 41],
    "s": [288, 2, 62],
    "t": 1
  }, {
    "p": [73, 0, 33],
    "s": [50, 18, 46],
    "i": 9,
    "t": 1,
    "d": 2
  }, {
    "p": [28, 0, 8],
    "s": [152, 24, 4]
  }, {
    "p": [0, -2, -71],
    "s": [516, 2, 252],
    "t": 1
  }, {
    "p": [-76, 0, -48],
    "s": [56, 74, 122],
    "bo": 1
  }, {
    "p": [37, 0, -68],
    "s": [110, 54, 80],
    "bo": 1
  }, {
    "p": [-112, 0, 74],
    "s": [126, 76, 38],
    "bo": 1
  }, {
    "p": [90, 0, 77],
    "s": [158, 76, 44],
    "bo": 1
  }, {
    "p": [-136, 16, -16],
    "s": [64, 2, 52],
    "t": 1
  }, {
    "p": [-136, 0, -44],
    "s": [64, 24, 4]
  }, {
    "p": [-170, 0, -18],
    "s": [4, 24, 56]
  }, {
    "p": [-234, 0, -27],
    "s": [32, 60, 97],
    "bo": 1
  }, {
    "p": [-258, 18, 41],
    "s": [47, 32, 44],
    "c": 13619151,
    "bo": 1
  }, {
    "p": [-218, 13, 74],
    "s": [88, 38, 54],
    "bo": 1
  }, {
    "p": [185, 0, -9],
    "s": [16, 67, 84],
    "bo": 1
  }, {
    "p": [180, 0, 45],
    "s": [60, 92, 44],
    "c": 11842740,
    "bo": 1
  }, {
    "p": [213, 0, -61],
    "s": [94, 92, 60],
    "c": 11645361,
    "bo": 1
  }, {
    "p": [96, 0, -175],
    "s": [110, 44, 44],
    "bo": 1
  }, {
    "p": [-85, 0, -140],
    "s": [56, 84, 112],
    "bo": 1
  }, {
    "p": [126, -4, -300],
    "s": [228, 4, 206],
    "t": 1
  }, {
    "p": [-82, -28, -252],
    "s": [60, 94, 138],
    "bo": 1
  }, {
    "p": [9, -28, -274],
    "s": [6, 34, 168]
  }, {
    "p": [49, -28, -385],
    "s": [96, 104, 68],
    "bo": 1
  }, {
    "p": [-23, -28, -252],
    "s": [58, 28, 110],
    "i": 9,
    "t": 1,
    "d": 1
  }, {
    "p": [59, -32, -452],
    "s": [218, 4, 138],
    "t": 1
  }, {
    "p": [-108, -28, -377],
    "s": [130, 88, 42],
    "bo": 1
  }, {
    "p": [-21, 6, -377],
    "s": [44, 38, 20],
    "bo": 1
  }, {
    "p": [-243, 0, -105],
    "s": [21, 50, 96],
    "c": 12302777,
    "bo": 1
  }, {
    "p": [190, 0, -346],
    "s": [117, 58, 118],
    "bo": 1
  }, {
    "p": [-195, 0, -17],
    "s": [46, 18, 54],
    "i": 9,
    "t": 1,
    "d": 1
  }, {
    "p": [-134, 0, -191],
    "s": [90, 77, 76],
    "bo": 1
  }, {
    "p": [-278, 0, -191],
    "s": [130, 77, 76],
    "bo": 1
  }, {
    "p": [-227, -2, -254],
    "s": [232, 2, 50],
    "t": 1
  }, {
    "p": [-210, -28, -323],
    "s": [132, 90, 66],
    "bo": 1
  }, {
    "p": [-128, -28, -300],
    "s": [32, 28, 42],
    "i": 9,
    "t": 1,
    "d": 1
  }, {
    "p": [-233, -2, -419],
    "s": [172, 2, 280],
    "t": 1
  }, {
    "p": [-326, -22, -321],
    "s": [34, 84, 88],
    "bo": 1
  }, {
    "p": [-370, -2, -253],
    "s": [55, 155, 58],
    "bo": 1
  }, {
    "p": [-158, -28, -274],
    "s": [28, 90, 32],
    "bo": 1
  }, {
    "p": [-263, -20, -322],
    "s": [30, 94, 94],
    "bo": 1
  }, {
    "p": [-330, -23, -394],
    "s": [22, 81, 210],
    "bo": 1
  }, {
    "p": [-88, -28, -429],
    "s": [78, 28, 62],
    "i": 9,
    "t": 1,
    "d": 2
  }, {
    "p": [-103, -22, -497],
    "s": [49, 84, 86],
    "bo": 1
  }, {
    "p": [-137, -2, -463],
    "s": [20, 2, 130],
    "t": 1
  }, {
    "p": [-164, 0, -547],
    "s": [98, 86, 40],
    "bo": 1
  }, {
    "p": [-283, 0, -506],
    "s": [72, 10, 86],
    "t": 1
  }, {
    "p": [-261, 0, -452],
    "s": [28, 10, 22],
    "t": 1
  }, {
    "p": [-298, 0, -450],
    "s": [42, 10, 26],
    "i": 9,
    "t": 1,
    "d": 3
  }, {
    "p": [-347, 0, -535],
    "s": [72, 72, 76],
    "bo": 1
  }, {
    "p": [-262, 0, -567],
    "s": [98, 52, 40],
    "bo": 1
  }, {
    "p": [-319, 0, -587],
    "s": [48, 139, 54],
    "c": 11645361
  }, {
    "p": [-1, -28, -377],
    "s": [4, 34, 20],
    "bo": 1
  }, {
    "p": [-41, -28, -377],
    "s": [4, 34, 20],
    "bo": 1
  }, {
    "p": [-63, -28, -506],
    "s": [52, 118, 92],
    "bo": 1
  }, {
    "p": [85, -28, -498],
    "s": [32, 112, 88],
    "bo": 1
  }, {
    "p": [173, 8, -503],
    "s": [148, 2, 84],
    "t": 1
  }, {
    "p": [39, -29, -544],
    "s": [218, 94, 46],
    "bo": 1
  }, {
    "p": [182, 10, -540],
    "s": [72, 87, 60],
    "bo": 1
  }, {
    "p": [292, -4, -329],
    "s": [104, 4, 264],
    "t": 1
  }, {
    "p": [280, 0, -485],
    "s": [58, 10, 48],
    "i": 9,
    "t": 1,
    "d": 3
  }, {
    "p": [278, 8, -527],
    "s": [62, 2, 36],
    "t": 1
  }, {
    "p": [264, 9, -558],
    "s": [94, 36, 26],
    "bo": 1
  }, {
    "p": [331, -23, -552],
    "s": [54, 135, 110],
    "c": "#aaaaaa",
    "bo": 1
  }, {
    "p": [332, 0, -499],
    "s": [48, 55, 110],
    "bo": 1
  }, {
    "p": [342, 1, -411],
    "s": [20, 31, 110],
    "bo": 1
  }, {
    "p": [336, 0, -303],
    "s": [54, 61, 110],
    "bo": 1
  }, {
    "p": [127, -28, -425],
    "s": [64, 35, 4]
  }, {
    "p": [196, -28, -461],
    "s": [110, 44, 4]
  }, {
    "p": [249, 0, -486],
    "s": [4, 16, 46]
  }, {
    "p": [204, -28, -440],
    "s": [72, 28, 38],
    "i": 9,
    "t": 1
  }, {
    "p": [156, 0, -188],
    "s": [32, 70, 82],
    "bo": 1
  }, {
    "p": [228, 0, -188],
    "s": [32, 86, 82],
    "bo": 1
  }, {
    "p": [367, 0, -146],
    "s": [58, 50, 118],
    "c": "#a2a2a2",
    "bo": 1
  }, {
    "p": [335, 81, -62],
    "s": [60, 58, 60]
  }, {
    "p": [348, 0, -227],
    "s": [8, 44, 52],
    "bo": 1
  }, {
    "p": [393, 0, -420],
    "s": [88, 64, 197]
  }, {
    "p": [396, 0, -196],
    "s": [58, 81, 186]
  }, {
    "p": [-356, 0, -369],
    "s": [42, 98, 50]
  }, {
    "p": [-264, 0, -84],
    "s": [42, 124, 50],
    "c": 11316396
  }, {
    "p": [1, 0, 0],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-42, 0, -79],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-42, 12, -79],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-42, 0, -67],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [0, -28, -325],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [0, -28, -337],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [0, -16, -333],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-76, -28, -327],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-76, -16, -327],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [237, 10, -473],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [224, 10, -520],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [155, 10, -504],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [167, 10, -504],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [163, 22, -504],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [214, 10, -466],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [312, 0, -399],
    "s": [2, 2, 92]
  }, {
    "p": [318, 0, -242],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [227, 0, -281],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [215, 0, -281],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [224, 12, -281],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-59, 18, 19],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-110, 18, -36],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-110, 0, -52],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-122, 0, -52],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-165, 18, -39],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [-215, 18, 13],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [-154, 0, -252],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-313, 0, -235],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-133, 0, -469],
    "s": [12, 12, 12],
    "i": 8
  }, {
    "p": [-190, 0, -485],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [206, 0, -207],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [206, 0, -195],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [98, 0, -61],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [98, 0, -73],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [95, 0, -52],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [133, 0, -150],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [192, 34, -188],
    "s": [40, 24, 82],
    "bo": 1
  }, {
    "p": [128, -4, -415],
    "s": [68, 12, 20],
    "t": 1
  }, {
    "p": [93, -28, -422],
    "s": [4, 42, 10]
  }, {
    "p": [337, -4, -150],
    "s": [22, 4, 94],
    "t": 1
  }, {
    "p": [-11, -28, -384],
    "s": [20, 34, 2],
    "pe": 1,
    "t": 2,
    "bo": 1
  }, {
    "p": [-32, -28, -370],
    "s": [18, 34, 2],
    "pe": 1,
    "t": 2,
    "bo": 1
  }, {
    "p": [173, 0, -233],
    "s": [2, 34, 24],
    "pe": 1,
    "t": 2
  }, {
    "p": [202, 0, -226],
    "s": [20, 34, 2],
    "pe": 1,
    "t": 2,
    "bo": 1
  }, {
    "p": [182, 0, -150],
    "s": [20, 34, 2],
    "pe": 1,
    "t": 2,
    "bo": 1
  }, {
    "p": [211, 0, -162],
    "s": [2, 34, 24],
    "t": 2,
    "bo": 1
  }, {
    "p": [20, -28, -438],
    "s": [28, 76, 40],
    "bo": 1
  }, {
    "p": [114, 0, -388],
    "s": [36, 8, 34],
    "i": 9,
    "t": 1,
    "d": 3
  }, {
    "p": [-337, 139, -563],
    "s": [12, 4, 6],
    "l": 1,
    "c": 11184810
  }, {
    "p": [-299, 139, -566],
    "s": [8, 4, 12],
    "l": 1,
    "c": 11644847
  }, {
    "p": [-297, 139, -586],
    "s": [4, 4, 12],
    "l": 1,
    "c": 11842740
  }, {
    "p": [-300, 139, -608],
    "s": [10, 4, 12],
    "l": 1,
    "c": 10855845
  }, {
    "p": [-316, 139, -563],
    "s": [12, 2, 6],
    "l": 1,
    "c": 11184810
  }, {
    "p": [-206, 86, -535],
    "s": [14, 4, 16],
    "l": 1
  }, {
    "p": [-126, 86, -535],
    "s": [22, 4, 16],
    "l": 1
  }, {
    "p": [-165, 86, -530],
    "s": [22, 4, 6],
    "l": 1
  }, {
    "p": [-209, 86, -560],
    "s": [8, 4, 14],
    "l": 1
  }, {
    "p": [-230, 52, -550],
    "s": [24, 2, 6],
    "l": 1
  }, {
    "p": [-264, 52, -550],
    "s": [18, 2, 6],
    "l": 1
  }, {
    "p": [-295, 52, -550],
    "s": [14, 4, 6],
    "l": 1
  }, {
    "p": [-316, 70, -502],
    "s": [6, 12, 6],
    "l": 1,
    "t": 2
  }, {
    "p": [-378, 73, -502],
    "s": [6, 8, 6],
    "l": 1,
    "t": 2
  }, {
    "p": [-318, 72, -504],
    "s": [14, 4, 14],
    "l": 1
  }, {
    "p": [-378, 72, -504],
    "s": [10, 2, 14],
    "l": 1
  }, {
    "p": [-358, 72, -499],
    "s": [14, 2, 4],
    "l": 1
  }, {
    "p": [-314, 72, -536],
    "s": [6, 4, 16],
    "l": 1
  }, {
    "p": [-321, 58, -480],
    "s": [4, 2, 24],
    "l": 1
  }, {
    "p": [-321, 58, -384],
    "s": [4, 4, 16],
    "l": 1
  }, {
    "p": [-321, 58, -413],
    "s": [4, 3, 21],
    "l": 1
  }, {
    "p": [-321, 58, -446],
    "s": [4, 3, 19],
    "l": 1
  }, {
    "p": [-53, 60, -392],
    "s": [20, 6, 12],
    "l": 1
  }, {
    "p": [-166, 60, -364],
    "s": [14, 4, 16],
    "l": 1
  }, {
    "p": [233, 45, -548],
    "s": [12, 2, 6],
    "l": 1
  }, {
    "p": [262, 45, -548],
    "s": [11, 2, 6],
    "l": 1,
    "c": 13290186
  }, {
    "p": [288, 45, -548],
    "s": [16, 2, 6],
    "l": 1
  }, {
    "p": [-82, 90, -466],
    "s": [14, 4, 12],
    "l": 1
  }, {
    "p": [-43, 90, -467],
    "s": [12, 4, 14],
    "l": 1
  }, {
    "p": [-44, 90, -519],
    "s": [14, 6, 30],
    "l": 1
  }, {
    "p": [-60, 90, -463],
    "s": [14, 2, 6],
    "l": 1
  }, {
    "p": [-39, 90, -490],
    "s": [4, 2, 16],
    "l": 1
  }, {
    "p": [-84, 90, -524],
    "s": [10, 3, 26],
    "l": 1
  }, {
    "p": [-87, 90, -492],
    "s": [4, 2, 10],
    "l": 1
  }, {
    "p": [-63, 71, -450],
    "s": [4, 4, 20],
    "t": 2,
    "bo": 1
  }, {
    "p": [-122, 55, -459],
    "s": [6, 16, 6],
    "t": 2
  }, {
    "p": [-124, 62, -507],
    "s": [6, 3, 16],
    "l": 1,
    "c": 14474460
  }, {
    "p": [-124, 62, -476],
    "s": [6, 2, 14],
    "l": 1,
    "c": 14935011
  }, {
    "p": [-88, 62, -457],
    "s": [18, 3, 6],
    "l": 1
  }, {
    "p": [-116, 60, -396],
    "s": [26, 4, 4],
    "l": 1
  }, {
    "p": [-164, 60, -392],
    "s": [18, 6, 12],
    "l": 1
  }, {
    "p": [-82, 60, -396],
    "s": [14, 3, 4],
    "l": 1
  }, {
    "p": [85, 66, -447],
    "s": [4, 4, 16],
    "t": 2,
    "bo": 1
  }, {
    "p": [-31, 44, -377],
    "s": [9, 4, 20],
    "bo": 1
  }, {
    "p": [-14, 44, -377],
    "s": [10, 2, 20],
    "bo": 1
  }, {
    "p": [-341, 98, -387],
    "s": [12, 4, 14],
    "l": 1
  }, {
    "p": [-341, 98, -350],
    "s": [12, 6, 12],
    "l": 1
  }, {
    "p": [-338, 98, -369],
    "s": [6, 2, 12],
    "l": 1
  }, {
    "p": [-371, 98, -389],
    "s": [12, 4, 10],
    "l": 1
  }, {
    "p": [-356, 98, -392],
    "s": [8, 2, 4],
    "l": 1
  }, {
    "p": [53, 65, -523],
    "s": [18, 4, 4],
    "l": 1
  }, {
    "p": [135, 65, -523],
    "s": [12, 4, 4],
    "l": 1
  }, {
    "p": [114, 65, -523],
    "s": [12, 4, 4],
    "l": 1
  }, {
    "p": [211, 97, -517],
    "s": [14, 6, 14],
    "l": 1
  }, {
    "p": [153, 97, -518],
    "s": [14, 4, 16],
    "l": 1
  }, {
    "p": [184, 97, -514],
    "s": [12, 2, 8],
    "l": 1
  }, {
    "p": [215, 97, -539],
    "s": [6, 2, 18],
    "l": 1
  }, {
    "p": [211, 97, -564],
    "s": [14, 6, 12],
    "l": 1
  }, {
    "p": [153, 97, -562],
    "s": [14, 6, 16],
    "l": 1
  }, {
    "p": [149, 97, -539],
    "s": [6, 2, 12],
    "l": 1
  }, {
    "p": [148, 16, -461],
    "s": [14, 1, 4]
  }, {
    "p": [242, 16, -461],
    "s": [18, 2, 4]
  }, {
    "p": [249, 16, -497],
    "s": [4, 2, 10]
  }, {
    "p": [96, 84, -459],
    "s": [6, 12, 6],
    "l": 1,
    "t": 2
  }, {
    "p": [74, 84, -459],
    "s": [6, 10, 6],
    "l": 1,
    "t": 2
  }, {
    "p": [97, 84, -537],
    "s": [6, 20, 6],
    "l": 1,
    "t": 2
  }, {
    "p": [94, 84, -463],
    "s": [14, 4, 18],
    "l": 1
  }, {
    "p": [74, 84, -463],
    "s": [10, 4, 18],
    "l": 1
  }, {
    "p": [76, 84, -533],
    "s": [14, 4, 18],
    "l": 1
  }, {
    "p": [96, 84, -533],
    "s": [10, 4, 18],
    "l": 1
  }, {
    "p": [98, 84, -498],
    "s": [6, 4, 20],
    "l": 1
  }, {
    "p": [72, 84, -498],
    "s": [6, 4, 26],
    "l": 1
  }, {
    "p": [91, 76, -414],
    "s": [6, 16, 6],
    "l": 1,
    "t": 2
  }, {
    "p": [85, 76, -410],
    "s": [24, 6, 18],
    "l": 1
  }, {
    "p": [13, 76, -410],
    "s": [24, 6, 18],
    "l": 1
  }, {
    "p": [48, 76, -416],
    "s": [20, 4, 6],
    "l": 1
  }, {
    "p": [12, 76, -358],
    "s": [22, 6, 14],
    "l": 1
  }, {
    "p": [5, 76, -382],
    "s": [8, 4, 14],
    "l": 1
  }, {
    "p": [53, 76, -354],
    "s": [22, 4, 6],
    "l": 1
  }, {
    "p": [85, 76, -360],
    "s": [24, 6, 18],
    "l": 1
  }, {
    "p": [93, 76, -387],
    "s": [8, 4, 14],
    "l": 1
  }, {
    "p": [6, 76, -414],
    "s": [6, 20, 6],
    "l": 1,
    "t": 2
  }, {
    "p": [6, 76, -356],
    "s": [6, 14, 6],
    "l": 1,
    "t": 2
  }, {
    "p": [334, 32, -432],
    "s": [4, 2, 18],
    "l": 1
  }, {
    "p": [334, 32, -376],
    "s": [4, 3, 18],
    "l": 1
  }, {
    "p": [334, 32, -406],
    "s": [4, 2, 22],
    "l": 1
  }, {
    "p": [147, 58, -402],
    "s": [31, 9, 6],
    "l": 1
  }, {
    "p": [136, 58, -378],
    "s": [9, 12, 42],
    "l": 1
  }, {
    "p": [198, 58, -418],
    "s": [10, 4, 6],
    "l": 1
  }, {
    "p": [245, 58, -375],
    "s": [7, 4, 20],
    "l": 1
  }, {
    "p": [234, 58, -413],
    "s": [29, 5, 16],
    "l": 1
  }, {
    "p": [236, 58, -299],
    "s": [25, 4, 24],
    "l": 1
  }, {
    "p": [245, 58, -341],
    "s": [7, 4, 20],
    "l": 1
  }, {
    "p": [243, 58, -416],
    "s": [6, 19, 6],
    "t": 2
  }, {
    "p": [314, 61, -349],
    "s": [10, 4, 18],
    "l": 1
  }, {
    "p": [333, 61, -356],
    "s": [11, 3, 4],
    "l": 1
  }, {
    "p": [354, 61, -349],
    "s": [18, 4, 18],
    "l": 1
  }, {
    "p": [312, 61, -306],
    "s": [6, 4, 28],
    "l": 1
  }, {
    "p": [316, 61, -259],
    "s": [14, 4, 22],
    "l": 1
  }, {
    "p": [334, 61, -250],
    "s": [11, 3, 4],
    "l": 1
  }, {
    "p": [356, 61, -257],
    "s": [14, 3, 18],
    "l": 1
  }, {
    "p": [285, 58, -88],
    "s": [2, 40, 2],
    "l": 1,
    "t": 2
  }, {
    "p": [285, 58, -40],
    "s": [2, 40, 2],
    "l": 1,
    "t": 2
  }, {
    "p": [294, 93, -64],
    "s": [22, 2, 53],
    "t": 2
  }, {
    "p": [193, 58, -290],
    "s": [24, 4, 6],
    "l": 1
  }, {
    "p": [136, 58, -332],
    "s": [9, 6, 24],
    "l": 1
  }, {
    "p": [348, 44, -236],
    "s": [8, 4, 16],
    "l": 1,
    "c": 15132390
  }, {
    "p": [348, 44, -216],
    "s": [8, 2, 8],
    "l": 1
  }, {
    "p": [352, 64, -379],
    "s": [6, 4, 20],
    "l": 1
  }, {
    "p": [352, 64, -415],
    "s": [6, 3, 14],
    "l": 1
  }, {
    "p": [310, 55, -490],
    "s": [4, 4, 14],
    "l": 1
  }, {
    "p": [315, 55, -451],
    "s": [14, 4, 14],
    "l": 1
  }, {
    "p": [310, 55, -473],
    "s": [4, 2, 10],
    "l": 1
  }, {
    "p": [342, 55, -446],
    "s": [14, 4, 4],
    "l": 1
  }, {
    "p": [307, 112, -576],
    "s": [6, 4, 22],
    "l": 1,
    "c": "#b1b1b1"
  }, {
    "p": [335, 139, -89],
    "s": [12, 4, 6],
    "l": 1
  }, {
    "p": [313, 139, -84],
    "s": [16, 6, 16],
    "l": 1
  }, {
    "p": [357, 139, -84],
    "s": [16, 6, 16],
    "l": 1
  }, {
    "p": [313, 139, -40],
    "s": [16, 6, 16],
    "l": 1
  }, {
    "p": [308, 139, -62],
    "s": [6, 4, 12],
    "l": 1
  }, {
    "p": [228, 48, -102],
    "s": [10, 2, 14],
    "l": 1
  }, {
    "p": [-293, 40, -321],
    "s": [32, 22, 88],
    "bo": 1
  }, {
    "p": [-192, 62, -323],
    "s": [20, 4, 66],
    "l": 1
  }, {
    "p": [-328, 62, -361],
    "s": [20, 4, 8],
    "l": 1
  }, {
    "p": [-296, 62, -361],
    "s": [20, 4, 8],
    "l": 1
  }, {
    "p": [-253, 73, -364],
    "s": [6, 10, 6],
    "l": 1,
    "t": 2
  }, {
    "p": [-274, 73, -364],
    "s": [6, 14, 6],
    "l": 1,
    "t": 2
  }, {
    "p": [-274, 74, -322],
    "s": [8, 4, 94],
    "l": 1
  }, {
    "p": [-252, 74, -283],
    "s": [8, 4, 16],
    "l": 1
  }, {
    "p": [9, 6, -313],
    "s": [6, 2, 18]
  }, {
    "p": [9, 6, -199],
    "s": [6, 2, 18]
  }, {
    "p": [9, 6, -252],
    "s": [6, 2, 10]
  }, {
    "p": [164, 0, -61],
    "s": [4, 62, 4],
    "t": 2,
    "bo": 1
  }, {
    "p": [154, 54, -61],
    "s": [16, 4, 4],
    "t": 2,
    "bo": 1
  }, {
    "p": [158, 51, -61],
    "s": [16, 2, 2],
    "l": 1,
    "r": [0, 0, -0.7],
    "t": 2
  }, {
    "p": [-263, 0, -273],
    "s": [4, 54, 4],
    "t": 2,
    "bo": 1
  }, {
    "p": [-263, 47, -263],
    "s": [4, 4, 16],
    "t": 2,
    "bo": 1
  }, {
    "p": [-263, 43, -268],
    "s": [2, 2, 16],
    "l": 1,
    "r": [-0.7, 0, 0],
    "t": 2
  }, {
    "p": [238, 86, -224],
    "s": [12, 4, 10],
    "l": 1
  }, {
    "p": [240, 86, -152],
    "s": [8, 4, 10],
    "l": 1
  }, {
    "p": [217, 86, -222],
    "s": [10, 4, 14],
    "l": 1
  }, {
    "p": [242, 86, -189],
    "s": [4, 4, 28],
    "l": 1
  }, {
    "p": [251, 92, -82],
    "s": [18, 6, 18],
    "l": 1,
    "c": 11184810
  }, {
    "p": [176, 92, -84],
    "s": [20, 4, 14],
    "l": 1,
    "c": 11645361
  }, {
    "p": [173, 92, -38],
    "s": [14, 4, 14],
    "l": 1,
    "c": 12303291
  }, {
    "p": [207, 92, -88],
    "s": [20, 4, 6],
    "l": 1,
    "c": 12171705
  }, {
    "p": [168, 92, -61],
    "s": [4, 2, 12],
    "l": 1,
    "c": 10987431
  }, {
    "p": [254, 92, -41],
    "s": [12, 4, 20],
    "l": 1,
    "c": 11974326
  }, {
    "p": [214, 92, -34],
    "s": [24, 4, 6],
    "l": 1,
    "c": 11513775
  }, {
    "p": [145, 70, -158],
    "s": [10, 4, 22],
    "l": 1
  }, {
    "p": [168, 70, -154],
    "s": [8, 4, 14],
    "l": 1
  }, {
    "p": [145, 70, -218],
    "s": [10, 4, 22],
    "l": 1
  }, {
    "p": [168, 70, -222],
    "s": [8, 4, 14],
    "l": 1
  }, {
    "p": [214, 86, -184],
    "s": [4, 2, 24],
    "l": 1
  }, {
    "p": [216, 86, -152],
    "s": [8, 4, 10],
    "l": 1
  }, {
    "p": [179, 67, 0],
    "s": [4, 2, 10],
    "l": 1
  }, {
    "p": [179, 67, 17],
    "s": [4, 6, 15],
    "l": 1
  }, {
    "p": [136, 44, -157],
    "s": [4, 38, 4],
    "t": 2
  }, {
    "p": [45, 44, -157],
    "s": [4, 38, 4],
    "t": 2
  }, {
    "p": [45, 44, -193],
    "s": [4, 38, 4],
    "t": 2
  }, {
    "p": [136, 44, -193],
    "s": [4, 42, 4],
    "t": 2
  }, {
    "p": [91, 58, -175],
    "s": [100, 2, 44],
    "t": 2,
    "bo": 1
  }, {
    "p": [127, 44, -155],
    "s": [26, 4, 4],
    "l": 1
  }, {
    "p": [48, 44, -159],
    "s": [14, 4, 12],
    "l": 1
  }, {
    "p": [46, 44, -191],
    "s": [10, 4, 12],
    "l": 1
  }, {
    "p": [90, 44, -155],
    "s": [18, 2, 4],
    "l": 1
  }, {
    "p": [195, 58, -226],
    "s": [18, 4, 6],
    "l": 1
  }, {
    "p": [186, 58, -150],
    "s": [18, 4, 6],
    "l": 1
  }, {
    "p": [-3, 54, -100],
    "s": [30, 6, 16],
    "l": 1
  }, {
    "p": [77, 54, -98],
    "s": [30, 6, 20],
    "l": 1
  }, {
    "p": [79, 54, -35],
    "s": [26, 6, 14],
    "l": 1
  }, {
    "p": [-5, 54, -35],
    "s": [26, 6, 14],
    "l": 1
  }, {
    "p": [89, 54, -66],
    "s": [6, 4, 20],
    "l": 1
  }, {
    "p": [37, 54, -105],
    "s": [30, 4, 6],
    "l": 1
  }, {
    "p": [-15, 54, -66],
    "s": [6, 4, 20],
    "l": 1
  }, {
    "p": [38, 54, -31],
    "s": [18, 4, 6],
    "l": 1
  }, {
    "p": [-53, 60, -364],
    "s": [20, 4, 16],
    "l": 1
  }, {
    "p": [-237, 50, 35],
    "s": [5, 2, 10],
    "l": 1,
    "c": 13158600
  }, {
    "p": [164, 92, 31],
    "s": [28, 6, 16],
    "l": 1,
    "c": 11842740
  }, {
    "p": [205, 92, 31],
    "s": [10, 4, 16],
    "l": 1,
    "c": 13816530
  }, {
    "p": [156, 92, 60],
    "s": [12, 6, 14],
    "l": 1,
    "c": 13158600
  }, {
    "p": [-260, 47, 19],
    "s": [4, 54, 158]
  }, {
    "p": [-197, 47, 97],
    "s": [158, 54, 4]
  }, {
    "p": [-178, 13, 51],
    "s": [4, 74, 4],
    "t": 2
  }, {
    "p": [-254, 13, 51],
    "s": [4, 74, 4],
    "t": 2
  }, {
    "p": [-216, 80, 72],
    "s": [84, 2, 50],
    "t": 2
  }, {
    "p": [-55, 74, 2],
    "s": [14, 6, 22],
    "l": 1
  }, {
    "p": [-97, 74, 1],
    "s": [14, 6, 24],
    "l": 1
  }, {
    "p": [-102, 74, -42],
    "s": [4, 4, 24],
    "l": 1
  }, {
    "p": [-102, 74, -75],
    "s": [4, 4, 14],
    "l": 1
  }, {
    "p": [-77, 74, 11],
    "s": [14, 4, 4],
    "l": 1
  }, {
    "p": [-50, 74, -45],
    "s": [4, 4, 24],
    "l": 1
  }, {
    "p": [-54, 74, -97],
    "s": [12, 4, 24],
    "l": 1
  }, {
    "p": [-236, 50, -131],
    "s": [7, 4, 24],
    "l": 1,
    "c": 13158086
  }, {
    "p": [-236, 50, -96],
    "s": [7, 4, 22],
    "l": 1,
    "c": 11974326
  }, {
    "p": [-221, 60, 14],
    "s": [6, 2, 15],
    "l": 1
  }, {
    "p": [-244, 60, 13],
    "s": [12, 2, 17],
    "l": 1
  }, {
    "p": [-224, 60, -61],
    "s": [12, 2, 29],
    "l": 1
  }, {
    "p": [-220, 60, -17],
    "s": [4, 2, 8],
    "l": 1
  }, {
    "p": [-251, 124, -64],
    "s": [16, 4, 10],
    "l": 1,
    "c": 12171191
  }, {
    "p": [-279, 124, -66],
    "s": [12, 4, 14],
    "l": 1,
    "c": 12829635
  }, {
    "p": [-278, 124, -105],
    "s": [14, 3, 8],
    "l": 1
  }, {
    "p": [-109, 60, -359],
    "s": [34, 4, 6],
    "l": 1
  }, {
    "p": [-130, 77, -156],
    "s": [14, 3, 6],
    "l": 1
  }, {
    "p": [357, 139, -40],
    "s": [16, 6, 16],
    "l": 1
  }, {
    "p": [-296, 62, -281],
    "s": [20, 4, 8],
    "l": 1
  }, {
    "p": [-323, 62, -281],
    "s": [14, 4, 8],
    "l": 1
  }, {
    "p": [9, 0, -180],
    "s": [4, 54, 4],
    "t": 2,
    "bo": 1
  }, {
    "p": [9, 44, -175],
    "s": [2, 2, 12],
    "l": 1,
    "r": [-0.7, 0, 0],
    "t": 2
  }, {
    "p": [-106, 84, -96],
    "s": [14, 6, 24],
    "l": 1
  }, {
    "p": [-110, 84, -137],
    "s": [6, 4, 24],
    "l": 1
  }, {
    "p": [-64, 84, -96],
    "s": [14, 6, 24],
    "l": 1
  }, {
    "p": [-64, 84, -184],
    "s": [14, 6, 24],
    "l": 1
  }, {
    "p": [-60, 84, -137],
    "s": [6, 4, 16],
    "l": 1
  }, {
    "p": [-182, 51, 55],
    "s": [16, 4, 16],
    "l": 1
  }, {
    "p": [-250, 51, 50],
    "s": [16, 4, 6],
    "l": 1
  }, {
    "p": [-212, 51, 50],
    "s": [16, 2, 6],
    "l": 1
  }, {
    "p": [-252, 51, 60],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [343, 32, -364],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [243, 56, -292],
    "s": [6, 28, 6],
    "t": 2
  }, {
    "p": [10, 24, 8],
    "s": [18, 2, 4]
  }, {
    "p": [82, 24, 8],
    "s": [20, 2, 4]
  }, {
    "p": [-35, 24, 8],
    "s": [9, 1, 4]
  }, {
    "p": [-129, 24, -44],
    "s": [16, 2, 4]
  }, {
    "p": [-164, 24, -44],
    "s": [16, 2, 4]
  }, {
    "p": [-170, 24, -31],
    "s": [4, 2, 22]
  }, {
    "p": [-170, 24, 4],
    "s": [4, 2, 12]
  }, {
    "p": [-227, 62, -323],
    "s": [20, 4, 66],
    "l": 1
  }, {
    "p": [-108, 83, -89],
    "s": [6, 26, 6],
    "t": 2
  }, {
    "p": [-250, 44, -124],
    "s": [4, 41, 4],
    "t": 2
  }, {
    "p": [-280, 44, -124],
    "s": [4, 40, 4],
    "t": 2
  }, {
    "p": [-265, 74, -117],
    "s": [38, 2, 22],
    "t": 2
  }, {
    "p": [-57, 66, -201],
    "s": [10, 6, 36],
    "l": 1
  }, {
    "p": [-57, 66, -260],
    "s": [10, 4, 26],
    "l": 1
  }, {
    "p": [-61, 66, -308],
    "s": [18, 4, 26],
    "l": 1
  }, {
    "p": [-103, 66, -308],
    "s": [18, 4, 26],
    "l": 1
  }, {
    "p": [-107, 66, -251],
    "s": [10, 4, 22],
    "l": 1
  }, {
    "p": [-168, 62, -268],
    "s": [8, 2, 20],
    "l": 1
  }, {
    "p": [-150, 62, -268],
    "s": [12, 4, 20],
    "l": 1
  }, {
    "p": [-148, 62, -304],
    "s": [8, 4, 20],
    "l": 1
  }, {
    "p": [-148, 62, -342],
    "s": [8, 4, 28],
    "l": 1
  }, {
    "p": [335, 100, -92],
    "s": [6, 20, 2],
    "l": 1,
    "c": 0
  }, {
    "p": [196, 51, -91],
    "s": [6, 20, 2],
    "l": 1,
    "c": 0
  }, {
    "p": [-243, 94, -84],
    "s": [2, 16, 6],
    "l": 1,
    "c": 0
  }, {
    "p": [-295, 112, -587],
    "s": [2, 14, 6],
    "l": 1,
    "c": 0
  }, {
    "p": [-319, 112, -560],
    "s": [5, 14, 2],
    "l": 1,
    "c": 0
  }, {
    "p": [305, 100, -62],
    "s": [2, 20, 6],
    "l": 1,
    "c": 0
  }, {
    "p": [304, 78, -518],
    "s": [2, 14, 6],
    "l": 1,
    "c": 0
  }, {
    "p": [203, 70, -510],
    "s": [5, 14, 2],
    "l": 1,
    "c": 0
  }, {
    "p": [183, 70, -510],
    "s": [5, 14, 2],
    "l": 1,
    "c": 0
  }, {
    "p": [162, 70, -510],
    "s": [5, 14, 2],
    "l": 1,
    "c": 0
  }, {
    "p": [38, 18, 52],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [300, 49, -301],
    "s": [18, 4, 4],
    "t": 2,
    "bo": 1
  }, {
    "p": [-210, 0, -155],
    "s": [4, 1, 6],
    "l": 1
  }, {
    "p": [-177, 0, -258],
    "s": [4, 2, 6],
    "l": 1
  }, {
    "p": [-271, 0, -270],
    "s": [6, 2, 4],
    "l": 1
  }, {
    "p": [-242, 0, -431],
    "s": [8, 2, 4],
    "l": 1
  }, {
    "p": [-174, 0, -403],
    "s": [4, 1, 4],
    "l": 1
  }, {
    "p": [-154, -1, -404],
    "s": [8, 2, 8],
    "l": 1
  }, {
    "p": [-5, -28, -393],
    "s": [6, 2, 4],
    "l": 1
  }, {
    "p": [307, 0, -439],
    "s": [4, 1, 6],
    "l": 1
  }, {
    "p": [338, 0, -212],
    "s": [4, 2, 8],
    "l": 1
  }, {
    "p": [305, 0, -254],
    "s": [4, 2, 6],
    "l": 1
  }, {
    "p": [223, 0, -232],
    "s": [8, 2, 4],
    "l": 1
  }, {
    "p": [203, 0, -284],
    "s": [8, 2, 4],
    "c": 11316396
  }, {
    "p": [101, 0, -355],
    "s": [4, 2, 8],
    "l": 1
  }, {
    "p": [15, 0, -345],
    "s": [4, 2, 8],
    "l": 1
  }, {
    "p": [15, 0, -211],
    "s": [4, 2, 8]
  }, {
    "p": [-50, 0, -175],
    "s": [6, 2, 8],
    "l": 1
  }, {
    "p": [97, 0, -87],
    "s": [6, 2, 8],
    "l": 1
  }, {
    "p": [94, 0, 0],
    "s": [10, 2, 4],
    "l": 1
  }, {
    "p": [-43, 0, -1],
    "s": [6, 2, 8],
    "l": 1
  }, {
    "p": [-11, 18, 15],
    "s": [10, 2, 4],
    "l": 1
  }, {
    "p": [-154, 18, -38],
    "s": [6, 1, 3],
    "l": 1
  }, {
    "p": [-108, 18, -7],
    "s": [4, 2, 10],
    "l": 1
  }, {
    "p": [-136, 0, -52],
    "s": [8, 2, 6],
    "l": 1
  }, {
    "p": [162, 0, -52],
    "s": [3, 2, 5],
    "l": 1
  }, {
    "p": [46, 0, -149],
    "s": [6, 1, 5],
    "l": 1
  }, {
    "p": [-306, 0, -349],
    "s": [4, 1, 7],
    "l": 1
  }, {
    "p": [-332, 0, -270],
    "s": [4, 2, 8],
    "l": 1
  }, {
    "p": [-59, -28, -325],
    "s": [4, 2, 4]
  }, {
    "p": [-141, -28, -351],
    "s": [4, 2, 8]
  }, {
    "p": [-182, 0, -218],
    "s": [4, 2, 8],
    "l": 1
  }, {
    "p": [-218, 18, 43],
    "s": [8, 1, 4],
    "l": 1
  }, {
    "p": [-40, 18, 52],
    "s": [6, 2, 8],
    "l": 1
  }, {
    "p": [119, 0, -149],
    "s": [6, 2, 6],
    "l": 1
  }, {
    "p": [-196, 0, -524],
    "s": [5, 1, 4],
    "l": 1
  }, {
    "p": [160, 0, -70],
    "s": [4, 2, 4],
    "l": 1
  }, {
    "p": [-52, 0, -163],
    "s": [4, 2, 4],
    "l": 1
  }, {
    "p": [251, 0, -407],
    "s": [4, 2, 6],
    "l": 1
  }, {
    "p": [-5, -28, -408],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [251, 0, -288],
    "s": [3, 1, 5],
    "l": 1,
    "c": 12829635
  }, {
    "p": [313, 0, -344],
    "s": [3, 1, 4]
  }, {
    "p": [321, 0, -364],
    "s": [4, 2, 4],
    "l": 1
  }, {
    "p": [202, 0, -94],
    "s": [4, 1, 4]
  }, {
    "p": [16, 0, -264],
    "s": [4, 1, 6]
  }, {
    "p": [37, 0, -307],
    "s": [4, 6, 38]
  }, {
    "p": [94, 0, -325],
    "s": [22, 6, 4]
  }, {
    "p": [107, 0, -314],
    "s": [4, 6, 26]
  }, {
    "p": [37, 6, -316],
    "s": [4, 2, 10]
  }, {
    "p": [107, 6, -321],
    "s": [4, 2, 12]
  }, {
    "p": [99, 6, -325],
    "s": [12, 4, 4]
  }, {
    "p": [76, 0, -325],
    "s": [14, 2, 4]
  }, {
    "p": [9, 47, -171],
    "s": [4, 4, 14],
    "t": 2,
    "bo": 1
  }, {
    "p": [85, -1, -226],
    "s": [6, 2, 4],
    "l": 1
  }, {
    "p": [65, -1, -200],
    "s": [6, 2, 4],
    "l": 1
  }, {
    "p": [-124, 61, -114],
    "s": [22, 4, 4],
    "t": 2,
    "bo": 1
  }, {
    "p": [22, 45, -351],
    "s": [6, 14, 2],
    "l": 1,
    "c": 0
  }, {
    "p": [51, 45, -351],
    "s": [6, 14, 2],
    "l": 1,
    "c": 0
  }, {
    "p": [79, 45, -351],
    "s": [6, 14, 2],
    "l": 1,
    "c": 0
  }, {
    "p": [-63, 68, -456],
    "s": [2, 2, 14],
    "l": 1,
    "r": [-0.7, 0, 0],
    "t": 2
  }, {
    "p": [-115, 57, -114],
    "s": [14, 2, 2],
    "l": 1,
    "r": [0, 0, -0.7],
    "t": 2
  }, {
    "p": [91, 77, -175],
    "s": [100, 2, 44],
    "t": 2,
    "bo": 1
  }, {
    "p": [107, 10, -469],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [203, -28, -413],
    "s": [91, 86, 16],
    "bo": 1
  }, {
    "p": [165, 58, -413],
    "s": [11, 6, 16],
    "l": 1
  }, {
    "p": [179, 16, -461],
    "s": [20, 2, 4]
  }, {
    "p": [344, 50, -196],
    "s": [12, 3, 18],
    "l": 1,
    "c": "#b1b1b1"
  }, {
    "p": [340, 50, -160],
    "s": [4, 2, 18],
    "l": 1,
    "c": "#b9b9b9"
  }, {
    "p": [340, 50, -123],
    "s": [4, 4, 22],
    "l": 1,
    "c": "#b9b9b9"
  }, {
    "p": [322, -1, -401],
    "s": [20, 2, 96],
    "c": 10987431,
    "t": 1
  }, {
    "p": [144, 58, -294],
    "s": [25, 4, 14],
    "l": 1
  }, {
    "p": [305, 45, -301],
    "s": [14, 2, 2],
    "l": 1,
    "r": [0, 0, -0.7],
    "t": 2
  }, {
    "p": [85, 62, -453],
    "s": [2, 2, 14],
    "l": 1,
    "r": [-0.7, 0, 0],
    "t": 2
  }, {
    "p": [-22, 65, -523],
    "s": [18, 4, 4],
    "l": 1
  }, {
    "p": [16, 65, -523],
    "s": [20, 2, 4],
    "l": 1
  }, {
    "p": [-146, 0, -475],
    "s": [8, 26, 2],
    "i": 3,
    "t": 2,
    "d": 1
  }, {
    "p": [-210, 0, -276],
    "s": [76, 5, 2],
    "c": 13158600
  }, {
    "p": [-210, 0, -284],
    "s": [76, 4, 14],
    "l": 1,
    "c": 1916250,
    "o": 0.8,
    "t": 5
  }, {
    "p": [-253, 0, -269],
    "s": [4, 2, 6],
    "l": 1
  }, {
    "p": [-175, 0, -270],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [-302, 0, -232],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [-128, 0, -115],
    "s": [6, 2, 66],
    "t": 2
  }, {
    "p": [-121, 0, -114],
    "s": [6, 2, 66],
    "c": 13290186,
    "t": 2
  }, {
    "p": [-132, 2, -113],
    "s": [6, 2, 66],
    "t": 2
  }, {
    "p": [-125, 2, -114],
    "s": [6, 2, 66],
    "t": 2
  }, {
    "p": [-128, 4, -112],
    "s": [6, 2, 66],
    "c": 12632256,
    "t": 2
  }, {
    "p": [-135, 0, -112],
    "s": [6, 2, 66],
    "c": 12303291,
    "t": 2
  }, {
    "p": [-132, 38, -114],
    "s": [1, 25, 1],
    "l": 1,
    "c": 11645361,
    "t": 2
  }, {
    "p": [-196, 46, -191],
    "s": [34, 31, 76],
    "bo": 1
  }, {
    "p": [-183, 40, -157],
    "s": [2, 6, 2],
    "l": 1,
    "c": 3421236,
    "t": 5
  }, {
    "p": [-192, 42, -157],
    "s": [2, 6, 2],
    "l": 1,
    "c": 3421236,
    "t": 5
  }, {
    "p": [-201, 41, -157],
    "s": [2, 6, 2],
    "l": 1,
    "c": 3421236,
    "t": 5
  }, {
    "p": [-209, 40, -157],
    "s": [2, 6, 2],
    "l": 1,
    "c": 3421236,
    "t": 5
  }, {
    "p": [-192, 41, -227],
    "s": [2, 6, 2],
    "l": 1,
    "c": 3421236,
    "t": 5
  }, {
    "p": [-183, 40, -227],
    "s": [2, 6, 2],
    "l": 1,
    "c": 3421236,
    "t": 5
  }, {
    "p": [-201, 42, -227],
    "s": [2, 4, 2],
    "l": 1,
    "c": 3421236,
    "t": 5
  }, {
    "p": [-209, 40, -227],
    "s": [2, 6, 2],
    "l": 1,
    "c": 3421236,
    "t": 5
  }, {
    "p": [-442, 0, 157],
    "s": [62, 206, 72],
    "l": 1
  }, {
    "p": [-418, 206, 129],
    "s": [14, 6, 16],
    "l": 1
  }, {
    "p": [-414, 206, 157],
    "s": [6, 6, 22],
    "l": 1
  }, {
    "p": [-414, 206, 186],
    "s": [6, 4, 14],
    "l": 1
  }, {
    "p": [-444, 206, 123],
    "s": [20, 6, 4],
    "l": 1
  }, {
    "p": [-468, 206, 123],
    "s": [10, 6, 4],
    "l": 1
  }, {
    "p": [-442, 163, 121],
    "s": [8, 20, 2],
    "l": 1,
    "c": 0
  }, {
    "p": [-178, 13, 93],
    "s": [4, 74, 4],
    "t": 2
  }, {
    "p": [-254, 13, 93],
    "s": [4, 74, 4],
    "t": 2
  }, {
    "p": [-19, 64, 74],
    "s": [60, 12, 38],
    "bo": 1
  }, {
    "p": [123, 76, 57],
    "s": [28, 4, 4],
    "l": 1
  }, {
    "p": [70, 76, 57],
    "s": [34, 2, 4],
    "l": 1
  }, {
    "p": [21, 76, 57],
    "s": [26, 4, 4],
    "l": 1
  }, {
    "p": [-41, 76, 57],
    "s": [12, 2, 4],
    "l": 1
  }, {
    "p": [-75, 76, 57],
    "s": [16, 2, 4],
    "l": 1
  }, {
    "p": [-127, 76, 57],
    "s": [26, 4, 4],
    "l": 1
  }, {
    "p": [-19, 0, 73],
    "s": [60, 64, 2],
    "t": 2,
    "bo": 1
  }, {
    "p": [-46, 18, 61],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [-13, 32, 71],
    "s": [4, 4, 2],
    "l": 1,
    "c": 3092271,
    "t": 5,
    "bo": 1
  }, {
    "p": [-26, 32, 71],
    "s": [4, 4, 2],
    "l": 1,
    "c": 3092271,
    "t": 5,
    "bo": 1
  }, {
    "p": [19, 63, 48],
    "s": [4, 4, 16],
    "t": 2,
    "bo": 1
  }, {
    "p": [-56, 63, 48],
    "s": [4, 4, 16],
    "t": 2,
    "bo": 1
  }, {
    "p": [-56, 59, 53],
    "s": [2, 2, 12],
    "l": 1,
    "r": [0.87, 0, 0],
    "t": 2
  }, {
    "p": [19, 59, 53],
    "s": [2, 2, 12],
    "l": 1,
    "r": [0.87, 0, 0],
    "t": 2
  }, {
    "p": [-139, 301, 405],
    "s": [110, 66, 86],
    "t": 5
  }, {
    "p": [-73, 281, 361],
    "s": [70, 42, 56],
    "t": 5
  }, {
    "p": [-527, 412, 373],
    "s": [146, 90, 116],
    "t": 5
  }, {
    "p": [-571, 369, 297],
    "s": [118, 72, 94],
    "t": 5
  }, {
    "p": [673, 319, 120],
    "s": [110, 66, 86],
    "t": 5
  }, {
    "p": [485, 337, 226],
    "s": [146, 88, 198],
    "t": 5
  }, {
    "p": [334, 337, 95],
    "s": [58, 30, 97],
    "l": 1,
    "t": 5
  }, {
    "p": [-866, 323, -277],
    "s": [146, 90, 196],
    "l": 1,
    "t": 5
  }, {
    "p": [-926, 303, -516],
    "s": [122, 76, 160],
    "l": 1,
    "t": 5
  }, {
    "p": [-1998, 360, -35],
    "s": [260, 76, 368],
    "l": 1,
    "t": 5
  }, {
    "p": [1593, 397, -140],
    "s": [218, 132, 256],
    "t": 5
  }, {
    "p": [1593, 377, -267],
    "s": [118, 72, 92],
    "t": 5
  }, {
    "p": [-130, 234, -914],
    "s": [146, 90, 116],
    "t": 5
  }, {
    "p": [-46, 204, -952],
    "s": [118, 74, 94],
    "t": 5
  }, {
    "p": [98, 204, -952],
    "s": [96, 38, 48],
    "l": 1,
    "t": 5
  }, {
    "p": [735, 363, -1249],
    "s": [224, 104, 178],
    "t": 5
  }, {
    "p": [186, 263, 500],
    "s": [104, 58, 112],
    "l": 1,
    "t": 5
  }, {
    "p": [81, 263, 500],
    "s": [48, 28, 52],
    "l": 1,
    "t": 5
  }, {
    "p": [-561, 204, -851],
    "s": [118, 74, 94],
    "t": 5
  }, {
    "p": [-22, -28, -518],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [-34, -16, -518],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [-31, -28, -515],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [60, -28, -425],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [63, -28, -515],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [63, -28, -503],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [54, -28, -518],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [218, 70, -541],
    "s": [2, 14, 6],
    "l": 1,
    "c": 0
  }, {
    "p": [-13, 76, 57],
    "s": [10, 4, 4],
    "l": 1
  }, {
    "p": [-19, 70, 102],
    "s": [220, 40, 58],
    "c": 12303291,
    "bo": 1
  }, {
    "p": [89, 110, 108],
    "s": [4, 4, 18],
    "l": 1,
    "c": 13814731
  }, {
    "p": [-119, 110, 80],
    "s": [20, 4, 14],
    "l": 1,
    "c": 12303291
  }, {
    "p": [36, 110, 75],
    "s": [16, 4, 4],
    "l": 1,
    "c": 12500156
  }, {
    "p": [-2, 110, 75],
    "s": [24, 2, 4],
    "l": 1,
    "c": 12631228
  }, {
    "p": [-78, 110, 75],
    "s": [14, 2, 4],
    "l": 1,
    "c": 10329501
  }, {
    "p": [-44, 110, 75],
    "s": [14, 4, 4],
    "l": 1,
    "c": 12961221
  }, {
    "p": [81, 110, 80],
    "s": [20, 4, 14],
    "l": 1,
    "c": 12303291
  }, {
    "p": [-127, 110, 108],
    "s": [4, 4, 18],
    "l": 1,
    "c": 11645361
  }, {
    "p": [-121, 99, 70],
    "s": [4, 4, 8],
    "t": 2
  }, {
    "p": [82, 99, 70],
    "s": [4, 4, 8],
    "t": 2
  }, {
    "p": [92, 99, 82],
    "s": [12, 4, 4],
    "t": 2
  }, {
    "p": [-131, 99, 82],
    "s": [10, 4, 4],
    "t": 2
  }, {
    "p": [292, 45, -113],
    "s": [60, 2, 20],
    "t": 2,
    "bo": 1
  }, {
    "p": [264, 0, -121],
    "s": [2, 49, 2],
    "t": 2
  }, {
    "p": [12, -28, -461],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [138, -28, -456],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [20, 48, -433],
    "s": [28, 4, 14],
    "l": 1
  }, {
    "p": [20, 48, -453],
    "s": [28, 2, 10],
    "l": 1
  }, {
    "p": [161, -28, -424],
    "s": [4, 42, 6]
  }, {
    "p": [-109, 40, -404],
    "s": [4, 4, 14],
    "t": 2,
    "bo": 1
  }, {
    "p": [-109, 37, -400],
    "s": [2, 2, 14],
    "l": 1,
    "r": [0.7, 0, 0],
    "t": 2
  }, {
    "p": [20, 34, -461],
    "s": [4, 4, 20],
    "t": 2,
    "bo": 1
  }, {
    "p": [20, 32, -461],
    "s": [2, 2, 12],
    "l": 1,
    "r": [0.87, 0, 0],
    "t": 2
  }, {
    "p": [21, -28, -464],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [21, -16, -464],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-253, 57, -559],
    "s": [74, 32, 2],
    "c": 6904648,
    "t": 5
  }, {
    "p": [-286, 52, -562],
    "s": [4, 40, 4],
    "t": 2
  }, {
    "p": [-221, 52, -562],
    "s": [4, 40, 4],
    "t": 2
  }, {
    "p": [260, 51, -568],
    "s": [74, 32, 2],
    "c": 7363405,
    "t": 5
  }, {
    "p": [260, 67, -566],
    "s": [69, 0, 29],
    "i": 11,
    "l": 1,
    "r": [1.57, 0, 0]
  }, {
    "p": [-258, 69, -18],
    "s": [2, 26, 62],
    "c": 6903619,
    "t": 5
  }, {
    "p": [-256, 82, -18],
    "s": [57, 0, 23],
    "i": 11,
    "l": 1,
    "r": [1.57, 0, 1.57]
  }, {
    "p": [72, 0, -277],
    "s": [64, 41, 90],
    "i": 14,
    "l": 1
  }, {
    "p": [-283, 10, -505],
    "s": [69, 41, 78],
    "i": 14,
    "l": 1
  }, {
    "p": [174, 10, -504],
    "s": [142, 41, 78],
    "i": 14,
    "l": 1
  }, {
    "p": [-136, 18, -16],
    "s": [59, 41, 49],
    "i": 14,
    "l": 1
  }, {
    "p": [336, 79, -303],
    "s": [54, 2, 110],
    "t": 2,
    "bo": 1
  }, {
    "p": [312, 60, -251],
    "s": [4, 25, 4],
    "t": 2
  }, {
    "p": [312, 62, -355],
    "s": [4, 25, 4],
    "t": 2
  }, {
    "p": [360, 61, -355],
    "s": [4, 24, 4],
    "t": 2
  }, {
    "p": [360, 61, -251],
    "s": [4, 26, 4],
    "t": 2
  }, {
    "p": [257, 47, -352],
    "s": [18, 4, 4],
    "t": 2,
    "bo": 1
  }, {
    "p": [252, 44, -352],
    "s": [14, 2, 2],
    "l": 1,
    "r": [0, 0, 0.7],
    "t": 2
  }, {
    "p": [213, 0, -97],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [210, 56, -292],
    "s": [6, 30, 6],
    "t": 2
  }, {
    "p": [243, 56, -326],
    "s": [6, 29, 6],
    "t": 2
  }, {
    "p": [210, 56, -326],
    "s": [6, 26, 6],
    "t": 2
  }, {
    "p": [227, 77, -309],
    "s": [42, 2, 43],
    "t": 2,
    "bo": 1
  }, {
    "p": [137, 56, -292],
    "s": [6, 22, 6],
    "t": 2
  }, {
    "p": [-11, -28, -514],
    "s": [6, 2, 4],
    "l": 1
  }, {
    "p": [277, 10, -540],
    "s": [8, 1, 4],
    "l": 1
  }, {
    "p": [2, -28, -448],
    "s": [6, 2, 4],
    "l": 1
  }, {
    "p": [-147, 62, -261],
    "s": [4, 12, 4],
    "t": 2
  }, {
    "p": [-169, 62, -261],
    "s": [4, 15, 4],
    "t": 2
  }, {
    "p": [-169, 62, -286],
    "s": [4, 11, 4],
    "t": 2
  }, {
    "p": [-147, 62, -287],
    "s": [4, 13, 4],
    "t": 2
  }, {
    "p": [-158, 70, -274],
    "s": [28, 1, 32],
    "t": 2,
    "bo": 1
  }, {
    "p": [-118, 61, -197],
    "s": [48, 87, 47],
    "c": 10987431
  }, {
    "p": [-119, 96, -197],
    "s": [85, 2, 46],
    "t": 2
  }, {
    "p": [-159, 72, -218],
    "s": [3, 30, 3],
    "t": 2
  }, {
    "p": [-143, 72, -218],
    "s": [3, 28, 3],
    "t": 2
  }, {
    "p": [-143, 72, -176],
    "s": [3, 29, 3],
    "t": 2
  }, {
    "p": [-159, 72, -176],
    "s": [3, 28, 3],
    "t": 2
  }, {
    "p": [263, 35, -352],
    "s": [1, 13, 1],
    "l": 1,
    "c": 11645361,
    "t": 2
  }, {
    "p": [-109, 28, -409],
    "s": [1, 13, 1],
    "l": 1,
    "c": 11645361,
    "t": 2
  }, {
    "p": [-174, 0, -472],
    "s": [6, 1, 4],
    "l": 1
  }, {
    "p": [-147, 18, 52],
    "s": [6, 1, 5],
    "l": 1
  }, {
    "p": [200, 220, -911],
    "s": [174, 74, 155],
    "t": 5
  }, {
    "p": [92, 76, -356],
    "s": [6, 17, 6],
    "l": 1,
    "t": 2
  }, {
    "p": [-48, 59, -361],
    "s": [6, 14, 6],
    "l": 1,
    "t": 2
  }, {
    "p": [228, 48, -137],
    "s": [10, 3, 11],
    "l": 1
  }, {
    "p": [37, 0, -160],
    "s": [8, 13, 4]
  }, {
    "p": [29, 0, -160],
    "s": [8, 6, 4]
  }, {
    "p": [7, 0, -173],
    "s": [4, 1, 4],
    "l": 1
  }, {
    "p": [-79, 66, -218],
    "s": [3, 33, 3],
    "t": 2
  }, {
    "p": [-79, 84, -177],
    "s": [3, 17, 3],
    "t": 2
  }, {
    "p": [-93, 84, -177],
    "s": [3, 17, 3],
    "t": 2
  }, {
    "p": [-93, 66, -218],
    "s": [3, 35, 3],
    "t": 2
  }, {
    "p": [-96, 148, -197],
    "s": [4, 3, 11],
    "l": 1,
    "c": 10987431
  }, {
    "p": [-140, 148, -202],
    "s": [4, 3, 15],
    "l": 1,
    "c": 9013641
  }, {
    "p": [-137, 148, -178],
    "s": [10, 3, 9],
    "l": 1,
    "c": 11513775
  }, {
    "p": [-99, 148, -178],
    "s": [10, 3, 9],
    "l": 1,
    "c": 11973298
  }, {
    "p": [-99, 148, -216],
    "s": [10, 4, 9],
    "l": 1,
    "c": 10987431
  }, {
    "p": [-117, 148, -218],
    "s": [12, 2, 5],
    "l": 1,
    "c": 11974326
  }, {
    "p": [-138, 148, -217],
    "s": [8, 3, 7],
    "l": 1,
    "c": 10197915
  }, {
    "p": [-120, 148, -176],
    "s": [9, 2, 5],
    "l": 1,
    "c": 11513775
  }, {
    "p": [-118, 117, -197],
    "s": [50, 16, 5],
    "l": 1,
    "c": 0
  }, {
    "p": [-118, 117, -197],
    "s": [5, 16, 49],
    "l": 1,
    "c": 0
  }, {
    "p": [-43, 43, -298],
    "s": [18, 4, 4],
    "t": 2,
    "bo": 1
  }, {
    "p": [-48, 39, -298],
    "s": [14, 2, 2],
    "l": 1,
    "r": [0, 0, 0.7],
    "c": 15132390,
    "t": 2
  }, {
    "p": [-37, 31, -298],
    "s": [1, 13, 1],
    "l": 1,
    "c": 11645361,
    "t": 2
  }, {
    "p": [-212, 50, -63],
    "s": [14, 4, 4],
    "t": 2
  }, {
    "p": [-166, 0, -150],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [22, 42, -350],
    "s": [9, 3, 3],
    "c": 14935011,
    "bo": 1
  }, {
    "p": [51, 42, -350],
    "s": [9, 3, 3],
    "bo": 1
  }, {
    "p": [79, 42, -350],
    "s": [9, 3, 3],
    "bo": 1
  }, {
    "p": [183, 67, -509],
    "s": [9, 3, 3],
    "bo": 1
  }, {
    "p": [203, 67, -509],
    "s": [9, 3, 3],
    "bo": 1
  }, {
    "p": [162, 67, -509],
    "s": [9, 3, 3],
    "bo": 1
  }, {
    "p": [-54, 0, -115],
    "s": [4, 7, 4],
    "i": 16
  }, {
    "p": [-54, 0, -121],
    "s": [4, 7, 4],
    "i": 16
  }, {
    "p": [8, 18, 69],
    "s": [4, 7, 4],
    "i": 16
  }, {
    "p": [306, 0, -321],
    "s": [4, 7, 4],
    "i": 16
  }, {
    "p": [251, 0, -352],
    "s": [4, 7, 4],
    "i": 16
  }, {
    "p": [-160, 0, -150],
    "s": [4, 7, 4],
    "i": 16
  }, {
    "p": [-154, 0, -150],
    "s": [4, 7, 4],
    "i": 16
  }, {
    "p": [71, 0, -345],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-119, 18, -39],
    "s": [4, 7, 4],
    "i": 16
  }, {
    "p": [-73, 17, 16],
    "s": [5, 2, 4],
    "l": 1
  }, {
    "p": [-116, 0, -233],
    "s": [4, 2, 6],
    "l": 1
  }, {
    "p": [-169, 62, -393],
    "s": [6, 12, 6],
    "l": 1,
    "t": 2
  }, {
    "p": [174, 0, -28],
    "s": [4, 7, 4],
    "i": 16
  }, {
    "p": [174, 0, -23],
    "s": [4, 7, 4],
    "i": 16
  }, {
    "p": [176, 0, -16],
    "s": [2, 19, 4],
    "t": 2
  }, {
    "p": [112, 0, -209],
    "s": [57, 26, 25],
    "i": 17
  }, {
    "p": [55, -1, -255],
    "s": [6, 3, 4],
    "l": 1
  }, {
    "p": [56, 0, -249],
    "s": [4, 7, 4],
    "i": 16
  }, {
    "p": [62, 0, -348],
    "s": [4, 7, 4],
    "i": 16
  }, {
    "p": [86, 0, -297],
    "s": [4, 7, 4],
    "i": 16
  }, {
    "p": [86, 0, -292],
    "s": [4, 7, 4],
    "i": 16
  }, {
    "p": [-220, 0, -104],
    "s": [57, 26, 25],
    "i": 17,
    "l": 1,
    "r": [0, 1.57, 0]
  }, {
    "p": [-227, 0, -139],
    "s": [12, 12, 12],
    "i": 8
  }, {
    "p": [78, 0, -203],
    "s": [12, 12, 12],
    "i": 8
  }, {
    "p": [-173, 0, -70],
    "s": [4, 1, 4],
    "l": 1
  }, {
    "p": [169, 0, 17],
    "s": [6, 2, 8],
    "l": 1
  }, {
    "p": [147, 0, 28],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [289, 10, -542],
    "s": [4, 7, 4],
    "i": 16
  }, {
    "p": [295, 10, -542],
    "s": [4, 7, 4],
    "i": 16
  }, {
    "p": [-181, 0, -473],
    "s": [4, 7, 4],
    "i": 16
  }, {
    "p": [-52, 21, -269],
    "s": [1, 15, 6],
    "l": 1,
    "c": 0
  }, {
    "p": [-52, 29, -218],
    "s": [1, 15, 6],
    "l": 1,
    "c": 0
  }, {
    "p": [-53, 18, -269],
    "s": [6, 3, 9],
    "l": 1,
    "c": 14935011
  }, {
    "p": [-53, 26, -218],
    "s": [6, 3, 9],
    "l": 1,
    "c": 14935011
  }, {
    "p": [217, 67, -541],
    "s": [6, 3, 9],
    "c": 14935011,
    "bo": 1
  }, {
    "p": [304, 76, -518],
    "s": [6, 3, 9],
    "c": 11645361,
    "bo": 1
  }, {
    "p": [90, 44, -195],
    "s": [16, 2, 4],
    "l": 1
  }, {
    "p": [127, 44, -195],
    "s": [26, 4, 4],
    "l": 1
  }, {
    "p": [66, 44, -195],
    "s": [12, 3, 4],
    "l": 1
  }, {
    "p": [-317, 0, -415],
    "s": [4, 7, 4],
    "i": 16
  }, {
    "p": [-53, 0, -159],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "c": "#d5e371"
  }, {
    "p": [-54, 0, -169],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, 1.04, -3.14],
    "c": "#d5e371"
  }, {
    "p": [36, 0, -165],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.87, 0],
    "c": "#d5e371"
  }, {
    "p": [37, 0, -175],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.18, 0],
    "c": "#d5e371"
  }, {
    "p": [5, 0, -188],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, -0.09, -3.14],
    "c": "#d5e371"
  }, {
    "p": [-42, 0, -57],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.18, 0],
    "c": "#c9d47c"
  }, {
    "p": [-9, 0, 2],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.18, 0],
    "c": "#c9d47c"
  }, {
    "p": [-19, 0, -26],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.18, 0],
    "c": "#c9d47c"
  }, {
    "p": [21, 0, -346],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.87, 0]
  }, {
    "p": [59, 0, -344],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.17, 0]
  }, {
    "p": [80, 0, -212],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.17, 0]
  }, {
    "p": [29, 0, -346],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.52, 0]
  }, {
    "p": [129, 0, -286],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.17, 0]
  }, {
    "p": [101, 0, -318],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.17, 0]
  }, {
    "p": [59, 0, -243],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -1.04, 0]
  }, {
    "p": [139, 0, -231],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.17, 0]
  }, {
    "p": [-42, -28, -355],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.18, 0]
  }, {
    "p": [-5, -28, -347],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.52, 0]
  }, {
    "p": [-86, -28, -325],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.34, 0]
  }, {
    "p": [-260, 0, -269],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-298, 0, -236],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-307, 0, -275],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-182, 0, -271],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.52, 0]
  }, {
    "p": [-176, 0, -264],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-217, 0, -136],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.7, 0]
  }, {
    "p": [-214, 0, -72],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.7, 0]
  }, {
    "p": [-147, 0, -149],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.7, 0]
  }, {
    "p": [-109, 0, -62],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.7, 0]
  }, {
    "p": [-109, 18, -25],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.7, 0]
  }, {
    "p": [-215, 18, 19],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.7, 0]
  }, {
    "p": [-230, 18, 43],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.7, 0]
  }, {
    "p": [-46, 18, 54],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, 1.22, -3.14]
  }, {
    "p": [10, 18, 54],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 1.57, 0]
  }, {
    "p": [-48, 18, 16],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.7, 0]
  }, {
    "p": [160, 0, -62],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.53, 0]
  }, {
    "p": [169, 0, -27],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.86, 0],
    "c": "#c9d47c"
  }, {
    "p": [162, 0, 20],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.86, 0],
    "c": "#c9d47c"
  }, {
    "p": [173, 0, 11],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -1.38, 0],
    "c": "#c9d47c"
  }, {
    "p": [166, 0, -92],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.34, 0]
  }, {
    "p": [126, 0, -150],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.34, 0]
  }, {
    "p": [127, 0, -65],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.53, 0],
    "c": "#c9d47c"
  }, {
    "p": [134, 0, -70],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.52, 0],
    "c": "#c9d47c"
  }, {
    "p": [128, 0, -77],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [3.14, -1.23, 3.14],
    "c": "#c9d47c"
  }, {
    "p": [96, 0, -46],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.53, 0],
    "c": "#c9d47c"
  }, {
    "p": [130, 0, -71],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [174, 0, 20],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.86, 0],
    "c": "#c9d47c"
  }, {
    "p": [11, 0, 3],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.53, 0],
    "c": "#c9d47c"
  }, {
    "p": [206, 0, -218],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.34, 0]
  }, {
    "p": [208, 0, -186],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.51, 0]
  }, {
    "p": [174, 0, -156],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.51, 0]
  }, {
    "p": [101, 0, 2],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.53, 0]
  }, {
    "p": [205, 0, -279],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.17, 0]
  }, {
    "p": [237, 0, -283],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.88, 0],
    "c": "#c9d47c"
  }, {
    "p": [307, -1, -247],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [3.14, -1.41, 3.14],
    "c": "#c9d47c"
  }, {
    "p": [253, 0, -108],
    "s": [6, 1, 6],
    "l": 1
  }, {
    "p": [306, 0, -316],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.71, 0],
    "c": "#c9d47c"
  }, {
    "p": [274, 0, -350],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.13, -1.41, -3.13]
  }, {
    "p": [320, 1, -440],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, -0.71, -3.14]
  }, {
    "p": [320, 1, -420],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.86, 0]
  }, {
    "p": [319, 1, -430],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -1.56, 0]
  }, {
    "p": [322, 1, -372],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -1.04, 0]
  }, {
    "p": [318, 1, -385],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -1.39, 0]
  }, {
    "p": [326, 1, -389],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.69, 0]
  }, {
    "p": [329, 1, -361],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.69, 0]
  }, {
    "p": [251, 0, -357],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, -0.71, -3.14]
  }, {
    "p": [327, 1, -422],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -1.39, 0]
  }, {
    "p": [318, 1, -395],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [3.14, -0.18, 3.14]
  }, {
    "p": [326, 1, -434],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-0.1, -1.56, -0.1]
  }, {
    "p": [301, 10, -541],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, -0.71, -3.14]
  }, {
    "p": [222, 10, -511],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, -0.71, -3.14]
  }, {
    "p": [221, 10, -467],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, -0.71, -3.14]
  }, {
    "p": [-40, -28, -362],
    "s": [4, 1, 6]
  }, {
    "p": [-214, 0, -68],
    "s": [2, 1, 2],
    "l": 1
  }, {
    "p": [-280, 0, -296],
    "s": [3, 1, 4],
    "l": 1
  }, {
    "p": [195, 0, -284],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.69, 0]
  }, {
    "p": [305, 0, -307],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.88, 0],
    "c": "#c9d47c"
  }, {
    "p": [164, -28, -429],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, -0.36, -3.14]
  }, {
    "p": [105, -28, -456],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, -0.88, -3.14]
  }, {
    "p": [129, -28, -455],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, -0.88, -3.14]
  }, {
    "p": [222, 10, -529],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, -0.71, -3.14]
  }, {
    "p": [220, 10, -543],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [3.14, 0.51, -3.14]
  }, {
    "p": [61, -29, -435],
    "s": [6, 2, 4],
    "l": 1
  }, {
    "p": [276, 0, -346],
    "s": [2, 1, 3],
    "l": 1
  }, {
    "p": [134, 0, -77],
    "s": [2, 1, 3],
    "l": 1
  }, {
    "p": [-157, 0, -147],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -1.57, 0]
  }, {
    "p": [-247, 0, -271],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.52, 0]
  }, {
    "p": [50, -28, -423],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, -0.88, -3.14]
  }, {
    "p": [53, -28, -511],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, -0.71, -3.14]
  }, {
    "p": [49, -28, -517],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.51, 0]
  }, {
    "p": [-15, -28, -517],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 1.06, 0]
  }, {
    "p": [-21, -28, -512],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.16, 0]
  }, {
    "p": [-32, -28, -505],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, 1.56, -3.14]
  }, {
    "p": [6, -28, -462],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, 1.21, -3.14]
  }, {
    "p": [11, 0, -186],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, 1.04, -3.14],
    "c": "#d5e371"
  }, {
    "p": [3, -28, -315],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.52, 0]
  }, {
    "p": [-6, -28, -318],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -1.39, 0]
  }, {
    "p": [2, -28, -347],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -1.22, 0]
  }, {
    "p": [-67, -28, -325],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.34, 0]
  }, {
    "p": [3, -28, -422],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, 1.21, -3.14]
  }, {
    "p": [-187, 0, -477],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.7, 0]
  }, {
    "p": [-316, 0, -368],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.7, 0]
  }, {
    "p": [-316, 0, -376],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -1.57, 0]
  }, {
    "p": [-315, 0, -410],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, -0.7, -3.14]
  }, {
    "p": [-175, 0, -398],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [3.14, -0.7, 3.14]
  }, {
    "p": [-186, 0, -499],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [3.14, -0.7, 3.14]
  }, {
    "p": [-245, 0, -360],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [3.14, -0.7, 3.14]
  }, {
    "p": [-2, -28, -417],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, 0.16, -3.14]
  }, {
    "p": [-249, 0, -434],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, -0.7, -3.14]
  }, {
    "p": [-194, 0, -476],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [3.14, -0.52, 3.14]
  }, {
    "p": [133, 0, -224],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.87, 0]
  }, {
    "p": [293, 39, -301],
    "s": [1, 10, 1],
    "l": 1,
    "c": 11645361,
    "t": 2
  }, {
    "p": [-165, 18, -33],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.7, 0]
  }, {
    "p": [71, 0, -274],
    "s": [57, 26, 25],
    "i": 19,
    "l": 1,
    "r": [0, 1.57, 0]
  }, {
    "p": [71, 0, -274],
    "s": [25, 2, 57],
    "v": 1,
    "t": 5
  }, {
    "p": [71, 24, -274],
    "s": [25, 2, 57],
    "v": 1,
    "t": 5
  }, {
    "p": [59, 2, -274],
    "s": [1, 22, 57],
    "pe": 1,
    "v": 1,
    "t": 5
  }, {
    "p": [83, 2, -274],
    "s": [1, 22, 57],
    "pe": 1,
    "v": 1,
    "t": 5
  }, {
    "p": [71, -1, -274],
    "s": [22, 2, 54],
    "c": 7677719,
    "t": 5
  }, {
    "p": [-52, -28, -322],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.53, 0]
  }, {
    "p": [-48, -28, -315],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [3.14, -0.7, 3.14]
  }, {
    "p": [87, 0, -287],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.87, 0]
  }, {
    "p": [251, 0, -414],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, -0.71, -3.14]
  }, {
    "p": [68, 0, -114],
    "s": [12, 12, 12],
    "i": 8
  }, {
    "p": [228, 48, -124],
    "s": [10, 2, 6],
    "l": 1
  }, {
    "p": [223, 0, -143],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.34, 0]
  }, {
    "p": [261, 0, -321],
    "s": [57, 26, 25],
    "i": 19,
    "l": 1,
    "r": [0, 1.57, 0]
  }, {
    "p": [261, 0, -321],
    "s": [25, 2, 57],
    "v": 1,
    "t": 5
  }, {
    "p": [261, 24, -321],
    "s": [25, 2, 57],
    "pe": 1,
    "v": 1,
    "t": 5
  }, {
    "p": [273, 2, -321],
    "s": [1, 22, 57],
    "pe": 1,
    "v": 1,
    "t": 5
  }, {
    "p": [249, 2, -321],
    "s": [1, 22, 55],
    "pe": 1,
    "t": 5
  }, {
    "p": [261, 0, -321],
    "s": [23, 1, 54],
    "c": 9518129,
    "t": 5
  }, {
    "p": [275, 0, -291],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, -0.19, -3.14],
    "c": "#c9d47c"
  }, {
    "p": [-202, 0, -485],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-190, 12, -485],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-187, 0, -494],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [-156, 0, -514],
    "s": [57, 26, 25],
    "i": 19,
    "l": 1
  }, {
    "p": [-156, 0, -527],
    "s": [57, 52, 2],
    "c": 1776411,
    "t": 5
  }, {
    "p": [-153, 0, -514],
    "s": [63, 1, 23],
    "c": 1776411,
    "t": 5
  }, {
    "p": [-217, 0, -544],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [3.14, -0.52, 3.14]
  }, {
    "p": [-187, 0, -524],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [3.14, -0.52, 3.14]
  }, {
    "p": [-155, 1, -502],
    "s": [54, 24, 2],
    "v": 1,
    "c": 1776411,
    "t": 5
  }, {
    "p": [-155, 24, -514],
    "s": [57, 2, 25],
    "pe": 1,
    "v": 1,
    "c": 1776411,
    "t": 5
  }, {
    "p": [-245, 0, -453],
    "s": [4, 11, 23]
  }, {
    "p": [324, -18, -158],
    "s": [4, 25, 80]
  }, {
    "p": [260, -18, -158],
    "s": [4, 25, 80]
  }, {
    "p": [292, -14, -175],
    "s": [61, 14, 44],
    "i": 9,
    "c": "#ffffff",
    "t": 1,
    "d": 3
  }, {
    "p": [-305, 10, -521],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-270, 10, -445],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [-265, 0, -375],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-165, 0, -404],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-275, 0, -453],
    "s": [4, 16, 24]
  }, {
    "p": [324, 7, -150],
    "s": [4, 2, 22]
  }, {
    "p": [324, 7, -182],
    "s": [4, 2, 16]
  }, {
    "p": [-245, 16, -522],
    "s": [4, 2, 12]
  }, {
    "p": [-245, 16, -479],
    "s": [4, 2, 12]
  }, {
    "p": [-245, 0, -507],
    "s": [4, 16, 80]
  }, {
    "p": [-245, 0, -467],
    "s": [5, 17, 5]
  }, {
    "p": [-275, 16, -451],
    "s": [4, 2, 12]
  }, {
    "p": [228, 0, -98],
    "s": [10, 48, 18],
    "bo": 1
  }, {
    "p": [292, -1, -112],
    "s": [68, 1, 22],
    "t": 1
  }, {
    "p": [292, -18, -121],
    "s": [60, 19, 6],
    "c": "#525252",
    "t": 5
  }, {
    "p": [228, 20, -109],
    "s": [10, 28, 4],
    "bo": 1
  }, {
    "p": [292, 36, -64],
    "s": [50, 2, 80],
    "c": "#3e3e3e",
    "t": 5,
    "bo": 1
  }, {
    "p": [292, -3, -73],
    "s": [50, 4, 90],
    "c": "#525252",
    "t": 5
  }, {
    "p": [259, 0, -63],
    "s": [18, 37, 80],
    "bo": 1
  }, {
    "p": [380, 0, -63],
    "s": [128, 37, 80],
    "bo": 1
  }, {
    "p": [305, 10, -69],
    "s": [66, 22, 2],
    "l": 1,
    "r": [0, -1.57, 0],
    "c": "#2c3f55",
    "t": 5
  }, {
    "p": [292, 10, -69],
    "s": [66, 2, 24],
    "l": 1,
    "r": [0, -1.57, 0],
    "c": 2899797,
    "t": 5
  }, {
    "p": [292, 32, -69],
    "s": [66, 2, 28],
    "l": 1,
    "r": [0, -1.57, 0],
    "c": "#2c3f55",
    "t": 5
  }, {
    "p": [292, 3, -78],
    "s": [4, 4, 27],
    "r": [0, -1.57, 0],
    "c": 8551805,
    "t": 5
  }, {
    "p": [303, 1, -78],
    "s": [8, 8, 4],
    "r": [0, -1.57, 0],
    "c": 1447446,
    "t": 5
  }, {
    "p": [298, 1, -78],
    "s": [8, 8, 4],
    "r": [0, -1.57, 0],
    "c": 1447446,
    "t": 5
  }, {
    "p": [281, 1, -78],
    "s": [8, 8, 4],
    "r": [0, -1.57, 0],
    "c": 1447446,
    "t": 5
  }, {
    "p": [286, 1, -78],
    "s": [8, 8, 4],
    "r": [0, -1.57, 0],
    "c": 1447446,
    "t": 5
  }, {
    "p": [292, 6, -67],
    "s": [66, 4, 5],
    "l": 1,
    "r": [0, -1.57, 0],
    "c": 8551805,
    "t": 5
  }, {
    "p": [292, 6, -101],
    "s": [3, 4, 24],
    "l": 1,
    "r": [0, -1.57, 0],
    "c": 8551805,
    "t": 5
  }, {
    "p": [285, 12, -102],
    "s": [2, 20, 12],
    "l": 1,
    "r": [0, -1.57, 0],
    "c": "#6b6b6b",
    "t": 5
  }, {
    "p": [306, 12, -97],
    "s": [12, 20, 2],
    "l": 1,
    "r": [0, -1.57, 0],
    "c": "#6b6b6b",
    "t": 5
  }, {
    "p": [292, 5, -101],
    "s": [4, 1, 27],
    "l": 1,
    "r": [0, -1.57, 0],
    "c": 8551805,
    "t": 5
  }, {
    "p": [282, 7, -102],
    "s": [2, 2, 2],
    "l": 1,
    "r": [0, -1.57, 0],
    "c": 16730880,
    "e": 16711680,
    "o": 0.8,
    "t": 5
  }, {
    "p": [302, 7, -102],
    "s": [2, 2, 2],
    "l": 1,
    "r": [0, -1.57, 0],
    "c": "#ff4b00",
    "e": 16711680,
    "o": 0.8,
    "t": 5
  }, {
    "p": [316, 0, -64],
    "s": [2, 36, 80],
    "c": "#3e3e3e",
    "t": 5,
    "bo": 1
  }, {
    "p": [292, 0, -38],
    "s": [46, 36, 1],
    "c": 0,
    "t": 5
  }, {
    "p": [292, 0, -57],
    "s": [46, 36, 1],
    "c": 0,
    "o": 0.4,
    "t": 5
  }, {
    "p": [292, 0, -73],
    "s": [46, 36, 1],
    "c": 0,
    "o": 0.4,
    "t": 5
  }, {
    "p": [292, 0, -73],
    "s": [46, 36, 1],
    "c": 0,
    "o": 0.4,
    "t": 5
  }, {
    "p": [292, -18, -139],
    "s": [60, 4, 30],
    "c": "#b6b6b6",
    "t": 1
  }, {
    "p": [292, 0, -103],
    "s": [46, 36, 1],
    "c": 0,
    "o": 0.4,
    "t": 5,
    "bo": 1
  }, {
    "p": [292, 0, -91],
    "s": [46, 36, 1],
    "c": 0,
    "o": 0.4,
    "t": 5
  }, {
    "p": [228, 0, -142],
    "s": [10, 48, 14],
    "bo": 1
  }, {
    "p": [228, 19, -133],
    "s": [10, 29, 4],
    "bo": 1
  }, {
    "p": [228, 26, -121],
    "s": [10, 22, 20],
    "bo": 1
  }, {
    "p": [222, 0, -131],
    "s": [7, 1, 4],
    "l": 1
  }, {
    "p": [-156, 0, -488],
    "s": [57, 26, 25],
    "i": 17
  }, {
    "p": [-265, 10, -443],
    "s": [4, 7, 4],
    "i": 16
  }, {
    "p": [320, 0, -121],
    "s": [2, 50, 2],
    "t": 2
  }, {
    "p": [317, -14, -130],
    "s": [4, 1, 4],
    "l": 1,
    "c": "#c5c5c5"
  }, {
    "p": [313, 1, -100],
    "s": [4, 7, 4],
    "i": 16
  }, {
    "p": [315, 1, -119],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [-54, 0, -118],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.87, 0],
    "c": "#d5e371"
  }, {
    "p": [236, 0, -94],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [236, 0, -144],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.86, 0]
  }, {
    "p": [-253, 73, -557],
    "s": [69, 0, 28],
    "i": 11,
    "l": 1,
    "r": [1.57, 0, 0]
  }, {
    "p": [-250, 10, -544],
    "s": [4, 7, 4],
    "i": 16
  }, {
    "p": [-129, 2, -514],
    "s": [1, 24, 23],
    "l": 1,
    "c": 0,
    "o": 0.7000000000000001,
    "t": 5
  }, {
    "p": [-122, 58, -524],
    "s": [6, 14, 6],
    "t": 2
  }, {
    "p": [-83, 62, -459],
    "s": [6, 16, 6],
    "t": 2
  }, {
    "p": [-156, 26, -514],
    "s": [57, 26, 25],
    "i": 17
  }, {
    "p": [-136, -28, -350],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.7, 0]
  }, {
    "p": [176, 0, -10],
    "s": [2, 18, 4],
    "c": 14145495,
    "t": 2
  }, {
    "p": [-56, 0, -128],
    "s": [2, 18, 4],
    "c": 14145495,
    "t": 2
  }, {
    "p": [138, 0, -286],
    "s": [5, 19, 2],
    "t": 2
  }, {
    "p": [145, 0, -286],
    "s": [5, 18, 2],
    "t": 2
  }, {
    "p": [26, 0, -350],
    "s": [5, 18, 2],
    "t": 2
  }, {
    "p": [309, 0, -306],
    "s": [2, 19, 4],
    "t": 2
  }, {
    "p": [308, 0, -316],
    "s": [2, 19, 4],
    "t": 2
  }, {
    "p": [-260, 0, -439],
    "s": [26, 16, 4]
  }, {
    "p": [-269, 10, -452],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [3.14, 0.7, -3.14]
  }, {
    "p": [-212, 0, -385],
    "s": [51, 15, 20],
    "i": 7,
    "l": 1,
    "r": [-3.14, 0, -3.14]
  }, {
    "p": [-212, 0, -384],
    "s": [49, 8, 16],
    "v": 1
  }, {
    "p": [-217, 8, -384],
    "s": [24, 7, 16],
    "v": 1
  }, {
    "p": [-155, 0, -412],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [3.14, -0.87, 3.14]
  }, {
    "p": [-241, 0, -388],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [3.14, -0.7, 3.14]
  }, {
    "p": [-192, 0, -371],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [3.14, -0.7, 3.14]
  }, {
    "p": [279, 10, -69],
    "s": [66, 22, 2],
    "l": 1,
    "r": [0, -1.57, 0],
    "c": "#2c3f55",
    "t": 5
  }, {
    "p": [343, 32, -376],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [343, 44, -369],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [183, 88, -4],
    "s": [4, 2, 54],
    "t": 2
  }, {
    "p": [199, 88, -4],
    "s": [4, 2, 54],
    "t": 2
  }, {
    "p": [190, 90, -27],
    "s": [26, 1, 4],
    "c": 14277081,
    "t": 2
  }, {
    "p": [190, 90, -20],
    "s": [25, 1, 4],
    "t": 2
  }, {
    "p": [191, 90, -12],
    "s": [26, 1, 4],
    "c": 13158600,
    "t": 2
  }, {
    "p": [191, 90, 19],
    "s": [26, 1, 4],
    "t": 2
  }, {
    "p": [190, 90, -5],
    "s": [24, 1, 4],
    "t": 2
  }, {
    "p": [190, 90, 12],
    "s": [23, 1, 4],
    "t": 2
  }, {
    "p": [190, 90, 4],
    "s": [23, 1, 4],
    "c": 12303291,
    "t": 2
  }, {
    "p": [170, 87, -87],
    "s": [6, 19, 6],
    "t": 2
  }, {
    "p": [177, 43, -5],
    "s": [2, 13, 4],
    "l": 1,
    "c": 0
  }, {
    "p": [318, 1, -403],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.86, 0]
  }, {
    "p": [324, 1, -410],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.69, 0]
  }, {
    "p": [146, 0, 51],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.86, 0]
  }, {
    "p": [18, 28, -520],
    "s": [11, 3, 3],
    "bo": 1
  }, {
    "p": [-17, 31, -520],
    "s": [11, 3, 3],
    "bo": 1
  }, {
    "p": [51, 31, -520],
    "s": [11, 3, 3],
    "bo": 1
  }, {
    "p": [18, 31, -521],
    "s": [7, 16, 2],
    "l": 1,
    "c": 0
  }, {
    "p": [51, 34, -521],
    "s": [7, 16, 2],
    "l": 1,
    "c": 0
  }, {
    "p": [-17, 34, -521],
    "s": [7, 16, 2],
    "l": 1,
    "c": 0
  }, {
    "p": [150, 7, -425],
    "s": [18, 7, 4]
  }, {
    "p": [100, 7, -425],
    "s": [10, 7, 4]
  }, {
    "p": [101, 10, -461],
    "s": [8, 6, 4]
  }, {
    "p": [112, -28, -461],
    "s": [58, 36, 4]
  }, {
    "p": [123, 4, -443],
    "s": [36, 1, 32]
  }, {
    "p": [143, 4, -443],
    "s": [4, 10, 32]
  }, {
    "p": [103, 4, -443],
    "s": [4, 10, 32]
  }, {
    "p": [143, 14, -435],
    "s": [4, 2, 9]
  }, {
    "p": [103, 14, -449],
    "s": [4, 2, 9]
  }, {
    "p": [103, 14, -433],
    "s": [4, 2, 9]
  }, {
    "p": [123, 8, -443],
    "s": [36, 2, 36],
    "i": 9,
    "t": 1,
    "d": 3
  }, {
    "p": [152, 14, -425],
    "s": [8, 2, 4]
  }, {
    "p": [139, 1, -444],
    "s": [4, 3, 34],
    "t": 2
  }, {
    "p": [107, 1, -444],
    "s": [4, 3, 34],
    "t": 2
  }, {
    "p": [139, -1, -455],
    "s": [2, 2, 14],
    "l": 1,
    "r": [-0.7, 0, 0],
    "c": 13948116,
    "t": 2
  }, {
    "p": [107, -1, -455],
    "s": [2, 2, 14],
    "l": 1,
    "r": [-0.7, 0, 0],
    "c": 14277081,
    "t": 2
  }, {
    "p": [107, -1, -429],
    "s": [2, 2, 14],
    "l": 1,
    "r": [0.7, 0, 0],
    "c": 15132390,
    "t": 2
  }, {
    "p": [139, -1, -430],
    "s": [2, 2, 14],
    "l": 1,
    "r": [0.7, 0, 0],
    "c": 14803425,
    "t": 2
  }, {
    "p": [154, 8, -408],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.87, 0]
  }, {
    "p": [101, 8, -419],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.87, 0]
  }, {
    "p": [-241, 0, -453],
    "s": [4, 8, 25],
    "l": 1
  }, {
    "p": [-237, 0, -453],
    "s": [4, 5, 25],
    "l": 1
  }, {
    "p": [-233, 0, -453],
    "s": [4, 2, 25]
  }, {
    "p": [-236, 0, -453],
    "s": [14, 11, 23],
    "i": 9,
    "v": 1,
    "t": 1,
    "d": 2
  }, {
    "p": [-193, 0, -494],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, 0.53, 3.14]
  }, {
    "p": [369, 81, -121],
    "s": [4, 3, 17],
    "l": 1
  }, {
    "p": [-148, 101, 97],
    "s": [20, 2, 4],
    "l": 1
  }, {
    "p": [-238, -1, -586],
    "s": [175, 90, 11]
  }, {
    "p": [-280, 89, -586],
    "s": [22, 4, 11],
    "l": 1
  }, {
    "p": [-252, 50, 27],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [248, 15, -574],
    "s": [129, 75, 11]
  }, {
    "p": [223, 90, -574],
    "s": [21, 3, 11],
    "l": 1
  }, {
    "p": [253, 90, -574],
    "s": [21, 2, 11],
    "l": 1
  }, {
    "p": [287, 90, -574],
    "s": [17, 4, 11],
    "l": 1
  }, {
    "p": [-249, 124, -103],
    "s": [12, 4, 12],
    "l": 1,
    "c": 12499642
  }, {
    "p": [-246, 124, -84],
    "s": [6, 2, 12],
    "l": 1,
    "c": 14145495
  }, {
    "p": [-178, 101, 97],
    "s": [13, 2, 4],
    "l": 1
  }, {
    "p": [-207, 101, 97],
    "s": [13, 3, 4],
    "l": 1
  }, {
    "p": [-237, 101, 97],
    "s": [16, 2, 4],
    "l": 1
  }, {
    "p": [-260, 101, 73],
    "s": [4, 2, 17],
    "l": 1
  }, {
    "p": [-260, 101, 41],
    "s": [4, 2, 13],
    "l": 1
  }, {
    "p": [-260, 101, 12],
    "s": [4, 3, 11],
    "l": 1
  }, {
    "p": [-260, 101, -21],
    "s": [4, 2, 23],
    "l": 1
  }, {
    "p": [-243, 91, -84],
    "s": [6, 3, 10],
    "c": 12171705
  }, {
    "p": [-159, 77, -156],
    "s": [14, 4, 6],
    "l": 1
  }, {
    "p": [-185, 77, -156],
    "s": [11, 3, 6],
    "l": 1
  }, {
    "p": [-220, 77, -158],
    "s": [14, 3, 10],
    "l": 1
  }, {
    "p": [-278, 77, -226],
    "s": [23, 4, 6],
    "l": 1
  }, {
    "p": [-310, 77, -156],
    "s": [27, 2, 6],
    "l": 1
  }, {
    "p": [357, 98, -450],
    "s": [16, 3, 16],
    "l": 1
  }, {
    "p": [352, 98, -487],
    "s": [6, 4, 12],
    "l": 1
  }, {
    "p": [369, 81, -235],
    "s": [4, 3, 17],
    "l": 1
  }, {
    "p": [369, 81, -202],
    "s": [4, 2, 11],
    "l": 1
  }, {
    "p": [369, 81, -165],
    "s": [4, 2, 21],
    "l": 1
  }, {
    "p": [328, 37, -63],
    "s": [156, 44, 80],
    "bo": 1
  }, {
    "p": [347, 81, -101],
    "s": [13, 2, 4],
    "l": 1
  }, {
    "p": [257, 81, -100],
    "s": [14, 3, 6],
    "l": 1
  }, {
    "p": [318, 81, -101],
    "s": [16, 3, 4],
    "l": 1
  }, {
    "p": [285, 81, -101],
    "s": [14, 3, 4],
    "l": 1
  }, {
    "p": [361, 50, -188],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [361, 50, -176],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-242, 89, -586],
    "s": [22, 3, 11],
    "l": 1
  }, {
    "p": [-200, 89, -586],
    "s": [18, 4, 11],
    "l": 1
  }, {
    "p": [-256, 77, -156],
    "s": [17, 4, 6],
    "l": 1
  }, {
    "p": [-234, 77, -226],
    "s": [16, 4, 6],
    "l": 1
  }, {
    "p": [-319, 77, -226],
    "s": [20, 3, 6],
    "l": 1
  }, {
    "p": [-193, 77, -226],
    "s": [19, 2, 6],
    "l": 1
  }, {
    "p": [-151, 77, -226],
    "s": [19, 3, 6],
    "l": 1
  }, {
    "p": [-171, 18, 51],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.7, 0]
  }, {
    "p": [-118, 116, -197],
    "s": [9, 3, 52],
    "c": 11513775
  }, {
    "p": [-118, 116, -197],
    "s": [52, 3, 9],
    "c": 9868950
  }, {
    "p": [-143, 0, -49],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, -1.05, -3.14]
  }, {
    "p": [-348, 153, -230],
    "s": [11, 4, 12],
    "l": 1
  }, {
    "p": [-349, 153, -276],
    "s": [13, 4, 12],
    "l": 1
  }, {
    "p": [-392, 153, -230],
    "s": [11, 4, 12],
    "l": 1
  }, {
    "p": [-390, 153, -276],
    "s": [15, 4, 12],
    "l": 1
  }, {
    "p": [-370, 110, -253],
    "s": [72, 2, 76],
    "t": 2
  }, {
    "p": [-370, 106, -253],
    "s": [67, 4, 4],
    "t": 2
  }, {
    "p": [-370, 106, -235],
    "s": [67, 4, 4],
    "t": 2
  }, {
    "p": [-370, 106, -272],
    "s": [67, 4, 4],
    "t": 2
  }, {
    "p": [-370, 106, -253],
    "s": [4, 4, 72],
    "t": 2
  }, {
    "p": [-354, 106, -253],
    "s": [4, 4, 72],
    "t": 2
  }, {
    "p": [-387, 106, -253],
    "s": [4, 4, 72],
    "t": 2
  }, {
    "p": [-343, 123, -254],
    "s": [2, 16, 6],
    "l": 1,
    "c": 0
  }, {
    "p": [-345, 153, -252],
    "s": [5, 3, 12],
    "l": 1
  }, {
    "p": [-368, 153, -226],
    "s": [14, 2, 4],
    "l": 1
  }, {
    "p": [-368, 153, -280],
    "s": [11, 3, 4],
    "l": 1
  }, {
    "p": [-319, 103, -587],
    "s": [62, 2, 67],
    "c": 12500670,
    "t": 2
  }, {
    "p": [-319, 100, -587],
    "s": [4, 3, 63],
    "c": 14802654,
    "t": 2
  }, {
    "p": [-334, 100, -587],
    "s": [4, 3, 63],
    "c": 14276053,
    "t": 2
  }, {
    "p": [-303, 100, -587],
    "s": [4, 3, 63],
    "c": 14474460,
    "t": 2
  }, {
    "p": [-319, 100, -587],
    "s": [58, 3, 3],
    "c": 12829635,
    "t": 2
  }, {
    "p": [-319, 100, -569],
    "s": [58, 3, 3],
    "c": 13158600,
    "t": 2
  }, {
    "p": [-319, 100, -603],
    "s": [58, 3, 3],
    "c": 13619151,
    "t": 2
  }, {
    "p": [183, 85, -28],
    "s": [2, 2, 11],
    "l": 1,
    "r": [-0.7, 0, 0],
    "t": 2
  }, {
    "p": [199, 85, -28],
    "s": [2, 2, 11],
    "l": 1,
    "r": [-0.7, 0, 0],
    "t": 2
  }, {
    "p": [199, 85, 20],
    "s": [2, 2, 11],
    "l": 1,
    "r": [0.7, 0, 0],
    "t": 2
  }, {
    "p": [183, 85, 20],
    "s": [2, 2, 11],
    "l": 1,
    "r": [0.7, 0, 0],
    "t": 2
  }, {
    "p": [270, -14, -130],
    "s": [12, 12, 12],
    "i": 8
  }, {
    "p": [-231, 0, -398],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -1.05, 0]
  }, {
    "p": [-202, 0, -397],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -1.05, 0]
  }, {
    "p": [-260, 16, -439],
    "s": [12, 2, 4]
  }, {
    "p": [-245, 0, -439],
    "s": [5, 17, 5]
  }, {
    "p": [-275, 0, -439],
    "s": [5, 17, 5]
  }, {
    "p": [-236, 0, -467],
    "s": [14, 13, 3]
  }, {
    "p": [-236, 0, -439],
    "s": [14, 13, 3]
  }, {
    "p": [-239, 0, -472],
    "s": [6, 8, 6],
    "i": 2,
    "r": [-3.14, 0, -3.14]
  }, {
    "p": [-229, 0, -439],
    "s": [4, 14, 4]
  }, {
    "p": [-229, 0, -467],
    "s": [4, 14, 4]
  }, {
    "p": [-178, 0, -361],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [3.14, -0.7, 3.14]
  }, {
    "p": [-203, 0, -372],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0.01, -1.39, 0.01]
  }, {
    "p": [-221, 0, -371],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0.01, -1.39, 0.01]
  }, {
    "p": [-232, 1, -372],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 1.23, 0.01]
  }, {
    "p": [-184, 0, -388],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.52, 0]
  }, {
    "p": [-185, 0, -378],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, -0.88, -3.14]
  }, {
    "p": [-227, 0, -357],
    "s": [4, 19, 2],
    "l": 1,
    "t": 2
  }, {
    "p": [-217, 0, -356],
    "s": [4, 19, 2],
    "l": 1,
    "t": 2
  }, {
    "p": [-222, 0, -357],
    "s": [4, 14, 2],
    "l": 1,
    "t": 2
  }, {
    "p": [144, -28, -455],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -1.21, 0]
  }, {
    "p": [-239, 0, -479],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.88, 0]
  }, {
    "p": [260, 7, -182],
    "s": [4, 2, 16]
  }, {
    "p": [260, 7, -150],
    "s": [4, 2, 22]
  }, {
    "p": [335, 139, -35],
    "s": [12, 4, 6],
    "l": 1
  }, {
    "p": [362, 139, -62],
    "s": [6, 4, 12],
    "l": 1
  }, {
    "p": [212, 16, -461],
    "s": [20, 2, 4]
  }, {
    "p": [143, 14, -450],
    "s": [4, 2, 9]
  }, {
    "p": [268, 0, -64],
    "s": [2, 36, 80],
    "c": "#3e3e3e",
    "t": 5,
    "bo": 1
  }, {
    "p": [-69, -32, -345],
    "s": [150, 4, 76],
    "t": 1
  }, {
    "p": [-196, -2, -213],
    "s": [34, 2, 32],
    "t": 1
  }, {
    "p": [-210, 42, -361],
    "s": [76, 1, 12],
    "t": 2,
    "bo": 1
  }, {
    "p": [-247, 38, -360],
    "s": [2, 2, 12],
    "l": 1,
    "r": [0.7, 0, 0],
    "t": 2
  }, {
    "p": [-210, 38, -360],
    "s": [2, 2, 12],
    "l": 1,
    "r": [0.7, 0, 0],
    "t": 2
  }, {
    "p": [-174, 38, -360],
    "s": [2, 2, 12],
    "l": 1,
    "r": [0.7, 0, 0],
    "t": 2
  }, {
    "p": [-178, 43, -362],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [-184, 43, -360],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [-180, 51, -360],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [-228, 28, -368],
    "s": [1, 13, 1],
    "l": 1,
    "c": 11645361,
    "t": 2
  }, {
    "p": [-215, 0, -395],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -1.05, 0]
  }, {
    "p": [-415, 0, -444],
    "s": [58, 127, 90],
    "c": 10986917
  }, {
    "p": [-394, 127, -406],
    "s": [16, 3, 14],
    "l": 1,
    "c": 11645361
  }, {
    "p": [-394, 127, -481],
    "s": [16, 4, 16],
    "l": 1,
    "c": 11645361
  }, {
    "p": [-394, 127, -444],
    "s": [16, 3, 16],
    "l": 1,
    "c": 11184810
  }, {
    "p": [-434, 127, -407],
    "s": [20, 3, 16],
    "l": 1,
    "c": 10855331
  }, {
    "p": [-436, 127, -481],
    "s": [16, 3, 16],
    "l": 1,
    "c": 11645361
  }, {
    "p": [-210, 41, -368],
    "s": [76, 2, 2],
    "t": 2,
    "bo": 1
  }, {
    "p": [-345, 72, -526],
    "s": [40, 3, 3],
    "c": "#ffffff",
    "t": 2
  }, {
    "p": [-345, 72, -540],
    "s": [40, 3, 3],
    "c": "#ffffff",
    "t": 2
  }, {
    "p": [-345, 72, -533],
    "s": [3, 3, 40],
    "c": "#ffffff",
    "t": 2
  }, {
    "p": [-352, 90, -526],
    "s": [40, 3, 3],
    "l": 1,
    "r": [0, 0, 1.05],
    "c": "#ffffff",
    "t": 2
  }, {
    "p": [-345, 72, -526],
    "s": [3, 42, 3],
    "c": "#ffffff",
    "t": 2
  }, {
    "p": [-337, 90, -526],
    "s": [40, 3, 3],
    "l": 1,
    "r": [0, 0, -1.05],
    "c": "#ffffff",
    "t": 2
  }, {
    "p": [-337, 90, -540],
    "s": [40, 3, 3],
    "l": 1,
    "r": [0, 0, -1.05],
    "c": "#ffffff",
    "t": 2
  }, {
    "p": [-352, 90, -540],
    "s": [40, 3, 3],
    "l": 1,
    "r": [0, 0, 1.05],
    "c": "#ffffff",
    "t": 2
  }, {
    "p": [-345, 72, -540],
    "s": [3, 38, 3],
    "c": "#ffffff",
    "t": 2
  }, {
    "p": [-345, 86, -533],
    "s": [3, 3, 33],
    "c": "#ffffff",
    "t": 2
  }, {
    "p": [-345, 86, -540],
    "s": [21, 3, 3],
    "c": "#ffffff",
    "t": 2
  }, {
    "p": [-345, 86, -526],
    "s": [21, 3, 3],
    "c": "#ffffff",
    "t": 2
  }, {
    "p": [-345, 72, -514],
    "s": [3, 17, 3],
    "l": 1,
    "r": [-0.26, 0, 0],
    "c": "#ffffff",
    "t": 2
  }, {
    "p": [-345, 72, -552],
    "s": [3, 17, 3],
    "l": 1,
    "r": [0.26, 0, 0],
    "c": "#ffffff",
    "t": 2
  }, {
    "p": [-356, 98, -362],
    "s": [40, 3, 3],
    "c": "#ffffff",
    "t": 2
  }, {
    "p": [-356, 98, -376],
    "s": [40, 3, 3],
    "c": "#ffffff",
    "t": 2
  }, {
    "p": [-356, 98, -369],
    "s": [3, 3, 40],
    "c": "#ffffff",
    "t": 2
  }, {
    "p": [-363, 116, -362],
    "s": [40, 3, 3],
    "l": 1,
    "r": [0, 0, 1.05],
    "c": "#ffffff",
    "t": 2
  }, {
    "p": [-356, 98, -362],
    "s": [3, 42, 3],
    "c": "#ffffff",
    "t": 2
  }, {
    "p": [-348, 116, -362],
    "s": [40, 3, 3],
    "l": 1,
    "r": [0, 0, -1.05],
    "c": "#ffffff",
    "t": 2
  }, {
    "p": [-348, 116, -376],
    "s": [40, 3, 3],
    "l": 1,
    "r": [0, 0, -1.05],
    "c": "#ffffff",
    "t": 2
  }, {
    "p": [-363, 116, -376],
    "s": [40, 3, 3],
    "l": 1,
    "r": [0, 0, 1.05],
    "c": "#ffffff",
    "t": 2
  }, {
    "p": [-356, 98, -376],
    "s": [3, 42, 3],
    "c": "#ffffff",
    "t": 2
  }, {
    "p": [-356, 112, -369],
    "s": [3, 3, 33],
    "c": "#ffffff",
    "t": 2
  }, {
    "p": [-356, 112, -376],
    "s": [21, 3, 3],
    "c": "#ffffff",
    "t": 2
  }, {
    "p": [-356, 112, -362],
    "s": [21, 3, 3],
    "c": "#ffffff",
    "t": 2
  }, {
    "p": [-356, 140, -369],
    "s": [3, 3, 20],
    "c": "#ffffff",
    "t": 2
  }, {
    "p": [-359, 125, -369],
    "s": [9, 11, 6],
    "c": "#757575"
  }, {
    "p": [-346, 151, -369],
    "s": [41, 3, 3],
    "l": 1,
    "r": [0, 0, -2.45],
    "c": "#ffffff",
    "t": 2
  }, {
    "p": [-327, 164, -369],
    "s": [5, 2, 2],
    "l": 1,
    "r": [0, 0, 0.7],
    "c": "#ffffff",
    "t": 2
  }, {
    "p": [-326, 132, -369],
    "s": [1, 34, 1],
    "c": "#ffffff",
    "t": 2
  }, {
    "p": [-326, 129, -369],
    "s": [2, 3, 2],
    "c": "#343434",
    "t": 5
  }, {
    "p": [-356, 98, -350],
    "s": [3, 17, 3],
    "l": 1,
    "r": [-0.26, 0, 0],
    "c": "#ffffff",
    "t": 2
  }, {
    "p": [-356, 98, -388],
    "s": [3, 17, 3],
    "l": 1,
    "r": [0.26, 0, 0],
    "c": "#ffffff",
    "t": 2
  }, {
    "p": [-360, 136, -369],
    "s": [5, 3, 6],
    "c": "#757575"
  }, {
    "p": [-386, 90, -445],
    "s": [2, 19, 6],
    "l": 1,
    "c": 0
  }, {
    "p": [-386, 88, -445],
    "s": [6, 4, 12],
    "c": 11183011
  }, {
    "p": [-216, 48, -63],
    "s": [8, 2, 2],
    "l": 1,
    "r": [0, 0, 0.7],
    "t": 2
  }, {
    "p": [-207, 34, -63],
    "s": [1, 18, 1],
    "l": 1,
    "c": 11645361,
    "t": 2
  }, {
    "p": [378, 98, -463],
    "s": [40, 3, 3],
    "c": "#ffffff",
    "t": 2
  }, {
    "p": [378, 98, -477],
    "s": [40, 3, 3],
    "c": "#ffffff",
    "t": 2
  }, {
    "p": [378, 98, -470],
    "s": [3, 3, 40],
    "c": "#ffffff",
    "t": 2
  }, {
    "p": [371, 116, -463],
    "s": [40, 3, 3],
    "r": [0, 0, 1.05],
    "c": "#ffffff",
    "t": 2
  }, {
    "p": [378, 98, -463],
    "s": [3, 42, 3],
    "c": "#ffffff",
    "t": 2
  }, {
    "p": [386, 116, -463],
    "s": [40, 3, 3],
    "r": [0, 0, -1.05],
    "c": "#ffffff",
    "t": 2
  }, {
    "p": [386, 116, -477],
    "s": [40, 3, 3],
    "r": [0, 0, -1.05],
    "c": "#ffffff",
    "t": 2
  }, {
    "p": [371, 116, -477],
    "s": [40, 3, 3],
    "r": [0, 0, 1.05],
    "c": "#ffffff",
    "t": 2
  }, {
    "p": [378, 98, -477],
    "s": [3, 42, 3],
    "c": "#ffffff",
    "t": 2
  }, {
    "p": [378, 112, -470],
    "s": [3, 3, 33],
    "c": "#ffffff",
    "t": 2
  }, {
    "p": [378, 112, -477],
    "s": [21, 3, 3],
    "c": "#ffffff",
    "t": 2
  }, {
    "p": [378, 112, -463],
    "s": [21, 3, 3],
    "c": "#ffffff",
    "t": 2
  }, {
    "p": [378, 140, -470],
    "s": [3, 3, 20],
    "c": "#ffffff",
    "t": 2
  }, {
    "p": [383, 125, -470],
    "s": [9, 11, 6],
    "c": "#757575"
  }, {
    "p": [367, 150, -470],
    "s": [41, 3, 3],
    "l": 1,
    "r": [0, 0, -0.7],
    "c": "#ffffff",
    "t": 2
  }, {
    "p": [353, 165, -470],
    "s": [5, 2, 2],
    "l": 1,
    "r": [0, 0, 2.45],
    "c": "#522505",
    "t": 5
  }, {
    "p": [351, 131, -470],
    "s": [1, 34, 1],
    "c": "#522505",
    "t": 5
  }, {
    "p": [351, 128, -470],
    "s": [2, 3, 2],
    "c": "#343434",
    "t": 5
  }, {
    "p": [378, 98, -451],
    "s": [3, 17, 3],
    "r": [-0.26, 0, 0],
    "c": "#ffffff",
    "t": 2
  }, {
    "p": [378, 98, -489],
    "s": [3, 17, 3],
    "r": [0.26, 0, 0],
    "c": "#ffffff",
    "t": 2
  }, {
    "p": [383, 136, -470],
    "s": [5, 3, 6],
    "c": "#757575"
  }, {
    "p": [311, 112, -508],
    "s": [14, 4, 22],
    "l": 1,
    "c": "#b1b1b1"
  }, {
    "p": [347, 112, -500],
    "s": [22, 3, 6],
    "l": 1,
    "c": "#b1b1b1"
  }, {
    "p": [307, 112, -539],
    "s": [6, 3, 18],
    "l": 1,
    "c": "#b1b1b1"
  }, {
    "p": [253, 0, -457],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -1.04, 0]
  }, {
    "p": [219, 0, -106],
    "s": [4, 2, 3],
    "l": 1
  }, {
    "p": [234, 0, -112],
    "s": [3, 1, 4],
    "l": 1
  }, {
    "p": [219, 0, -142],
    "s": [3, 1, 4],
    "l": 1
  }, {
    "p": [313, 58, -449],
    "s": [6, 10, 6],
    "l": 1,
    "t": 2
  }, {
    "p": [393, 64, -477],
    "s": [88, 34, 70]
  }, {
    "p": [385, 98, -444],
    "s": [18, 3, 4],
    "l": 1
  }, {
    "p": [411, 98, -444],
    "s": [16, 3, 4],
    "l": 1
  }, {
    "p": [432, 98, -447],
    "s": [10, 3, 10],
    "l": 1
  }, {
    "p": [388, 89, -435],
    "s": [4, 4, 16],
    "t": 2
  }, {
    "p": [388, 85, -441],
    "s": [2, 2, 14],
    "l": 1,
    "r": [-0.7, 0, 0],
    "t": 2
  }, {
    "p": [282, -14, -128],
    "s": [7, 1, 4],
    "l": 1,
    "c": "#c5c5c5"
  }, {
    "p": [179, 67, -24],
    "s": [4, 5, 15],
    "l": 1
  }, {
    "p": [-224, 0, -104],
    "s": [31, 24, 54],
    "c": 4276545,
    "t": 5
  }, {
    "p": [-18, 18, 36],
    "s": [24, 36, 24],
    "i": 23,
    "l": 1,
    "tm": 0
  }, {
    "p": [-276, 10, -518],
    "s": [24, 36, 24],
    "i": 23,
    "l": 1,
    "tm": "1"
  }, {
    "p": [96, 8, -421],
    "s": [2, 6, 4],
    "pe": 1,
    "v": 1
  }, {
    "p": [221, 0, -97],
    "s": [4, 12, 12],
    "pe": 1,
    "v": 1
  }, {
    "p": [320, 0, -120],
    "s": [4, 7, 4],
    "pe": 1,
    "v": 1
  }, {
    "p": [138, 0, -150],
    "s": [4, 8, 6],
    "pe": 1,
    "v": 1
  }, {
    "p": [-156, 26, -514],
    "s": [57, 1, 26],
    "v": 1,
    "bo": 1
  }, {
    "p": [-306, 10, -511],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [3.14, 0.7, -3.14]
  }, {
    "p": [-253, 10, -542],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [3.14, -0.17, -3.14]
  }, {
    "p": [-304, 10, -542],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [3.14, -0.17, -3.14]
  }, {
    "p": [-252, 10, -475],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [3.14, -0.17, -3.14]
  }]
}, {
  "name": "Littletown",
  "ambInd": 1,
  "modURL": "",
  "terrainSeed": "",
  "terrainWidth": 2048,
  "terrainHeight": 2048,
  "terrainMntMlt": 1,
  "terrainMntCol": "#a0a0a0",
  "terrainGrsCol": "#4a6904",
  "terrainDrtCol": "#8c6835",
  "skyDome": false,
  "skyDomeCol0": "#3fb1b7",
  "skyDomeCol1": "#00cffc",
  "skyDomeCol2": "#1faedc",
  "zone": false,
  "zoneSize": 500,
  "zoneSpeed": 1,
  "zoneCol0": "#c542d9",
  "zoneCol1": "#c542d9",
  "zoneCol2": "#c542d9",
  "sizeMlt": 2,
  "shadowR": 1024,
  "ambient": 8093324,
  "light": 5461350,
  "sky": 6716054,
  "fog": 7832738,
  "fogD": 722.1829102596926,
  "dthY": -100,
  "nAmb": 1,
  "camPos": [36, 53, 252],
  "spawns": [[424, 0, -102, 0, 2], [-276, 0, 12, 0, 3], [-274, 0, 186, 0, 3], [287, 38, 32, 0, 2], [-156, 38, 33, 0, 3], [-95, 38, -4, 0], [384, 0, 87, 0, 2], [141, 0, 337, 0, 2]],
  "ambO": 0.7,
  "ambS": 5,
  "objects": [{
    "p": [138, 2, 6],
    "s": [4, 36, 60],
    "c": 12927811,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [205, 36, 30],
    "s": [62, 2, 108],
    "c": 7368816,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [238, 38, 45],
    "s": [4, 38, 74],
    "c": 16767158,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [170, 2, 123],
    "s": [30, 116, 18],
    "c": 7368816,
    "t": 11,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [-65, 2, 69],
    "s": [4, 30, 10],
    "c": 5799880,
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [304, 2, -7],
    "s": [2, 52, 12],
    "i": 3,
    "t": 2
  }, {
    "p": [138, 38, 3],
    "s": [4, 6, 38],
    "c": 12927811,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [138, 38, 81],
    "s": [4, 6, 34],
    "c": 12927811,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [138, 38, 43],
    "s": [4, 46, 42],
    "c": 12927811,
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [138, 38, 104],
    "s": [4, 40, 12],
    "c": 12927811,
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [138, 38, -20],
    "s": [4, 51, 8],
    "c": 12927811,
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [138, 66, 3],
    "s": [4, 21, 38],
    "c": 12927811,
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [138, 2, 81],
    "s": [4, 36, 58],
    "c": 12927811,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [138, 26, 44],
    "s": [4, 12, 16],
    "c": 12927811,
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [220, 2, 112],
    "s": [168, 74, 4],
    "c": 12927811,
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [205, 2, -26],
    "s": [138, 88, 4],
    "c": 12927811,
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [297, 2, -26],
    "s": [14, 88, 4],
    "c": 12927811,
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [282, 26, -26],
    "s": [16, 64, 4],
    "c": 12927811,
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [302, 38, 16],
    "s": [4, 46, 80],
    "c": 12927811,
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [302, 79, 74],
    "s": [4, 3, 4],
    "c": 12927811,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [302, 62, 64],
    "s": [4, 20, 16],
    "c": 12927811,
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [302, 2, 25],
    "s": [4, 36, 98],
    "c": 12927811,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [302, 2, 100],
    "s": [4, 36, 20],
    "c": 12927811,
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [302, 26, 82],
    "s": [4, 12, 16],
    "c": 12927811,
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [238, 38, -16],
    "s": [4, 38, 16],
    "c": 16767158,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [238, 64, 0],
    "s": [4, 12, 16],
    "c": 16767158,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [176, 34, 98],
    "s": [4, 42, 24],
    "c": 16767158,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [291, 38, 84],
    "s": [18, 38, 4],
    "c": 16767158,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [262, 38, 84],
    "s": [8, 38, 4],
    "c": 16767158,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [274, 62, 84],
    "s": [16, 14, 4],
    "c": 16767158,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [216, 2, 84],
    "s": [84, 74, 4],
    "c": 16767158,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [256, 2, 98],
    "s": [4, 36, 24],
    "c": 16767158,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [238, 2, 67],
    "s": [4, 36, 30],
    "c": 16767158,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [238, 2, -5],
    "s": [4, 36, 38],
    "c": 16767158,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [238, 26, 33],
    "s": [4, 12, 38],
    "c": 16767158,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [157, 36, 43],
    "s": [34, 2, 134],
    "c": 7368816,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [270, 36, 30],
    "s": [60, 2, 108],
    "c": 7368816,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [279, 36, 97],
    "s": [42, 2, 26],
    "c": 7368816,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [220, 0, 43],
    "s": [172, 2, 146],
    "c": 7368816,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [183, 0, -75],
    "s": [150, 2, 98],
    "c": 7368816,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [158, 2, -31],
    "s": [4, 30, 6],
    "c": 12927811,
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [158, 2, -74],
    "s": [4, 30, 4],
    "c": 12927811,
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [158, 2, -117],
    "s": [4, 30, 2],
    "c": 12927811,
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [158, 32, -73],
    "s": [4, 12, 90],
    "c": 12927811,
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [254, 2, -60],
    "s": [4, 42, 64],
    "c": 12927811,
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [254, 2, -113],
    "s": [4, 42, 10],
    "c": 12927811,
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [254, 26, -100],
    "s": [4, 18, 16],
    "c": 12927811,
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [206, 2, -120],
    "s": [100, 42, 4],
    "c": 12927811,
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [158, 2, -96],
    "s": [2, 30, 42],
    "pe": 1,
    "c": "#ffffff",
    "t": 10,
    "ts": 0,
    "td": 0
  }, {
    "p": [170, 0, 125],
    "s": [34, 2, 18],
    "c": 7368816,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [260, 0, -100],
    "s": [4, 2, 20],
    "c": 7368816,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [308, 0, 82],
    "s": [4, 2, 20],
    "c": 7368816,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-41, 0, -24],
    "s": [4, 2, 20],
    "c": 7368816,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [282, 0, -32],
    "s": [20, 2, 4],
    "c": 7368816,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [29, -1, 323],
    "s": [106, 2, 845],
    "c": 3750201,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-65, 32, 115],
    "s": [4, 12, 102],
    "c": 5799880,
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [-65, 2, 115],
    "s": [4, 30, 10],
    "c": 5799880,
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [-65, 2, 161],
    "s": [4, 30, 10],
    "c": 5799880,
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [-145, 2, 161],
    "s": [4, 42, 10],
    "c": 5799880,
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [-145, 2, 102],
    "s": [4, 42, 76],
    "c": 5799880,
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [-105, 2, 168],
    "s": [84, 42, 4],
    "c": 5799880,
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [-145, 26, 148],
    "s": [4, 18, 16],
    "c": 5799880,
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [-65, 2, 139],
    "s": [2, 30, 42],
    "pe": 1,
    "t": 10,
    "ts": 0,
    "td": 0
  }, {
    "p": [-91, 0, 118],
    "s": [116, 2, 108],
    "c": 7368816,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-113, 0, -16],
    "s": [140, 2, 164],
    "c": 7368816,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-142, 2, 62],
    "s": [30, 74, 4],
    "c": 5799880,
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [-78, 2, 62],
    "s": [66, 74, 4],
    "c": 5799880,
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [-113, 2, -94],
    "s": [136, 74, 4],
    "c": 5799880,
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [-47, 66, -16],
    "s": [4, 10, 152],
    "c": 5799880,
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [-47, 38, -77],
    "s": [4, 28, 30],
    "c": 5799880,
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [-47, 38, -3],
    "s": [4, 28, 42],
    "c": 5799880,
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [-47, 38, 35],
    "s": [4, 6, 34],
    "c": 5799880,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-47, 38, -43],
    "s": [4, 6, 38],
    "c": 5799880,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-47, 38, 56],
    "s": [4, 28, 8],
    "c": 5799880,
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [-47, 2, -62],
    "s": [4, 36, 60],
    "c": 5799880,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-47, 26, -24],
    "s": [4, 12, 16],
    "c": 5799880,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-177, 2, 62],
    "s": [8, 74, 4],
    "c": 5799880,
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [-179, 2, 5],
    "s": [4, 74, 110],
    "c": 5799880,
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [-179, 2, -79],
    "s": [4, 74, 26],
    "c": 5799880,
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [-119, 26, 62],
    "s": [16, 50, 4],
    "c": 5799880,
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [-165, 26, 62],
    "s": [16, 50, 4],
    "c": 5799880,
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [-140, 2, -80],
    "s": [4, 36, 24],
    "c": 16767158,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-105, 2, -66],
    "s": [74, 74, 4],
    "c": 16767158,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-70, 34, -80],
    "s": [4, 42, 24],
    "c": 16767158,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-179, 26, -58],
    "s": [4, 12, 16],
    "c": 5799880,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-58, 36, -16],
    "s": [20, 2, 152],
    "c": 7368816,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-134, 2, 32],
    "s": [4, 28, 56],
    "c": 16767158,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-134, 2, -49],
    "s": [4, 28, 30],
    "c": 16767158,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-134, 30, -2],
    "s": [4, 8, 124],
    "c": 16767158,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-100, 36, -2],
    "s": [64, 2, 124],
    "c": 7368816,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-157, 36, -3],
    "s": [42, 2, 126],
    "c": 7368816,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-160, 36, -79],
    "s": [36, 2, 26],
    "c": 7368816,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-179, 62, -58],
    "s": [4, 14, 16],
    "c": 5799880,
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [-134, 38, -57],
    "s": [4, 38, 14],
    "c": 16767158,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-134, 38, 13],
    "s": [4, 38, 94],
    "c": 16767158,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-134, 60, -42],
    "s": [4, 16, 16],
    "c": 16767158,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [337, -2, 99],
    "s": [4, 40, 4],
    "pe": 1,
    "c": 7692103,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [306, -2, 99],
    "s": [4, 40, 4],
    "pe": 1,
    "c": 7692103,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [337, -2, 5],
    "s": [4, 40, 4],
    "pe": 1,
    "c": 7692103,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [306, -2, 5],
    "s": [4, 40, 4],
    "pe": 1,
    "c": 7692103,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [322, 34, 52],
    "s": [36, 2, 100],
    "pe": 1,
    "c": 7692103,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-199, 34, -47],
    "s": [36, 2, 82],
    "pe": 1,
    "c": 7692103,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-214, -1, -9],
    "s": [4, 38, 4],
    "pe": 1,
    "c": 7692103,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-214, -1, -85],
    "s": [4, 38, 4],
    "pe": 1,
    "c": 7692103,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-183, -1, -85],
    "s": [4, 38, 4],
    "pe": 1,
    "c": 7692103,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-183, -1, -9],
    "s": [4, 38, 4],
    "pe": 1,
    "c": 7692103,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [132, 0, 44],
    "s": [4, 2, 20],
    "c": 7368816,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-185, 0, -58],
    "s": [4, 2, 20],
    "c": 7368816,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-151, 0, 148],
    "s": [4, 2, 20],
    "c": 7368816,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-165, 0, 68],
    "s": [18, 2, 4],
    "c": 7368816,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-113, 76, -16],
    "s": [146, 4, 170],
    "c": 5263440,
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [-105, 44, 119],
    "s": [94, 4, 112],
    "c": 5263440,
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [220, 75, 42],
    "s": [165, 4, 137],
    "c": 5263440,
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [206, 44, -77],
    "s": [108, 4, 98],
    "c": 5263440,
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [-79, 2, -105],
    "s": [30, 118, 18],
    "c": 7368816,
    "t": 11,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [-79, 0, -107],
    "s": [34, 2, 18],
    "c": 7368816,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [32, 2, -207],
    "s": [124, 74, 150],
    "c": 12958048,
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [32, 74, -207],
    "s": [136, 4, 162],
    "c": 5263440,
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [32, 0, -207],
    "s": [128, 2, 154],
    "c": 7368816,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [94, -1, 159],
    "s": [4, 26, 4],
    "c": 7692103,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [94, -1, 217],
    "s": [2, 24, 113],
    "pe": 1,
    "c": 7692103,
    "t": 10,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [246, -1, 159],
    "s": [302, 24, 2],
    "pe": 1,
    "c": 7692103,
    "t": 10,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [-37, -1, 235],
    "s": [2, 24, 58],
    "pe": 1,
    "c": 7692103,
    "t": 10,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [-37, -1, 205],
    "s": [4, 26, 4],
    "c": 7692103,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-163, -1, 205],
    "s": [254, 24, 2],
    "pe": 1,
    "c": 7692103,
    "t": 10,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [398, -1, 159],
    "s": [4, 26, 4],
    "c": 7692103,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [399, -1, 59],
    "s": [2, 24, 206],
    "c": 7692103,
    "t": 10,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [399, -1, -156],
    "s": [4, 26, 4],
    "c": 7692103,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [260, -1, -157],
    "s": [340, 24, 2],
    "c": 7692103,
    "t": 10,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [-161, -1, -157],
    "s": [262, 24, 2],
    "c": 7692103,
    "t": 10,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [-290, -1, 204],
    "s": [4, 26, 4],
    "c": 7692103,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-291, -1, 24],
    "s": [2, 24, 358],
    "c": 7692103,
    "t": 10,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [-290, -1, -156],
    "s": [4, 26, 4],
    "c": 7692103,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-181, 2, 3],
    "s": [2, 52, 12],
    "i": 3,
    "t": 2,
    "d": 2
  }, {
    "p": [32, 0, -121],
    "s": [48, 2, 18],
    "c": 7368816,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [32, 39, -123],
    "s": [46, 3, 19],
    "l": 1,
    "c": 5263440,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-251, -1, 173],
    "s": [2, 24, 63],
    "pe": 1,
    "c": 7692103,
    "t": 10,
    "ts": 0,
    "td": 0
  }, {
    "p": [-267, 0, 73],
    "s": [46, 30, 42],
    "c": 5799880,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-267, 30, 73],
    "s": [54, 2, 50],
    "c": 5395026,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [343, 0, -138],
    "s": [52, 32, 36],
    "c": 12927811,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [343, 32, -138],
    "s": [56, 2, 40],
    "c": 5263440,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [399, -1, -46],
    "s": [4, 26, 4],
    "c": 7692103,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [416, -1, -45],
    "s": [30, 24, 2],
    "c": 7692103,
    "t": 10,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [431, -1, -46],
    "s": [4, 26, 4],
    "c": 7692103,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [432, -1, -101],
    "s": [2, 24, 110],
    "c": 7692103,
    "t": 10,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [431, -1, -156],
    "s": [4, 26, 4],
    "c": 7692103,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-250, -1, 16],
    "s": [8, 24, 72],
    "pe": 1,
    "c": 6984507,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-213, -1, -120],
    "s": [8, 10, 20],
    "pe": 1,
    "c": 6984507,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-232, 26, -143],
    "s": [58, 2, 32],
    "c": 7039851,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-232, 0, -143],
    "s": [52, 26, 26],
    "c": 5799880,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-233, -1, 86],
    "s": [22, 10, 8],
    "pe": 1,
    "c": 6984507,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [313, -1, -134],
    "s": [8, 10, 44],
    "c": 6984507,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-144, -1, -154],
    "s": [124, 10, 5],
    "c": 6984507,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [435, 0, -16],
    "s": [52, 32, 36],
    "c": 12927811,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [435, 32, -16],
    "s": [56, 2, 40],
    "c": 5263440,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [399, -2, -100],
    "s": [8, 20, 56],
    "pe": 1,
    "c": 6984507,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [342, -1, 52],
    "s": [6, 10, 104],
    "pe": 1,
    "c": 6984507,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-251, -1, 205],
    "s": [4, 26, 4],
    "c": 7692103,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-251, -1, 106],
    "s": [2, 24, 25],
    "pe": 1,
    "c": 7692103,
    "t": 10,
    "ts": 0,
    "td": 0
  }, {
    "p": [151, 2, -99],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [340, 0, -114],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [108, 0, 152],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [108, 12, 152],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [191, 2, -112],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [246, 2, -50],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-137, 2, 116],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-104, 2, 160],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-56, 0, 198],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-56, 12, 198],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-140, 2, 106],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [249, 2, -59],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [-202, 0, -148],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [-92, 2, 160],
    "s": [12, 12, 12],
    "i": 8
  }, {
    "p": [203, 2, -112],
    "s": [12, 12, 12],
    "i": 8
  }, {
    "p": [130, 34, 79],
    "s": [12, 2, 42],
    "pe": 1,
    "c": 7692103,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [136, 2, 105],
    "s": [2, 42, 8],
    "i": 3,
    "t": 2,
    "d": 2
  }, {
    "p": [-47, 44, 35],
    "s": [1, 22, 34],
    "pe": 1,
    "c": 9533019,
    "t": 10,
    "ts": 0,
    "td": 0
  }, {
    "p": [-219, -1, 176],
    "s": [4, 32, 4],
    "pe": 1,
    "c": 6574655,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-219, 30, 176],
    "s": [26, 26, 28],
    "c": 6193707,
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [-219, 20, 181],
    "s": [2, 2, 8],
    "pe": 1,
    "c": 6574655,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-219, 19, 188],
    "s": [6, 6, 8],
    "pe": 1,
    "c": 6193707,
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [-224, 18, 176],
    "s": [6, 2, 2],
    "pe": 1,
    "c": 6574655,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-229, 17, 176],
    "s": [6, 4, 6],
    "pe": 1,
    "c": 6193707,
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [375, -1, 138],
    "s": [4, 32, 4],
    "pe": 1,
    "c": 6574655,
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [375, 29, 138],
    "s": [26, 26, 28],
    "c": 6193707,
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [375, 19, 133],
    "s": [2, 2, 8],
    "c": 6574655,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [375, 18, 127],
    "s": [6, 6, 8],
    "c": 6193707,
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [371, 15, 138],
    "s": [6, 2, 2],
    "c": 6574655,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [365, 14, 138],
    "s": [6, 4, 6],
    "c": 6193707,
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [37, 1, -78],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [49, 1, -78],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [44, 1, -66],
    "s": [12, 12, 12],
    "i": 8
  }, {
    "p": [41, 13, -78],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [130, 2, 51],
    "s": [16, 24, 2],
    "pe": 1,
    "c": 7692103,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-39, 2, -31],
    "s": [16, 24, 2],
    "pe": 1,
    "c": 7692103,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [29, 1, 225],
    "s": [51, 15, 20],
    "i": 7,
    "l": 1
  }, {
    "p": [-125, -1, 175],
    "s": [4, 22, 2],
    "l": 1,
    "r": [-0.17, 0, 0],
    "c": 7692103,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-113, 0, 175],
    "s": [4, 22, 2],
    "l": 1,
    "r": [-0.17, 0, 0],
    "c": 7692103,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [154, 2, -46],
    "s": [51, 15, 20],
    "i": 7,
    "l": 1,
    "r": [-3.14, 0, -3.14]
  }, {
    "p": [-60, 2, 115],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [169, 0, -150],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [90, 0, 175],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [395, 0, 28],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [-246, 0, 112],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [29, 1, 225],
    "s": [48, 8, 16],
    "v": 1,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [34, 8, 225],
    "s": [24, 8, 16],
    "v": 1,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [148, 9, -45],
    "s": [24, 8, 16],
    "v": 1,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [154, 3, -45],
    "s": [48, 8, 16],
    "v": 1,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [138, 44, 3],
    "s": [1, 22, 38],
    "pe": 1,
    "c": 7692103,
    "t": 10,
    "ts": 0,
    "td": 0
  }, {
    "p": [117, 21, 180],
    "s": [26, 28, 28],
    "l": 1,
    "c": 5204775,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [117, -1, 180],
    "s": [4, 28, 4],
    "l": 1,
    "c": 6574655,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-64, -1, 235],
    "s": [4, 31, 4],
    "l": 1,
    "c": 6574655,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-64, 21, 235],
    "s": [26, 28, 28],
    "l": 1,
    "c": 7709238,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-42, 23, 288],
    "s": [27, 28, 24],
    "pe": 1,
    "c": 6193707,
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [-37, -1, 265],
    "s": [4, 26, 4],
    "c": 7692103,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [94, -1, 275],
    "s": [4, 26, 4],
    "c": 7692103,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-42, -1, 289],
    "s": [4, 31, 4],
    "pe": 1,
    "c": 6574655,
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [-315, -1, 13],
    "s": [4, 31, 4],
    "l": 1,
    "c": 6574655,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-321, -1, -132],
    "s": [4, 31, 4],
    "l": 1,
    "c": 6574655,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [459, 14, -62],
    "s": [26, 27, 35],
    "l": 1,
    "c": 6324784,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [207, 17, -188],
    "s": [26, 25, 28],
    "l": 1,
    "c": 5204775,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-102, 16, -181],
    "s": [26, 28, 28],
    "l": 1,
    "c": 5204775,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-320, 19, 175],
    "s": [26, 28, 28],
    "l": 1,
    "c": 7709238,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [85, 0, 188],
    "s": [2, 73, 2],
    "c": 7368816,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [79, 71, 188],
    "s": [10, 2, 2],
    "c": 7368816,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [75, 70, 498],
    "s": [10, 2, 4],
    "l": 1,
    "c": 7368816,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [75, 69, 188],
    "s": [9, 1, 3],
    "l": 1,
    "c": 0,
    "e": 16767098,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-27, 0, 332],
    "s": [2, 73, 2],
    "c": 7368816,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-21, 71, 332],
    "s": [10, 2, 2],
    "c": 7368816,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-17, 70, 332],
    "s": [10, 2, 4],
    "c": 7368816,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-17, 69, 332],
    "s": [9, 1, 3],
    "l": 1,
    "c": 0,
    "e": 16767098,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-9, 0, -104],
    "s": [2, 73, 2],
    "c": 7368816,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-9, 71, -99],
    "s": [2, 2, 8],
    "c": 7368816,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-9, 69, -96],
    "s": [2, 1, 8],
    "l": 1,
    "c": 0,
    "e": 16767098,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-9, 70, -96],
    "s": [3, 2, 9],
    "c": 7368816,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [279, 15, 184],
    "s": [26, 28, 28],
    "l": 1,
    "c": 6193707,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-321, 11, -132],
    "s": [26, 30, 28],
    "l": 1,
    "c": 7709238,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [230, 2, 2],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [246, 2, 62],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [246, 38, 28],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [190, 38, 76],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-126, 38, 36],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-171, 38, -16],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-126, 2, -58],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-55, 2, -1],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-84, 38, 56],
    "s": [4, 22, 2],
    "l": 1,
    "r": [0.17, 0, 0],
    "c": 7692103,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-76, 38, 56],
    "s": [4, 22, 2],
    "l": 1,
    "r": [0.17, 0, 0],
    "c": 7692103,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-96, 38, 56],
    "s": [4, 22, 2],
    "l": 1,
    "r": [0.17, 0, 0],
    "c": 7692103,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-114, 39, 29],
    "s": [4, 0, 5],
    "i": 4,
    "l": 1,
    "r": [0, 0.52, 0],
    "c": 10987431,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-81, 39, 47],
    "s": [4, 0, 5],
    "i": 4,
    "l": 1,
    "r": [0, -0.53, 0],
    "c": 11645361,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-144, 39, -57],
    "s": [4, 0, 5],
    "i": 4,
    "l": 1,
    "r": [0, -0.53, 0],
    "c": 10658466,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-109, 3, -53],
    "s": [4, 0, 5],
    "i": 4,
    "l": 1,
    "r": [0, -0.53, 0],
    "c": 11184810,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [60, 2, -62],
    "s": [4, 0, 5],
    "i": 4,
    "l": 1,
    "r": [0, -0.53, 0],
    "c": 9671571,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [8, 2, 178],
    "s": [4, 0, 5],
    "i": 4,
    "l": 1,
    "r": [0, -0.53, 0],
    "c": 10329501,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-120, 38, 28],
    "s": [2, 4, 2],
    "l": 1,
    "pe": 1,
    "c": 5211204,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-67, 39, -59],
    "s": [4, 0, 5],
    "i": 4,
    "l": 1,
    "r": [-3.14, 1.05, -3.14],
    "c": 10987431,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-120, 40, 28],
    "s": [1, 4, 1],
    "l": 1,
    "pe": 1,
    "c": 5211204,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-53, 38, 55],
    "s": [2, 4, 2],
    "l": 1,
    "pe": 1,
    "c": 5211204,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-53, 40, 55],
    "s": [1, 4, 1],
    "l": 1,
    "pe": 1,
    "c": 5211204,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-80, 38, -62],
    "s": [2, 4, 2],
    "l": 1,
    "pe": 1,
    "c": 5211204,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-80, 40, -62],
    "s": [1, 4, 1],
    "l": 1,
    "pe": 1,
    "c": 5211204,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-138, 38, -11],
    "s": [2, 4, 2],
    "l": 1,
    "pe": 1,
    "c": 5211204,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-138, 40, -11],
    "s": [1, 4, 1],
    "l": 1,
    "pe": 1,
    "c": 5211204,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-142, 39, -5],
    "s": [4, 0, 5],
    "i": 4,
    "l": 1,
    "r": [3.14, -1.04, 3.14],
    "c": 10658466,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-89, 38, -58],
    "s": [12, 12, 12],
    "i": 8
  }, {
    "p": [-70, 3, 108],
    "s": [4, 0, 5],
    "i": 4,
    "l": 1,
    "r": [-3.14, 1.05, -3.14],
    "c": 10987431,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-86, 2, 66],
    "s": [2, 4, 2],
    "l": 1,
    "pe": 1,
    "c": 5211204,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-86, 4, 66],
    "s": [1, 4, 1],
    "l": 1,
    "pe": 1,
    "c": 5211204,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-106, 3, 127],
    "s": [4, 0, 5],
    "i": 4,
    "l": 1,
    "r": [-3.14, 1.05, -3.14],
    "c": 10987431,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-103, 3, 119],
    "s": [4, 0, 5],
    "i": 4,
    "l": 1,
    "r": [0, 0.7, 0],
    "c": 10987431,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-92, 4, 58],
    "s": [1, 4, 1],
    "l": 1,
    "pe": 1,
    "c": 5211204,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-92, 2, 58],
    "s": [2, 4, 2],
    "l": 1,
    "pe": 1,
    "c": 5211204,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [173, 2, -20],
    "s": [1, 8, 7],
    "pe": 1,
    "c": 7692103,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [195, 2, -20],
    "s": [1, 8, 7],
    "pe": 1,
    "c": 7692103,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [184, 9, -20],
    "s": [11, 1, 4],
    "pe": 1,
    "c": 3421236,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [184, 8, -20],
    "s": [21, 1, 6],
    "pe": 1,
    "c": 7692103,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [184, 10, -20],
    "s": [2, 1, 1],
    "pe": 1,
    "c": 3421236,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [184, 11, -20],
    "s": [22, 11, 1],
    "pe": 1,
    "c": 3421236,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [184, 12, -19],
    "s": [20, 9, 1],
    "pe": 1,
    "c": 3421236,
    "e": 16777215,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [164, 3, -13],
    "s": [4, 0, 5],
    "i": 4,
    "l": 1,
    "r": [0, -0.53, 0],
    "c": 9671571,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [235, 3, 48],
    "s": [4, 0, 5],
    "i": 4,
    "l": 1,
    "r": [-3.14, 1.4, -3.14],
    "c": 9671571,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [143, 2, 84],
    "s": [1, 17, 3],
    "l": 1,
    "r": [0, 0, 0.17],
    "c": 7692103,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [143, 2, 80],
    "s": [1, 17, 3],
    "l": 1,
    "r": [0, 0, 0.17],
    "c": 7692103,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [225, 3, 68],
    "s": [4, 0, 5],
    "i": 4,
    "l": 1,
    "r": [0, -0.53, 0],
    "c": 9671571,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [258, 30, -100],
    "s": [8, 1, 1],
    "l": 1,
    "c": 9012870,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [261, 28, -100],
    "s": [5, 2, 3],
    "l": 1,
    "c": 9012870,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [261, 27, -100],
    "s": [4, 1, 2],
    "l": 1,
    "c": 0,
    "e": 16767098,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-152, 27, 148],
    "s": [5, 2, 3],
    "l": 1,
    "c": 9012870,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-150, 29, 148],
    "s": [6, 1, 1],
    "l": 1,
    "c": 9012870,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-152, 26, 148],
    "s": [4, 1, 2],
    "l": 1,
    "c": 0,
    "e": 16767098,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-242, 26, 73],
    "s": [4, 1, 1],
    "l": 1,
    "c": 9012870,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-240, 24, 73],
    "s": [4, 2, 3],
    "l": 1,
    "c": 9012870,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-240, 23, 73],
    "s": [3, 1, 2],
    "l": 1,
    "c": 0,
    "e": 16767098,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-234, 22, -128],
    "s": [1, 1, 4],
    "l": 1,
    "c": 9012870,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-234, 20, -126],
    "s": [3, 2, 4],
    "l": 1,
    "c": 9012870,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-234, 19, -126],
    "s": [2, 1, 3],
    "l": 1,
    "c": 0,
    "e": 16767098,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [306, 65, 63],
    "s": [8, 1, 1],
    "l": 1,
    "c": 9012870,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [309, 63, 63],
    "s": [5, 2, 3],
    "l": 1,
    "c": 9012870,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [309, 62, 63],
    "s": [4, 1, 2],
    "l": 1,
    "c": 0,
    "e": 16767098,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [198, 0, 242],
    "s": [123, 42, 120],
    "c": 5799880,
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [198, 42, 242],
    "s": [130, 2, 128],
    "c": 8553090,
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [167, 0, 311],
    "s": [30, 61, 18],
    "c": 7368816,
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [303, 6, 186],
    "s": [23, 27, 23],
    "l": 1,
    "c": 4743462,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [331, 10, 205],
    "s": [31, 30, 30],
    "l": 1,
    "c": 7576379,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-121, 0, 322],
    "s": [123, 60, 120],
    "c": 12951902,
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [-121, 60, 322],
    "s": [130, 2, 126],
    "c": 6908265,
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [-58, 35, 356],
    "s": [3, 1, 14],
    "l": 1,
    "c": 6250335,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-58, 36, 356],
    "s": [1, 12, 1],
    "l": 1,
    "c": 6250335,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-59, 36, 362],
    "s": [2, 12, 1],
    "l": 1,
    "c": 6250335,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-59, 36, 350],
    "s": [2, 12, 1],
    "l": 1,
    "c": 6250335,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-59, 48, 356],
    "s": [3, 1, 14],
    "l": 1,
    "c": 6250335,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-59, 36, 356],
    "s": [1, 12, 11],
    "l": 1,
    "c": 0,
    "e": 16767098,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-112, 35, 261],
    "s": [14, 1, 3],
    "l": 1,
    "c": 6250335,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-112, 36, 262],
    "s": [1, 12, 2],
    "l": 1,
    "c": 6250335,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-106, 36, 262],
    "s": [1, 12, 2],
    "l": 1,
    "c": 6250335,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-118, 36, 262],
    "s": [1, 12, 2],
    "l": 1,
    "c": 6250335,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-112, 48, 262],
    "s": [14, 1, 3],
    "l": 1,
    "c": 6250335,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-112, 36, 262],
    "s": [11, 12, 1],
    "l": 1,
    "c": 0,
    "e": 16767098,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [77, 49, -131],
    "s": [14, 1, 3],
    "l": 1,
    "c": 6250335,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [77, 50, -132],
    "s": [11, 12, 1],
    "l": 1,
    "c": 0,
    "e": 16767098,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [71, 50, -132],
    "s": [1, 12, 2],
    "l": 1,
    "c": 6250335,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [83, 50, -132],
    "s": [1, 12, 2],
    "l": 1,
    "c": 6250335,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [77, 62, -132],
    "s": [14, 1, 3],
    "l": 1,
    "c": 6250335,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [77, 50, -132],
    "s": [1, 12, 2],
    "l": 1,
    "c": 6250335,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [95, 47, -163],
    "s": [3, 1, 14],
    "l": 1,
    "c": 6250335,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [94, 48, -163],
    "s": [1, 12, 11],
    "l": 1,
    "c": 0,
    "e": 16767098,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [93, 48, -157],
    "s": [4, 13, 1],
    "l": 1,
    "c": 6250335,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [94, 60, -163],
    "s": [3, 1, 14],
    "l": 1,
    "c": 6250335,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [93, 48, -169],
    "s": [4, 13, 1],
    "l": 1,
    "c": 6250335,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [93, 48, -163],
    "s": [4, 13, 1],
    "l": 1,
    "c": 6250335,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [32, 0, -109],
    "s": [23, 2, 6],
    "c": 7368816,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [113, -1, 298],
    "s": [4, 28, 4],
    "c": 6574655,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [114, 22, 298],
    "s": [26, 28, 28],
    "c": 5204775,
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [-121, 0, 322],
    "s": [135, 8, 133],
    "c": 6193707,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [124, 11, -198],
    "s": [26, 28, 28],
    "l": 1,
    "c": 5204775,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [418, 15, -183],
    "s": [26, 33, 28],
    "l": 1,
    "c": 7247414,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [163, 2, 422],
    "s": [113, 78, 116],
    "c": 12927811,
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [165, 0, 419],
    "s": [134, 8, 126],
    "c": 6193707,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [85, 0, 498],
    "s": [2, 73, 2],
    "l": 1,
    "c": 7368816,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [79, 71, 498],
    "s": [10, 2, 2],
    "l": 1,
    "c": 7368816,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [75, 70, 188],
    "s": [10, 2, 4],
    "c": 7368816,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [75, 69, 498],
    "s": [9, 1, 3],
    "l": 1,
    "c": 0,
    "e": 16767098,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [163, 80, 422],
    "s": [123, 3, 125],
    "l": 1,
    "c": 5921370,
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [106, 54, 387],
    "s": [1, 12, 11],
    "l": 1,
    "c": 0,
    "e": 16767098,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [105, 53, 387],
    "s": [3, 1, 14],
    "l": 1,
    "c": 6250335,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [105, 66, 387],
    "s": [3, 1, 14],
    "l": 1,
    "c": 6250335,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [106, 54, 393],
    "s": [2, 12, 1],
    "l": 1,
    "c": 6250335,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [106, 54, 381],
    "s": [2, 12, 1],
    "l": 1,
    "c": 6250335,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [106, 54, 387],
    "s": [2, 12, 1],
    "l": 1,
    "c": 6250335,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [106, 54, 452],
    "s": [1, 12, 11],
    "l": 1,
    "c": 0,
    "e": 16767098,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [105, 53, 452],
    "s": [3, 1, 14],
    "l": 1,
    "c": 6250335,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [105, 66, 452],
    "s": [3, 1, 14],
    "l": 1,
    "c": 6250335,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [106, 54, 446],
    "s": [2, 12, 1],
    "l": 1,
    "c": 6250335,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [106, 54, 458],
    "s": [2, 12, 1],
    "l": 1,
    "c": 6250335,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [106, 54, 452],
    "s": [2, 12, 1],
    "l": 1,
    "c": 6250335,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [253, -1, 376],
    "s": [4, 28, 4],
    "l": 1,
    "c": 6574655,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [253, 22, 376],
    "s": [26, 28, 28],
    "l": 1,
    "c": 5204775,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-224, 19, 248],
    "s": [26, 28, 28],
    "l": 1,
    "c": 7709238,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-224, -1, 248],
    "s": [4, 23, 4],
    "l": 1,
    "c": 6574655,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-89, 0, 470],
    "s": [104, 135, 116],
    "c": 10658466,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-30, -1, 392],
    "s": [4, 31, 4],
    "c": 6574655,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-30, 23, 392],
    "s": [27, 28, 24],
    "c": 6193707,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-89, 135, 470],
    "s": [110, 3, 122],
    "l": 1,
    "c": 5921370,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-89, 65, 470],
    "s": [111, 5, 124],
    "c": 5921370,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-27, 0, 651],
    "s": [2, 73, 2],
    "l": 1,
    "c": 7368816,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-21, 71, 651],
    "s": [10, 2, 2],
    "l": 1,
    "c": 7368816,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-17, 70, 651],
    "s": [10, 2, 4],
    "l": 1,
    "c": 7368816,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-17, 69, 651],
    "s": [9, 1, 3],
    "l": 1,
    "c": 0,
    "e": 16767098,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [107, -1, 504],
    "s": [4, 31, 4],
    "l": 1,
    "c": 6574655,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [107, 21, 504],
    "s": [27, 28, 24],
    "l": 1,
    "c": 6193707,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [156, 0, 621],
    "s": [123, 84, 120],
    "l": 1,
    "c": 12951902,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-97, 0, 686],
    "s": [123, 52, 120],
    "l": 1,
    "c": 5799880,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-97, 52, 686],
    "s": [131, 4, 132],
    "l": 1,
    "c": 5723991,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [156, 84, 621],
    "s": [131, 5, 132],
    "l": 1,
    "c": 5723991,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [489, 22, 19],
    "s": [26, 28, 28],
    "l": 1,
    "c": 6324784,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [424, 18, 101],
    "s": [26, 28, 28],
    "l": 1,
    "c": 6324784,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [427, 15, 26],
    "s": [27, 30, 30],
    "l": 1,
    "c": 7576379,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [387, 13, 187],
    "s": [23, 27, 23],
    "l": 1,
    "c": 4743462,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [458, 18, 69],
    "s": [23, 24, 27],
    "l": 1,
    "c": 4743462,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [727, 0, -41],
    "s": [104, 74, 79],
    "l": 1,
    "c": 10658466,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [687, 74, -41],
    "s": [24, 48, 26],
    "l": 1,
    "c": 10658466,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [727, 74, -41],
    "s": [105, 6, 76],
    "l": 1,
    "c": 10658466,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [687, 121, -41],
    "s": [31, 6, 32],
    "l": 1,
    "c": 7890002,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [687, 127, -41],
    "s": [22, 13, 19],
    "l": 1,
    "c": 7890002,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [727, 80, -41],
    "s": [105, 6, 54],
    "l": 1,
    "c": 10658466,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [727, 84, -61],
    "s": [115, 6, 53],
    "l": 1,
    "r": [-0.52, 0, 0],
    "c": 7890002,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [681, 154, -41],
    "s": [2, 25, 2],
    "l": 1,
    "c": 7890002,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [681, 171, -41],
    "s": [2, 2, 14],
    "l": 1,
    "c": 7890002,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [687, 124, -30],
    "s": [22, 33, 11],
    "l": 1,
    "r": [-0.35, 0, 0],
    "c": 7890002,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [687, 124, -52],
    "s": [22, 33, 11],
    "l": 1,
    "r": [0.35, 0, 0],
    "c": 7890002,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [727, 84, -22],
    "s": [115, 6, 51],
    "l": 1,
    "r": [0.53, 0, 0],
    "c": 7890002,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [727, 80, -41],
    "s": [105, 12, 34],
    "l": 1,
    "c": 10658466,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [674, 0, -41],
    "s": [2, 57, 32],
    "l": 1,
    "c": 7890002,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [692, 16, -106],
    "s": [26, 31, 28],
    "l": 1,
    "c": 6324784,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [691, -1, -106],
    "s": [4, 34, 4],
    "l": 1,
    "c": 6574655,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [648, 17, 8],
    "s": [26, 34, 28],
    "l": 1,
    "c": 6324784,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [648, -1, 9],
    "s": [4, 34, 4],
    "l": 1,
    "c": 6574655,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [458, 17, -140],
    "s": [26, 31, 28],
    "l": 1,
    "c": 6324784,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [621, 18, -154],
    "s": [26, 28, 28],
    "l": 1,
    "c": 6324784,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [621, -1, -154],
    "s": [4, 34, 4],
    "l": 1,
    "c": 6574655,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [208, 0, -376],
    "s": [121, 69, 83],
    "l": 1,
    "c": 10658466,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [674, 108, -41],
    "s": [1, 9, 9],
    "l": 1,
    "c": 0,
    "e": 16767098,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [673, 113, -41],
    "s": [1, 4, 1],
    "l": 1,
    "c": 2960685,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [673, 113, -41],
    "s": [1, 4, 1],
    "l": 1,
    "r": [2.09, 0, 0],
    "c": 2960685,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [674, 64, -41],
    "s": [2, 19, 4],
    "l": 1,
    "c": 2105376,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [752, 18, 167],
    "s": [39, 24, 1182],
    "l": 1,
    "c": 4743462,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [611, 18, -401],
    "s": [257, 31, 27],
    "l": 1,
    "c": 6060596,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [592, 31, -395],
    "s": [38, 34, 28],
    "l": 1,
    "c": 6324784,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [737, 15, -383],
    "s": [47, 36, 49],
    "l": 1,
    "c": 6324784,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [746, 22, -200],
    "s": [38, 28, 38],
    "l": 1,
    "c": 6324784,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [746, 22, -292],
    "s": [38, 33, 38],
    "l": 1,
    "c": 6324784,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [748, 0, -142],
    "s": [4, 23, 132],
    "l": 1,
    "c": 6574655,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [758, 0, -298],
    "s": [4, 23, 219],
    "l": 1,
    "c": 6574655,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [735, -1, -287],
    "s": [4, 34, 4],
    "l": 1,
    "c": 6574655,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [27, 0, 172],
    "s": [1506, 0, 1212],
    "i": 4,
    "c": "#728447",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [640, 0, -405],
    "s": [307, 23, 5],
    "l": 1,
    "c": 6574655,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [542, -1, -391],
    "s": [4, 34, 4],
    "l": 1,
    "c": 6574655,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [610, 18, -235],
    "s": [26, 28, 28],
    "l": 1,
    "c": 6324784,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [610, -1, -235],
    "s": [4, 34, 4],
    "l": 1,
    "c": 6574655,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [460, -1, -324],
    "s": [4, 34, 4],
    "l": 1,
    "c": 6574655,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [460, 18, -324],
    "s": [26, 28, 28],
    "l": 1,
    "c": 6324784,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [748, 0, 331],
    "s": [4, 23, 852],
    "l": 1,
    "c": 6574655,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [501, 17, -113],
    "s": [26, 28, 28],
    "l": 1,
    "c": 6324784,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [459, 9, -102],
    "s": [25, 26, 25],
    "l": 1,
    "c": 5732402,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [451, 22, 93],
    "s": [26, 24, 25],
    "l": 1,
    "c": 6984507,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [427, 10, 60],
    "s": [26, 28, 29],
    "l": 1,
    "c": 6324784,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [424, 15, 135],
    "s": [30, 28, 27],
    "l": 1,
    "c": 4743462,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [501, 16, -8],
    "s": [29, 25, 29],
    "l": 1,
    "c": 4941357,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [530, 9, -52],
    "s": [29, 25, 29],
    "l": 1,
    "c": 5732402,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [595, 9, 107],
    "s": [29, 25, 29],
    "l": 1,
    "c": 5732402,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [418, 13, 183],
    "s": [29, 25, 29],
    "l": 1,
    "c": 5732402,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [477, 20, 166],
    "s": [27, 30, 30],
    "l": 1,
    "c": 7576379,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [746, 22, 77],
    "s": [38, 28, 44],
    "l": 1,
    "c": 6324784,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [746, 22, 140],
    "s": [38, 29, 41],
    "l": 1,
    "c": 6588720,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [439, 8, 46],
    "s": [29, 25, 29],
    "l": 1,
    "c": 5732402,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [746, 23, 254],
    "s": [38, 28, 34],
    "l": 1,
    "c": 6324784,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [746, 18, 349],
    "s": [38, 29, 74],
    "l": 1,
    "c": 6324784,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [450, 14, -177],
    "s": [25, 30, 25],
    "l": 1,
    "c": 5732402,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [166, 0, -429],
    "s": [1786, 23, 5],
    "l": 1,
    "c": 5917499,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-81, 19, -418],
    "s": [1233, 31, 27],
    "l": 1,
    "c": 6060596,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [436, 16, -407],
    "s": [38, 37, 28],
    "l": 1,
    "c": 5665581,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [319, 17, -407],
    "s": [38, 37, 28],
    "l": 1,
    "c": 5665581,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [437, -1, -401],
    "s": [4, 34, 4],
    "l": 1,
    "c": 6574655,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [318, -1, -401],
    "s": [4, 34, 4],
    "l": 1,
    "c": 6574655,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [291, -1, -412],
    "s": [4, 34, 4],
    "l": 1,
    "c": 6574655,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [371, -1, -412],
    "s": [4, 34, 4],
    "l": 1,
    "c": 6574655,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [376, 31, -439],
    "s": [38, 33, 28],
    "l": 1,
    "c": 5665581,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [291, -1, -234],
    "s": [4, 34, 4],
    "l": 1,
    "c": 6574655,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [291, 8, -237],
    "s": [31, 33, 28],
    "l": 1,
    "c": 6324784,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [208, 69, -376],
    "s": [128, 3, 89],
    "l": 1,
    "c": 6381921,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [399, -1, 45],
    "s": [4, 26, 4],
    "c": 7692103,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [408, -1, -415],
    "s": [4, 34, 4],
    "l": 1,
    "c": 6574655,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [242, 47, -334],
    "s": [11, 12, 1],
    "l": 1,
    "c": 0,
    "e": 16767098,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [173, 47, -334],
    "s": [11, 12, 1],
    "l": 1,
    "c": 0,
    "e": 16767098,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [173, 46, -333],
    "s": [14, 1, 3],
    "l": 1,
    "c": 6250335,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [173, 59, -333],
    "s": [14, 1, 3],
    "l": 1,
    "c": 6250335,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [242, 59, -333],
    "s": [14, 1, 3],
    "l": 1,
    "c": 6250335,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [242, 46, -333],
    "s": [14, 1, 3],
    "l": 1,
    "c": 6250335,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [167, 47, -334],
    "s": [1, 12, 2],
    "l": 1,
    "c": 6250335,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [179, 47, -334],
    "s": [1, 12, 2],
    "l": 1,
    "c": 6250335,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [236, 47, -334],
    "s": [1, 12, 2],
    "l": 1,
    "c": 6250335,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [248, 47, -334],
    "s": [1, 12, 2],
    "l": 1,
    "c": 6250335,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [242, 47, -334],
    "s": [1, 12, 2],
    "l": 1,
    "c": 6250335,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [173, 47, -334],
    "s": [1, 12, 2],
    "l": 1,
    "c": 6250335,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-24, 112, 468],
    "s": [2, 9, 1],
    "l": 1,
    "c": 5723991,
    "e": 16711680,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-27, 66, 470],
    "s": [14, 57, 3],
    "l": 1,
    "c": 5921370,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-30, 112, 468],
    "s": [2, 9, 1],
    "l": 1,
    "c": 5723991,
    "e": 16711680,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-27, 116, 468],
    "s": [4, 2, 1],
    "l": 1,
    "c": 5723991,
    "e": 16711680,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-24, 101, 468],
    "s": [2, 9, 1],
    "l": 1,
    "c": 5723991,
    "e": 16711680,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-30, 101, 468],
    "s": [2, 9, 1],
    "l": 1,
    "c": 5723991,
    "e": 16711680,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-27, 101, 468],
    "s": [4, 2, 1],
    "l": 1,
    "c": 5723991,
    "e": 16711680,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-27, 108, 468],
    "s": [4, 2, 1],
    "l": 1,
    "c": 5723991,
    "e": 16711680,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-27, 90, 468],
    "s": [2, 9, 1],
    "l": 1,
    "c": 5723991,
    "e": 16711680,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-27, 97, 468],
    "s": [8, 2, 1],
    "l": 1,
    "c": 5723991,
    "e": 16711680,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-25, 79, 468],
    "s": [2, 9, 1],
    "l": 1,
    "c": 5723991,
    "e": 16711680,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-27, 86, 468],
    "s": [6, 2, 1],
    "l": 1,
    "c": 5723991,
    "e": 16711680,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-27, 79, 468],
    "s": [6, 2, 1],
    "l": 1,
    "c": 5723991,
    "e": 16711680,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-27, 82, 468],
    "s": [6, 2, 1],
    "l": 1,
    "c": 5723991,
    "e": 16711680,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-25, 68, 468],
    "s": [2, 9, 1],
    "l": 1,
    "c": 5723991,
    "e": 16711680,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-28, 68, 468],
    "s": [6, 2, 1],
    "l": 1,
    "c": 5723991,
    "e": 16711680,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-37, 108, 470],
    "s": [6, 3, 3],
    "l": 1,
    "c": 5921370,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-37, 77, 470],
    "s": [6, 3, 3],
    "l": 1,
    "c": 5921370,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [65, 1, 654],
    "s": [51, 15, 20],
    "i": 7,
    "l": 1,
    "r": [0, -1.57, 0]
  }, {
    "p": [32, 0, 814],
    "s": [79, 135, 116],
    "l": 1,
    "c": 10658466,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [32, 135, 814],
    "s": [87, 3, 124],
    "l": 1,
    "c": 6052956,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [88, -1, 709],
    "s": [4, 31, 4],
    "l": 1,
    "c": 6574655,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [90, 17, 708],
    "s": [27, 28, 24],
    "l": 1,
    "c": 6193707,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-33, -1, 770],
    "s": [4, 31, 4],
    "l": 1,
    "c": 6574655,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-34, 16, 770],
    "s": [27, 28, 24],
    "l": 1,
    "c": 6193707,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [115, -2, 958],
    "s": [113, 65, 116],
    "l": 1,
    "c": 12927811,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [115, 63, 958],
    "s": [124, 5, 126],
    "l": 1,
    "c": 5066061,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-63, -18, 928],
    "s": [123, 112, 120],
    "l": 1,
    "c": 12951902,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-63, 93, 928],
    "s": [131, 4, 127],
    "l": 1,
    "c": 7368816,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-155, -75, 1251],
    "s": [79, 289, 61],
    "l": 1,
    "c": 10658466,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [151, -31, 1120],
    "s": [108, 142, 61],
    "l": 1,
    "c": 10658466,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [308, 0, 1120],
    "s": [79, 220, 61],
    "l": 1,
    "c": 10658466,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-269, -31, 1008],
    "s": [108, 142, 113],
    "l": 1,
    "c": 10658466,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [437, 0, 747],
    "s": [677, 23, 5],
    "l": 1,
    "c": 6574655,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [609, 21, 751],
    "s": [315, 24, 44],
    "l": 1,
    "c": 4743462,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [269, 21, 751],
    "s": [374, 27, 53],
    "l": 1,
    "c": 4743462,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [525, 20, 744],
    "s": [38, 29, 41],
    "l": 1,
    "c": 6588720,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [744, 18, 739],
    "s": [43, 35, 46],
    "l": 1,
    "c": 6588720,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [333, 22, 743],
    "s": [38, 32, 41],
    "l": 1,
    "c": 6588720,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [636, 20, 744],
    "s": [38, 29, 41],
    "l": 1,
    "c": 6588720,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [746, 23, 557],
    "s": [38, 28, 34],
    "l": 1,
    "c": 6324784,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [443, 24, 258],
    "s": [23, 24, 23],
    "l": 1,
    "c": 4743462,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [359, 11, 197],
    "s": [24, 24, 30],
    "l": 1,
    "c": 6390324,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [313, 13, 245],
    "s": [26, 28, 28],
    "l": 1,
    "c": 5204775,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [369, 60, 323],
    "s": [132, 3, 130],
    "l": 1,
    "c": 6250335,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [369, -4, 323],
    "s": [123, 64, 120],
    "l": 1,
    "c": 12951902,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [252, 12, -209],
    "s": [26, 28, 28],
    "l": 1,
    "c": 4940075,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [208, -1, -370],
    "s": [137, 10, 89],
    "c": 6984507,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [373, 18, -259],
    "s": [26, 28, 28],
    "l": 1,
    "c": 6324784,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [247, 24, 743],
    "s": [38, 32, 41],
    "l": 1,
    "c": 6588720,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [571, -57, 1262],
    "s": [79, 220, 61],
    "l": 1,
    "c": 10658466,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [563, 13, 53],
    "s": [29, 25, 29],
    "l": 1,
    "c": 5732402,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [439, 5, 10],
    "s": [29, 25, 29],
    "l": 1,
    "c": 5732402,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [288, 9, -185],
    "s": [25, 26, 25],
    "l": 1,
    "c": 5732402,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [337, 14, -183],
    "s": [25, 26, 25],
    "l": 1,
    "c": 6720572,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [164, 6, -221],
    "s": [25, 30, 25],
    "l": 1,
    "c": 5732402,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [213, 12, -250],
    "s": [21, 25, 21],
    "l": 1,
    "c": 5732402,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [368, 15, -183],
    "s": [26, 27, 28],
    "l": 1,
    "c": 6324784,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [392, 11, -194],
    "s": [25, 26, 25],
    "l": 1,
    "c": 5666099,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [316, 5, -203],
    "s": [25, 26, 25],
    "l": 1,
    "c": 5666099,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [439, 8, 83],
    "s": [29, 25, 29],
    "l": 1,
    "c": 5732402,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [212, 18, -319],
    "s": [26, 28, 28],
    "l": 1,
    "c": 6324784,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [51, 31, -439],
    "s": [38, 33, 28],
    "l": 1,
    "c": 5665581,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [111, 17, -407],
    "s": [38, 37, 28],
    "l": 1,
    "c": 5665581,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [25, -1, -412],
    "s": [4, 34, 4],
    "l": 1,
    "c": 6574655,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [111, -1, -401],
    "s": [4, 34, 4],
    "l": 1,
    "c": 6574655,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [73, -1, -407],
    "s": [4, 34, 4],
    "l": 1,
    "c": 6574655,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-92, 17, -407],
    "s": [38, 37, 28],
    "l": 1,
    "c": 5665581,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-175, 27, -427],
    "s": [38, 33, 28],
    "l": 1,
    "c": 5665581,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-175, 27, -427],
    "s": [38, 33, 28],
    "l": 1,
    "c": 5665581,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-90, -1, -400],
    "s": [4, 34, 4],
    "l": 1,
    "c": 6574655,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-174, -1, -418],
    "s": [4, 34, 4],
    "l": 1,
    "c": 6574655,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-67, 22, -274],
    "s": [26, 28, 28],
    "l": 1,
    "c": 5204775,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-66, -1, -273],
    "s": [4, 31, 4],
    "l": 1,
    "c": 6574655,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-12, 50, -132],
    "s": [11, 12, 1],
    "l": 1,
    "c": 0,
    "e": 16767098,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-12, 49, -131],
    "s": [14, 1, 3],
    "l": 1,
    "c": 6250335,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-12, 62, -132],
    "s": [14, 1, 3],
    "l": 1,
    "c": 6250335,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-18, 50, -132],
    "s": [1, 12, 2],
    "l": 1,
    "c": 6250335,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-6, 50, -132],
    "s": [1, 12, 2],
    "l": 1,
    "c": 6250335,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-12, 50, -132],
    "s": [1, 12, 2],
    "l": 1,
    "c": 6250335,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-63, 10, -181],
    "s": [25, 30, 25],
    "l": 1,
    "c": 6851648,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [32, 26, -126],
    "s": [16, 13, 22],
    "c": 12958048,
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [125, -1, 2],
    "s": [4, 2, 6],
    "l": 1,
    "c": 7368816,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [128, 0, 89],
    "s": [4, 2, 6],
    "l": 1,
    "c": 7368816,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [88, -1, 82],
    "s": [4, 2, 6],
    "l": 1,
    "c": 7368816,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [142, -1, 128],
    "s": [4, 2, 6],
    "l": 1,
    "c": 7368816,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-37, -1, -55],
    "s": [4, 2, 6],
    "l": 1,
    "c": 7368816,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [239, 3, -66],
    "s": [4, 0, 5],
    "i": 4,
    "l": 1,
    "r": [0, -0.53, 0],
    "c": 9671571,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-38, 3, 157],
    "s": [4, 0, 5],
    "i": 4,
    "l": 1,
    "r": [0, -0.53, 0],
    "c": 9671571,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-247, -1, -414],
    "s": [4, 34, 4],
    "l": 1,
    "c": 6574655,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-341, -1, -413],
    "s": [4, 34, 4],
    "l": 1,
    "c": 6574655,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-252, 15, -427],
    "s": [51, 58, 28],
    "l": 1,
    "c": 5665581,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-372, 15, -411],
    "s": [48, 41, 35],
    "l": 1,
    "c": 5665581,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-212, 10, -177],
    "s": [26, 28, 28],
    "l": 1,
    "c": 5204775,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-156, -1, 235],
    "s": [4, 31, 4],
    "l": 1,
    "c": 6574655,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-157, 15, 235],
    "s": [26, 28, 28],
    "l": 1,
    "c": 7709238,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [165, -1, -213],
    "s": [4, 34, 4],
    "l": 1,
    "c": 6574655,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [203, -1, -186],
    "s": [4, 34, 4],
    "l": 1,
    "c": 6574655,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [124, -1, -188],
    "s": [4, 34, 4],
    "l": 1,
    "c": 6574655,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [285, -1, -185],
    "s": [4, 34, 4],
    "l": 1,
    "c": 6574655,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [250, -1, -202],
    "s": [4, 34, 4],
    "l": 1,
    "c": 6574655,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-125, -1, -105],
    "s": [4, 2, 6],
    "l": 1,
    "c": 7368816,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-262, -1, -17],
    "s": [4, 2, 6],
    "l": 1,
    "c": 7368816,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-245, -1, 190],
    "s": [4, 2, 6],
    "c": 7368816,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [392, -1, 40],
    "s": [4, 2, 6],
    "l": 1,
    "c": 7368816,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [265, -1, -65],
    "s": [4, 2, 6],
    "l": 1,
    "c": 7368816,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [109, -1, -146],
    "s": [4, 2, 6],
    "l": 1,
    "c": 7368816,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [213, -1, -318],
    "s": [4, 34, 4],
    "l": 1,
    "c": 6574655,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [213, -1, -248],
    "s": [4, 34, 4],
    "l": 1,
    "c": 6574655,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [55, -1, -407],
    "s": [4, 34, 4],
    "l": 1,
    "c": 6574655,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [24, 1, 395],
    "s": [51, 15, 20],
    "i": 7,
    "l": 1,
    "r": [3.14, -1.22, 3.14]
  }, {
    "p": [-259, 17, 231],
    "s": [26, 28, 28],
    "l": 1,
    "c": 7709238,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-203, 18, 291],
    "s": [26, 26, 28],
    "l": 1,
    "c": 6193707,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-203, -1, 292],
    "s": [4, 23, 4],
    "l": 1,
    "c": 6574655,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-155, -75, 1251],
    "s": [4, 341, 4],
    "l": 1,
    "c": 10658466,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [308, 85, 1120],
    "s": [4, 189, 2],
    "l": 1,
    "c": 10658466,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-102, -1, -180],
    "s": [4, 31, 4],
    "l": 1,
    "c": 6574655,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-64, -1, -180],
    "s": [4, 31, 4],
    "l": 1,
    "c": 6574655,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-285, -1, -78],
    "s": [4, 2, 4],
    "l": 1,
    "c": 7368816,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-39, -1, -141],
    "s": [4, 2, 4],
    "l": 1,
    "c": 7368816,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [350, -1, 5],
    "s": [4, 2, 4],
    "l": 1,
    "c": 7368816,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [427, -1, -136],
    "s": [4, 2, 4],
    "l": 1,
    "c": 7368816,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [327, -1, 154],
    "s": [4, 2, 4],
    "l": 1,
    "c": 7368816,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [200, -1, 121],
    "s": [4, 2, 4],
    "c": 7368816,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-11, 0, -75],
    "s": [4, 2, 6],
    "l": 1,
    "c": 7368816,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [133, 0, 15],
    "s": [1, 15, 3],
    "l": 1,
    "r": [0, 0, -0.17],
    "c": 7692103,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [133, 0, 11],
    "s": [1, 15, 3],
    "l": 1,
    "r": [0, 0, -0.17],
    "c": 7692103,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-47, 2, 22],
    "s": [4, 36, 76],
    "c": 5799880,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-253, 16, -176],
    "s": [26, 28, 28],
    "l": 1,
    "c": 5204775,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-182, 0, -245],
    "s": [121, 51, 83],
    "c": 13619151,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-209, -1, -176],
    "s": [4, 31, 4],
    "l": 1,
    "c": 6574655,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-183, 66, -58],
    "s": [4, 1, 1],
    "l": 1,
    "c": 9012870,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-185, 64, -58],
    "s": [4, 2, 3],
    "l": 1,
    "c": 9012870,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-185, 63, -58],
    "s": [3, 1, 2],
    "l": 1,
    "c": 0,
    "e": 16767098,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-182, 51, -245],
    "s": [130, 3, 95],
    "c": 7039851,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-173, 31, -203],
    "s": [11, 12, 1],
    "l": 1,
    "c": 0,
    "e": 16767098,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-179, 31, -203],
    "s": [1, 12, 2],
    "l": 1,
    "c": 6250335,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-167, 31, -203],
    "s": [1, 12, 2],
    "l": 1,
    "c": 6250335,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-173, 31, -203],
    "s": [1, 12, 2],
    "l": 1,
    "c": 6250335,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-173, 30, -203],
    "s": [14, 1, 4],
    "l": 1,
    "c": 6250335,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-173, 43, -203],
    "s": [14, 1, 3],
    "l": 1,
    "c": 6250335,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-392, 0, 747],
    "s": [677, 23, 5],
    "l": 1,
    "c": 6574655,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-385, 21, 751],
    "s": [691, 27, 53],
    "l": 1,
    "c": 4743462,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-405, 0, -51],
    "s": [123, 60, 120],
    "c": 12951902,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-403, 60, -51],
    "s": [130, 2, 130],
    "c": 5263440,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-316, 15, 11],
    "s": [26, 30, 28],
    "l": 1,
    "c": 7709238,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-320, -1, 173],
    "s": [4, 31, 4],
    "l": 1,
    "c": 6574655,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-707, 19, 165],
    "s": [44, 31, 1300],
    "l": 1,
    "c": 6060596,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-694, 0, 183],
    "s": [1, 23, 1208],
    "l": 1,
    "c": 6574655,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-343, 40, -83],
    "s": [1, 12, 11],
    "l": 1,
    "c": 0,
    "e": 16767098,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-344, 52, -83],
    "s": [4, 1, 13],
    "l": 1,
    "c": 6250335,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-343, 39, -83],
    "s": [4, 1, 14],
    "l": 1,
    "c": 6250335,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-344, 40, -89],
    "s": [4, 12, 1],
    "l": 1,
    "c": 6250335,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-344, 40, -77],
    "s": [4, 12, 1],
    "l": 1,
    "c": 6250335,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-344, 40, -83],
    "s": [4, 12, 1],
    "l": 1,
    "c": 6250335,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-315, 5, -45],
    "s": [26, 30, 28],
    "l": 1,
    "c": 6786608,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-371, -25, 16],
    "s": [27, 105, 15],
    "c": 6579300,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-310, 16, -166],
    "s": [26, 28, 28],
    "l": 1,
    "c": 5204775,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-310, -1, -167],
    "s": [4, 31, 4],
    "l": 1,
    "c": 6574655,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-290, 11, -213],
    "s": [26, 30, 28],
    "l": 1,
    "c": 7709238,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-270, 16, -274],
    "s": [26, 28, 28],
    "l": 1,
    "c": 5204775,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-269, -1, -271],
    "s": [4, 34, 4],
    "l": 1,
    "c": 6574655,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-334, 16, -216],
    "s": [26, 28, 28],
    "l": 1,
    "c": 5204775,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-328, -1, -219],
    "s": [4, 34, 4],
    "l": 1,
    "c": 6574655,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-42, 0, 25],
    "s": [6, 9, 78],
    "c": 6984507,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [17, 2, -126],
    "s": [14, 37, 22],
    "c": 12958048,
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [32, 2, -119],
    "s": [16, 24, 2],
    "pe": 1,
    "c": 7692103,
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [47, 2, -126],
    "s": [14, 37, 22],
    "c": 12958048,
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [-255, -1, 230],
    "s": [4, 23, 4],
    "l": 1,
    "c": 6574655,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [275, -1, 183],
    "s": [4, 28, 4],
    "l": 1,
    "c": 6574655,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [32, 42, -132],
    "s": [29, 18, 1],
    "l": 1,
    "c": 0,
    "e": 16767098,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [17, 42, -132],
    "s": [1, 18, 2],
    "l": 1,
    "c": 6250335,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [32, 42, -132],
    "s": [1, 18, 2],
    "l": 1,
    "c": 6250335,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [32, 60, -132],
    "s": [31, 1, 3],
    "l": 1,
    "c": 6250335,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [11, 42, -116],
    "s": [2, 8, 2],
    "l": 1,
    "c": 5263440,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [53, 42, -116],
    "s": [2, 8, 2],
    "l": 1,
    "c": 5263440,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [53, 42, -131],
    "s": [2, 8, 2],
    "l": 1,
    "c": 5263440,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [11, 42, -131],
    "s": [2, 8, 2],
    "l": 1,
    "c": 5263440,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [11, 42, -123],
    "s": [1, 7, 1],
    "l": 1,
    "c": 5263440,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [53, 42, -124],
    "s": [1, 7, 1],
    "l": 1,
    "c": 5263440,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [46, 42, -116],
    "s": [1, 7, 1],
    "l": 1,
    "c": 5263440,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [18, 42, -116],
    "s": [1, 7, 1],
    "l": 1,
    "c": 5263440,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [27, 42, -116],
    "s": [1, 7, 1],
    "l": 1,
    "c": 5263440,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [36, 42, -116],
    "s": [1, 7, 1],
    "l": 1,
    "c": 5263440,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [32, 49, -116],
    "s": [42, 1, 2],
    "l": 1,
    "c": 5263440,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [53, 49, -124],
    "s": [2, 1, 14],
    "l": 1,
    "c": 5263440,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [11, 49, -123],
    "s": [2, 1, 14],
    "l": 1,
    "c": 5263440,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-183, 36, -58],
    "s": [4, 2, 20],
    "c": 7368816,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [306, 36, 64],
    "s": [4, 2, 20],
    "c": 7368816,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [47, 42, -132],
    "s": [1, 18, 2],
    "l": 1,
    "c": 6250335,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [340, -1, -182],
    "s": [4, 34, 4],
    "l": 1,
    "c": 6574655,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [369, -1, -182],
    "s": [4, 34, 4],
    "l": 1,
    "c": 6574655,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [419, -1, -183],
    "s": [4, 34, 4],
    "l": 1,
    "c": 6574655,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [391, -1, -193],
    "s": [4, 34, 4],
    "l": 1,
    "c": 6574655,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-70, 2, 160],
    "s": [3, 6, 6],
    "l": 1,
    "c": 12927811,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-70, 7, 162],
    "s": [1, 3, 1],
    "l": 1,
    "c": 8882055,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [98, 2, -212],
    "s": [14, 100, 25],
    "c": 7368816,
    "t": 11,
    "ts": 0,
    "td": 0
  }, {
    "p": [-397, 16, -128],
    "s": [26, 28, 28],
    "l": 1,
    "c": 5204775,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-389, -1, -128],
    "s": [4, 34, 4],
    "l": 1,
    "c": 6574655,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-689, 15, -307],
    "s": [48, 41, 58],
    "l": 1,
    "c": 5665581,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-689, 17, -208],
    "s": [48, 41, 41],
    "l": 1,
    "c": 5665581,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-574, 17, -413],
    "s": [48, 41, 35],
    "l": 1,
    "c": 5665581,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-404, 17, -176],
    "s": [26, 31, 28],
    "l": 1,
    "c": 5204775,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-405, -1, -177],
    "s": [4, 34, 4],
    "l": 1,
    "c": 6574655,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-460, 15, -411],
    "s": [36, 43, 35],
    "l": 1,
    "c": 5665581,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [369, 39, 263],
    "s": [11, 12, 1],
    "l": 1,
    "c": 0,
    "e": 16767098,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [369, 38, 262],
    "s": [14, 1, 3],
    "l": 1,
    "c": 6250335,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [369, 51, 263],
    "s": [14, 1, 3],
    "l": 1,
    "c": 6250335,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [375, 39, 263],
    "s": [1, 12, 3],
    "l": 1,
    "c": 6250335,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [363, 39, 263],
    "s": [1, 12, 3],
    "l": 1,
    "c": 6250335,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [369, 39, 263],
    "s": [1, 12, 3],
    "l": 1,
    "c": 6250335,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-372, 0, 98],
    "s": [104, 106, 116],
    "l": 1,
    "c": 10658466,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-372, 105, 98],
    "s": [115, 3, 126],
    "l": 1,
    "c": 7368816,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-366, 17, 737],
    "s": [48, 41, 41],
    "l": 1,
    "c": 5665581,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-489, 17, 737],
    "s": [66, 36, 41],
    "l": 1,
    "c": 5665581,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-205, 17, 737],
    "s": [66, 36, 41],
    "l": 1,
    "c": 5665581,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-624, 17, 737],
    "s": [66, 39, 41],
    "l": 1,
    "c": 5665581,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-689, 17, 202],
    "s": [48, 41, 41],
    "l": 1,
    "c": 5665581,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-689, 17, 318],
    "s": [48, 41, 41],
    "l": 1,
    "c": 5665581,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-306, 23, 205],
    "s": [26, 26, 28],
    "l": 1,
    "c": 6193707,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-306, -1, 205],
    "s": [4, 31, 4],
    "l": 1,
    "c": 6574655,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-290, 12, 243],
    "s": [26, 28, 28],
    "l": 1,
    "c": 8695624,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-288, -1, 249],
    "s": [4, 23, 4],
    "l": 1,
    "c": 6574655,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [126, 0, 60],
    "s": [2, 37, 2],
    "pe": 1,
    "c": 7692103,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [126, 0, 98],
    "s": [2, 37, 2],
    "pe": 1,
    "c": 7692103,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-161, -1, 205],
    "s": [4, 26, 4],
    "c": 7692103,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-290, -1, -49],
    "s": [4, 26, 4],
    "c": 7692103,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [238, -1, -156],
    "s": [4, 26, 4],
    "c": 7692103,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [182, -1, 159],
    "s": [4, 26, 4],
    "c": 7692103,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [296, -1, 159],
    "s": [4, 26, 4],
    "c": 7692103,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [1009, 10, 134],
    "s": [65, 76, 76],
    "l": 1,
    "c": 6324784,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [995, 21, -386],
    "s": [65, 53, 76],
    "l": 1,
    "c": 6324784,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [555, 21, -559],
    "s": [137, 54, 76],
    "l": 1,
    "c": 6324784,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [924, 10, 606],
    "s": [74, 74, 87],
    "l": 1,
    "c": 6324784,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-289, -7, 309],
    "s": [82, 106, 86],
    "l": 1,
    "c": 10658466,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [849, -8, -520],
    "s": [65, 84, 76],
    "l": 1,
    "c": 6324784,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [661, -4, 165],
    "s": [123, 64, 120],
    "l": 1,
    "c": 12951902,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [661, 60, 165],
    "s": [132, 4, 131],
    "l": 1,
    "c": 6381921,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-289, 99, 309],
    "s": [89, 4, 93],
    "l": 1,
    "c": 7895160,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-345, 18, 247],
    "s": [26, 26, 28],
    "l": 1,
    "c": 6193707,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-431, 14, 166],
    "s": [26, 26, 28],
    "l": 1,
    "c": 6193707,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-269, 74, 266],
    "s": [11, 12, 1],
    "l": 1,
    "c": 0,
    "e": 16767098,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-269, 73, 265],
    "s": [14, 1, 3],
    "l": 1,
    "c": 6250335,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-269, 86, 266],
    "s": [14, 1, 3],
    "l": 1,
    "c": 6250335,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-263, 74, 266],
    "s": [1, 12, 2],
    "l": 1,
    "c": 6250335,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-275, 74, 266],
    "s": [1, 12, 2],
    "l": 1,
    "c": 6250335,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-269, 74, 266],
    "s": [1, 12, 2],
    "l": 1,
    "c": 6250335,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [995, 17, -153],
    "s": [65, 68, 47],
    "l": 1,
    "c": 6324784,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-136, 3, -80],
    "s": [7, 32, 23],
    "c": 8355711,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-130, 3, -80],
    "s": [7, 29, 23],
    "c": 8355711,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-124, 3, -80],
    "s": [7, 26, 23],
    "c": 8355711,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-118, 3, -80],
    "s": [7, 23, 23],
    "c": 8355711,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-112, 3, -80],
    "s": [7, 20, 23],
    "c": 8355711,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-106, 3, -80],
    "s": [7, 17, 23],
    "c": 8355711,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-100, 3, -80],
    "s": [7, 14, 23],
    "c": 8355711,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-94, 3, -80],
    "s": [7, 11, 23],
    "c": 8355711,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-88, 3, -80],
    "s": [7, 8, 23],
    "c": 8355711,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-82, 3, -80],
    "s": [7, 5, 23],
    "c": 8355711,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-76, 2, -80],
    "s": [7, 3, 23],
    "c": 8355711,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-102, 2, -80],
    "s": [72, 36, 24],
    "i": 9,
    "v": 1,
    "t": 5,
    "d": 2,
    "ts": 0,
    "td": 0
  }, {
    "p": [-125, 3, 54],
    "s": [4, 0, 5],
    "i": 4,
    "l": 1,
    "r": [0, 1.04, 0],
    "c": 11184810,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [251, 3, 98],
    "s": [7, 32, 23],
    "c": 8355711,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [244, 3, 98],
    "s": [7, 29, 23],
    "c": 8355711,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [237, 3, 98],
    "s": [7, 26, 23],
    "c": 8355711,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [230, 3, 98],
    "s": [7, 23, 23],
    "c": 8355711,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [223, 3, 98],
    "s": [7, 20, 23],
    "c": 8355711,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [216, 3, 98],
    "s": [7, 17, 23],
    "c": 8355711,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [209, 3, 98],
    "s": [7, 14, 23],
    "c": 8355711,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [202, 3, 98],
    "s": [7, 11, 23],
    "c": 8355711,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [195, 3, 98],
    "s": [7, 8, 23],
    "c": 8355711,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [188, 3, 98],
    "s": [7, 5, 23],
    "c": 8355711,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [181, 2, 98],
    "s": [7, 3, 23],
    "c": 8355711,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [212, 2, 98],
    "s": [84, 36, 24],
    "i": 9,
    "v": 1,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-320, 72, 67],
    "s": [1, 20, 23],
    "l": 1,
    "c": 0,
    "e": 16767098,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-320, 72, 125],
    "s": [1, 20, 23],
    "l": 1,
    "c": 0,
    "e": 16767098,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-319, 71, 67],
    "s": [3, 1, 27],
    "l": 1,
    "c": 6250335,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-320, 92, 67],
    "s": [2, 1, 27],
    "l": 1,
    "c": 6250335,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-320, 72, 55],
    "s": [2, 20, 1],
    "l": 1,
    "c": 6250335,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-320, 72, 79],
    "s": [2, 20, 1],
    "l": 1,
    "c": 6250335,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-320, 72, 67],
    "s": [2, 20, 1],
    "l": 1,
    "c": 6250335,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-319, 71, 125],
    "s": [3, 1, 27],
    "l": 1,
    "c": 6250335,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-320, 92, 125],
    "s": [2, 1, 27],
    "l": 1,
    "c": 6250335,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-320, 72, 137],
    "s": [2, 20, 1],
    "l": 1,
    "c": 6250335,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-320, 72, 113],
    "s": [2, 20, 1],
    "l": 1,
    "c": 6250335,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-320, 72, 125],
    "s": [2, 20, 1],
    "l": 1,
    "c": 6250335,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [137, -1, -156],
    "s": [4, 26, 4],
    "c": 7692103,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [119, 0, -15],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-47, -1, 357],
    "s": [38, 24, 2],
    "c": 7692103,
    "t": 10,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [116, -1, 275],
    "s": [41, 24, 2],
    "pe": 1,
    "c": 7692103,
    "t": 10,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [70, 2, 357],
    "s": [4, 0, 5],
    "i": 4,
    "l": 1,
    "r": [0, -1.23, 0],
    "c": 10329501,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-12, 2, 249],
    "s": [4, 0, 5],
    "i": 4,
    "l": 1,
    "r": [0, -0.53, 0],
    "c": 10329501,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-49, -1, 265],
    "s": [21, 24, 2],
    "c": 7692103,
    "t": 10,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [-29, -1, 357],
    "s": [4, 26, 4],
    "c": 7692103,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [41, -1, 365],
    "s": [3, 12, 1],
    "l": 1,
    "r": [0.35, 0, 0],
    "c": 13158600,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [58, 9, 369],
    "s": [40, 3, 1],
    "l": 1,
    "c": 13158600,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [41, -1, 373],
    "s": [3, 12, 1],
    "l": 1,
    "r": [-0.35, 0, 0],
    "c": 13158600,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [75, -1, 365],
    "s": [3, 12, 1],
    "l": 1,
    "r": [0.35, 0, 0],
    "c": 13158600,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [75, -1, 373],
    "s": [3, 12, 1],
    "l": 1,
    "r": [-0.35, 0, 0],
    "c": 13158600,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [3, 9, 369],
    "s": [40, 3, 1],
    "l": 1,
    "c": 13158600,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-14, -1, 365],
    "s": [3, 12, 1],
    "l": 1,
    "r": [0.35, 0, 0],
    "c": 13158600,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [20, -1, 365],
    "s": [3, 12, 1],
    "l": 1,
    "r": [0.35, 0, 0],
    "c": 13158600,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-14, -1, 373],
    "s": [3, 12, 1],
    "l": 1,
    "r": [-0.35, 0, 0],
    "c": 13158600,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [20, -1, 373],
    "s": [3, 12, 1],
    "l": 1,
    "r": [-0.35, 0, 0],
    "c": 13158600,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [58, 1, 382],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-31, 0, 369],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-5, 1, 377],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [47, 1, 378],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [34, 1, 368],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [89, 0, 373],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [73, 2, 406],
    "s": [4, 0, 5],
    "i": 4,
    "l": 1,
    "r": [3.14, -1.39, 3.14],
    "c": 10329501,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [75, 2, 282],
    "s": [4, 0, 5],
    "i": 4,
    "l": 1,
    "r": [0, -1.4, 0],
    "c": 10329501,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [90, 0, 266],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [100, -1, 348],
    "s": [4, 2, 6],
    "l": 1,
    "c": 7368816,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [164, -1, 342],
    "s": [2, 27, 48],
    "pe": 1,
    "c": 7692103,
    "t": 10,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [133, 0, 292],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [24, -1, 428],
    "s": [168, 13, 119],
    "v": 1,
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [-47, -1, 363],
    "s": [37, 13, 14],
    "v": 1,
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [-20, 1, 372],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [188, -1, 339],
    "s": [4, 28, 4],
    "l": 1,
    "c": 6574655,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [189, 22, 341],
    "s": [26, 28, 28],
    "l": 1,
    "c": 5204775,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [221, -1, 351],
    "s": [1, 7, 1],
    "l": 1,
    "c": 6984507,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [289, -1, 366],
    "s": [1, 7, 1],
    "l": 1,
    "c": 6984507,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [113, 3, -37],
    "s": [4, 0, 5],
    "i": 4,
    "l": 1,
    "r": [0, -0.53, 0],
    "c": 9671571,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [167, 3, -75],
    "s": [4, 0, 5],
    "i": 4,
    "l": 1,
    "r": [0, -0.53, 0],
    "c": 9671571,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [164, 39, -13],
    "s": [4, 0, 5],
    "i": 4,
    "l": 1,
    "r": [0, -0.53, 0],
    "c": 9671571,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [249, 39, 47],
    "s": [4, 0, 5],
    "i": 4,
    "l": 1,
    "r": [0, -0.53, 0],
    "c": 9671571,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-142, 2, 25],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-175, 2, -28],
    "s": [2, 4, 2],
    "l": 1,
    "pe": 1,
    "c": 5211204,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-175, 4, -28],
    "s": [1, 4, 1],
    "l": 1,
    "pe": 1,
    "c": 5211204,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [243, 2, 8],
    "s": [1, 17, 3],
    "l": 1,
    "r": [0, 0, 0.17],
    "c": 7692103,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-129, 2, 12],
    "s": [1, 17, 3],
    "l": 1,
    "r": [0, 0, 0.17],
    "c": 7692103,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-139, 2, 74],
    "s": [1, 17, 3],
    "l": 1,
    "r": [0, 0, 0.17],
    "c": 7692103,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-139, 2, 81],
    "s": [1, 17, 3],
    "l": 1,
    "r": [0, 0, 0.17],
    "c": 7692103,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [158, 38, -22],
    "s": [2, 4, 2],
    "l": 1,
    "pe": 1,
    "c": 5211204,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [158, 40, -22],
    "s": [1, 4, 1],
    "l": 1,
    "pe": 1,
    "c": 5211204,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [202, 38, 77],
    "s": [4, 22, 2],
    "l": 1,
    "r": [0.17, 0, 0],
    "c": 7692103,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [209, 38, 77],
    "s": [4, 22, 2],
    "l": 1,
    "r": [0.17, 0, 0],
    "c": 7692103,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [145, 2, -22],
    "s": [2, 4, 2],
    "l": 1,
    "pe": 1,
    "c": 5211204,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [145, 4, -22],
    "s": [1, 4, 1],
    "l": 1,
    "pe": 1,
    "c": 5211204,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [188, 8, 88],
    "s": [2, 4, 2],
    "l": 1,
    "pe": 1,
    "c": 5211204,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [188, 10, 88],
    "s": [1, 4, 1],
    "l": 1,
    "pe": 1,
    "c": 5211204,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-93, 14, -70],
    "s": [2, 4, 2],
    "l": 1,
    "pe": 1,
    "c": 5211204,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-93, 16, -70],
    "s": [1, 4, 1],
    "l": 1,
    "pe": 1,
    "c": 5211204,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [145, 39, 105],
    "s": [4, 0, 5],
    "i": 4,
    "l": 1,
    "r": [0, 1.39, 0],
    "c": 9671571,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [168, 38, 106],
    "s": [4, 22, 2],
    "l": 1,
    "r": [0.17, 0, 0],
    "c": 7692103,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [35, 1, 304],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [23, 1, 304],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [29, 13, 304],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-92, 32, -2],
    "s": [7, 2, 7],
    "c": 9012870,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-92, 34, -2],
    "s": [3, 2, 3],
    "c": 9012870,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-92, 31, -2],
    "s": [3, 1, 3],
    "l": 1,
    "c": 0,
    "e": 16767098,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-92, 74, -2],
    "s": [3, 2, 3],
    "c": 9012870,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-92, 72, -2],
    "s": [7, 2, 7],
    "c": 9012870,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-92, 71, -2],
    "s": [3, 1, 3],
    "l": 1,
    "c": 0,
    "e": 16767098,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [183, 74, 39],
    "s": [3, 2, 3],
    "c": 9012870,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [183, 72, 39],
    "s": [7, 2, 7],
    "c": 9012870,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [183, 71, 39],
    "s": [3, 1, 3],
    "l": 1,
    "c": 0,
    "e": 16767098,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [183, 34, 39],
    "s": [3, 2, 3],
    "c": 9012870,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [272, 32, 39],
    "s": [7, 2, 7],
    "c": 9012870,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [183, 31, 39],
    "s": [3, 1, 3],
    "l": 1,
    "c": 0,
    "e": 16767098,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [272, 34, 39],
    "s": [3, 2, 3],
    "c": 9012870,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [183, 32, 39],
    "s": [7, 2, 7],
    "c": 9012870,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [272, 31, 39],
    "s": [3, 1, 3],
    "l": 1,
    "c": 0,
    "e": 16767098,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [294, 2, 23],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [288, 3, 9],
    "s": [4, 0, 5],
    "i": 4,
    "l": 1,
    "r": [-3.14, 1.4, -3.14],
    "c": 9671571,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-163, 32, -2],
    "s": [7, 2, 7],
    "c": 9012870,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-163, 34, -2],
    "s": [3, 2, 3],
    "c": 9012870,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-163, 31, -2],
    "s": [3, 1, 3],
    "l": 1,
    "c": 0,
    "e": 16767098,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [28, 1, 305],
    "s": [72, 50, 63],
    "i": 14,
    "l": 1
  }, {
    "p": [-89, 38, -8],
    "s": [61, 38, 65],
    "i": 14,
    "l": 1
  }, {
    "p": [184, 2, 37],
    "s": [61, 33, 59],
    "i": 14,
    "l": 1
  }, {
    "p": [367, 0, 32],
    "s": [24, 36, 24],
    "i": 23,
    "l": 1,
    "tm": 0
  }, {
    "p": [-215, 0, 35],
    "s": [24, 36, 24],
    "i": 23,
    "l": 1,
    "tm": "1"
  }, {
    "p": [-100, 14, 70],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-100, 2, 70],
    "s": [12, 12, 12],
    "i": 8
  }, {
    "p": [-35, -1, -18],
    "s": [3, 2, 3],
    "l": 1,
    "c": 7368816,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-35, -1, -28],
    "s": [3, 2, 3],
    "l": 1,
    "c": 7368816,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-35, -1, -23],
    "s": [4, 2, 5],
    "l": 1,
    "c": 7368816,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-29, -1, -28],
    "s": [5, 2, 4],
    "l": 1,
    "c": 7368816,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-29, -1, -18],
    "s": [5, 2, 4],
    "l": 1,
    "c": 7368816,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-29, -1, -23],
    "s": [3, 2, 3],
    "l": 1,
    "c": 7368816,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [127, -1, 39],
    "s": [4, 2, 3],
    "l": 1,
    "c": 7368816,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [127, -1, 49],
    "s": [4, 2, 3],
    "l": 1,
    "c": 7368816,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [127, -1, 44],
    "s": [4, 2, 5],
    "l": 1,
    "c": 7368816,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [109, -1, 40],
    "s": [4, 2, 6],
    "l": 1,
    "c": 7368816,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [121, -1, 48],
    "s": [4, 2, 6],
    "l": 1,
    "c": 7368816,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [115, -1, 44],
    "s": [4, 2, 5],
    "l": 1,
    "c": 7368816,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [103, -1, 44],
    "s": [4, 2, 5],
    "l": 1,
    "c": 7368816,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [121, -1, 40],
    "s": [4, 2, 6],
    "l": 1,
    "c": 7368816,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [109, -1, 48],
    "s": [4, 2, 6],
    "l": 1,
    "c": 7368816,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [115, -1, 49],
    "s": [4, 2, 3],
    "l": 1,
    "c": 7368816,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [115, -1, 39],
    "s": [4, 2, 3],
    "l": 1,
    "c": 7368816,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [97, -1, 48],
    "s": [4, 2, 6],
    "l": 1,
    "c": 7368816,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [97, -1, 40],
    "s": [4, 2, 6],
    "l": 1,
    "c": 7368816,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [91, -1, 44],
    "s": [4, 2, 5],
    "l": 1,
    "c": 7368816,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [85, -1, 40],
    "s": [4, 2, 6],
    "l": 1,
    "c": 7368816,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [85, -1, 48],
    "s": [4, 2, 6],
    "l": 1,
    "c": 7368816,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [103, -1, 49],
    "s": [4, 2, 3],
    "l": 1,
    "c": 7368816,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [91, -1, 49],
    "s": [4, 2, 3],
    "l": 1,
    "c": 7368816,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [91, -1, 39],
    "s": [4, 2, 3],
    "l": 1,
    "c": 7368816,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [103, -1, 39],
    "s": [4, 2, 3],
    "l": 1,
    "c": 7368816,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-251, -1, 141],
    "s": [4, 26, 4],
    "pe": 1,
    "c": 7692103,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-251, -1, 118],
    "s": [4, 26, 4],
    "pe": 1,
    "c": 7692103,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [220, 82, 43],
    "s": [178, 4, 152],
    "r": [0.09, 0, 0],
    "c": 5263440,
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [302, 84, -1],
    "s": [4, 3, 46],
    "c": 12927811,
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [302, 87, -13],
    "s": [4, 3, 22],
    "c": 12927811,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [302, 38, 91],
    "s": [4, 38, 38],
    "c": 12927811,
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [302, 76, 91],
    "s": [4, 3, 38],
    "c": 12927811,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [138, 66, 81],
    "s": [4, 15, 34],
    "c": 12927811,
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [138, 87, -14],
    "s": [4, 1, 4],
    "c": 12927811,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [56, 1, 115],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [56, 6, 111],
    "s": [1, 3, 1],
    "c": 8882055,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [56, 1, 109],
    "s": [3, 6, 6],
    "c": 12927811,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [40, 10, 48],
    "s": [24, 2, 100],
    "pe": 1,
    "c": 2899797,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [40, 37, 48],
    "s": [28, 2, 100],
    "pe": 1,
    "c": "#2c3f55",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [40, 3, 38],
    "s": [27, 4, 4],
    "c": 8551805,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [40, 3, 22],
    "s": [27, 4, 4],
    "c": 8551805,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [29, 1, 22],
    "s": [4, 8, 8],
    "c": 1447446,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [29, 1, 38],
    "s": [4, 8, 8],
    "c": 1447446,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [34, 1, 38],
    "s": [4, 8, 8],
    "c": 1447446,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [34, 1, 22],
    "s": [4, 8, 8],
    "c": 1447446,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [51, 1, 38],
    "s": [4, 8, 8],
    "c": 1447446,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [46, 1, 38],
    "s": [4, 8, 8],
    "c": 1447446,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [51, 1, 22],
    "s": [4, 8, 8],
    "c": 1447446,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [46, 1, 22],
    "s": [4, 8, 8],
    "c": 1447446,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [40, 12, 97],
    "s": [24, 25, 2],
    "pe": 1,
    "c": "#2c3f55",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [40, 6, 59],
    "s": [5, 4, 85],
    "c": 8551805,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [40, 6, -1],
    "s": [24, 4, 3],
    "c": 8551805,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [47, 12, -2],
    "s": [12, 25, 2],
    "pe": 1,
    "c": "#6b6b6b",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [26, 12, 3],
    "s": [2, 25, 12],
    "c": "#6b6b6b",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [40, 5, -1],
    "s": [27, 1, 4],
    "c": 8551805,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [40, 3, 110],
    "s": [27, 4, 4],
    "c": 8551805,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [51, 1, 110],
    "s": [4, 8, 8],
    "c": 1447446,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [29, 1, 110],
    "s": [4, 8, 8],
    "c": 1447446,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [50, 7, -2],
    "s": [2, 2, 2],
    "l": 1,
    "c": 16730880,
    "e": 16711680,
    "o": 0.8,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [30, 7, -2],
    "s": [2, 2, 2],
    "l": 1,
    "c": "#ff4b00",
    "e": 16711680,
    "o": 0.8,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [40, 5, 102],
    "s": [24, 28, 4],
    "c": "#bbbbbb",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [40, 5, 118],
    "s": [24, 24, 4],
    "c": "#bbbbbb",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [40, 6, 111],
    "s": [17, 6, 14],
    "c": "#595959",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [40, 5, 121],
    "s": [25, 6, 3],
    "c": "#5c5c5c",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [40, 17, 122],
    "s": [22, 10, 1],
    "l": 1,
    "c": "#22272d",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [40, 11, 121],
    "s": [24, 6, 2],
    "c": "#bbbbbb",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [40, 17, 121],
    "s": [24, 11, 2],
    "l": 1,
    "c": "#bbbbbb",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [40, 17, 121],
    "s": [24, 11, 2],
    "v": 1,
    "c": "#213041",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [50, 12, 122],
    "s": [2, 2, 2],
    "l": 1,
    "e": 16765184,
    "o": 0.8,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [30, 12, 122],
    "s": [2, 2, 2],
    "l": 1,
    "e": 16765184,
    "o": 0.8,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [40, 12, 122],
    "s": [14, 4, 2],
    "c": "#6e6e6e",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [40, 20, 118],
    "s": [28, 4, 1],
    "c": "#6e6e6e",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [40, 3, 86],
    "s": [22, 6, 22],
    "c": 8551805,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [30, 12, 100],
    "s": [1, 25, 1],
    "c": "#666666",
    "e": 1579032,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [50, 12, 100],
    "s": [1, 25, 1],
    "c": "#666666",
    "e": 1579032,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [40, 8, 49],
    "s": [28, 2, 98],
    "pe": 1,
    "v": 1,
    "c": 2899797,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [40, 20, 113],
    "s": [25, 8, 8],
    "c": "#22272d",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [40, 12, 111],
    "s": [24, 18, 14],
    "c": "#bbbbbb",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [45, 12, 46],
    "s": [6, 2, 92],
    "l": 1,
    "c": 7035206,
    "t": 2,
    "ts": 0,
    "td": 0
  }, {
    "p": [47, 12, -3],
    "s": [4, 25, 2],
    "i": 3,
    "t": 2,
    "d": 3
  }, {
    "p": [11, 1, 22],
    "s": [4, 7, 4],
    "i": 16,
    "l": 1
  }, {
    "p": [56, 1, -12],
    "s": [4, 7, 4],
    "i": 16,
    "l": 1
  }, {
    "p": [23, 1, -12],
    "s": [4, 7, 4],
    "i": 16,
    "l": 1
  }, {
    "p": [35, 12, 87],
    "s": [12, 12, 12],
    "i": 8
  }, {
    "p": [27, 10, 78],
    "s": [2, 27, 40],
    "pe": 1,
    "c": "#2c3f55",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [27, 10, 19],
    "s": [2, 27, 42],
    "pe": 1,
    "c": "#2c3f55",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [53, 10, 89],
    "s": [2, 27, 18],
    "pe": 1,
    "c": "#2c3f55",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [53, 10, 30],
    "s": [2, 27, 64],
    "pe": 1,
    "c": "#2c3f55",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [53, 32, 71],
    "s": [1, 5, 18],
    "c": "#ffffff",
    "t": 10,
    "ts": 0,
    "td": 0
  }, {
    "p": [27, 32, 49],
    "s": [1, 5, 18],
    "c": "#ffffff",
    "t": 10,
    "ts": 0,
    "td": 0
  }, {
    "p": [53, 10, 71],
    "s": [2, 2, 18],
    "c": "#2c3f55",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [27, 10, 49],
    "s": [2, 2, 18],
    "c": "#2c3f55",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [18, 1, 75],
    "s": [6, 2, 92],
    "c": 8678483,
    "t": 2,
    "ts": 0,
    "td": 0
  }, {
    "p": [11, 1, 74],
    "s": [6, 2, 92],
    "c": 7692103,
    "t": 2,
    "ts": 0,
    "td": 0
  }, {
    "p": [4, 1, 76],
    "s": [6, 2, 92],
    "c": 5259054,
    "t": 2,
    "ts": 0,
    "td": 0
  }, {
    "p": [6, 3, 75],
    "s": [6, 2, 92],
    "c": 7692103,
    "t": 2,
    "ts": 0,
    "td": 0
  }, {
    "p": [14, 3, 76],
    "s": [6, 2, 92],
    "c": 7692103,
    "t": 2,
    "ts": 0,
    "td": 0
  }, {
    "p": [10, 5, 76],
    "s": [6, 2, 92],
    "c": 7035206,
    "t": 2,
    "ts": 0,
    "td": 0
  }, {
    "p": [11, 1, 125],
    "s": [4, 7, 4],
    "i": 16,
    "l": 1
  }, {
    "p": [-34, 0, 61],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "c": "#d1f777"
  }, {
    "p": [-37, 0, -3],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "c": "#d1f777"
  }, {
    "p": [-26, 0, 37],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "c": "#d1f777"
  }, {
    "p": [-26, 0, -44],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "c": "#d1f777"
  }, {
    "p": [-39, 0, -96],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "c": "#d1f777"
  }, {
    "p": [-14, 0, -105],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "c": "#d1f777"
  }, {
    "p": [-5, 0, -102],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "c": "#d1f777"
  }, {
    "p": [6, 0, -127],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [36, -1, -101],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "c": "#d1f777"
  }, {
    "p": [60, 0, -124],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "c": "#d1f777"
  }, {
    "p": [90, 0, -128],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "c": "#d1f777"
  }, {
    "p": [99, 0, -136],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.79, 0],
    "c": "#d1f777"
  }, {
    "p": [106, 0, -118],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "c": "#d1f777"
  }, {
    "p": [106, 0, -84],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "c": "#d1f777"
  }, {
    "p": [85, 0, -29],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "c": "#d1f777"
  }, {
    "p": [131, -1, -22],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "c": "#d1f777"
  }, {
    "p": [84, 0, 12],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "c": "#d1f777"
  }, {
    "p": [131, 0, 27],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [83, 0, 59],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "c": "#d1f777"
  }, {
    "p": [86, 0, 119],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "c": "#d1f777"
  }, {
    "p": [158, 0, -153],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [90, 0, 166],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "c": "#d1f777"
  }, {
    "p": [87, 0, 238],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-27, 0, 237],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-33, 0, 202],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-31, 0, 149],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "c": "#d1f777"
  }, {
    "p": [-25, 0, 122],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "c": "#d1f777"
  }, {
    "p": [-69, 0, 174],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-96, 0, 201],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-67, 0, 201],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-170, 0, 201],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-147, 0, 174],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-216, 0, 180],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-216, 0, 172],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-247, 0, 198],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-247, 0, 118],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-180, 0, 68],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-151, 0, 69],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-151, 0, 125],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-243, 0, 50],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-241, 0, 79],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-215, 0, -5],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-184, 0, -46],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-257, 0, -12],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-254, 0, -128],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-218, 0, -88],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-196, 0, -147],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-204, 0, -143],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-134, 0, -149],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-99, 0, -113],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-158, 0, -100],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-35, 0, -153],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-65, 0, -118],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-28, 0, 308],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [103, 0, 279],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [109, 0, 302],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [85, 0, 338],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [94, 0, 362],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [144, 0, 353],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [160, 0, 323],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-26, -1, 381],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-33, -1, 413],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [84, -1, 414],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [133, 0, 69],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [132, 0, 112],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "c": "#d1f777"
  }, {
    "p": [151, 0, 131],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [189, 0, 132],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [229, 0, 156],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [271, 0, 118],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [286, 0, 156],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [334, 0, 156],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [308, 0, 114],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [308, 0, 59],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [349, 0, 38],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [371, 0, 135],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [395, 0, 116],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [391, 0, 22],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [396, 0, -1],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [307, 0, -18],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [296, 0, -34],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [260, 0, -35],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [260, 0, -72],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [394, 0, -43],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [404, 0, -49],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [429, 0, -60],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [405, 0, -153],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [292, 0, -154],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [206, 0, -125],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [177, 0, -154],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [177, 0, -147],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-10, 0, -108],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [64, 0, -126],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "c": "#d1f777"
  }, {
    "p": [-287, 0, -54],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [108, -1, 118],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "c": "#d1f777"
  }, {
    "p": [99, -1, 152],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "c": "#d1f777"
  }, {
    "p": [124, 0, 151],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [110, 0, 144],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "c": "#d1f777"
  }, {
    "p": [90, 0, 179],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "c": "#d1f777"
  }, {
    "p": [88, 0, 264],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-31, 0, 265],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-32, 0, 255],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-33, 0, 223],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [105, -1, 82],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "c": "#d1f777"
  }, {
    "p": [109, 0, 10],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "c": "#d1f777"
  }, {
    "p": [95, 0, -62],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "c": "#d1f777"
  }, {
    "p": [74, -1, -113],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "c": "#d1f777"
  }, {
    "p": [96, 0, -103],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "c": "#d1f777"
  }, {
    "p": [136, 0, -148],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [99, 0, -154],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.61, 0],
    "c": "#d1f777"
  }, {
    "p": [170, 0, -126],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [211, 0, -154],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [243, 0, -126],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [262, 0, -152],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [308, 0, -118],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [287, 0, -89],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [325, 0, -36],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [333, 0, -105],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [307, 0, -64],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [359, 0, -76],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [364, 0, -30],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [376, 0, 55],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [358, 0, 113],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [386, 0, 155],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [363, 0, -118],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [378, 0, -148],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [423, 0, -148],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [429, 0, -105],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [405, 0, -98],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [392, 0, -121],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [391, 0, -99],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [391, 0, -79],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [340, 0, 0],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [339, 0, 55],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [338, 0, 86],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-131, 0, 200],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-213, 0, 200],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-171, 0, 172],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-202, 0, 131],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-180, 0, 107],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-211, 0, 70],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-215, 0, 18],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-284, 0, 102],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-260, 0, 102],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-288, 0, 142],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-289, 0, 191],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-264, 0, 202],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-254, 0, 179],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-258, 0, 153],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-183, 2, 46],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-185, 0, 6],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-256, 0, 15],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-255, 0, 38],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-288, 0, 36],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-287, 0, 1],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-287, 0, -30],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-258, 0, -81],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-234, 0, -43],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-208, 0, -44],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-197, 0, -88],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-268, 0, -113],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-278, 0, -139],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-165, 0, -124],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-91, 0, -134],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-47, 0, 350],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1
  }, {
    "p": [-113, 85, -16],
    "s": [137, 10, 159],
    "i": 12,
    "l": 1
  }, {
    "p": [219, 85, 43],
    "s": [170, 10, 146],
    "i": 12,
    "l": 1
  }, {
    "p": [208, 50, -78],
    "s": [93, 10, 87],
    "i": 12,
    "l": 1
  }, {
    "p": [-105, 50, 119],
    "s": [87, 10, 99],
    "i": 12,
    "l": 1
  }]
}, {
  "name": "Sandstorm",
  "ambInd": 3,
  "modURL": "",
  "terrainSeed": "",
  "terrainWidth": 2048,
  "terrainHeight": 2048,
  "terrainMntMlt": 1,
  "terrainMntCol": "#a0a0a0",
  "terrainGrsCol": "#4a6904",
  "terrainDrtCol": "#8c6835",
  "skyDome": true,
  "skyDomeCol0": "#7bd7ff",
  "skyDomeCol1": "#f7d4b4",
  "skyDomeCol2": "#dce8ed",
  "zone": false,
  "zoneSize": 500,
  "zoneSpeed": 1,
  "zoneCol0": "#c542d9",
  "zoneCol1": "#c542d9",
  "zoneCol2": "#c542d9",
  "sizeMlt": 2,
  "shadowR": 1024,
  "ambient": 10654352,
  "light": 16777215,
  "sky": 14477549,
  "fog": 12294553,
  "fogD": 633.4396002067896,
  "dthY": -100,
  "modes": [0],
  "camPos": [-124, 62, -269],
  "spawns": [[0, 13, -3, 0], [-77, 33, -347, 0, 1], [278, 33, 122, 0, 2], [-105, 48, 86, 0, 1], [241, 33, -322, 0, 1], [-42, 48, 48, 0], [-39, 33, -210, 0, 3]],
  "ambO": 0.7,
  "ambS": 5,
  "shadLength": 387,
  "shadWidth": 425,
  "objects": [{
    "p": [-5, 12, 0],
    "s": [94, 1, 114],
    "t": 1
  }, {
    "p": [-67, 12, 0],
    "s": [30, 1, 44],
    "t": 1
  }, {
    "p": [-178, 32, 0],
    "s": [122, 1, 150],
    "t": 1
  }, {
    "p": [-163, 14, 157],
    "s": [154, 34, 56],
    "t": 1
  }, {
    "p": [-28, 9, 104],
    "s": [312, 39, 50],
    "t": 1
  }, {
    "p": [1, 47, -26],
    "s": [104, 1, 210],
    "t": 1
  }, {
    "p": [194, -4, 56],
    "s": [216, 37, 221],
    "t": 1
  }, {
    "p": [-175, 19, -137],
    "s": [53, 25, 64],
    "t": 1
  }, {
    "p": [64, 13, -4],
    "s": [44, 20, 36],
    "i": 9,
    "t": 1
  }, {
    "p": [-208, 33, 101],
    "s": [36, 15, 56],
    "i": 9,
    "t": 1,
    "d": 1
  }, {
    "p": [-174, 33, -89],
    "s": [48, 11, 32],
    "i": 9,
    "t": 1,
    "d": 3
  }, {
    "p": [-175, 33, -185],
    "s": [53, 11, 32],
    "i": 9,
    "t": 1,
    "d": 1
  }, {
    "p": [80, 33, -106],
    "s": [54, 15, 49],
    "i": 9,
    "t": 1,
    "d": 2
  }, {
    "p": [110, 33, 54],
    "s": [36, 15, 50],
    "i": 9,
    "t": 1,
    "d": 1
  }, {
    "p": [-138, 26, 76],
    "s": [104, 29, 6],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [-187, 26, 104],
    "s": [6, 29, 50],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [159, 32, 103],
    "s": [38, 1, 55],
    "t": 1
  }, {
    "p": [-50, 16, -225],
    "s": [6, 22, 25],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [-50, 16, -246],
    "s": [6, 36, 7],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [-50, 31, -207],
    "s": [6, 19, 11],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [-50, 38, -216],
    "s": [6, 4, 7],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [220, 33, 125],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-103, 32, -128],
    "s": [96, 2, 111],
    "l": 1,
    "c": "#393939",
    "t": 11
  }, {
    "p": [-103, 109, -129],
    "s": [100, 3, 117],
    "c": "#393939",
    "t": 11,
    "bo": 1
  }, {
    "p": [61, 87, -245],
    "s": [87, 4, 77],
    "c": 4868682,
    "t": 11,
    "bo": 1
  }, {
    "p": [20, 87, -167],
    "s": [169, 4, 79],
    "c": 4868682,
    "t": 11,
    "bo": 1
  }, {
    "p": [61, 30, -242],
    "s": [82, 4, 79],
    "l": 1,
    "c": "#4a4a4a",
    "t": 11
  }, {
    "p": [20, 30, -166],
    "s": [164, 4, 73],
    "l": 1,
    "c": "#4a4a4a",
    "t": 2
  }, {
    "p": [20, 32, -166],
    "s": [162, 55, 71],
    "c": "#ffd5b1",
    "bo": 1
  }, {
    "p": [-33, 51, -202],
    "s": [15, 1, 1],
    "c": 4868682,
    "t": 2
  }, {
    "p": [-40, 34, -202],
    "s": [1, 17, 1],
    "c": 4868682,
    "t": 2
  }, {
    "p": [-26, 34, -202],
    "s": [1, 17, 1],
    "c": 4868682,
    "t": 2
  }, {
    "p": [-33, 34, -201],
    "s": [13, 17, 2],
    "l": 1,
    "c": 8221547,
    "t": 2
  }, {
    "p": [-147, 112, -120],
    "s": [35, 3, 15],
    "c": 5263440,
    "t": 2,
    "bo": 1
  }, {
    "p": [-133, 33, -194],
    "s": [36, 1, 21],
    "l": 1,
    "c": "#4a4a4a",
    "t": 11
  }, {
    "p": [-159, 40, -308],
    "s": [87, 1, 57],
    "t": 1
  }, {
    "p": [-187, 33, -268],
    "s": [31, 8, 23],
    "i": 9,
    "t": 1,
    "d": 3
  }, {
    "p": [-141, 40, -270],
    "s": [51, 1, 19],
    "t": 1
  }, {
    "p": [-169, 17, -270],
    "s": [5, 29, 19],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [-141, 17, -258],
    "s": [61, 29, 5],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [-113, 17, -299],
    "s": [5, 29, 77],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [-103, 17, -129],
    "s": [94, 92, 112],
    "c": "#ffd5b1",
    "bo": 1
  }, {
    "p": [-97, 33, -349],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-197, 44, -155],
    "s": [1, 19, 6],
    "l": 1,
    "r": [0, 0, 0.17],
    "c": 8684676,
    "t": 2
  }, {
    "p": [-229, 32, -162],
    "s": [56, 45, 111],
    "c": "#ffd5b1",
    "bo": 1
  }, {
    "p": [-229, 77, -162],
    "s": [61, 3, 115],
    "c": 4868682,
    "t": 11,
    "bo": 1
  }, {
    "p": [-248, 32, -309],
    "s": [94, 94, 112],
    "c": "#ffd5b1",
    "bo": 1
  }, {
    "p": [-248, 126, -309],
    "s": [102, 3, 117],
    "c": 5723991,
    "t": 11,
    "bo": 1
  }, {
    "p": [-241, 32, -237],
    "s": [56, 33, 111],
    "c": "#9d8672",
    "t": 11,
    "bo": 1
  }, {
    "p": [-241, 65, -237],
    "s": [62, 3, 111],
    "c": 4868682,
    "t": 11,
    "bo": 1
  }, {
    "p": [-241, 31, -236],
    "s": [58, 3, 35],
    "l": 1,
    "c": "#4a4a4a",
    "t": 11
  }, {
    "p": [-229, 31, -162],
    "s": [58, 3, 112],
    "l": 1,
    "c": 4868682,
    "t": 2
  }, {
    "p": [-340, 32, -199],
    "s": [91, 73, 116],
    "c": "#ffd5b1"
  }, {
    "p": [-197, 44, -163],
    "s": [1, 19, 6],
    "l": 1,
    "r": [0, 0, 0.17],
    "c": 8684676,
    "t": 2
  }, {
    "p": [-63, 32, -411],
    "s": [81, 85, 112],
    "c": "#ffd5b1",
    "bo": 1
  }, {
    "p": [-170, 97, -392],
    "s": [140, 4, 120],
    "c": 4408131,
    "t": 11,
    "bo": 1
  }, {
    "p": [-110, 82, -335],
    "s": [4, 4, 8],
    "pe": 1,
    "c": 7039851,
    "t": 2,
    "bo": 1
  }, {
    "p": [-170, 32, -392],
    "s": [133, 65, 112],
    "c": "#ffd5b1",
    "bo": 1
  }, {
    "p": [-63, 117, -411],
    "s": [87, 4, 119],
    "c": 5066061,
    "t": 11,
    "bo": 1
  }, {
    "p": [-63, 154, -411],
    "s": [58, 3, 56],
    "c": 4868682,
    "t": 11
  }, {
    "p": [22, 61, -381],
    "s": [91, 32, 88],
    "c": "#ffd5b1"
  }, {
    "p": [-203, 134, -483],
    "s": [97, 5, 94],
    "c": 5395026,
    "t": 11
  }, {
    "p": [-103, 84, -129],
    "s": [95, 2, 113],
    "l": 1,
    "c": "#393939",
    "t": 11
  }, {
    "p": [-103, 59, -129],
    "s": [96, 2, 113],
    "l": 1,
    "c": "#393939",
    "t": 11
  }, {
    "p": [-63, 123, -411],
    "s": [52, 32, 49],
    "c": "#ffd5b1"
  }, {
    "p": [61, 32, -241],
    "s": [80, 55, 79],
    "c": "#ffd5b1",
    "bo": 1
  }, {
    "p": [-63, 89, -411],
    "s": [83, 2, 113],
    "l": 1,
    "c": "#4a4a4a",
    "t": 11
  }, {
    "p": [-63, 59, -411],
    "s": [83, 2, 113],
    "l": 1,
    "c": "#4a4a4a",
    "t": 11
  }, {
    "p": [-250, 82, -309],
    "s": [100, 2, 113],
    "l": 1,
    "c": "#4a4a4a",
    "t": 11
  }, {
    "p": [61, 59, -242],
    "s": [82, 2, 79],
    "l": 1,
    "c": "#4a4a4a",
    "t": 11
  }, {
    "p": [20, 59, -166],
    "s": [164, 2, 73],
    "l": 1,
    "c": "#4a4a4a",
    "t": 11
  }, {
    "p": [-63, 32, -411],
    "s": [83, 2, 113],
    "l": 1,
    "c": "#4a4a4a",
    "t": 11
  }, {
    "p": [-151, 82, -335],
    "s": [4, 4, 9],
    "pe": 1,
    "c": 7039851,
    "t": 2,
    "bo": 1
  }, {
    "p": [-189, 82, -335],
    "s": [4, 4, 10],
    "pe": 1,
    "c": 7039851,
    "t": 2,
    "bo": 1
  }, {
    "p": [-133, 32, -194],
    "s": [34, 27, 18],
    "c": "#ffd5b1"
  }, {
    "p": [15, 45, -208],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [15, 33, -220],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-204, 32, -485],
    "s": [91, 102, 87],
    "c": "#ffd5b1"
  }, {
    "p": [22, 90, -381],
    "s": [98, 4, 93],
    "c": "#525252",
    "t": 11,
    "bo": 1
  }, {
    "p": [22, 59, -381],
    "s": [92, 2, 89],
    "l": 1,
    "c": "#525252",
    "t": 11
  }, {
    "p": [22, 32, -381],
    "s": [93, 2, 89],
    "l": 1,
    "c": "#525252",
    "t": 11
  }, {
    "p": [253, 32, -160],
    "s": [64, 53, 72],
    "c": "#ffd5b1",
    "bo": 1
  }, {
    "p": [193, 95, -293],
    "s": [70, 3, 117],
    "c": "#4a4a4a",
    "t": 11,
    "bo": 1
  }, {
    "p": [193, 54, -292],
    "s": [69, 2, 115],
    "l": 1,
    "c": "#4a4a4a",
    "t": 11
  }, {
    "p": [193, 32, -285],
    "s": [70, 2, 101],
    "l": 1,
    "c": "#4a4a4a",
    "t": 11
  }, {
    "p": [154, 59, -273],
    "s": [18, 2, 44],
    "pe": 1,
    "c": 9539985,
    "t": 2
  }, {
    "p": [147, 33, -293],
    "s": [2, 29, 2],
    "pe": 1,
    "c": 9539985,
    "t": 2
  }, {
    "p": [147, 33, -253],
    "s": [2, 29, 2],
    "pe": 1,
    "c": 9539985,
    "t": 2
  }, {
    "p": [158, 33, -244],
    "s": [1, 38, 4],
    "i": 3,
    "t": 2,
    "d": 2
  }, {
    "p": [129, 32, -403],
    "s": [124, 73, 93],
    "c": "#ffd5b1"
  }, {
    "p": [129, 105, -404],
    "s": [132, 4, 115],
    "c": "#525252",
    "t": 11,
    "bo": 1
  }, {
    "p": [168, 33, -404],
    "s": [44, 1, 115],
    "l": 1,
    "c": "#4a4a4a",
    "t": 11
  }, {
    "p": [129, 33, -355],
    "s": [37, 36, 6],
    "c": 8553090,
    "t": 2,
    "bo": 1
  }, {
    "p": [236, 32, -367],
    "s": [90, 32, 61],
    "c": "#ffd5b1",
    "bo": 1
  }, {
    "p": [236, 64, -367],
    "s": [97, 5, 68],
    "c": 5395026,
    "t": 2,
    "bo": 1
  }, {
    "p": [236, 29, -367],
    "s": [92, 5, 63],
    "l": 1,
    "c": "#4a4a4a",
    "t": 11
  }, {
    "p": [74, 33, -341],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [57, 33, -288],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [261, 33, -330],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [273, 33, -330],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-213, 59, -246],
    "s": [10, 4, 4],
    "pe": 1,
    "c": 7039851,
    "t": 2,
    "bo": 1
  }, {
    "p": [-213, 59, -225],
    "s": [10, 4, 4],
    "pe": 1,
    "c": 7039851,
    "t": 2,
    "bo": 1
  }, {
    "p": [-59, 33, -336],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-59, 33, -348],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-50, 16, -360],
    "s": [6, 40, 15],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [-50, 16, -270],
    "s": [6, 40, 41],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [-50, 16, -240],
    "s": [6, 29, 5],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [-50, 38, -234],
    "s": [6, 2, 7],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [-50, 50, -204],
    "s": [6, 6, 5],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [-50, 56, -286],
    "s": [6, 3, 9],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [-50, 56, -270],
    "s": [6, 2, 9],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [-50, 56, -254],
    "s": [6, 3, 9],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [-50, 56, -200],
    "s": [6, 3, 9],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [-50, 56, -319],
    "s": [6, 2, 9],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [-50, 56, -334],
    "s": [6, 3, 7],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [15, 33, -208],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [3, 33, -208],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-9, 33, -208],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-158, 41, -330],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-146, 41, -330],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-124, 41, -269],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [169, 32, -352],
    "s": [44, 73, 9],
    "c": "#ffd5b1",
    "bo": 1
  }, {
    "p": [90, 32, -352],
    "s": [46, 73, 9],
    "c": "#ffd5b1",
    "bo": 1
  }, {
    "p": [130, 69, -352],
    "s": [34, 36, 9],
    "c": "#ffd5b1",
    "bo": 1
  }, {
    "p": [86, 33, -341],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [319, 32, -317],
    "s": [79, 58, 183],
    "c": "#ffd5b1",
    "bo": 1
  }, {
    "p": [319, 90, -317],
    "s": [87, 4, 189],
    "c": "#4a4a4a",
    "t": 11,
    "bo": 1
  }, {
    "p": [319, 60, -281],
    "s": [80, 2, 112],
    "l": 1,
    "c": "#4a4a4a",
    "t": 11
  }, {
    "p": [319, 32, -281],
    "s": [81, 2, 113],
    "l": 1,
    "c": "#4a4a4a",
    "t": 11
  }, {
    "p": [281, 70, -240],
    "s": [4, 14, 9],
    "l": 1,
    "c": 8553090,
    "t": 2
  }, {
    "p": [281, 70, -270],
    "s": [4, 14, 9],
    "l": 1,
    "c": 8553090,
    "t": 2
  }, {
    "p": [282, 69, -270],
    "s": [7, 1, 10],
    "l": 1,
    "c": 5066061,
    "t": 2
  }, {
    "p": [282, 69, -240],
    "s": [7, 1, 10],
    "l": 1,
    "c": 5066061,
    "t": 2
  }, {
    "p": [126, 43, -355],
    "s": [3, 5, 8],
    "c": "#464646",
    "t": 5
  }, {
    "p": [327, 32, -470],
    "s": [142, 99, 87],
    "c": "#ffd5b1"
  }, {
    "p": [328, 130, -470],
    "s": [152, 4, 96],
    "c": 4868682,
    "t": 11
  }, {
    "p": [191, 32, -555],
    "s": [109, 76, 87],
    "c": "#ffd5b1"
  }, {
    "p": [191, 105, -557],
    "s": [113, 5, 100],
    "c": 5395026,
    "t": 11
  }, {
    "p": [325, 32, -186],
    "s": [80, 77, 79],
    "c": "#ffd5b1",
    "bo": 1
  }, {
    "p": [326, 109, -185],
    "s": [88, 3, 86],
    "c": 4868682,
    "t": 11,
    "bo": 1
  }, {
    "p": [326, 86, -186],
    "s": [83, 2, 80],
    "l": 1,
    "c": "#4a4a4a",
    "t": 11
  }, {
    "p": [326, 60, -186],
    "s": [83, 2, 80],
    "l": 1,
    "c": "#4a4a4a",
    "t": 11
  }, {
    "p": [168, 62, -160],
    "s": [20, 2, 44],
    "c": "#7d7d7d",
    "t": 2,
    "bo": 1
  }, {
    "p": [176, 64, -180],
    "s": [2, 7, 2],
    "c": "#7d7d7d",
    "t": 2
  }, {
    "p": [176, 71, -160],
    "s": [3, 1, 44],
    "c": "#7d7d7d",
    "t": 2
  }, {
    "p": [171, 71, -181],
    "s": [7, 1, 2],
    "c": "#7d7d7d",
    "t": 2
  }, {
    "p": [167, 64, -160],
    "s": [1, 17, 13],
    "l": 1,
    "c": 8221547,
    "t": 2
  }, {
    "p": [167, 81, -160],
    "s": [2, 1, 15],
    "l": 1,
    "c": 4868682,
    "t": 2
  }, {
    "p": [167, 64, -167],
    "s": [2, 17, 1],
    "l": 1,
    "c": 4868682,
    "t": 2
  }, {
    "p": [299, 32, -100],
    "s": [52, 63, 93],
    "c": "#ffd5b1",
    "bo": 1
  }, {
    "p": [326, 32, -185],
    "s": [84, 2, 79],
    "l": 1,
    "c": "#4a4a4a",
    "t": 11
  }, {
    "p": [299, 95, -100],
    "s": [57, 3, 97],
    "c": 5395026,
    "t": 11,
    "bo": 1
  }, {
    "p": [278, 29, -100],
    "s": [12, 5, 95],
    "l": 1,
    "c": "#4a4a4a",
    "t": 11
  }, {
    "p": [265, 39, -256],
    "s": [3, 1, 30],
    "c": 9539985,
    "t": 2
  }, {
    "p": [265, 33, -256],
    "s": [1, 6, 30],
    "c": 9539985,
    "t": 2
  }, {
    "p": [241, 33, -281],
    "s": [1, 6, 30],
    "c": 9539985,
    "t": 2
  }, {
    "p": [241, 39, -281],
    "s": [3, 1, 30],
    "c": 9539985,
    "t": 2
  }, {
    "p": [233, 63, -265],
    "s": [20, 2, 4],
    "l": 1,
    "r": [0, 0, -0.18],
    "c": 4399894,
    "t": 5
  }, {
    "p": [233, 63, -269],
    "s": [20, 2, 4],
    "l": 1,
    "r": [0, 0, -0.18],
    "c": 6710886,
    "t": 5
  }, {
    "p": [233, 63, -277],
    "s": [20, 2, 4],
    "l": 1,
    "r": [0, 0, -0.18],
    "c": 6710886,
    "t": 5
  }, {
    "p": [233, 63, -293],
    "s": [20, 2, 4],
    "l": 1,
    "r": [0, 0, -0.18],
    "c": 6710886,
    "t": 5
  }, {
    "p": [233, 63, -273],
    "s": [20, 2, 4],
    "l": 1,
    "r": [0, 0, -0.18],
    "c": 4399894,
    "t": 5
  }, {
    "p": [233, 63, -281],
    "s": [20, 2, 4],
    "l": 1,
    "r": [0, 0, -0.18],
    "c": 4399894,
    "t": 5
  }, {
    "p": [233, 63, -289],
    "s": [20, 2, 4],
    "l": 1,
    "r": [0, 0, -0.18],
    "c": 4399894,
    "t": 5
  }, {
    "p": [233, 63, -297],
    "s": [20, 2, 4],
    "l": 1,
    "r": [0, 0, -0.18],
    "c": 4399894,
    "t": 5
  }, {
    "p": [-133, 59, -195],
    "s": [36, 2, 19],
    "l": 1,
    "c": "#4a4a4a",
    "t": 11
  }, {
    "p": [-133, 60, -194],
    "s": [34, 1, 19],
    "pe": 1,
    "v": 1,
    "c": 4408131,
    "t": 2
  }, {
    "p": [215, 33, -179],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [215, 33, -167],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [199, 33, -86],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [173, 30, -341],
    "s": [2, 8, 2],
    "l": 1,
    "c": 5988172,
    "t": 5
  }, {
    "p": [325, 32, -14],
    "s": [80, 55, 79],
    "c": "#ffd5b1",
    "bo": 1
  }, {
    "p": [319, 32, 135],
    "s": [68, 76, 115],
    "c": "#ffd5b1",
    "bo": 1
  }, {
    "p": [325, 87, -14],
    "s": [86, 3, 85],
    "c": "#525252",
    "t": 11,
    "bo": 1
  }, {
    "p": [325, 29, -14],
    "s": [82, 5, 81],
    "l": 1,
    "c": "#4a4a4a",
    "t": 11
  }, {
    "p": [304, 32, 30],
    "s": [13, 43, 9],
    "c": "#ffd5b1",
    "bo": 1
  }, {
    "p": [304, 32, 73],
    "s": [13, 43, 9],
    "c": "#ffd5b1",
    "bo": 1
  }, {
    "p": [304, 75, 51],
    "s": [13, 9, 53],
    "c": "#ffd5b1",
    "bo": 1
  }, {
    "p": [302, 43, 47],
    "s": [3, 8, 3],
    "c": "#4d4d4d",
    "t": 5,
    "bo": 1
  }, {
    "p": [302, 33, 51],
    "s": [1, 42, 39],
    "c": 8553090,
    "t": 2,
    "bo": 1
  }, {
    "p": [325, 60, -14],
    "s": [81, 2, 80],
    "l": 1,
    "c": "#4a4a4a",
    "t": 11
  }, {
    "p": [304, 77, 51],
    "s": [26, 4, 4],
    "pe": 1,
    "c": 7039851,
    "t": 2,
    "bo": 1
  }, {
    "p": [304, 77, 62],
    "s": [26, 4, 4],
    "pe": 1,
    "c": 7039851,
    "t": 2,
    "bo": 1
  }, {
    "p": [304, 77, 72],
    "s": [26, 4, 4],
    "pe": 1,
    "c": 7039851,
    "t": 2,
    "bo": 1
  }, {
    "p": [304, 77, 40],
    "s": [26, 4, 4],
    "pe": 1,
    "c": 7039851,
    "t": 2,
    "bo": 1
  }, {
    "p": [304, 77, 30],
    "s": [26, 4, 4],
    "pe": 1,
    "c": 7039851,
    "t": 2,
    "bo": 1
  }, {
    "p": [431, 12, -96],
    "s": [92, 102, 160],
    "c": "#ffd5b1"
  }, {
    "p": [431, 113, -96],
    "s": [99, 4, 165],
    "c": 4868682,
    "t": 11
  }, {
    "p": [319, 108, 135],
    "s": [74, 3, 121],
    "c": 5395026,
    "t": 11,
    "bo": 1
  }, {
    "p": [319, 83, 135],
    "s": [69, 2, 116],
    "l": 1,
    "c": "#4a4a4a",
    "t": 11
  }, {
    "p": [319, 56, 135],
    "s": [69, 2, 116],
    "l": 1,
    "c": "#4a4a4a",
    "t": 11
  }, {
    "p": [94, -2, -52],
    "s": [80, 114, 60],
    "c": "#ffd5b1",
    "bo": 1
  }, {
    "p": [180, 32, -48],
    "s": [92, 40, 64],
    "c": "#ffd5b1",
    "bo": 1
  }, {
    "p": [180, 72, -48],
    "s": [95, 4, 66],
    "c": 4868682,
    "t": 11,
    "bo": 1
  }, {
    "p": [94, 111, -52],
    "s": [88, 4, 67],
    "c": 4868682,
    "t": 11,
    "bo": 1
  }, {
    "p": [94, 32, -52],
    "s": [82, 2, 61],
    "l": 1,
    "c": "#393939",
    "t": 11
  }, {
    "p": [180, 32, -48],
    "s": [94, 2, 65],
    "l": 1,
    "c": "#4a4a4a",
    "t": 11
  }, {
    "p": [319, 32, 135],
    "s": [70, 2, 117],
    "l": 1,
    "c": "#4a4a4a",
    "t": 11
  }, {
    "p": [92, 33, -404],
    "s": [44, 1, 115],
    "l": 1,
    "c": "#4a4a4a",
    "t": 11
  }, {
    "p": [-144, 32, -345],
    "s": [83, 2, 20],
    "l": 1,
    "c": "#a5a5a5",
    "t": 2
  }, {
    "p": [269, 29, -76],
    "s": [6, 5, 25],
    "l": 1,
    "c": "#4a4a4a",
    "t": 11
  }, {
    "p": [-156, 44, -136],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [280, 33, 0],
    "s": [1, 23, 6],
    "l": 1,
    "r": [0, 0, -0.18],
    "c": 8684676,
    "t": 2
  }, {
    "p": [281, 33, 10],
    "s": [1, 18, 6],
    "l": 1,
    "r": [0, 0, -0.18],
    "c": 8684676,
    "t": 2
  }, {
    "p": [240, 32, 163],
    "s": [92, 51, 64],
    "c": "#ffd5b1",
    "bo": 1
  }, {
    "p": [240, 83, 163],
    "s": [97, 3, 70],
    "c": 5395026,
    "t": 11,
    "bo": 1
  }, {
    "p": [239, 56, 163],
    "s": [91, 2, 65],
    "l": 1,
    "c": "#4a4a4a",
    "t": 11
  }, {
    "p": [240, 32, 163],
    "s": [90, 2, 66],
    "l": 1,
    "c": "#4a4a4a",
    "t": 11
  }, {
    "p": [235, 57, 123],
    "s": [49, 2, 17],
    "pe": 1,
    "c": "#616161",
    "t": 2
  }, {
    "p": [213, 32, 117],
    "s": [2, 28, 2],
    "pe": 1,
    "c": "#616161",
    "t": 2
  }, {
    "p": [257, 32, 117],
    "s": [2, 28, 2],
    "pe": 1,
    "c": "#616161",
    "t": 2
  }, {
    "p": [205, 33, 130],
    "s": [5, 34, 1],
    "i": 3,
    "t": 2,
    "d": 3
  }, {
    "p": [94, 59, -52],
    "s": [81, 2, 61],
    "l": 1,
    "c": "#393939",
    "t": 11
  }, {
    "p": [94, 86, -52],
    "s": [81, 2, 61],
    "l": 1,
    "c": "#393939",
    "t": 11
  }, {
    "p": [226, 34, -67],
    "s": [1, 17, 13],
    "l": 1,
    "c": 8221547,
    "t": 2
  }, {
    "p": [226, 34, -60],
    "s": [2, 17, 1],
    "l": 1,
    "c": 4868682,
    "t": 2
  }, {
    "p": [226, 51, -67],
    "s": [2, 1, 15],
    "l": 1,
    "c": 4868682,
    "t": 2
  }, {
    "p": [226, 34, -74],
    "s": [2, 17, 1],
    "l": 1,
    "c": 4868682,
    "t": 2
  }, {
    "p": [-159, 76, -120],
    "s": [2, 38, 2],
    "l": 1,
    "c": 12303291,
    "t": 2
  }, {
    "p": [158, 32, 72],
    "s": [60, 68, 93],
    "c": "#ffd5b1",
    "bo": 1
  }, {
    "p": [158, 67, 72],
    "s": [61, 2, 94],
    "l": 1,
    "c": "#393939",
    "t": 11
  }, {
    "p": [142, 75, 31],
    "s": [5, 14, 9],
    "l": 1,
    "c": 8553090,
    "t": 2
  }, {
    "p": [142, 74, 31],
    "s": [6, 1, 10],
    "l": 1,
    "c": 5066061,
    "t": 2
  }, {
    "p": [194, 33, 34],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [149, 38, 158],
    "s": [70, 60, 79],
    "c": "#ffd5b1",
    "bo": 1
  }, {
    "p": [77, 32, 169],
    "s": [74, 69, 80],
    "c": "#ffd5b1",
    "bo": 1
  }, {
    "p": [192, 33, 125],
    "s": [6, 1, 15],
    "l": 1,
    "c": "#4a4a4a",
    "t": 11
  }, {
    "p": [77, 101, 169],
    "s": [81, 4, 87],
    "c": "#525252",
    "t": 11,
    "bo": 1
  }, {
    "p": [77, 76, 169],
    "s": [74, 2, 81],
    "l": 1,
    "c": "#393939",
    "t": 11
  }, {
    "p": [77, 47, 169],
    "s": [74, 2, 81],
    "l": 1,
    "c": "#393939",
    "t": 11
  }, {
    "p": [154, 33, 115],
    "s": [47, 1, 5],
    "l": 1,
    "c": 5395026,
    "t": 2
  }, {
    "p": [115, 33, -16],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [127, 33, -16],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [79, 61, 14],
    "s": [10, 1, 2],
    "l": 1,
    "c": 5066061,
    "t": 2
  }, {
    "p": [182, 79, 32],
    "s": [5, 14, 9],
    "l": 1,
    "c": 8553090,
    "t": 2
  }, {
    "p": [182, 78, 32],
    "s": [6, 1, 10],
    "l": 1,
    "c": 5066061,
    "t": 2
  }, {
    "p": [-97, 33, -199],
    "s": [30, 6, 1],
    "c": 9539985,
    "t": 2
  }, {
    "p": [-113, 33, -199],
    "s": [2, 25, 2],
    "c": 9539985,
    "t": 2
  }, {
    "p": [-81, 33, -199],
    "s": [2, 25, 2],
    "c": 9539985,
    "t": 2
  }, {
    "p": [-97, 39, -199],
    "s": [30, 1, 3],
    "c": 9539985,
    "t": 2
  }, {
    "p": [-81, 58, -193],
    "s": [4, 2, 20],
    "l": 1,
    "r": [-0.17, 0, 0],
    "c": 4081241,
    "t": 5
  }, {
    "p": [-113, 58, -193],
    "s": [4, 2, 20],
    "l": 1,
    "r": [-0.17, 0, 0],
    "c": 4081241,
    "t": 5
  }, {
    "p": [-85, 58, -193],
    "s": [4, 2, 20],
    "l": 1,
    "r": [-0.17, 0, 0],
    "c": 8026746,
    "t": 5
  }, {
    "p": [-109, 58, -193],
    "s": [4, 2, 20],
    "l": 1,
    "r": [-0.17, 0, 0],
    "c": 8026746,
    "t": 5
  }, {
    "p": [-105, 58, -193],
    "s": [4, 2, 20],
    "l": 1,
    "r": [-0.17, 0, 0],
    "c": 4081241,
    "t": 5
  }, {
    "p": [-101, 58, -193],
    "s": [4, 2, 20],
    "l": 1,
    "r": [-0.17, 0, 0],
    "c": 8026746,
    "t": 5
  }, {
    "p": [-97, 58, -193],
    "s": [4, 2, 20],
    "l": 1,
    "r": [-0.17, 0, 0],
    "c": 4081241,
    "t": 5
  }, {
    "p": [-89, 58, -193],
    "s": [4, 2, 20],
    "l": 1,
    "r": [-0.17, 0, 0],
    "c": 4081241,
    "t": 5
  }, {
    "p": [-93, 58, -193],
    "s": [4, 2, 20],
    "l": 1,
    "r": [-0.17, 0, 0],
    "c": 8026746,
    "t": 5
  }, {
    "p": [65, 91, 51],
    "s": [58, 4, 80],
    "c": 4868682,
    "t": 11,
    "bo": 1
  }, {
    "p": [133, 33, 22],
    "s": [4, 17, 1],
    "l": 1,
    "r": [0.17, 0, 0],
    "c": 8684676,
    "t": 2
  }, {
    "p": [140, 33, 22],
    "s": [4, 17, 1],
    "l": 1,
    "r": [0.17, 0, 0],
    "c": 8684676,
    "t": 2
  }, {
    "p": [65, 54, 51],
    "s": [55, 2, 75],
    "l": 1,
    "c": "#393939",
    "t": 11
  }, {
    "p": [79, 62, 16],
    "s": [9, 14, 5],
    "l": 1,
    "c": 8553090,
    "t": 2
  }, {
    "p": [-102, 34, -17],
    "s": [42, 61, 62],
    "c": "#ffd5b1",
    "bo": 1
  }, {
    "p": [-102, 92, -17],
    "s": [47, 4, 67],
    "c": 4868682,
    "t": 11,
    "bo": 1
  }, {
    "p": [-102, 32, -18],
    "s": [44, 2, 62],
    "l": 1,
    "c": "#393939",
    "t": 11
  }, {
    "p": [206, 13, -15],
    "s": [15, 74, 7],
    "c": "#ffd5b1",
    "bo": 1
  }, {
    "p": [206, 32, -13],
    "s": [17, 2, 5],
    "l": 1,
    "c": "#4a4a4a",
    "t": 11
  }, {
    "p": [180, 30, 115],
    "s": [2, 9, 2],
    "l": 1,
    "c": 5988172,
    "t": 5
  }, {
    "p": [-87, 100, 47],
    "s": [67, 4, 72],
    "c": 4868682,
    "t": 11,
    "bo": 1
  }, {
    "p": [-87, 102, 48],
    "s": [45, 10, 55],
    "c": "#ffd5b1"
  }, {
    "p": [-87, 112, 48],
    "s": [51, 4, 61],
    "c": "#4a4a4a",
    "t": 11
  }, {
    "p": [-87, 76, 47],
    "s": [63, 2, 67],
    "l": 1,
    "c": "#393939",
    "t": 11
  }, {
    "p": [-87, 52, 47],
    "s": [63, 2, 67],
    "l": 1,
    "c": "#393939",
    "t": 11
  }, {
    "p": [-67, 84, 26],
    "s": [9, 14, 7],
    "l": 1,
    "c": 8553090,
    "t": 2
  }, {
    "p": [-67, 83, 23],
    "s": [10, 1, 2],
    "l": 1,
    "c": 5066061,
    "t": 2
  }, {
    "p": [73, 32, 52],
    "s": [40, 2, 78],
    "l": 1,
    "c": "#393939",
    "t": 11
  }, {
    "p": [65, 13, 51],
    "s": [54, 79, 74],
    "c": "#ffd5b1",
    "bo": 1
  }, {
    "p": [28, 12, -46],
    "s": [169, 2, 54],
    "c": "#6e6e6e",
    "t": 2
  }, {
    "p": [27, 12, 37],
    "s": [167, 2, 52],
    "c": "#6e6e6e",
    "t": 2
  }, {
    "p": [-52, 46, -32],
    "s": [8, 31, 210],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [50, 46, -28],
    "s": [8, 31, 117],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [50, 77, -80],
    "s": [8, 2, 13],
    "l": 1,
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [50, 77, -58],
    "s": [8, 3, 15],
    "l": 1,
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [50, 77, -36],
    "s": [8, 5, 13],
    "l": 1,
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [50, 77, -14],
    "s": [8, 3, 16],
    "l": 1,
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [50, 77, 8],
    "s": [8, 4, 13],
    "l": 1,
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [-52, 77, 8],
    "s": [8, 4, 13],
    "l": 1,
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [-52, 77, 30],
    "s": [8, 4, 13],
    "l": 1,
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [-52, 77, 74],
    "s": [8, 4, 14],
    "l": 1,
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [-52, 77, 52],
    "s": [8, 3, 13],
    "l": 1,
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [-52, 77, -14],
    "s": [8, 2, 13],
    "l": 1,
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [-52, 77, -36],
    "s": [8, 4, 13],
    "l": 1,
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [-52, 77, -58],
    "s": [8, 3, 16],
    "l": 1,
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [-52, 77, -80],
    "s": [8, 4, 10],
    "l": 1,
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [-52, 77, -102],
    "s": [8, 3, 13],
    "l": 1,
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [-52, 77, -124],
    "s": [8, 4, 13],
    "l": 1,
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [-1, 12, 19],
    "s": [110, 34, 14],
    "c": "#786555",
    "t": 11
  }, {
    "p": [-1, 11, -51],
    "s": [110, 35, 62],
    "c": "#786555",
    "t": 11
  }, {
    "p": [-1, 46, -2],
    "s": [94, 1, 57],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [-51, 32, 188],
    "s": [73, 76, 116],
    "c": "#ffd5b1",
    "bo": 1
  }, {
    "p": [-124, 32, 215],
    "s": [73, 76, 62],
    "c": "#ffd5b1",
    "bo": 1
  }, {
    "p": [-197, 32, 217],
    "s": [73, 52, 79],
    "c": "#ffd5b1",
    "bo": 1
  }, {
    "p": [13, 47, 163],
    "s": [60, 2, 81],
    "l": 1,
    "c": "#393939",
    "t": 11
  }, {
    "p": [-52, 47, 157],
    "s": [73, 2, 56],
    "l": 1,
    "c": "#393939",
    "t": 11
  }, {
    "p": [-126, 47, 211],
    "s": [75, 2, 55],
    "l": 1,
    "c": "#393939",
    "t": 11
  }, {
    "p": [-265, -3, 183],
    "s": [63, 104, 108],
    "c": "#ffd5b1",
    "bo": 1
  }, {
    "p": [-268, 62, 74],
    "s": [84, 55, 111],
    "c": "#ffd5b1"
  }, {
    "p": [-268, 32, -10],
    "s": [73, 56, 60],
    "c": "#ffd5b1",
    "bo": 1
  }, {
    "p": [-232, 61, -73],
    "s": [68, 49, 68],
    "c": "#ffd5b1"
  }, {
    "p": [-51, 108, 187],
    "s": [81, 3, 121],
    "c": "#393939",
    "t": 11,
    "bo": 1
  }, {
    "p": [-128, 108, 214],
    "s": [73, 3, 68],
    "c": 5395026,
    "t": 11,
    "bo": 1
  }, {
    "p": [-70, 32, 127],
    "s": [28, 64, 10],
    "c": "#ffd5b1",
    "bo": 1
  }, {
    "p": [-70, 47, 125],
    "s": [30, 2, 8],
    "l": 1,
    "c": "#393939",
    "t": 11
  }, {
    "p": [-51, 77, 157],
    "s": [75, 2, 56],
    "l": 1,
    "c": "#393939",
    "t": 11
  }, {
    "p": [-126, 77, 211],
    "s": [75, 2, 55],
    "l": 1,
    "c": "#393939",
    "t": 11
  }, {
    "p": [-117, 50, 154],
    "s": [25, 1, 25],
    "c": "#9d9d9d",
    "t": 1
  }, {
    "p": [-14, 24, -245],
    "s": [29, 13, 3],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [-117, 24, 168],
    "s": [31, 28, 3],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [-103, 24, 154],
    "s": [3, 28, 25],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [-131, 24, 154],
    "s": [3, 28, 25],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [-196, 47, 180],
    "s": [73, 2, 7],
    "l": 1,
    "c": "#393939",
    "t": 11
  }, {
    "p": [-242, 47, 154],
    "s": [19, 2, 57],
    "l": 1,
    "c": "#393939",
    "t": 11
  }, {
    "p": [-242, 73, 154],
    "s": [19, 2, 57],
    "l": 1,
    "h": 190,
    "c": "#393939",
    "t": 11
  }, {
    "p": [-196, 84, 214],
    "s": [80, 3, 81],
    "c": 5395026,
    "t": 11,
    "bo": 1
  }, {
    "p": [67, 33, -285],
    "s": [6, 8, 6],
    "i": 2,
    "r": [0, -1.57, 0]
  }, {
    "p": [-265, 101, 178],
    "s": [70, 3, 124],
    "c": 5395026,
    "t": 11,
    "bo": 1
  }, {
    "p": [-228, 32, 49],
    "s": [5, 2, 62],
    "l": 1,
    "c": "#393939",
    "t": 11
  }, {
    "p": [-234, 32, -9],
    "s": [7, 2, 63],
    "l": 1,
    "c": "#393939",
    "t": 11
  }, {
    "p": [-214, 32, -71],
    "s": [34, 2, 65],
    "l": 1,
    "c": "#393939",
    "t": 11
  }, {
    "p": [-265, 117, 74],
    "s": [86, 3, 119],
    "c": "#393939",
    "t": 11,
    "bo": 1
  }, {
    "p": [431, 40, -96],
    "s": [66, 102, 125],
    "c": "#ffd5b1"
  }, {
    "p": [431, 141, -96],
    "s": [77, 4, 135],
    "c": 4868682,
    "t": 11
  }, {
    "p": [-266, 78, -11],
    "s": [78, 3, 59],
    "c": 5395026,
    "t": 11,
    "bo": 1
  }, {
    "p": [-232, 109, -73],
    "s": [74, 3, 72],
    "c": "#393939",
    "t": 11,
    "bo": 1
  }, {
    "p": [-239, 62, 74],
    "s": [27, 2, 112],
    "l": 1,
    "c": "#393939",
    "t": 11
  }, {
    "p": [-268, 88, 74],
    "s": [85, 2, 112],
    "l": 1,
    "c": "#393939",
    "t": 11
  }, {
    "p": [-232, 60, -73],
    "s": [69, 2, 69],
    "l": 1,
    "c": "#393939",
    "t": 11
  }, {
    "p": [-232, 84, -73],
    "s": [69, 2, 69],
    "l": 1,
    "c": "#393939",
    "t": 11
  }, {
    "p": [-227, 48, 171],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-215, 48, 171],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-78, 48, 86],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-176, 48, 87],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-125, 33, 67],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-137, 33, 67],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-90, 48, 86],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-225, 33, -34],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-213, 33, -34],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-129, 33, -33],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-179, 48, 174],
    "s": [6, 19, 1],
    "l": 1,
    "r": [0.17, 0, 0],
    "c": 8684676,
    "t": 2
  }, {
    "p": [-189, 48, 174],
    "s": [6, 19, 1],
    "l": 1,
    "r": [0.17, 0, 0],
    "c": 8684676,
    "t": 2
  }, {
    "p": [-228, 120, 42],
    "s": [35, 3, 15],
    "c": 5263440,
    "t": 2,
    "bo": 1
  }, {
    "p": [-217, 69, 42],
    "s": [2, 53, 2],
    "l": 1,
    "c": 12303291,
    "t": 2
  }, {
    "p": [-232, 34, 3],
    "s": [2, 17, 13],
    "l": 1,
    "c": 8221547,
    "t": 2
  }, {
    "p": [-231, 34, -4],
    "s": [1, 17, 1],
    "c": "#a5a5a5",
    "t": 2
  }, {
    "p": [-231, 34, 10],
    "s": [1, 17, 1],
    "c": "#a5a5a5",
    "t": 2
  }, {
    "p": [-231, 51, 3],
    "s": [1, 1, 15],
    "c": "#a5a5a5",
    "t": 2
  }, {
    "p": [-232, 72, 14],
    "s": [10, 3, 3],
    "pe": 1,
    "c": 7039851,
    "t": 2,
    "bo": 1
  }, {
    "p": [-232, 72, -11],
    "s": [10, 3, 3],
    "pe": 1,
    "c": 7039851,
    "t": 2,
    "bo": 1
  }, {
    "p": [-232, 72, 1],
    "s": [10, 3, 3],
    "pe": 1,
    "c": 7039851,
    "t": 2,
    "bo": 1
  }, {
    "p": [-232, 72, -24],
    "s": [10, 3, 3],
    "pe": 1,
    "c": 7039851,
    "t": 2,
    "bo": 1
  }, {
    "p": [-232, 72, -35],
    "s": [10, 3, 3],
    "pe": 1,
    "c": 7039851,
    "t": 2,
    "bo": 1
  }, {
    "p": [-222, 32, 59],
    "s": [1, 23, 4],
    "l": 1,
    "r": [0, 0, 0.17],
    "c": 8684676,
    "t": 2
  }, {
    "p": [-222, 33, 52],
    "s": [1, 16, 4],
    "l": 1,
    "r": [0, 0, 0.17],
    "c": 8684676,
    "t": 2
  }, {
    "p": [-55, 13, -19],
    "s": [4, 34, 2],
    "l": 1,
    "c": "#575757",
    "t": 2
  }, {
    "p": [-55, 45, -4],
    "s": [4, 2, 28],
    "l": 1,
    "c": "#575757",
    "t": 2
  }, {
    "p": [47, 48, 123],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [110, 48, 125],
    "s": [6, 8, 6],
    "i": 2,
    "r": [0, 1.57, 0]
  }, {
    "p": [40, 48, -78],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [29, 47, -28],
    "s": [2, 31, 2],
    "pe": 1,
    "c": 9539985,
    "t": 2
  }, {
    "p": [29, 47, 4],
    "s": [2, 31, 2],
    "pe": 1,
    "c": 9539985,
    "t": 2
  }, {
    "p": [36, 78, 4],
    "s": [21, 2, 4],
    "l": 1,
    "r": [0, 0, 0.17],
    "c": 5385783,
    "t": 5
  }, {
    "p": [36, 78, -4],
    "s": [21, 2, 4],
    "l": 1,
    "r": [0, 0, 0.17],
    "c": 5385783,
    "t": 5
  }, {
    "p": [36, 78, 0],
    "s": [21, 2, 4],
    "l": 1,
    "r": [0, 0, 0.17],
    "c": 7237230,
    "t": 5
  }, {
    "p": [36, 78, -8],
    "s": [21, 2, 4],
    "l": 1,
    "r": [0, 0, 0.17],
    "c": 7237230,
    "t": 5
  }, {
    "p": [36, 78, -12],
    "s": [21, 2, 4],
    "l": 1,
    "r": [0, 0, 0.17],
    "c": 5385783,
    "t": 5
  }, {
    "p": [36, 78, -16],
    "s": [21, 2, 4],
    "l": 1,
    "r": [0, 0, 0.17],
    "c": 7237230,
    "t": 5
  }, {
    "p": [36, 78, -20],
    "s": [21, 2, 4],
    "l": 1,
    "r": [0, 0, 0.17],
    "c": 5385783,
    "t": 5
  }, {
    "p": [36, 78, -24],
    "s": [21, 2, 4],
    "l": 1,
    "r": [0, 0, 0.17],
    "c": 7237230,
    "t": 5
  }, {
    "p": [36, 78, -28],
    "s": [21, 2, 4],
    "l": 1,
    "r": [0, 0, 0.17],
    "c": 5385783,
    "t": 5
  }, {
    "p": [29, 47, -12],
    "s": [1, 7, 30],
    "pe": 1,
    "c": 9539985,
    "t": 2
  }, {
    "p": [29, 54, -12],
    "s": [3, 1, 30],
    "pe": 1,
    "c": 9539985,
    "t": 2
  }, {
    "p": [40, 48, -66],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [46, 47, 4],
    "s": [2, 33, 2],
    "l": 1,
    "c": 9539985,
    "t": 2
  }, {
    "p": [46, 47, -28],
    "s": [2, 33, 2],
    "l": 1,
    "c": 9539985,
    "t": 2
  }, {
    "p": [-30, 47, 8],
    "s": [2, 31, 2],
    "pe": 1,
    "c": 9539985,
    "t": 2
  }, {
    "p": [-38, 78, 8],
    "s": [22, 2, 4],
    "l": 1,
    "r": [0, 0, -0.18],
    "c": 3030610,
    "t": 5
  }, {
    "p": [-38, 78, 12],
    "s": [22, 2, 4],
    "l": 1,
    "r": [0, 0, -0.18],
    "c": 7895160,
    "t": 5
  }, {
    "p": [-38, 78, 20],
    "s": [22, 2, 4],
    "l": 1,
    "r": [0, 0, -0.18],
    "c": 7895160,
    "t": 5
  }, {
    "p": [-38, 78, 16],
    "s": [22, 2, 4],
    "l": 1,
    "r": [0, 0, -0.18],
    "c": 3030610,
    "t": 5
  }, {
    "p": [-38, 78, 24],
    "s": [22, 2, 4],
    "l": 1,
    "r": [0, 0, -0.18],
    "c": 3030610,
    "t": 5
  }, {
    "p": [-38, 78, 28],
    "s": [22, 2, 4],
    "l": 1,
    "r": [0, 0, -0.18],
    "c": 7895160,
    "t": 5
  }, {
    "p": [-38, 78, 32],
    "s": [22, 2, 4],
    "l": 1,
    "r": [0, 0, -0.18],
    "c": 3030610,
    "t": 5
  }, {
    "p": [-38, 78, 36],
    "s": [22, 2, 4],
    "l": 1,
    "r": [0, 0, -0.18],
    "c": 7895160,
    "t": 5
  }, {
    "p": [-38, 78, 40],
    "s": [22, 2, 4],
    "l": 1,
    "r": [0, 0, -0.18],
    "c": 3030610,
    "t": 5
  }, {
    "p": [-30, 47, 40],
    "s": [2, 31, 2],
    "pe": 1,
    "c": 9539985,
    "t": 2
  }, {
    "p": [-30, 47, 24],
    "s": [1, 7, 30],
    "pe": 1,
    "c": 9539985,
    "t": 2
  }, {
    "p": [-30, 54, 24],
    "s": [3, 1, 30],
    "pe": 1,
    "c": 9539985,
    "t": 2
  }, {
    "p": [-48, 47, 8],
    "s": [2, 33, 2],
    "l": 1,
    "c": 9539985,
    "t": 2
  }, {
    "p": [-48, 47, 40],
    "s": [2, 33, 2],
    "l": 1,
    "c": 9539985,
    "t": 2
  }, {
    "p": [-30, 47, -59],
    "s": [2, 31, 2],
    "pe": 1,
    "c": 9539985,
    "t": 2
  }, {
    "p": [-38, 78, -59],
    "s": [22, 2, 4],
    "l": 1,
    "r": [0, 0, -0.18],
    "c": 5849386,
    "t": 5
  }, {
    "p": [-38, 78, -63],
    "s": [22, 2, 4],
    "l": 1,
    "r": [0, 0, -0.18],
    "c": 7895160,
    "t": 5
  }, {
    "p": [-38, 78, -67],
    "s": [22, 2, 4],
    "l": 1,
    "r": [0, 0, -0.18],
    "c": 5849386,
    "t": 5
  }, {
    "p": [-38, 78, -71],
    "s": [22, 2, 4],
    "l": 1,
    "r": [0, 0, -0.18],
    "c": 7895160,
    "t": 5
  }, {
    "p": [-38, 78, -75],
    "s": [22, 2, 4],
    "l": 1,
    "r": [0, 0, -0.18],
    "c": 5849386,
    "t": 5
  }, {
    "p": [-38, 78, -79],
    "s": [22, 2, 4],
    "l": 1,
    "r": [0, 0, -0.18],
    "c": 7895160,
    "t": 5
  }, {
    "p": [-38, 78, -83],
    "s": [22, 2, 4],
    "l": 1,
    "r": [0, 0, -0.18],
    "c": 5849386,
    "t": 5
  }, {
    "p": [-38, 78, -87],
    "s": [22, 2, 4],
    "l": 1,
    "r": [0, 0, -0.18],
    "c": 7895160,
    "t": 5
  }, {
    "p": [-38, 78, -91],
    "s": [22, 2, 4],
    "l": 1,
    "r": [0, 0, -0.18],
    "c": 5849386,
    "t": 5
  }, {
    "p": [-30, 47, -91],
    "s": [2, 31, 2],
    "pe": 1,
    "c": 9539985,
    "t": 2
  }, {
    "p": [-48, 47, -59],
    "s": [2, 33, 2],
    "l": 1,
    "c": 9539985,
    "t": 2
  }, {
    "p": [-48, 47, -91],
    "s": [2, 33, 2],
    "l": 1,
    "c": 9539985,
    "t": 2
  }, {
    "p": [-30, 47, -75],
    "s": [1, 7, 30],
    "pe": 1,
    "c": 9539985,
    "t": 2
  }, {
    "p": [-30, 54, -75],
    "s": [3, 1, 30],
    "pe": 1,
    "c": 9539985,
    "t": 2
  }, {
    "p": [-44, 47, -17],
    "s": [1, 23, 5],
    "l": 1,
    "r": [0, 0, 0.17],
    "c": 8684676,
    "t": 2
  }, {
    "p": [-44, 47, -8],
    "s": [1, 23, 5],
    "l": 1,
    "r": [0, 0, 0.17],
    "c": 8684676,
    "t": 2
  }, {
    "p": [35, 91, -143],
    "s": [12, 12, 12],
    "i": 1,
    "l": 1,
    "r": [0, -0.35, 0]
  }, {
    "p": [32, 48, 43],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [32, 48, 67],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [32, 48, 55],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-40, 46, 77],
    "s": [32, 31, 8],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [26, 46, 77],
    "s": [24, 31, 8],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [-46, 77, 77],
    "s": [4, 4, 8],
    "l": 1,
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [-30, 77, 77],
    "s": [8, 3, 12],
    "l": 1,
    "r": [0, -1.57, 0],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [20, 77, 77],
    "s": [8, 2, 12],
    "l": 1,
    "r": [0, -1.57, 0],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [36, 77, 77],
    "s": [4, 2, 8],
    "l": 1,
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [-42, 48, 67],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [227, 33, -297],
    "s": [3, 32, 2],
    "l": 1,
    "c": 9539985,
    "t": 2
  }, {
    "p": [227, 33, -265],
    "s": [3, 32, 2],
    "l": 1,
    "c": 9539985,
    "t": 2
  }, {
    "p": [280, 33, -240],
    "s": [4, 32, 2],
    "l": 1,
    "c": 9539985,
    "t": 2
  }, {
    "p": [-159, 41, -308],
    "s": [83, 50, 55],
    "i": 14,
    "l": 1
  }, {
    "p": [240, 33, 106],
    "s": [87, 50, 45],
    "i": 14,
    "l": 1
  }, {
    "p": [-151, 48, 104],
    "s": [64, 50, 48],
    "i": 14,
    "l": 1
  }, {
    "p": [-1, 48, -23],
    "s": [89, 50, 72],
    "i": 14,
    "l": 1
  }, {
    "p": [-1, 48, -35],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-1, 48, -23],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-195, 41, -309],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-195, 53, -309],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [158, 100, 72],
    "s": [67, 3, 101],
    "c": 4868682,
    "t": 11,
    "bo": 1
  }, {
    "p": [158, 32, 72],
    "s": [62, 2, 95],
    "l": 1,
    "c": "#393939",
    "t": 11
  }, {
    "p": [126, 41, 94],
    "s": [6, 48, 24],
    "c": "#ffd5b1",
    "bo": 1
  }, {
    "p": [169, 32, -341],
    "s": [22, 2, 11],
    "l": 1,
    "c": "#4a4a4a",
    "t": 11
  }, {
    "p": [153, 33, -325],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [188, 32, -222],
    "s": [291, 1, 335],
    "t": 1
  }, {
    "p": [134, 32, -160],
    "s": [66, 76, 72],
    "c": "#ffd5b1",
    "bo": 1
  }, {
    "p": [193, 54, -292],
    "s": [68, 43, 114],
    "c": "#ffd5b1"
  }, {
    "p": [273, 63, -240],
    "s": [20, 2, 4],
    "l": 1,
    "r": [0, 0, 0.17],
    "c": 6116223,
    "t": 1
  }, {
    "p": [273, 63, -244],
    "s": [20, 2, 4],
    "l": 1,
    "r": [0, 0, 0.17],
    "c": 7895160,
    "t": 5
  }, {
    "p": [273, 63, -252],
    "s": [20, 2, 4],
    "l": 1,
    "r": [0, 0, 0.17],
    "c": 7895160,
    "t": 5
  }, {
    "p": [273, 63, -248],
    "s": [20, 2, 4],
    "l": 1,
    "r": [0, 0, 0.17],
    "c": 6116223,
    "t": 1
  }, {
    "p": [273, 63, -256],
    "s": [20, 2, 4],
    "l": 1,
    "r": [0, 0, 0.17],
    "c": 6116223,
    "t": 1
  }, {
    "p": [273, 63, -264],
    "s": [20, 2, 4],
    "l": 1,
    "r": [0, 0, 0.17],
    "c": 6116223,
    "t": 1
  }, {
    "p": [273, 63, -260],
    "s": [20, 2, 4],
    "l": 1,
    "r": [0, 0, 0.17],
    "c": 7895160,
    "t": 5
  }, {
    "p": [273, 63, -272],
    "s": [20, 2, 4],
    "l": 1,
    "r": [0, 0, 0.17],
    "c": 6116223,
    "t": 1
  }, {
    "p": [273, 63, -268],
    "s": [20, 2, 4],
    "l": 1,
    "r": [0, 0, 0.17],
    "c": 7895160,
    "t": 5
  }, {
    "p": [280, 33, -272],
    "s": [4, 32, 2],
    "l": 1,
    "c": 9539985,
    "t": 2
  }, {
    "p": [134, 108, -160],
    "s": [71, 4, 77],
    "c": "#4a4a4a",
    "t": 11,
    "bo": 1
  }, {
    "p": [246, 29, -160],
    "s": [52, 5, 74],
    "l": 1,
    "c": "#4a4a4a",
    "t": 11
  }, {
    "p": [278, 29, -174],
    "s": [12, 5, 46],
    "l": 1,
    "c": 5395026,
    "t": 2
  }, {
    "p": [252, 60, -160],
    "s": [63, 2, 73],
    "l": 1,
    "c": "#4a4a4a",
    "t": 11
  }, {
    "p": [284, 60, -160],
    "s": [1, 2, 73],
    "l": 1,
    "c": 5395026,
    "t": 2
  }, {
    "p": [253, 85, -160],
    "s": [67, 3, 75],
    "c": "#4a4a4a",
    "t": 11,
    "bo": 1
  }, {
    "p": [135, 29, -160],
    "s": [66, 5, 74],
    "l": 1,
    "c": "#4a4a4a",
    "t": 11
  }, {
    "p": [135, 59, -160],
    "s": [66, 2, 73],
    "l": 1,
    "c": "#4a4a4a",
    "t": 11
  }, {
    "p": [101, 59, -126],
    "s": [2, 2, 5],
    "l": 1,
    "c": "#a5a5a5",
    "t": 2
  }, {
    "p": [101, 59, -129],
    "s": [2, 2, 1],
    "l": 1,
    "c": "#a5a5a5",
    "t": 2
  }, {
    "p": [134, 84, -160],
    "s": [67, 2, 73],
    "l": 1,
    "c": "#4a4a4a",
    "t": 11
  }, {
    "p": [176, 64, -140],
    "s": [2, 7, 2],
    "c": "#393939",
    "t": 2
  }, {
    "p": [171, 71, -139],
    "s": [7, 1, 2],
    "c": "#7d7d7d",
    "t": 2
  }, {
    "p": [167, 64, -153],
    "s": [2, 17, 1],
    "l": 1,
    "c": 4868682,
    "t": 2
  }, {
    "p": [171, 33, -155],
    "s": [1, 20, 6],
    "l": 1,
    "r": [0, 0, 0.17],
    "c": "#616161",
    "t": 2
  }, {
    "p": [171, 33, -142],
    "s": [1, 20, 6],
    "l": 1,
    "r": [0, 0, 0.17],
    "c": "#616161",
    "t": 2
  }, {
    "p": [144, 33, -202],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [144, 45, -202],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [181, 33, -229],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [267, 33, -118],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [21, 33, -331],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [21, 45, -331],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-41, 33, -349],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-14, 35, -258],
    "s": [23, 1, 23],
    "c": "#9d9d9d",
    "t": 1
  }, {
    "p": [-117, 24, 140],
    "s": [31, 28, 3],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [-27, 24, -258],
    "s": [3, 13, 23],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [-14, 24, -271],
    "s": [29, 13, 3],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [-1, 24, -258],
    "s": [3, 13, 23],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [281, 32, 80],
    "s": [9, 14, 4],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [218, 32, 80],
    "s": [5, 16, 5],
    "c": "#9d8672"
  }, {
    "p": [148, 33, -118],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [233, 63, -285],
    "s": [20, 2, 4],
    "l": 1,
    "r": [0, 0, -0.18],
    "c": 6710886,
    "t": 5
  }, {
    "p": [279, 33, 108],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [203, 32, 80],
    "s": [30, 15, 4],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [255, 32, 80],
    "s": [5, 16, 5],
    "c": "#9d8672"
  }, {
    "p": [-166, 48, 85],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [-229, 48, 134],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [-229, 48, 141],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [-229, 48, 148],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [-147, 33, 69],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [-41, 13, 8],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [-34, 13, 8],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [-92, 48, 180],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [-92, 48, 173],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [-153, 44, -127],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [-134, 41, -267],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [-198, 41, -299],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [-208, 33, -249],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [-208, 33, -242],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [-30, 33, -350],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [11, 33, -333],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [96, 33, -343],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [154, 33, -282],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [154, 33, -275],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [191, 33, -231],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [280, 33, -201],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [280, 33, -208],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [257, 33, -120],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [189, 33, -84],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [230, 33, -36],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [230, 33, -29],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [193, 33, 44],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [230, 33, 127],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [237, 33, 127],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [-68, 48, 84],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [22, 48, 69],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [-44, 48, 57],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [-44, 48, -26],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [-44, 48, -114],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [9, 48, -24],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [395, 7, 103],
    "s": [80, 88, 59],
    "c": "#ffd5b1"
  }, {
    "p": [396, 95, 104],
    "s": [88, 4, 67],
    "c": 4868682,
    "t": 11
  }, {
    "p": [184, 32, 235],
    "s": [102, 76, 49],
    "c": "#ffd5b1"
  }, {
    "p": [184, 108, 235],
    "s": [109, 5, 57],
    "c": 5395026,
    "t": 11
  }, {
    "p": [-89, 33, -137],
    "s": [54, 1, 97],
    "l": 1,
    "c": "#4a4a4a",
    "t": 11
  }, {
    "p": [-121, 32, 14],
    "s": [6, 2, 2],
    "l": 1,
    "c": "#393939",
    "t": 11
  }, {
    "p": [-68, 32, 47],
    "s": [26, 2, 68],
    "l": 1,
    "c": 4868682,
    "t": 2
  }, {
    "p": [-102, 62, -17],
    "s": [43, 2, 63],
    "l": 1,
    "c": "#393939",
    "t": 11
  }, {
    "p": [-123, 34, 0],
    "s": [1, 17, 13],
    "l": 1,
    "c": 8221547,
    "t": 2
  }, {
    "p": [-122, 34, -7],
    "s": [4, 17, 1],
    "c": 4868682,
    "t": 2
  }, {
    "p": [-122, 34, 7],
    "s": [4, 17, 1],
    "c": 4868682,
    "t": 2
  }, {
    "p": [-122, 51, 0],
    "s": [4, 1, 15],
    "c": 4868682,
    "t": 2
  }, {
    "p": [-60, 24, -69],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [-84, 43, -34],
    "s": [7, 14, 9],
    "l": 1,
    "c": 8553090,
    "t": 2
  }, {
    "p": [-84, 42, -34],
    "s": [8, 1, 10],
    "l": 1,
    "c": 5066061,
    "t": 2
  }, {
    "p": [-111, 10, -62],
    "s": [12, 23, 43],
    "t": 1
  }, {
    "p": [-93, 24, -62],
    "s": [24, 9, 28],
    "i": 9,
    "t": 1,
    "d": 2
  }, {
    "p": [241, 33, -297],
    "s": [2, 30, 2],
    "c": 9539985,
    "t": 2,
    "bo": 1
  }, {
    "p": [241, 33, -265],
    "s": [2, 30, 2],
    "c": 9539985,
    "t": 2,
    "bo": 1
  }, {
    "p": [265, 33, -272],
    "s": [2, 30, 2],
    "c": 9539985,
    "t": 2,
    "bo": 1
  }, {
    "p": [265, 33, -240],
    "s": [2, 30, 2],
    "c": 9539985,
    "t": 2,
    "bo": 1
  }, {
    "p": [-61, 3, -61],
    "s": [40, 21, 26],
    "t": 1
  }, {
    "p": [-69, 13, -35],
    "s": [26, 11, 26],
    "i": 9,
    "t": 1,
    "d": 3
  }, {
    "p": [-85, 32, -318],
    "s": [255, 1, 281],
    "c": "#ffffff",
    "t": 1
  }, {
    "p": [52, 33, -106],
    "s": [2, 14, 50],
    "t": 1
  }, {
    "p": [302, 43, 57],
    "s": [3, 8, 3],
    "c": "#4d4d4d",
    "t": 5,
    "bo": 1
  }, {
    "p": [134, 43, -355],
    "s": [3, 5, 8],
    "c": "#464646",
    "t": 5
  }, {
    "p": [-40, 33, -219],
    "s": [4, 2, 3],
    "l": 1,
    "r": [0, 0.52, 0],
    "c": "#9d8672"
  }, {
    "p": [-59, 33, -230],
    "s": [6, 2, 4],
    "l": 1,
    "r": [0, -0.52, 0],
    "c": "#9d8672"
  }, {
    "p": [-64, 33, -223],
    "s": [4, 2, 4],
    "l": 1,
    "c": "#9d8672"
  }, {
    "p": [400, 123, -68],
    "s": [5, 14, 9],
    "l": 1,
    "c": 8553090,
    "t": 2
  }, {
    "p": [400, 122, -68],
    "s": [6, 1, 10],
    "l": 1,
    "c": 5066061,
    "t": 2
  }, {
    "p": [236, 33, 101],
    "s": [24, 36, 24],
    "i": 23,
    "l": 1,
    "tm": 0
  }, {
    "p": [-144, 41, -301],
    "s": [24, 36, 24],
    "i": 23,
    "l": 1,
    "tm": "1"
  }, {
    "p": [-205, 32, -237],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.96, 0],
    "c": "#d2b559"
  }, {
    "p": [-208, 32, -224],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, 1.13, -3.14],
    "c": "#d2b559"
  }, {
    "p": [-65, 32, -191],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, 1.13, -3.14]
  }, {
    "p": [-78, 32, -198],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, -0.62, -3.14]
  }, {
    "p": [-57, 32, -205],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, -0.62, -3.14]
  }, {
    "p": [-100, 32, -340],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, -0.62, -3.14]
  }, {
    "p": [-67, 32, -351],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -1.3, 0]
  }, {
    "p": [-87, 32, -352],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.53, 0]
  }, {
    "p": [-50, 16, -326],
    "s": [6, 40, 23],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [-50, 16, -345],
    "s": [6, 34, 15],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [-28, 32, -343],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.86, 0]
  }, {
    "p": [-19, 32, -206],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.86, 0]
  }, {
    "p": [-22, 35, -252],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.6, 0]
  }, {
    "p": [-9, 35, -265],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [3.14, -0.97, 3.14]
  }, {
    "p": [-191, 39, -300],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, 0.61, -3.14]
  }, {
    "p": [-167, 40, -331],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, 0.61, -3.14]
  }, {
    "p": [-136, 41, -332],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, 0.61, -3.14]
  }, {
    "p": [-197, 40, -333],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, 0.61, -3.14]
  }, {
    "p": [-120, 40, -278],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, 0.61, -3.14]
  }, {
    "p": [-134, 40, -273],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, -1.05, -3.14]
  }, {
    "p": [-152, 32, -205],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, -0.36, -3.14]
  }, {
    "p": [23, 32, -286],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.86, 0]
  }, {
    "p": [4, 32, -217],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.86, 0]
  }, {
    "p": [16, 32, -229],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.16, 0]
  }, {
    "p": [-107, 32, -258],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, -0.88, -3.14]
  }, {
    "p": [-106, 33, -296],
    "s": [6, 2, 4],
    "l": 1,
    "r": [0, -1.39, 0],
    "c": "#9d8672"
  }, {
    "p": [5, 32, -333],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.86, 0]
  }, {
    "p": [12, 32, -326],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.1, 0]
  }, {
    "p": [31, 32, -333],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.71, 0]
  }, {
    "p": [48, 32, -291],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.71, 0]
  }, {
    "p": [68, 32, -333],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.71, 0]
  }, {
    "p": [73, 32, -284],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.71, 0]
  }, {
    "p": [156, 32, -316],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.71, 0]
  }, {
    "p": [149, 32, -278],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.8, 0]
  }, {
    "p": [156, 32, -344],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.71, 0]
  }, {
    "p": [103, 32, -282],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.08, 0]
  }, {
    "p": [105, 32, -249],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.97, 0]
  }, {
    "p": [-70, 96, 130],
    "s": [30, 4, 23],
    "l": 1,
    "r": [-0.52, 0, 0],
    "c": 5395026,
    "t": 11
  }, {
    "p": [-70, 69, 123],
    "s": [15, 1, 6],
    "l": 1,
    "c": 5066061,
    "t": 2
  }, {
    "p": [-70, 68, 121],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [0, 1.57, 0]
  }, {
    "p": [39, 32, -283],
    "s": [25, 2, 9],
    "l": 1,
    "c": "#a5a5a5",
    "t": 2
  }, {
    "p": [39, 14, -282],
    "s": [24, 64, 10],
    "c": "#ffd5b1",
    "bo": 1
  }, {
    "p": [39, 79, -278],
    "s": [25, 3, 22],
    "r": [-0.35, 0, 0],
    "c": 5395026,
    "t": 11,
    "bo": 1
  }, {
    "p": [38, 51, -286],
    "s": [15, 1, 7],
    "l": 1,
    "c": 5066061,
    "t": 2
  }, {
    "p": [38, 50, -288],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [0, 1.57, 0]
  }, {
    "p": [263, 14, -197],
    "s": [24, 64, 10],
    "c": "#ffd5b1",
    "bo": 1
  }, {
    "p": [263, 79, -193],
    "s": [26, 3, 22],
    "l": 1,
    "r": [-0.35, 0, 0],
    "c": 5395026,
    "t": 11
  }, {
    "p": [262, 51, -201],
    "s": [15, 1, 7],
    "l": 1,
    "c": 5066061,
    "t": 2
  }, {
    "p": [262, 50, -203],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [0, 1.57, 0]
  }, {
    "p": [-146, 87, 185],
    "s": [15, 1, 6],
    "l": 1,
    "c": 5066061,
    "t": 2
  }, {
    "p": [-146, 86, 183],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [0, 1.57, 0]
  }, {
    "p": [100, 82, 130],
    "s": [15, 1, 6],
    "l": 1,
    "c": 5066061,
    "t": 2
  }, {
    "p": [100, 81, 128],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [0, 1.57, 0]
  }, {
    "p": [-82, 91, -184],
    "s": [15, 1, 6],
    "l": 1,
    "c": 5066061,
    "t": 2
  }, {
    "p": [-82, 90, -186],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [0, 1.57, 0]
  }, {
    "p": [-133, 37, -188],
    "s": [28, 64, 10],
    "c": "#ffd5b1",
    "bo": 1
  }, {
    "p": [-133, 52, -190],
    "s": [30, 2, 8],
    "l": 1,
    "c": "#a5a5a5",
    "t": 2
  }, {
    "p": [-133, 101, -185],
    "s": [30, 4, 23],
    "l": 1,
    "r": [-0.52, 0, 0],
    "c": 5395026,
    "t": 11
  }, {
    "p": [-133, 74, -192],
    "s": [15, 1, 6],
    "l": 1,
    "c": 5066061,
    "t": 2
  }, {
    "p": [-133, 73, -194],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [0, 1.57, 0]
  }, {
    "p": [87, 66, -281],
    "s": [15, 1, 4],
    "l": 1,
    "c": 5066061,
    "t": 2
  }, {
    "p": [87, 65, -282],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [0, 1.57, 0]
  }, {
    "p": [13, 32, 160],
    "s": [55, 110, 60],
    "c": "#ffd5b1"
  }, {
    "p": [13, 37, 128],
    "s": [56, 64, 10],
    "c": "#ffd5b1",
    "bo": 1
  }, {
    "p": [13, 98, 126],
    "s": [59, 4, 14],
    "l": 1,
    "r": [-0.52, 0, 0],
    "c": 5395026,
    "t": 11
  }, {
    "p": [27, 74, 124],
    "s": [15, 1, 6],
    "l": 1,
    "c": 5066061,
    "t": 2
  }, {
    "p": [27, 73, 122],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [0, 1.57, 0]
  }, {
    "p": [13, 141, 160],
    "s": [58, 3, 62],
    "c": "#393939",
    "t": 11
  }, {
    "p": [-2, 73, 122],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [0, 1.57, 0]
  }, {
    "p": [-2, 74, 124],
    "s": [15, 1, 6],
    "l": 1,
    "c": 5066061,
    "t": 2
  }, {
    "p": [-43, 131, 149],
    "s": [58, 1, 34],
    "c": "#393939",
    "t": 11
  }, {
    "p": [-43, 111, 149],
    "s": [58, 5, 34],
    "c": "#ffd5b1"
  }, {
    "p": [-69, 111, 135],
    "s": [2, 22, 2],
    "c": "#393939",
    "t": 2
  }, {
    "p": [-17, 111, 135],
    "s": [2, 22, 2],
    "c": "#393939",
    "t": 2
  }, {
    "p": [-44, 111, 135],
    "s": [2, 22, 2],
    "c": "#393939",
    "t": 2
  }, {
    "p": [-44, 111, 164],
    "s": [2, 22, 2],
    "c": "#393939",
    "t": 2
  }, {
    "p": [-69, 111, 163],
    "s": [2, 22, 2],
    "c": "#393939",
    "t": 2
  }, {
    "p": [-17, 111, 163],
    "s": [2, 22, 2],
    "c": "#393939",
    "t": 2
  }, {
    "p": [-29, 116, 133],
    "s": [11, 1, 3],
    "l": 1,
    "c": "#d28181",
    "t": 2
  }, {
    "p": [-29, 112, 131],
    "s": [11, 5, 1],
    "l": 1,
    "c": "#d28181",
    "t": 2
  }, {
    "p": [-60, 125, 131],
    "s": [8, 8, 1],
    "l": 1,
    "c": "#b2d4b2",
    "t": 2
  }, {
    "p": [-60, 132, 133],
    "s": [8, 1, 3],
    "l": 1,
    "c": "#b2d4b2",
    "t": 2
  }, {
    "p": [-75, 111, 131],
    "s": [6, 8, 6],
    "i": 2,
    "l": 1,
    "r": [0, -0.17, 0]
  }, {
    "p": [-86, 111, 132],
    "s": [6, 8, 6],
    "i": 2,
    "l": 1,
    "r": [0, 0.52, 0]
  }, {
    "p": [13, 113, 126],
    "s": [40, 2, 9],
    "c": "#393939",
    "t": 2
  }, {
    "p": [31, 113, 123],
    "s": [2, 8, 2],
    "c": "#393939",
    "t": 2
  }, {
    "p": [-5, 113, 123],
    "s": [2, 8, 2],
    "c": "#393939",
    "t": 2
  }, {
    "p": [13, 121, 123],
    "s": [40, 1, 3],
    "c": "#393939",
    "t": 2
  }, {
    "p": [31, 121, 129],
    "s": [3, 1, 9],
    "c": "#393939",
    "t": 2
  }, {
    "p": [-5, 121, 129],
    "s": [3, 1, 9],
    "c": "#393939",
    "t": 2
  }, {
    "p": [20, 116, 131],
    "s": [13, 17, 3],
    "l": 1,
    "c": 8221547,
    "t": 2
  }, {
    "p": [13, 116, 130],
    "s": [1, 17, 2],
    "l": 1,
    "c": "#a5a5a5",
    "t": 2
  }, {
    "p": [27, 116, 130],
    "s": [1, 17, 2],
    "l": 1,
    "c": "#a5a5a5",
    "t": 2
  }, {
    "p": [20, 133, 130],
    "s": [15, 1, 2],
    "l": 1,
    "c": "#a5a5a5",
    "t": 2
  }, {
    "p": [20, 115, 130],
    "s": [15, 1, 2],
    "l": 1,
    "c": "#a5a5a5",
    "t": 2
  }, {
    "p": [5, 108, 121],
    "s": [6, 14, 1],
    "l": 1,
    "c": "#dec28f",
    "t": 2
  }, {
    "p": [1, 108, 121],
    "s": [2, 14, 1],
    "l": 1,
    "c": "#a4be8d",
    "t": 2
  }, {
    "p": [1, 122, 123],
    "s": [2, 1, 5],
    "l": 1,
    "c": "#a4be8d",
    "t": 2
  }, {
    "p": [5, 122, 123],
    "s": [6, 1, 5],
    "l": 1,
    "c": "#dec28f",
    "t": 2
  }, {
    "p": [40, 102, 143],
    "s": [8, 50, 14],
    "c": "#ffd5b1"
  }, {
    "p": [-8, 161, 157],
    "s": [1, 7, 1],
    "l": 1,
    "r": [0, 0, 0.17],
    "c": "#2f2f2f",
    "t": 5
  }, {
    "p": [-21, 132, 142],
    "s": [6, 8, 6],
    "i": 2,
    "l": 1,
    "r": [0, -0.17, 0]
  }, {
    "p": [76, 103, 141],
    "s": [2, 22, 2],
    "c": "#393939",
    "t": 2
  }, {
    "p": [76, 123, 141],
    "s": [1, 1, 9],
    "c": "#393939",
    "t": 2
  }, {
    "p": [59, 123, 137],
    "s": [33, 1, 1],
    "c": "#393939",
    "t": 2
  }, {
    "p": [65, 113, 142],
    "s": [6, 11, 1],
    "l": 1,
    "c": "#d28181",
    "t": 2
  }, {
    "p": [52, 113, 136],
    "s": [7, 11, 1],
    "l": 1,
    "c": "#7ec382",
    "t": 2
  }, {
    "p": [65, 124, 139],
    "s": [6, 1, 7],
    "l": 1,
    "c": "#d28181",
    "t": 2
  }, {
    "p": [65, 121, 136],
    "s": [6, 3, 1],
    "l": 1,
    "c": "#d28181",
    "t": 2
  }, {
    "p": [52, 124, 139],
    "s": [7, 1, 7],
    "l": 1,
    "c": "#7ec382",
    "t": 2
  }, {
    "p": [52, 122, 142],
    "s": [7, 2, 1],
    "c": "#7ec382",
    "t": 2
  }, {
    "p": [59, 123, 141],
    "s": [33, 1, 1],
    "c": "#393939",
    "t": 2
  }, {
    "p": [59, 123, 145],
    "s": [33, 1, 1],
    "c": "#393939",
    "t": 2
  }, {
    "p": [-212, 119, 247],
    "s": [120, 3, 33],
    "l": 1,
    "r": [-0.52, 0, 0],
    "c": "#393939",
    "t": 11
  }, {
    "p": [-212, 80, 257],
    "s": [120, 35, 45],
    "c": "#ffd5b1"
  }, {
    "p": [-212, 115, 257],
    "s": [120, 20, 15],
    "c": "#ffd5b1"
  }, {
    "p": [-212, 136, 256],
    "s": [121, 3, 17],
    "l": 1,
    "r": [-0.52, 0, 0],
    "c": "#393939",
    "t": 11
  }, {
    "p": [-132, 52, 254],
    "s": [40, 89, 40],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [-118, 143, 254],
    "s": [12, 14, 40],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [-132, 158, 254],
    "s": [40, 8, 40],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [-132, 141, 254],
    "s": [41, 2, 41],
    "c": "#313131",
    "t": 11
  }, {
    "p": [-132, 165, 254],
    "s": [41, 2, 41],
    "c": "#313131",
    "t": 11
  }, {
    "p": [-146, 143, 254],
    "s": [12, 14, 40],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [-145, 167, 241],
    "s": [12, 6, 12],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [-145, 167, 267],
    "s": [12, 6, 12],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [-119, 167, 267],
    "s": [12, 6, 12],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [-119, 167, 240],
    "s": [12, 6, 12],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [-132, 157, 254],
    "s": [41, 2, 41],
    "c": "#313131",
    "t": 11
  }, {
    "p": [-131, 137, 228],
    "s": [4, 4, 15],
    "c": "#7d7d7d",
    "t": 2
  }, {
    "p": [-131, 134, 232],
    "s": [3, 2, 13],
    "l": 1,
    "r": [0.7, 0, 0],
    "c": "#7d7d7d",
    "t": 2
  }, {
    "p": [-292, 52, 254],
    "s": [40, 91, 40],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [-292, 143, 254],
    "s": [40, 23, 40],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [-292, 141, 254],
    "s": [41, 2, 41],
    "c": "#313131",
    "t": 11
  }, {
    "p": [-292, 165, 254],
    "s": [41, 2, 41],
    "c": "#313131",
    "t": 11
  }, {
    "p": [-305, 167, 241],
    "s": [12, 6, 12],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [-305, 167, 267],
    "s": [12, 6, 12],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [-279, 167, 267],
    "s": [12, 6, 12],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [-279, 167, 240],
    "s": [12, 6, 12],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [-292, 157, 254],
    "s": [41, 2, 41],
    "c": "#313131",
    "t": 11
  }, {
    "p": [115, 97, -102],
    "s": [2, 2, 69],
    "l": 1,
    "c": "#7d7d7d",
    "t": 2
  }, {
    "p": [123, 97, -102],
    "s": [2, 2, 66],
    "l": 1,
    "c": "#7d7d7d",
    "t": 2
  }, {
    "p": [131, 97, -102],
    "s": [2, 2, 65],
    "l": 1,
    "c": "#7d7d7d",
    "t": 2
  }, {
    "p": [118, 99, -104],
    "s": [11, 1, 12],
    "l": 1,
    "c": "#acb1af",
    "e": "#502323",
    "t": 2
  }, {
    "p": [127, 99, -90],
    "s": [11, 1, 12],
    "l": 1,
    "c": "#868785",
    "e": "#0e110b",
    "t": 2
  }, {
    "p": [132, 81, -90],
    "s": [1, 18, 12],
    "l": 1,
    "c": "#868785",
    "e": "#0e110b",
    "t": 2
  }, {
    "p": [126, 99, -116],
    "s": [11, 1, 6],
    "l": 1,
    "c": "#617187",
    "e": "#0f1b2d",
    "t": 2
  }, {
    "p": [121, 86, -116],
    "s": [1, 13, 6],
    "l": 1,
    "c": "#617187",
    "e": "#0f1b2d",
    "t": 2
  }, {
    "p": [113, 90, -104],
    "s": [1, 9, 12],
    "l": 1,
    "c": "#acb1af",
    "e": "#502323",
    "t": 2
  }, {
    "p": [-111, 68, -64],
    "s": [2, 2, 69],
    "c": "#7d7d7d",
    "t": 2
  }, {
    "p": [-103, 68, -64],
    "s": [2, 2, 66],
    "c": "#7d7d7d",
    "t": 2
  }, {
    "p": [-108, 70, -64],
    "s": [11, 1, 8],
    "c": "#bb5d5d",
    "t": 2
  }, {
    "p": [-100, 70, -82],
    "s": [11, 1, 6],
    "l": 1,
    "c": "#617187",
    "e": "#0f1b2d",
    "t": 2
  }, {
    "p": [-105, 65, -82],
    "s": [1, 5, 6],
    "l": 1,
    "c": "#617187",
    "e": "#0f1b2d",
    "t": 2
  }, {
    "p": [-113, 61, -64],
    "s": [1, 9, 8],
    "l": 1,
    "c": "#bb5d5d",
    "t": 2
  }, {
    "p": [-268, 33, 74],
    "s": [84, 31, 111],
    "c": "#9d8672",
    "t": 11,
    "bo": 1
  }, {
    "p": [-119, 26, 154],
    "s": [65, 109, 54],
    "i": 15,
    "l": 1,
    "r": [0, 0.35, 0],
    "c": "#7f6e38"
  }, {
    "p": [-175, 47, 171],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.87, 0]
  }, {
    "p": [-229, 47, 154],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, 1.04, 3.14]
  }, {
    "p": [-155, 47, 179],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.87, 0]
  }, {
    "p": [-159, 47, 84],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.87, 0]
  }, {
    "p": [-179, 47, 97],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.7, 0]
  }, {
    "p": [-101, 47, 87],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.87, 0]
  }, {
    "p": [-88, 47, 127],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.87, 0]
  }, {
    "p": [-52, 47, 125],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.87, 0]
  }, {
    "p": [-60, 47, 83],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.88, 0]
  }, {
    "p": [31, 47, 85],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.69, 0]
  }, {
    "p": [36, 47, 119],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.69, 0]
  }, {
    "p": [-19, 47, 125],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.69, 0]
  }, {
    "p": [-56, 45, -47],
    "s": [2, 2, 54],
    "l": 1,
    "c": "#393939",
    "t": 11
  }, {
    "p": [-232, 32, -73],
    "s": [68, 28, 67],
    "c": "#9d8672",
    "t": 11,
    "bo": 1
  }, {
    "p": [-8, 142, 157],
    "s": [1, 19, 1],
    "c": "#2f2f2f",
    "t": 5
  }, {
    "p": [-24, 45, 129],
    "s": [2, 58, 2],
    "c": "#2f2f2f",
    "t": 5
  }, {
    "p": [-41, 103, 129],
    "s": [36, 2, 2],
    "c": "#2f2f2f",
    "t": 5
  }, {
    "p": [-58, 105, 129],
    "s": [2, 9, 2],
    "c": "#2f2f2f",
    "t": 5
  }, {
    "p": [-87, 34, 47],
    "s": [62, 66, 66],
    "c": "#ffd5b1",
    "bo": 1
  }, {
    "p": [-87, 13, 47],
    "s": [62, 19, 66],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [-102, 13, -17],
    "s": [42, 19, 62],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [-340, 105, -199],
    "s": [93, 4, 119],
    "c": "#393939",
    "t": 11
  }, {
    "p": [22, 32, -381],
    "s": [91, 27, 88],
    "c": "#9d8672",
    "t": 11,
    "bo": 1
  }, {
    "p": [-292, 52, 112],
    "s": [40, 89, 40],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [-292, 143, 98],
    "s": [40, 14, 12],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [-292, 158, 112],
    "s": [40, 8, 40],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [-292, 141, 112],
    "s": [41, 2, 41],
    "c": "#313131",
    "t": 11
  }, {
    "p": [-292, 165, 112],
    "s": [41, 2, 41],
    "c": "#313131",
    "t": 11
  }, {
    "p": [-305, 167, 99],
    "s": [12, 6, 12],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [-305, 167, 125],
    "s": [12, 6, 12],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [-279, 167, 125],
    "s": [12, 6, 12],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [-279, 167, 98],
    "s": [12, 6, 12],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [-292, 157, 112],
    "s": [41, 2, 41],
    "c": "#313131",
    "t": 11
  }, {
    "p": [-268, 137, 111],
    "s": [15, 4, 4],
    "c": "#7d7d7d",
    "t": 2
  }, {
    "p": [-292, 143, 126],
    "s": [40, 14, 12],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [-285, 119, 184],
    "s": [120, 3, 33],
    "l": 1,
    "r": [-1.57, -1.05, -1.57],
    "c": "#393939",
    "t": 11
  }, {
    "p": [-296, 115, 190],
    "s": [15, 20, 120],
    "c": "#ffd5b1"
  }, {
    "p": [-296, 136, 187],
    "s": [121, 3, 17],
    "l": 1,
    "r": [-1.57, -1.05, -1.57],
    "c": "#393939",
    "t": 11
  }, {
    "p": [-295, 80, 187],
    "s": [45, 35, 120],
    "c": "#ffd5b1"
  }, {
    "p": [-226, 45, 122],
    "s": [2, 58, 2],
    "l": 1,
    "c": "#2f2f2f",
    "t": 5
  }, {
    "p": [-226, 103, 124],
    "s": [2, 2, 6],
    "l": 1,
    "c": "#2f2f2f",
    "t": 5
  }, {
    "p": [-226, 105, 126],
    "s": [2, 18, 2],
    "l": 1,
    "c": "#2f2f2f",
    "t": 5
  }, {
    "p": [164, 34, 142],
    "s": [60, 105, 48],
    "c": "#ffd5b1",
    "bo": 1
  }, {
    "p": [164, 139, 142],
    "s": [63, 5, 51],
    "c": "#313131",
    "t": 11
  }, {
    "p": [164, 144, 142],
    "s": [56, 21, 40],
    "c": "#ffd5b1"
  }, {
    "p": [164, 165, 142],
    "s": [30, 35, 30],
    "c": "#ffd5b1"
  }, {
    "p": [164, 200, 142],
    "s": [34, 6, 34],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [164, 206, 142],
    "s": [29, 6, 28],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [164, 212, 142],
    "s": [23, 6, 22],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [164, 218, 142],
    "s": [17, 6, 16],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [164, 224, 142],
    "s": [5, 13, 9],
    "c": "#ffd5b1"
  }, {
    "p": [164, 237, 142],
    "s": [3, 32, 4],
    "c": "#ffd5b1"
  }, {
    "p": [164, 165, 142],
    "s": [58, 3, 42],
    "c": "#313131",
    "t": 11
  }, {
    "p": [164, 165, 157],
    "s": [10, 20, 1],
    "c": "#3c3c3c"
  }, {
    "p": [142, 129, 142],
    "s": [4, 4, 58],
    "c": "#7d7d7d",
    "t": 2
  }, {
    "p": [186, 129, 142],
    "s": [4, 4, 58],
    "c": "#7d7d7d",
    "t": 2
  }, {
    "p": [164, 129, 128],
    "s": [68, 4, 4],
    "c": "#7d7d7d",
    "t": 2
  }, {
    "p": [164, 129, 156],
    "s": [68, 4, 4],
    "c": "#7d7d7d",
    "t": 2
  }, {
    "p": [164, 50, 165],
    "s": [16, 2, 8],
    "l": 1,
    "c": "#7d7d7d",
    "t": 2
  }, {
    "p": [164, 94, 165],
    "s": [16, 2, 8],
    "l": 1,
    "c": "#7d7d7d",
    "t": 2
  }, {
    "p": [161, 34, 26],
    "s": [13, 17, 3],
    "l": 1,
    "c": 8221547,
    "t": 2
  }, {
    "p": [154, 34, 25],
    "s": [1, 17, 2],
    "l": 1,
    "c": "#a5a5a5",
    "t": 2
  }, {
    "p": [168, 34, 25],
    "s": [1, 17, 2],
    "l": 1,
    "c": "#a5a5a5",
    "t": 2
  }, {
    "p": [161, 51, 25],
    "s": [15, 1, 2],
    "l": 1,
    "c": "#a5a5a5",
    "t": 2
  }, {
    "p": [161, 33, 25],
    "s": [15, 1, 2],
    "l": 1,
    "c": "#a5a5a5",
    "t": 2
  }, {
    "p": [149, 96, 158],
    "s": [71, 4, 81],
    "c": "#525252",
    "t": 11
  }, {
    "p": [-119, 57, 31],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [-3.14, 0, -3.14]
  }, {
    "p": [-117, 58, 31],
    "s": [6, 1, 15],
    "l": 1,
    "c": 5066061,
    "t": 2
  }, {
    "p": [-119, 57, 62],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [-3.14, 0, -3.14]
  }, {
    "p": [-117, 58, 62],
    "s": [6, 1, 15],
    "l": 1,
    "c": 5066061,
    "t": 2
  }, {
    "p": [-151, 89, -90],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [-3.14, 0, -3.14]
  }, {
    "p": [-149, 90, -90],
    "s": [6, 1, 15],
    "l": 1,
    "c": 5066061,
    "t": 2
  }, {
    "p": [-216, 90, 233],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [0, 1.57, 0]
  }, {
    "p": [-216, 91, 235],
    "s": [15, 1, 6],
    "l": 1,
    "c": 5066061,
    "t": 2
  }, {
    "p": [-177, 90, 233],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [0, 1.57, 0]
  }, {
    "p": [-177, 91, 235],
    "s": [15, 1, 6],
    "l": 1,
    "c": 5066061,
    "t": 2
  }, {
    "p": [-216, 89, -38],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [0, -1.57, 0]
  }, {
    "p": [-216, 90, -40],
    "s": [6, 1, 15],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": 5066061,
    "t": 2
  }, {
    "p": [-197, 89, -93],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1
  }, {
    "p": [-199, 90, -93],
    "s": [6, 1, 15],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": 5066061,
    "t": 2
  }, {
    "p": [-225, 32, 15],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, 1.04, 3.14]
  }, {
    "p": [-203, 32, -35],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, 1.04, 3.14]
  }, {
    "p": [-128, 32, -23],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.53, 0]
  }, {
    "p": [-123, 32, 18],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.53, 0]
  }, {
    "p": [-123, 32, 55],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -1.39, 0]
  }, {
    "p": [-149, 32, 61],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -1.39, 0]
  }, {
    "p": [-187, 32, 69],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.87, 0]
  }, {
    "p": [-222, 32, 44],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.87, 0]
  }, {
    "p": [-153, 32, -72],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.18, 0]
  }, {
    "p": [-140, 33, -72],
    "s": [2, 45, 2],
    "l": 1,
    "c": "#2f2f2f",
    "t": 5
  }, {
    "p": [-132, 89, -72],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [0, -1.57, 0]
  }, {
    "p": [-132, 90, -74],
    "s": [6, 1, 15],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": 5066061,
    "t": 2
  }, {
    "p": [-143, 78, -72],
    "s": [8, 2, 2],
    "l": 1,
    "c": "#2f2f2f",
    "t": 5
  }, {
    "p": [-146, 80, -72],
    "s": [2, 34, 2],
    "l": 1,
    "c": "#2f2f2f",
    "t": 5
  }, {
    "p": [-197, 33, -44],
    "s": [2, 82, 2],
    "l": 1,
    "c": "#2f2f2f",
    "t": 5
  }, {
    "p": [573, 13, -162],
    "s": [55, 40, 60],
    "c": "#ffd5b1"
  }, {
    "p": [573, 52, -162],
    "s": [58, 3, 62],
    "c": "#393939",
    "t": 11
  }, {
    "p": [517, 42, -173],
    "s": [58, 1, 34],
    "c": "#393939",
    "t": 11
  }, {
    "p": [517, 22, -173],
    "s": [58, 5, 34],
    "c": "#ffd5b1"
  }, {
    "p": [491, 22, -187],
    "s": [2, 22, 2],
    "c": "#393939",
    "t": 2
  }, {
    "p": [543, 22, -187],
    "s": [2, 22, 2],
    "c": "#393939",
    "t": 2
  }, {
    "p": [516, 22, -187],
    "s": [2, 22, 2],
    "c": "#393939",
    "t": 2
  }, {
    "p": [516, 22, -158],
    "s": [2, 22, 2],
    "c": "#393939",
    "t": 2
  }, {
    "p": [491, 22, -159],
    "s": [2, 22, 2],
    "c": "#393939",
    "t": 2
  }, {
    "p": [543, 22, -159],
    "s": [2, 22, 2],
    "c": "#393939",
    "t": 2
  }, {
    "p": [531, 27, -189],
    "s": [11, 1, 3],
    "c": "#e63f3f",
    "t": 2
  }, {
    "p": [531, 23, -191],
    "s": [11, 5, 1],
    "c": "#e63f3f",
    "t": 2
  }, {
    "p": [500, 36, -191],
    "s": [8, 8, 1],
    "c": "#a1e1a1",
    "t": 2
  }, {
    "p": [500, 43, -189],
    "s": [8, 1, 3],
    "c": "#a1e1a1",
    "t": 2
  }, {
    "p": [511, 27, -187],
    "s": [6, 8, 6],
    "i": 2,
    "r": [0, -0.17, 0]
  }, {
    "p": [573, 24, -196],
    "s": [40, 2, 9],
    "c": "#393939",
    "t": 2
  }, {
    "p": [591, 24, -199],
    "s": [2, 8, 2],
    "c": "#393939",
    "t": 2
  }, {
    "p": [555, 24, -199],
    "s": [2, 8, 2],
    "c": "#393939",
    "t": 2
  }, {
    "p": [573, 32, -199],
    "s": [40, 1, 3],
    "c": "#393939",
    "t": 2
  }, {
    "p": [591, 32, -193],
    "s": [3, 1, 9],
    "c": "#393939",
    "t": 2
  }, {
    "p": [555, 32, -193],
    "s": [3, 1, 9],
    "c": "#393939",
    "t": 2
  }, {
    "p": [580, 27, -191],
    "s": [13, 17, 3],
    "l": 1,
    "c": 8221547,
    "t": 2
  }, {
    "p": [573, 27, -192],
    "s": [1, 17, 2],
    "l": 1,
    "c": "#a5a5a5",
    "t": 2
  }, {
    "p": [587, 27, -192],
    "s": [1, 17, 2],
    "l": 1,
    "c": "#a5a5a5",
    "t": 2
  }, {
    "p": [580, 44, -192],
    "s": [15, 1, 2],
    "l": 1,
    "c": "#a5a5a5",
    "t": 2
  }, {
    "p": [580, 26, -192],
    "s": [15, 1, 2],
    "l": 1,
    "c": "#a5a5a5",
    "t": 2
  }, {
    "p": [565, 19, -201],
    "s": [6, 14, 1],
    "c": "#e6ab3e",
    "t": 2
  }, {
    "p": [561, 19, -201],
    "s": [2, 14, 1],
    "c": "#8de63e",
    "t": 2
  }, {
    "p": [561, 33, -199],
    "s": [2, 1, 5],
    "c": "#8de63e",
    "t": 2
  }, {
    "p": [565, 33, -199],
    "s": [6, 1, 5],
    "c": "#e6ab3e",
    "t": 2
  }, {
    "p": [552, 72, -165],
    "s": [1, 7, 1],
    "r": [0, 0, 0.17],
    "c": "#2f2f2f",
    "t": 5
  }, {
    "p": [539, 43, -180],
    "s": [6, 8, 6],
    "i": 2,
    "r": [0, -0.17, 0]
  }, {
    "p": [552, 53, -165],
    "s": [1, 19, 1],
    "c": "#2f2f2f",
    "t": 5
  }, {
    "p": [306, 88, -169],
    "s": [54, 44, 56],
    "c": "#ffd5b1"
  }, {
    "p": [306, 130, -169],
    "s": [58, 3, 62],
    "c": "#393939",
    "t": 11
  }, {
    "p": [250, 108, -180],
    "s": [58, 1, 34],
    "c": "#393939",
    "t": 11
  }, {
    "p": [250, 88, -180],
    "s": [58, 5, 34],
    "c": "#ffd5b1"
  }, {
    "p": [224, 88, -194],
    "s": [2, 22, 2],
    "c": "#7d7d7d",
    "t": 2
  }, {
    "p": [276, 88, -194],
    "s": [2, 22, 2],
    "c": "#7d7d7d",
    "t": 2
  }, {
    "p": [249, 88, -194],
    "s": [2, 22, 2],
    "c": "#7d7d7d",
    "t": 2
  }, {
    "p": [249, 88, -165],
    "s": [2, 22, 2],
    "c": "#7d7d7d",
    "t": 2
  }, {
    "p": [224, 88, -166],
    "s": [2, 22, 2],
    "c": "#7d7d7d",
    "t": 2
  }, {
    "p": [276, 88, -166],
    "s": [2, 22, 2],
    "c": "#7d7d7d",
    "t": 2
  }, {
    "p": [264, 93, -196],
    "s": [11, 1, 3],
    "c": "#dc7c7c",
    "t": 2
  }, {
    "p": [264, 85, -198],
    "s": [11, 9, 1],
    "c": "#d26262",
    "t": 2
  }, {
    "p": [221, 102, -173],
    "s": [1, 8, 7],
    "c": "#e63f3f",
    "t": 2
  }, {
    "p": [244, 93, -194],
    "s": [6, 8, 6],
    "i": 2,
    "l": 1,
    "r": [0, -0.17, 0]
  }, {
    "p": [285, 149, -172],
    "s": [1, 7, 1],
    "l": 1,
    "r": [0, 0, 0.17],
    "c": "#2f2f2f",
    "t": 5
  }, {
    "p": [272, 109, -187],
    "s": [6, 8, 6],
    "i": 2,
    "l": 1,
    "r": [0, -0.17, 0]
  }, {
    "p": [285, 131, -172],
    "s": [1, 19, 1],
    "c": "#2f2f2f",
    "t": 5
  }, {
    "p": [223, 109, -173],
    "s": [3, 1, 7],
    "c": "#e63f3f",
    "t": 2
  }, {
    "p": [136, 84, -198],
    "s": [40, 2, 9],
    "c": "#7d7d7d",
    "t": 2,
    "bo": 1
  }, {
    "p": [154, 84, -201],
    "s": [2, 8, 2],
    "c": "#7d7d7d",
    "t": 2
  }, {
    "p": [118, 84, -201],
    "s": [2, 8, 2],
    "c": "#7d7d7d",
    "t": 2
  }, {
    "p": [136, 92, -201],
    "s": [40, 1, 3],
    "c": "#7d7d7d",
    "t": 2,
    "bo": 1
  }, {
    "p": [154, 92, -195],
    "s": [3, 1, 9],
    "c": "#7d7d7d",
    "t": 2
  }, {
    "p": [118, 92, -195],
    "s": [3, 1, 9],
    "c": "#7d7d7d",
    "t": 2
  }, {
    "p": [124, 79, -203],
    "s": [5, 14, 1],
    "l": 1,
    "c": "#8de63e",
    "t": 2
  }, {
    "p": [124, 93, -201],
    "s": [5, 1, 5],
    "l": 1,
    "c": "#8de63e",
    "t": 2
  }, {
    "p": [272, 88, -156],
    "s": [12, 12, 12],
    "i": 1,
    "l": 1
  }, {
    "p": [272, 100, -156],
    "s": [12, 12, 12],
    "i": 1,
    "l": 1
  }, {
    "p": [136, 86, -197],
    "s": [1, 17, 1],
    "l": 1,
    "c": "#393939",
    "t": 2
  }, {
    "p": [150, 86, -197],
    "s": [1, 17, 1],
    "l": 1,
    "c": "#393939",
    "t": 2
  }, {
    "p": [143, 103, -197],
    "s": [15, 1, 1],
    "l": 1,
    "c": "#393939",
    "t": 2
  }, {
    "p": [143, 86, -196],
    "s": [13, 17, 2],
    "l": 1,
    "c": 8221547,
    "t": 2
  }, {
    "p": [-232, 80, 145],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1
  }, {
    "p": [-234, 81, 145],
    "s": [6, 1, 15],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": 5066061,
    "t": 2
  }, {
    "p": [-225, 95, 101],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1
  }, {
    "p": [-227, 96, 101],
    "s": [6, 1, 15],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": 5066061,
    "t": 2
  }, {
    "p": [127, 88, 94],
    "s": [8, 3, 26],
    "l": 1,
    "r": [0, 0, 0.35],
    "c": "#525252",
    "t": 11
  }, {
    "p": [122, 66, 94],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [-3.14, 0, -3.14]
  }, {
    "p": [124, 67, 94],
    "s": [6, 1, 15],
    "l": 1,
    "c": 5066061,
    "t": 2
  }, {
    "p": [-13, 11, -257],
    "s": [65, 109, 54],
    "i": 15,
    "l": 1,
    "r": [3.14, -0.35, 3.14],
    "c": "#846d22"
  }, {
    "p": [111, 78, 28],
    "s": [47, 2, 2],
    "c": "#7d7d7d",
    "t": 2
  }, {
    "p": [111, 78, 36],
    "s": [47, 2, 2],
    "c": "#7d7d7d",
    "t": 2
  }, {
    "p": [119, 80, 32],
    "s": [8, 1, 11],
    "l": 1,
    "c": "#d28d8d",
    "t": 2
  }, {
    "p": [119, 71, 27],
    "s": [8, 9, 1],
    "l": 1,
    "c": "#d28d8d",
    "t": 2
  }, {
    "p": [99, 71, 37],
    "s": [3, 9, 1],
    "l": 1,
    "c": "#bbd9bb",
    "t": 2
  }, {
    "p": [99, 80, 32],
    "s": [3, 1, 11],
    "l": 1,
    "c": "#bbd9bb",
    "t": 2
  }, {
    "p": [99, 75, 27],
    "s": [3, 5, 1],
    "l": 1,
    "c": "#bbd9bb",
    "t": 2
  }, {
    "p": [119, 77, 37],
    "s": [8, 3, 1],
    "l": 1,
    "c": "#d28d8d",
    "t": 2
  }, {
    "p": [-200, 95, -276],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1
  }, {
    "p": [-202, 96, -276],
    "s": [6, 1, 15],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": 5066061,
    "t": 2
  }, {
    "p": [-200, 95, -312],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1
  }, {
    "p": [-202, 96, -312],
    "s": [6, 1, 15],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": 5066061,
    "t": 2
  }, {
    "p": [-124, 68, -33],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [-3.14, 0, -3.14]
  }, {
    "p": [-122, 69, -33],
    "s": [6, 1, 15],
    "l": 1,
    "c": 5066061,
    "t": 2
  }, {
    "p": [20, 65, -225],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [-3.14, 0, -3.14]
  }, {
    "p": [22, 66, -225],
    "s": [6, 1, 15],
    "l": 1,
    "c": 5066061,
    "t": 2
  }, {
    "p": [158, 70, -318],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [-3.14, 0, -3.14]
  }, {
    "p": [160, 71, -318],
    "s": [6, 1, 15],
    "l": 1,
    "c": 5066061,
    "t": 2
  }, {
    "p": [-42, 96, -354],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [0, -1.57, 0]
  }, {
    "p": [-42, 97, -356],
    "s": [6, 1, 15],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": 5066061,
    "t": 2
  }, {
    "p": [-8, 67, -336],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [0, -1.57, 0]
  }, {
    "p": [-8, 68, -338],
    "s": [6, 1, 15],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": 5066061,
    "t": 2
  }, {
    "p": [90, 78, -346],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [0, -1.57, 0]
  }, {
    "p": [90, 79, -348],
    "s": [6, 1, 15],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": 5066061,
    "t": 2
  }, {
    "p": [-55, 13, 11],
    "s": [4, 34, 2],
    "l": 1,
    "c": "#575757",
    "t": 2
  }, {
    "p": [53, 13, -19],
    "s": [4, 34, 2],
    "l": 1,
    "c": "#575757",
    "t": 2
  }, {
    "p": [53, 13, 11],
    "s": [4, 34, 2],
    "l": 1,
    "c": "#575757",
    "t": 2
  }, {
    "p": [53, 45, -4],
    "s": [4, 2, 28],
    "l": 1,
    "c": "#575757",
    "t": 2
  }, {
    "p": [-1, 13, 11],
    "s": [4, 34, 2],
    "l": 1,
    "c": "#575757",
    "t": 2
  }, {
    "p": [-1, 13, -19],
    "s": [4, 34, 2],
    "l": 1,
    "c": "#575757",
    "t": 2
  }, {
    "p": [-1, 45, -4],
    "s": [4, 2, 28],
    "l": 1,
    "c": "#575757",
    "t": 2
  }, {
    "p": [-112, 45, 81],
    "s": [2, 66, 2],
    "l": 1,
    "c": "#2f2f2f",
    "t": 5
  }, {
    "p": [-225, 103, -128],
    "s": [43, 2, 72],
    "c": "#393939",
    "t": 11
  }, {
    "p": [-225, 80, -128],
    "s": [43, 8, 72],
    "c": "#ffd5b1"
  }, {
    "p": [-206, 88, -162],
    "s": [2, 19, 2],
    "c": "#7d7d7d",
    "t": 2
  }, {
    "p": [-206, 88, -109],
    "s": [2, 19, 2],
    "c": "#7d7d7d",
    "t": 2
  }, {
    "p": [-244, 88, -162],
    "s": [2, 19, 2],
    "c": "#7d7d7d",
    "t": 2
  }, {
    "p": [-244, 88, -109],
    "s": [2, 19, 2],
    "c": "#7d7d7d",
    "t": 2
  }, {
    "p": [-244, 88, -136],
    "s": [2, 19, 2],
    "c": "#7d7d7d",
    "t": 2
  }, {
    "p": [-206, 88, -136],
    "s": [2, 19, 2],
    "c": "#7d7d7d",
    "t": 2
  }, {
    "p": [-201, 124, -104],
    "s": [1, 7, 1],
    "l": 1,
    "r": [0, 0, 0.17],
    "c": "#2f2f2f",
    "t": 5
  }, {
    "p": [-201, 105, -104],
    "s": [1, 19, 1],
    "c": "#2f2f2f",
    "t": 5
  }, {
    "p": [-213, 105, -113],
    "s": [6, 8, 6],
    "i": 2,
    "l": 1,
    "r": [0, 0.52, 0]
  }, {
    "p": [-205, 80, -169],
    "s": [6, 8, 6],
    "i": 2,
    "l": 1,
    "r": [0, 0.52, 0]
  }, {
    "p": [-216, 80, -170],
    "s": [12, 12, 12],
    "i": 1,
    "l": 1
  }, {
    "p": [-207, 105, -145],
    "s": [9, 1, 13],
    "l": 1,
    "c": "#6383ed",
    "t": 2
  }, {
    "p": [-203, 95, -145],
    "s": [1, 10, 13],
    "l": 1,
    "c": "#6383ed",
    "t": 2
  }, {
    "p": [-200, 33, -258],
    "s": [2, 83, 2],
    "l": 1,
    "c": "#2f2f2f",
    "t": 5
  }, {
    "p": [-200, 116, -262],
    "s": [2, 18, 2],
    "l": 1,
    "c": "#2f2f2f",
    "t": 5
  }, {
    "p": [-200, 116, -259],
    "s": [2, 2, 4],
    "l": 1,
    "c": "#2f2f2f",
    "t": 5
  }, {
    "p": [-226, 68, -244],
    "s": [12, 12, 12],
    "i": 1,
    "l": 1,
    "r": [0, -0.35, 0]
  }, {
    "p": [-218, 68, -234],
    "s": [6, 8, 6],
    "i": 2,
    "l": 1,
    "r": [0, 0.52, 0]
  }, {
    "p": [270, 34, -76],
    "s": [6, 48, 24],
    "c": "#ffd5b1",
    "bo": 1
  }, {
    "p": [271, 81, -76],
    "s": [12, 3, 26],
    "l": 1,
    "r": [0, 0, 0.35],
    "c": "#525252",
    "t": 11
  }, {
    "p": [266, 59, -76],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [-3.14, 0, -3.14]
  }, {
    "p": [268, 60, -76],
    "s": [6, 1, 15],
    "l": 1,
    "c": 5066061,
    "t": 2
  }, {
    "p": [284, 62, 94],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [-3.14, 0, -3.14]
  }, {
    "p": [286, 63, 94],
    "s": [6, 1, 15],
    "l": 1,
    "c": 5066061,
    "t": 2
  }, {
    "p": [284, 65, 3],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [-3.14, 0, -3.14]
  }, {
    "p": [286, 66, 3],
    "s": [6, 1, 15],
    "l": 1,
    "c": 5066061,
    "t": 2
  }, {
    "p": [189, 75, 97],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1
  }, {
    "p": [187, 76, 97],
    "s": [6, 1, 15],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": 5066061,
    "t": 2
  }, {
    "p": [189, 75, 51],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1
  }, {
    "p": [187, 76, 51],
    "s": [6, 1, 15],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": 5066061,
    "t": 2
  }, {
    "p": [220, 65, -181],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [-3.14, 0, -3.14]
  }, {
    "p": [222, 66, -181],
    "s": [6, 1, 15],
    "l": 1,
    "c": 5066061,
    "t": 2
  }, {
    "p": [193, 34, -292],
    "s": [68, 20, 113],
    "c": "#9d8672",
    "t": 11,
    "bo": 1
  }, {
    "p": [-161, 141, 263],
    "s": [17, 5, 3],
    "c": "#313131",
    "t": 11
  }, {
    "p": [-263, 141, 263],
    "s": [17, 5, 3],
    "c": "#313131",
    "t": 11
  }, {
    "p": [-195, 141, 263],
    "s": [17, 5, 3],
    "c": "#313131",
    "t": 11
  }, {
    "p": [-228, 141, 263],
    "s": [17, 5, 3],
    "c": "#313131",
    "t": 11
  }, {
    "p": [-304, 141, 225],
    "s": [5, 5, 17],
    "c": "#313131",
    "t": 11
  }, {
    "p": [-304, 141, 141],
    "s": [5, 5, 17],
    "c": "#313131",
    "t": 11
  }, {
    "p": [-304, 141, 179],
    "s": [5, 5, 17],
    "c": "#313131",
    "t": 11
  }, {
    "p": [-319, 34, -70],
    "s": [65, 109, 54],
    "i": 15,
    "l": 1,
    "r": [0, 0.87, 0]
  }, {
    "p": [-335, 46, 4],
    "s": [65, 109, 54],
    "i": 15,
    "l": 1,
    "r": [-3.14, 1.4, -3.14]
  }, {
    "p": [-385, 50, -47],
    "s": [65, 109, 54],
    "i": 15,
    "l": 1,
    "r": [0, -1.23, 0]
  }, {
    "p": [181, 120, -296],
    "s": [43, 2, 72],
    "c": "#393939",
    "t": 11
  }, {
    "p": [181, 97, -295],
    "s": [43, 8, 72],
    "c": "#ffd5b1"
  }, {
    "p": [200, 105, -323],
    "s": [2, 19, 2],
    "c": "#7d7d7d",
    "t": 2
  }, {
    "p": [161, 105, -262],
    "s": [2, 19, 2],
    "c": "#7d7d7d",
    "t": 2
  }, {
    "p": [161, 105, -289],
    "s": [2, 19, 2],
    "c": "#7d7d7d",
    "t": 2
  }, {
    "p": [161, 105, -317],
    "s": [2, 19, 2],
    "c": "#7d7d7d",
    "t": 2
  }, {
    "p": [194, 122, -264],
    "s": [6, 8, 6],
    "i": 2,
    "l": 1,
    "r": [0, 0.52, 0]
  }, {
    "p": [201, 97, -330],
    "s": [6, 8, 6],
    "i": 2,
    "r": [0, 0.52, 0]
  }, {
    "p": [190, 97, -331],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [163, 122, -306],
    "s": [9, 1, 13],
    "l": 1,
    "c": "#3661f0",
    "t": 2
  }, {
    "p": [159, 112, -306],
    "s": [1, 10, 13],
    "l": 1,
    "c": "#3661f0",
    "t": 2
  }, {
    "p": [172, 122, -266],
    "s": [9, 1, 13],
    "l": 1,
    "c": "#66b18e",
    "t": 2
  }, {
    "p": [172, 110, -260],
    "s": [9, 12, 1],
    "l": 1,
    "c": "#66b18e",
    "t": 2
  }, {
    "p": [181, 95, -346],
    "s": [44, 32, 54],
    "c": "#ffd5b1"
  }, {
    "p": [181, 127, -346],
    "s": [46, 2, 56],
    "c": "#525252",
    "t": 11
  }, {
    "p": [201, 105, -289],
    "s": [2, 19, 2],
    "c": "#7d7d7d",
    "t": 2
  }, {
    "p": [201, 105, -262],
    "s": [2, 19, 2],
    "c": "#7d7d7d",
    "t": 2
  }, {
    "p": [200, 105, -317],
    "s": [2, 19, 2],
    "c": "#7d7d7d",
    "t": 2
  }, {
    "p": [197, 98, -253],
    "s": [12, 12, 12],
    "i": 1,
    "l": 1
  }, {
    "p": [164, 105, -266],
    "s": [6, 8, 6],
    "i": 2,
    "l": 1,
    "r": [0, -1.05, 0]
  }, {
    "p": [158, 33, -341],
    "s": [2, 80, 2],
    "l": 1,
    "c": "#2f2f2f",
    "t": 5
  }, {
    "p": [158, 113, -331],
    "s": [2, 19, 2],
    "l": 1,
    "c": "#2f2f2f",
    "t": 5
  }, {
    "p": [158, 113, -337],
    "s": [2, 2, 10],
    "l": 1,
    "c": "#2f2f2f",
    "t": 5
  }, {
    "p": [177, 125, -346],
    "s": [1, 19, 1],
    "c": "#2f2f2f",
    "t": 5
  }, {
    "p": [177, 144, -346],
    "s": [1, 6, 1],
    "l": 1,
    "r": [0.35, 0, 0],
    "c": "#2f2f2f",
    "t": 5
  }, {
    "p": [177, 149, -344],
    "s": [1, 3, 1],
    "l": 1,
    "c": "#2f2f2f",
    "t": 5
  }, {
    "p": [166, 48, -80],
    "s": [15, 1, 4],
    "l": 1,
    "c": 5066061,
    "t": 2
  }, {
    "p": [166, 47, -81],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [0, 1.57, 0]
  }, {
    "p": [70, 92, -82],
    "s": [15, 1, 4],
    "l": 1,
    "c": 5066061,
    "t": 2
  }, {
    "p": [70, 91, -83],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [0, 1.57, 0]
  }, {
    "p": [268, 62, 131],
    "s": [15, 1, 4],
    "l": 1,
    "c": 5066061,
    "t": 2
  }, {
    "p": [268, 61, 130],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [0, 1.57, 0]
  }, {
    "p": [-67, 82, 14],
    "s": [15, 1, 4],
    "l": 1,
    "c": 5066061,
    "t": 2
  }, {
    "p": [-67, 81, 13],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [0, 1.57, 0]
  }, {
    "p": [-80, 71, -19],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1
  }, {
    "p": [-82, 72, -19],
    "s": [6, 1, 15],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": 5066061,
    "t": 2
  }, {
    "p": [135, 90, -39],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1
  }, {
    "p": [133, 91, -39],
    "s": [6, 1, 15],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": 5066061,
    "t": 2
  }, {
    "p": [102, 65, -262],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1
  }, {
    "p": [100, 66, -262],
    "s": [6, 1, 15],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": 5066061,
    "t": 2
  }, {
    "p": [228, 70, -316],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1
  }, {
    "p": [226, 71, -316],
    "s": [6, 1, 15],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": 5066061,
    "t": 2
  }, {
    "p": [151, 64, -123],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [0, -1.57, 0]
  }, {
    "p": [151, 65, -125],
    "s": [6, 1, 15],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": 5066061,
    "t": 2
  }, {
    "p": [233, 65, -123],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [0, -1.57, 0]
  }, {
    "p": [233, 66, -125],
    "s": [6, 1, 15],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": 5066061,
    "t": 2
  }, {
    "p": [151, 48, -15],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [0, -1.57, 0]
  }, {
    "p": [151, 49, -17],
    "s": [6, 1, 15],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": 5066061,
    "t": 2
  }, {
    "p": [211, 67, -234],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [0, -1.57, 0]
  }, {
    "p": [210, 68, -236],
    "s": [6, 1, 16],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": 5066061,
    "t": 2
  }, {
    "p": [-200, 54, -204],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1
  }, {
    "p": [-202, 55, -204],
    "s": [6, 1, 15],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": 5066061,
    "t": 2
  }, {
    "p": [68, 91, -21],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [0, -1.57, 0]
  }, {
    "p": [68, 92, -23],
    "s": [6, 1, 15],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": 5066061,
    "t": 2
  }, {
    "p": [53, 91, -54],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [-3.14, 0, -3.14]
  }, {
    "p": [55, 92, -54],
    "s": [6, 1, 15],
    "l": 1,
    "c": 5066061,
    "t": 2
  }, {
    "p": [63, 64, -129],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [0, -1.57, 0]
  }, {
    "p": [63, 65, -131],
    "s": [6, 1, 15],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": 5066061,
    "t": 2
  }, {
    "p": [16, 64, -129],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [0, -1.57, 0]
  }, {
    "p": [16, 65, -131],
    "s": [6, 1, 15],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": 5066061,
    "t": 2
  }, {
    "p": [-79, 64, -72],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [0, -1.57, 0]
  }, {
    "p": [-79, 65, -74],
    "s": [6, 1, 15],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": 5066061,
    "t": 2
  }, {
    "p": [-28, 33, -130],
    "s": [2, 61, 2],
    "l": 1,
    "c": "#2f2f2f",
    "t": 5
  }, {
    "p": [284, 33, 23],
    "s": [2, 43, 2],
    "l": 1,
    "c": "#2f2f2f",
    "t": 5
  }, {
    "p": [284, 78, 17],
    "s": [2, 15, 2],
    "l": 1,
    "c": "#2f2f2f",
    "t": 5
  }, {
    "p": [284, 76, 20],
    "s": [2, 2, 8],
    "l": 1,
    "c": "#2f2f2f",
    "t": 5
  }, {
    "p": [219, 33, -81],
    "s": [2, 47, 2],
    "l": 1,
    "c": "#2f2f2f",
    "t": 5
  }, {
    "p": [220, 32, -132],
    "s": [2, 40, 2],
    "l": 1,
    "c": "#2f2f2f",
    "t": 5
  }, {
    "p": [220, 72, -135],
    "s": [2, 2, 8],
    "l": 1,
    "c": "#2f2f2f",
    "t": 5
  }, {
    "p": [220, 74, -138],
    "s": [2, 16, 2],
    "l": 1,
    "c": "#2f2f2f",
    "t": 5
  }, {
    "p": [-140, 34, -203],
    "s": [1, 17, 2],
    "l": 1,
    "c": "#a5a5a5",
    "t": 2
  }, {
    "p": [-126, 34, -203],
    "s": [1, 17, 2],
    "l": 1,
    "c": "#a5a5a5",
    "t": 2
  }, {
    "p": [-133, 51, -203],
    "s": [15, 1, 2],
    "l": 1,
    "c": "#a5a5a5",
    "t": 2
  }, {
    "p": [-133, 34, -202],
    "s": [13, 17, 3],
    "l": 1,
    "c": 8221547,
    "t": 2
  }, {
    "p": [353, 21, -77],
    "s": [65, 109, 54],
    "i": 15,
    "l": 1,
    "r": [-3.14, -0.17, -3.14]
  }, {
    "p": [360, 29, -127],
    "s": [65, 109, 54],
    "i": 15,
    "l": 1,
    "r": [-0.01, -1.4, -0.01]
  }, {
    "p": [266, 11, 231],
    "s": [65, 109, 54],
    "i": 15,
    "l": 1,
    "r": [-3.14, -0.17, -3.14]
  }, {
    "p": [226, 0, -434],
    "s": [65, 109, 54],
    "i": 15,
    "l": 1,
    "r": [-3.14, -0.17, -3.14]
  }, {
    "p": [-156, 43, -147],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, 1.13, -3.14]
  }, {
    "p": [-155, 43, -164],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, -0.79, -3.14]
  }, {
    "p": [-198, 43, -113],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, -0.79, -3.14]
  }, {
    "p": [-160, 43, -124],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, -0.79, -3.14]
  }, {
    "p": [-196, 43, -147],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, -0.79, -3.14]
  }, {
    "p": [105, 32, -203],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.97, 0]
  }, {
    "p": [132, 32, -203],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, 0.08, -3.14]
  }, {
    "p": [172, 32, -231],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, -0.97, -3.14]
  }, {
    "p": [154, 32, -200],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.8, 0]
  }, {
    "p": [191, 32, -225],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.8, 0]
  }, {
    "p": [199, 32, -231],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [3.14, -0.45, 3.14]
  }, {
    "p": [216, 32, -191],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [3.14, -0.45, 3.14]
  }, {
    "p": [247, 32, -201],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [3.14, -0.97, 3.14]
  }, {
    "p": [273, 32, -206],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [3.14, -0.97, 3.14]
  }, {
    "p": [280, 32, -221],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [3.14, -0.97, 3.14]
  }, {
    "p": [264, 32, -237],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.95, 0]
  }, {
    "p": [230, 32, -234],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, 1.47, -3.14]
  }, {
    "p": [239, 32, -262],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, 1.47, -3.14]
  }, {
    "p": [275, 32, -271],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, -0.97, -3.14]
  }, {
    "p": [240, 32, -301],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, -0.97, -3.14]
  }, {
    "p": [275, 32, -320],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, -0.97, -3.14]
  }, {
    "p": [253, 32, -331],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.62, 0]
  }, {
    "p": [172, 32, -161],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [3.14, -0.45, 3.14]
  }, {
    "p": [216, 32, -157],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.77, 0]
  }, {
    "p": [171, 32, -137],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, 0.59, -3.14]
  }, {
    "p": [189, 32, -91],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, 0.59, -3.14]
  }, {
    "p": [182, 32, -84],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, -0.98, -3.14]
  }, {
    "p": [158, 32, -120],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, -0.98, -3.14]
  }, {
    "p": [225, 32, -84],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, 0.59, -3.14]
  }, {
    "p": [216, 32, -128],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.12, -1.5, -3.12]
  }, {
    "p": [250, 32, -119],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.59, 0]
  }, {
    "p": [257, 32, -112],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -1.11, 0]
  }, {
    "p": [269, 32, -109],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.24, 0]
  }, {
    "p": [266, 32, -90],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.41, 0]
  }, {
    "p": [230, 32, -43],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, 0.41, -3.14]
  }, {
    "p": [270, 32, -61],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, 0.41, -3.14]
  }, {
    "p": [280, 32, -49],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, 0.41, -3.14]
  }, {
    "p": [280, 32, -6],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -1.11, 0]
  }, {
    "p": [231, 32, -23],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.06, 0]
  }, {
    "p": [218, 32, -12],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.81, 0]
  }, {
    "p": [294, 32, 31],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.76, 0]
  }, {
    "p": [294, 32, 72],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.76, 0]
  }, {
    "p": [251, 32, 77],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -1.28, 0]
  }, {
    "p": [199, 32, 43],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, 0.58, -3.14]
  }, {
    "p": [191, 32, 25],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, 0.58, -3.14]
  }, {
    "p": [192, 32, 74],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, 0.58, -3.14]
  }, {
    "p": [192, 32, 85],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, 0.58, -3.14]
  }, {
    "p": [194, 32, 113],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, 0.58, -3.14]
  }, {
    "p": [210, 32, 126],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, -0.82, -3.14]
  }, {
    "p": [197, 32, 126],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, -0.82, -3.14]
  }, {
    "p": [228, 32, 120],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, -1.34, -3.14]
  }, {
    "p": [242, 32, 127],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.75, 0]
  }, {
    "p": [217, 32, 115],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, -1.34, -3.14]
  }, {
    "p": [279, 32, 98],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, -1.34, -3.14]
  }, {
    "p": [282, 32, 86],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.75, 0]
  }, {
    "p": [137, 32, -12],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, 0.58, -3.14]
  }, {
    "p": [144, 32, 21],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, 0.58, -3.14]
  }, {
    "p": [96, 32, 26],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, -0.99, -3.14]
  }, {
    "p": [106, 32, -17],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, -0.99, -3.14]
  }, {
    "p": [57, 47, 124],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.69, 0]
  }, {
    "p": [103, 47, 125],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.88, 0]
  }, {
    "p": [123, 47, 116],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.34, 0]
  }, {
    "p": [94, 47, 87],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.53, 0]
  }, {
    "p": [-48, 68, 24],
    "s": [2, 2, 30],
    "l": 1,
    "c": 9539985,
    "t": 2
  }, {
    "p": [-45, 55, -25],
    "s": [2, 3, 2],
    "l": 1,
    "c": "#571f1f",
    "t": 5
  }, {
    "p": [46, 68, -12],
    "s": [2, 2, 30],
    "l": 1,
    "c": 9539985,
    "t": 2
  }, {
    "p": [23, 55, 70],
    "s": [2, 2, 2],
    "l": 1,
    "c": "#571f1f",
    "t": 5
  }, {
    "p": [21, 55, 70],
    "s": [2, 1, 2],
    "l": 1,
    "c": "#571f1f",
    "t": 5
  }, {
    "p": [22, 54, 68],
    "s": [2, 3, 2],
    "l": 1,
    "c": "#571f1f",
    "t": 5
  }, {
    "p": [-14, 91, -132],
    "s": [2, 23, 2],
    "c": "#7d7d7d",
    "t": 2
  }, {
    "p": [28, 91, -132],
    "s": [2, 23, 2],
    "c": "#7d7d7d",
    "t": 2
  }, {
    "p": [7, 92, -130],
    "s": [45, 20, 1],
    "c": "#4d4d4d",
    "t": 2
  }, {
    "p": [-42, 48, -124],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [47, 91, -135],
    "s": [6, 8, 6],
    "i": 2,
    "l": 1,
    "r": [0, 0.17, 0]
  }, {
    "p": [-17, 91, -135],
    "s": [6, 8, 6],
    "i": 2,
    "l": 1,
    "r": [0, 0.69, 0]
  }, {
    "p": [7, 92, -130],
    "s": [46, 1, 2],
    "c": "#4d4d4d",
    "t": 2
  }, {
    "p": [38, 103, -143],
    "s": [6, 8, 6],
    "i": 2,
    "l": 1,
    "r": [0, 0.17, 0]
  }, {
    "p": [-16, 98, -136],
    "s": [6, 8, 6],
    "i": 2,
    "l": 1,
    "r": [0, 0.69, 0]
  }, {
    "p": [-76, 106, -150],
    "s": [34, 20, 40],
    "c": "#ffd5b1"
  }, {
    "p": [-76, 126, -150],
    "s": [36, 3, 42],
    "c": "#393939",
    "t": 11
  }, {
    "p": [-63, 122, -135],
    "s": [1, 19, 1],
    "c": "#2f2f2f",
    "t": 5
  }, {
    "p": [-63, 141, -135],
    "s": [1, 6, 1],
    "l": 1,
    "r": [0.35, 0, 0],
    "c": "#2f2f2f",
    "t": 5
  }, {
    "p": [-63, 146, -133],
    "s": [1, 3, 1],
    "l": 1,
    "c": "#2f2f2f",
    "t": 5
  }, {
    "p": [-70, 107, 25],
    "s": [1, 19, 1],
    "c": "#2f2f2f",
    "t": 5
  }, {
    "p": [-70, 126, 25],
    "s": [1, 6, 1],
    "r": [0.35, 0, 0],
    "c": "#2f2f2f",
    "t": 5
  }, {
    "p": [-70, 131, 27],
    "s": [1, 3, 1],
    "c": "#2f2f2f",
    "t": 5
  }, {
    "p": [-30, 94, -130],
    "s": [6, 2, 2],
    "l": 1,
    "c": "#2f2f2f",
    "t": 5
  }, {
    "p": [-32, 96, -130],
    "s": [2, 6, 2],
    "l": 1,
    "c": "#2f2f2f",
    "t": 5
  }, {
    "p": [-250, 98, -18],
    "s": [31, 2, 72],
    "c": "#393939",
    "t": 11
  }, {
    "p": [-236, 88, -37],
    "s": [2, 13, 2],
    "c": "#7d7d7d",
    "t": 2
  }, {
    "p": [-236, 88, 16],
    "s": [2, 13, 2],
    "c": "#7d7d7d",
    "t": 2
  }, {
    "p": [-236, 88, -10],
    "s": [2, 13, 2],
    "c": "#7d7d7d",
    "t": 2
  }, {
    "p": [-264, 88, -10],
    "s": [2, 13, 2],
    "c": "#7d7d7d",
    "t": 2
  }, {
    "p": [-264, 88, 16],
    "s": [2, 13, 2],
    "c": "#7d7d7d",
    "t": 2
  }, {
    "p": [-263, 88, -37],
    "s": [2, 13, 2],
    "c": "#7d7d7d",
    "t": 2
  }, {
    "p": [-244, 100, -30],
    "s": [12, 12, 12],
    "i": 1,
    "l": 1,
    "r": [0, -0.35, 0]
  }, {
    "p": [-235, 111, -43],
    "s": [6, 8, 6],
    "i": 2,
    "l": 1,
    "r": [0, 0.52, 0]
  }, {
    "p": [-239, 88, 11],
    "s": [6, 8, 6],
    "i": 2,
    "l": 1,
    "r": [0, 0.52, 0]
  }, {
    "p": [-166, 121, -351],
    "s": [58, 1, 34],
    "c": "#393939",
    "t": 11
  }, {
    "p": [-166, 101, -351],
    "s": [58, 5, 34],
    "c": "#ffd5b1"
  }, {
    "p": [-192, 101, -365],
    "s": [2, 22, 2],
    "c": "#7d7d7d",
    "t": 2
  }, {
    "p": [-140, 101, -365],
    "s": [2, 22, 2],
    "c": "#7d7d7d",
    "t": 2
  }, {
    "p": [-167, 101, -365],
    "s": [2, 22, 2],
    "c": "#7d7d7d",
    "t": 2
  }, {
    "p": [-167, 101, -336],
    "s": [2, 22, 2],
    "c": "#7d7d7d",
    "t": 2
  }, {
    "p": [-192, 101, -337],
    "s": [2, 22, 2],
    "c": "#7d7d7d",
    "t": 2
  }, {
    "p": [-140, 101, -337],
    "s": [2, 22, 2],
    "c": "#7d7d7d",
    "t": 2
  }, {
    "p": [-136, 115, -344],
    "s": [1, 8, 7],
    "l": 1,
    "c": "#e63f3f",
    "t": 2
  }, {
    "p": [-179, 106, -339],
    "s": [6, 8, 6],
    "i": 2,
    "l": 1,
    "r": [0, -0.17, 0]
  }, {
    "p": [-144, 122, -358],
    "s": [6, 8, 6],
    "i": 2,
    "l": 1,
    "r": [0, -0.17, 0]
  }, {
    "p": [-138, 122, -344],
    "s": [3, 1, 7],
    "l": 1,
    "c": "#e63f3f",
    "t": 2
  }, {
    "p": [-95, 121, -383],
    "s": [12, 12, 12],
    "i": 1,
    "l": 1
  }, {
    "p": [-110, 101, -353],
    "s": [12, 12, 12],
    "i": 1,
    "l": 1
  }, {
    "p": [-222, 101, -362],
    "s": [54, 44, 56],
    "c": "#ffd5b1"
  }, {
    "p": [-222, 143, -362],
    "s": [58, 3, 62],
    "c": "#393939",
    "t": 11
  }, {
    "p": [-43, 55, -25],
    "s": [2, 2, 2],
    "l": 1,
    "c": "#571f1f",
    "t": 5
  }, {
    "p": [-45, 55, -27],
    "s": [2, 2, 2],
    "l": 1,
    "c": "#571f1f",
    "t": 5
  }, {
    "p": [-43, 55, -27],
    "s": [2, 1, 2],
    "l": 1,
    "c": "#571f1f",
    "t": 5
  }, {
    "p": [222, 85, 132],
    "s": [2, 23, 2],
    "c": "#7d7d7d",
    "t": 2
  }, {
    "p": [264, 85, 132],
    "s": [2, 23, 2],
    "c": "#7d7d7d",
    "t": 2
  }, {
    "p": [243, 87, 131],
    "s": [45, 20, 1],
    "c": "#4d4d4d",
    "t": 2
  }, {
    "p": [217, 85, 134],
    "s": [6, 8, 6],
    "i": 2,
    "l": 1,
    "r": [0, 0.69, 0]
  }, {
    "p": [243, 87, 130],
    "s": [46, 1, 2],
    "c": "#4d4d4d",
    "t": 2
  }, {
    "p": [213, 93, 137],
    "s": [6, 8, 6],
    "i": 2,
    "l": 1,
    "r": [0, 1.21, 0]
  }, {
    "p": [325, 57, -4],
    "s": [18, 46, 38],
    "c": "#ffd5b1"
  }, {
    "p": [325, 103, -4],
    "s": [21, 3, 40],
    "c": "#525252",
    "t": 11
  }, {
    "p": [324, 95, 10],
    "s": [1, 19, 1],
    "c": "#2f2f2f",
    "t": 5
  }, {
    "p": [324, 114, 10],
    "s": [1, 6, 1],
    "l": 1,
    "r": [0.35, 0, 0],
    "c": "#2f2f2f",
    "t": 5
  }, {
    "p": [324, 119, 12],
    "s": [1, 3, 1],
    "l": 1,
    "c": "#2f2f2f",
    "t": 5
  }, {
    "p": [-83, 121, -380],
    "s": [12, 12, 12],
    "i": 1,
    "l": 1
  }, {
    "p": [-204, 137, -305],
    "s": [6, 8, 6],
    "i": 2,
    "l": 1,
    "r": [0, 0.88, 0]
  }, {
    "p": [-203, 129, -304],
    "s": [6, 8, 6],
    "i": 2,
    "l": 1,
    "r": [0, -0.17, 0]
  }, {
    "p": [-204, 127, -294],
    "s": [2, 25, 2],
    "c": "#7d7d7d",
    "t": 2
  }, {
    "p": [-203, 131, -278],
    "s": [1, 20, 44],
    "c": "#7d7d7d",
    "t": 2
  }, {
    "p": [-203, 131, -278],
    "s": [3, 1, 45],
    "c": "#7d7d7d",
    "t": 2
  }, {
    "p": [-204, 127, -262],
    "s": [2, 25, 2],
    "c": "#7d7d7d",
    "t": 2
  }, {
    "p": [-202, 129, -311],
    "s": [6, 8, 6],
    "i": 2,
    "l": 1,
    "r": [0, 0.18, 0]
  }, {
    "p": [-214, 129, -259],
    "s": [12, 12, 12],
    "i": 1,
    "l": 1,
    "r": [0, -0.35, 0]
  }, {
    "p": [-227, 129, -255],
    "s": [6, 8, 6],
    "i": 2,
    "l": 1,
    "r": [0, -0.17, 0]
  }, {
    "p": [-201, 136, -339],
    "s": [1, 19, 1],
    "c": "#2f2f2f",
    "t": 5
  }, {
    "p": [-201, 155, -339],
    "s": [1, 6, 1],
    "l": 1,
    "r": [0.35, 0, 0],
    "c": "#2f2f2f",
    "t": 5
  }, {
    "p": [-201, 160, -337],
    "s": [1, 3, 1],
    "l": 1,
    "c": "#2f2f2f",
    "t": 5
  }, {
    "p": [210, 85, 138],
    "s": [6, 8, 6],
    "i": 2,
    "l": 1,
    "r": [0, 0.34, 0]
  }, {
    "p": [39, 12, -16],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 1.16, 0]
  }, {
    "p": [-27, 12, 7],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, 0.76, -3.14]
  }, {
    "p": [-61, 12, 10],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, -0.81, -3.14]
  }, {
    "p": [-59, 22, -63],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.24, 0]
  }, {
    "p": [-77, 22, -70],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.41, 0]
  }, {
    "p": [-128, 32, -42],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.53, 0]
  }, {
    "p": [-87, 32, 47],
    "s": [63, 2, 67],
    "l": 1,
    "c": "#393939",
    "t": 11
  }, {
    "p": [-118, 24, 153],
    "s": [5, 127, 6],
    "v": 1,
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [-14, 36, -257],
    "s": [5, 123, 6],
    "v": 1,
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [438, 32, 66],
    "s": [65, 109, 54],
    "i": 15,
    "l": 1,
    "r": [-3.14, -0.17, -3.14]
  }, {
    "p": [397, 32, 15],
    "s": [65, 109, 54],
    "i": 15,
    "l": 1,
    "r": [0, -0.53, 0]
  }, {
    "p": [22, 47, 63],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.69, 0]
  }, {
    "p": [34, 47, 34],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.69, 0]
  }, {
    "p": [-32, 47, 68],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.69, 0]
  }, {
    "p": [-45, 47, 51],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, 0.86, 3.14]
  }, {
    "p": [-29, 47, 42],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.06, 1.56, 3.06]
  }, {
    "p": [-42, 47, -13],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.06, 1.56, 3.06]
  }, {
    "p": [-42, 47, -34],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, 0.86, 3.14]
  }, {
    "p": [9, 47, -31],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, 0.86, 3.14]
  }, {
    "p": [-44, 47, -91],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, 0.86, 3.14]
  }, {
    "p": [-32, 47, -126],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, 0.86, 3.14]
  }, {
    "p": [42, 47, -56],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, 0.86, 3.14]
  }, {
    "p": [42, 47, -88],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, 0.86, 3.14]
  }, {
    "p": [32, 47, -29],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [3.14, -1.23, 3.14]
  }, {
    "p": [138, 32, -119],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, -0.98, -3.14]
  }, {
    "p": [138, 32, -85],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, -0.98, -3.14]
  }, {
    "p": [-10, 47, -41],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, -0.19, 3.14]
  }, {
    "p": [10, 47, -17],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 1.06, 0]
  }, {
    "p": [261, 32, 80],
    "s": [9, 14, 4],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [271, 32, 80],
    "s": [12, 3, 4],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [271, 44, 80],
    "s": [11, 3, 4],
    "c": "#7a6a5d",
    "t": 11
  }, {
    "p": [275, 35, 78],
    "s": [3, 10, 1],
    "pe": 1,
    "c": "#b4b4b4",
    "t": 2
  }, {
    "p": [272, 34, 78],
    "s": [3, 12, 1],
    "pe": 1,
    "c": "#898989",
    "t": 2
  }, {
    "p": [269, 35, 78],
    "s": [3, 10, 1],
    "pe": 1,
    "c": "#cacaca",
    "t": 2
  }, {
    "p": [266, 35, 78],
    "s": [3, 11, 1],
    "pe": 1,
    "c": "#898989",
    "t": 2
  }, {
    "p": [203, 47, 80],
    "s": [11, 1, 4],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [-113, 46, -319],
    "s": [5, 1, 11],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [-113, 46, -291],
    "s": [5, 2, 11],
    "c": "#9d8672",
    "t": 11
  }, {
    "p": [-104, 33, -329],
    "s": [7, 2, 4],
    "l": 1,
    "r": [0, 0.36, 0],
    "c": "#9d8672"
  }, {
    "p": [50, 77, -36],
    "s": [8, 1, 101],
    "i": 9,
    "v": 1,
    "b": -0.1
  }, {
    "p": [-52, 77, -25],
    "s": [8, 1, 212],
    "i": 9,
    "v": 1,
    "b": -0.1,
    "d": 2
  }, {
    "p": [-41, 77, 77],
    "s": [34, 1, 8],
    "i": 9,
    "v": 1,
    "b": -0.1,
    "d": 1
  }, {
    "p": [26, 77, 77],
    "s": [24, 1, 8],
    "i": 9,
    "v": 1,
    "b": -0.1,
    "d": 1
  }, {
    "p": [176, 67, -234],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [0, -1.57, 0]
  }, {
    "p": [176, 68, -236],
    "s": [6, 1, 16],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": 5066061,
    "t": 2
  }, {
    "p": [-46, 90, -195],
    "s": [1, 19, 1],
    "c": "#2f2f2f",
    "t": 5
  }, {
    "p": [-46, 109, -195],
    "s": [1, 5, 1],
    "l": 1,
    "r": [-0.44, 0, 0],
    "c": "#2f2f2f",
    "t": 5
  }, {
    "p": [-52, 12, -18],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, 0.76, -3.14]
  }, {
    "p": [2, 12, -15],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 1.16, 0]
  }, {
    "p": [-217, 32, -25],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.53, 0]
  }, {
    "p": [-149, 32, -252],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.62, 0],
    "c": "#d2b559"
  }, {
    "p": [-110, 50, 146],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.87, 0]
  }, {
    "p": [-124, 50, 161],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.26, 0]
  }, {
    "p": [195, 32, -12],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -1.28, 0]
  }, {
    "p": [-225, 47, 132],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, 1.04, 3.14]
  }, {
    "p": [-135, 32, -70],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.97, 0]
  }, {
    "p": [164, 192, 142],
    "s": [4, 4, 40],
    "c": "#7d7d7d",
    "t": 2
  }, {
    "p": [164, 192, 142],
    "s": [41, 4, 4],
    "c": "#7d7d7d",
    "t": 2
  }, {
    "p": [240, 33, -202],
    "s": [6, 2, 4],
    "l": 1,
    "r": [0, -1.39, 0],
    "c": "#9d8672"
  }, {
    "p": [267, 33, -101],
    "s": [6, 2, 4],
    "l": 1,
    "r": [0, -1.39, 0],
    "c": "#9d8672"
  }, {
    "p": [216, 32, -7],
    "s": [6, 2, 4],
    "l": 1,
    "r": [0, -1.39, 0],
    "c": "#9d8672"
  }, {
    "p": [286, 32, 31],
    "s": [6, 2, 4],
    "l": 1,
    "r": [0, -1.39, 0],
    "c": "#9d8672"
  }, {
    "p": [269, 32, -53],
    "s": [6, 2, 4],
    "l": 1,
    "r": [0, -1.39, 0],
    "c": "#9d8672"
  }, {
    "p": [259, 32, 74],
    "s": [6, 2, 4],
    "l": 1,
    "r": [0, -0.43, 0],
    "c": "#9d8672"
  }, {
    "p": [-21, 12, 7],
    "s": [6, 2, 4],
    "l": 1,
    "r": [0, -0.43, 0],
    "c": "#9d8672"
  }, {
    "p": [8, 13, -15],
    "s": [6, 2, 4],
    "l": 1,
    "r": [0, 0.27, 0],
    "c": "#9d8672"
  }, {
    "p": [-157, 32, 66],
    "s": [6, 2, 4],
    "l": 1,
    "r": [0, -0.43, 0],
    "c": "#9d8672"
  }, {
    "p": [-221, 33, 23],
    "s": [6, 2, 4],
    "l": 1,
    "r": [3.14, -1.49, 3.14],
    "c": "#9d8672"
  }, {
    "p": [-136, 48, 138],
    "s": [6, 2, 4],
    "l": 1,
    "r": [0, 1.14, 0],
    "c": "#9d8672"
  }, {
    "p": [-129, 33, -14],
    "s": [6, 2, 4],
    "l": 1,
    "r": [0, -1.04, 0],
    "c": "#9d8672"
  }, {
    "p": [-143, 33, -251],
    "s": [4, 2, 4],
    "l": 1,
    "c": "#9d8672"
  }, {
    "p": [-204, 33, -231],
    "s": [4, 2, 4],
    "l": 1,
    "c": "#9d8672"
  }, {
    "p": [153, 33, -311],
    "s": [6, 2, 4],
    "l": 1,
    "r": [0, -1.39, 0],
    "c": "#9d8672"
  }, {
    "p": [124, 33, -203],
    "s": [6, 2, 4],
    "l": 1,
    "r": [0, 0.09, 0],
    "c": "#9d8672"
  }, {
    "p": [216, 33, -141],
    "s": [6, 2, 4],
    "l": 1,
    "r": [0, -1.39, 0],
    "c": "#9d8672"
  }, {
    "p": [150, 33, 21],
    "s": [4, 2, 4],
    "l": 1,
    "r": [0, -1.39, 0],
    "c": "#9d8672"
  }, {
    "p": [22, 48, 85],
    "s": [6, 2, 4],
    "l": 1,
    "r": [0, -0.34, 0],
    "c": "#9d8672"
  }, {
    "p": [-36, 48, 57],
    "s": [6, 2, 4],
    "l": 1,
    "r": [0, -0.34, 0],
    "c": "#9d8672"
  }, {
    "p": [-54, 48, 85],
    "s": [6, 2, 4],
    "l": 1,
    "r": [0, 0.18, 0],
    "c": "#9d8672"
  }, {
    "p": [-40, 48, -21],
    "s": [2, 1, 2],
    "l": 1,
    "c": "#571f1f",
    "t": 5
  }, {
    "p": [17, 48, 71],
    "s": [2, 1, 2],
    "l": 1,
    "c": "#571f1f",
    "t": 5
  }, {
    "p": [10, 55, -23],
    "s": [2, 1, 2],
    "l": 1,
    "c": "#571f1f",
    "t": 5
  }, {
    "p": [10, 55, -25],
    "s": [2, 2, 2],
    "l": 1,
    "c": "#571f1f",
    "t": 5
  }, {
    "p": [8, 53, -24],
    "s": [2, 3, 2],
    "l": 1,
    "c": "#571f1f",
    "t": 5
  }, {
    "p": [-193, 32, -41],
    "s": [4, 2, 4],
    "l": 1,
    "r": [0, -0.87, 0],
    "c": "#9d8672"
  }, {
    "p": [-195, 32, -35],
    "s": [2, 2, 2],
    "l": 1,
    "r": [0, -0.43, 0],
    "c": "#9d8672"
  }, {
    "p": [-133, 32, -20],
    "s": [2, 2, 2],
    "l": 1,
    "r": [0, -0.43, 0],
    "c": "#9d8672"
  }, {
    "p": [-151, 33, -208],
    "s": [4, 2, 4],
    "l": 1,
    "c": "#9d8672"
  }, {
    "p": [223, 32, 77],
    "s": [3, 2, 3],
    "l": 1,
    "r": [0, -1.39, 0],
    "c": "#9d8672"
  }, {
    "p": [248, 32, 75],
    "s": [2, 2, 2],
    "l": 1,
    "r": [0, -1.39, 0],
    "c": "#9d8672"
  }, {
    "p": [-185, 48, 132],
    "s": [3, 1, 3],
    "l": 1,
    "r": [0, 1.14, 0],
    "c": "#9d8672"
  }, {
    "p": [-20, 48, 76],
    "s": [6, 2, 4],
    "l": 1,
    "r": [0, 1.49, 0],
    "c": "#9d8672"
  }, {
    "p": [44, 47, -126],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, 0.86, 3.14]
  }, {
    "p": [7, 47, -127],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 1.32, 0]
  }]
}, {
  "name": "Subzero",
  "ambInd": 1,
  "modURL": "",
  "terrainSeed": "",
  "terrainWidth": 2048,
  "terrainHeight": 2048,
  "terrainMntMlt": 1,
  "terrainMntCol": "#a0a0a0",
  "terrainGrsCol": "#4a6904",
  "terrainDrtCol": "#8c6835",
  "skyDome": false,
  "skyDomeCol0": "#ffffff",
  "skyDomeCol1": "#7196a2",
  "skyDomeCol2": "#184452",
  "zone": false,
  "zoneSize": 500,
  "zoneSpeed": 1,
  "zoneCol0": "#c542d9",
  "zoneCol1": "#c542d9",
  "zoneCol2": "#c542d9",
  "sizeMlt": 2,
  "shadowR": 1024,
  "ambient": 8555670,
  "light": 16120058,
  "sky": 13883868,
  "fog": 13030361,
  "fogD": 601.943118216585,
  "dthY": -100,
  "camPos": [-13, 93, -6],
  "spawns": [[-41, 67, -58, 0], [-187, 54, -238, 0, 2], [-299, 54, 2, 0, 3], [131, 67, -203, 0, 3], [186, 67, -250, 0], [350, 67, -265, 0, 2], [319, 86, -59, 0], [178, 84, -49, 0], [140, 84, -13, 0, 1], [-162, 67, 63, 0]],
  "ambO": 1,
  "ambS": 5,
  "objects": [{
    "p": [-1, 64, 0],
    "s": [140, 2, 142],
    "l": 1,
    "t": 5
  }, {
    "p": [-100, 64, 50],
    "s": [58, 2, 42],
    "l": 1,
    "t": 5
  }, {
    "p": [-149, 53, 8],
    "s": [40, 13, 126],
    "l": 1,
    "t": 5
  }, {
    "p": [-139, 51, -111],
    "s": [172, 2, 130],
    "l": 1,
    "t": 5
  }, {
    "p": [-277, 51, -77],
    "s": [104, 2, 202],
    "l": 1,
    "t": 5
  }, {
    "p": [5, 64, -123],
    "s": [60, 2, 104],
    "l": 1,
    "t": 5
  }, {
    "p": [-54, 51, -143],
    "s": [58, 15, 42],
    "l": 1,
    "t": 5
  }, {
    "p": [240, 65, -325],
    "s": [132, 2, 38],
    "c": 5723991,
    "t": 11
  }, {
    "p": [213, 64, -207],
    "s": [40, 2, 63],
    "l": 1,
    "t": 5
  }, {
    "p": [213, 64, -112],
    "s": [39, 20, 37],
    "l": 1,
    "t": 5
  }, {
    "p": [-124, 51, -285],
    "s": [203, 2, 50],
    "l": 1,
    "t": 5
  }, {
    "p": [-198, 50, -218],
    "s": [38, 2, 84],
    "c": 7566195,
    "t": 1
  }, {
    "p": [343, 64, -252],
    "s": [77, 2, 43],
    "l": 1,
    "t": 5
  }, {
    "p": [343, 64, -122],
    "s": [82, 2, 217],
    "l": 1,
    "t": 5
  }, {
    "p": [327, 64, -11],
    "s": [140, 20, 129],
    "l": 1,
    "t": 5
  }, {
    "p": [-326, 11, -77],
    "s": [9, 47, 632],
    "c": 10983566,
    "t": 11
  }, {
    "p": [-2731, 11, -77],
    "s": [5362, 31, 11525],
    "l": 1,
    "c": 5203837,
    "t": 5
  }, {
    "p": [-290, 51, -217],
    "s": [78, 56, 80],
    "c": 9342330,
    "t": 10,
    "bo": 1
  }, {
    "p": [-252, 51, -178],
    "s": [4, 56, 4],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [-328, 56, -178],
    "s": [4, 51, 4],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [-252, 51, -256],
    "s": [4, 56, 4],
    "c": 11513775,
    "t": 2
  }, {
    "p": [-290, 76, -178],
    "s": [72, 4, 4],
    "c": 11513775,
    "t": 2
  }, {
    "p": [-290, 103, -178],
    "s": [72, 4, 4],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [-290, 51, -178],
    "s": [4, 70, 5],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [-252, 76, -217],
    "s": [4, 4, 74],
    "c": 11513775,
    "t": 2
  }, {
    "p": [-252, 103, -217],
    "s": [4, 4, 74],
    "c": 11513775,
    "t": 2
  }, {
    "p": [-268, 113, -217],
    "s": [45, 2, 84],
    "l": 1,
    "r": [0, 0, -0.35],
    "c": 7039851,
    "t": 2
  }, {
    "p": [-312, 113, -217],
    "s": [45, 2, 84],
    "l": 1,
    "r": [0, 0, 0.35],
    "c": 7039851,
    "t": 2
  }, {
    "p": [-290, 107, -217],
    "s": [77, 4, 80],
    "c": 9342330,
    "t": 10
  }, {
    "p": [-290, 120, -217],
    "s": [5, 5, 89],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [-267, 115, -217],
    "s": [45, 2, 84],
    "l": 1,
    "r": [0, 0, -0.35],
    "t": 5
  }, {
    "p": [-313, 115, -217],
    "s": [45, 2, 84],
    "l": 1,
    "r": [0, 0, 0.35],
    "t": 5
  }, {
    "p": [-290, 125, -217],
    "s": [5, 2, 89],
    "t": 5
  }, {
    "p": [-276, 51, -178],
    "s": [2, 20, 4],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [-264, 51, -178],
    "s": [2, 20, 4],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [-270, 71, -178],
    "s": [14, 2, 4],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [-290, 111, -217],
    "s": [55, 4, 80],
    "c": 9342330,
    "t": 10
  }, {
    "p": [-290, 115, -217],
    "s": [34, 4, 80],
    "c": 9342330,
    "t": 10
  }, {
    "p": [-290, 119, -217],
    "s": [13, 2, 80],
    "c": 9342330,
    "t": 10
  }, {
    "p": [-319, 56, -198],
    "s": [9, 72, 20],
    "c": 8355711,
    "t": 11
  }, {
    "p": [-234, 51, -212],
    "s": [34, 40, 96],
    "c": 8882055,
    "t": 11,
    "bo": 1
  }, {
    "p": [-151, 51, -212],
    "s": [60, 40, 96],
    "c": 8355711,
    "t": 11,
    "bo": 1
  }, {
    "p": [-186, 90, -212],
    "s": [128, 31, 94],
    "c": 8215901,
    "t": 10,
    "bo": 1
  }, {
    "p": [-249, 91, -166],
    "s": [4, 30, 4],
    "c": 8684676,
    "t": 2,
    "bo": 1
  }, {
    "p": [-207, 91, -166],
    "s": [4, 26, 4],
    "c": 8684676,
    "t": 2,
    "bo": 1
  }, {
    "p": [-165, 91, -166],
    "s": [4, 26, 4],
    "c": 8684676,
    "t": 2,
    "bo": 1
  }, {
    "p": [-123, 91, -166],
    "s": [4, 30, 4],
    "c": 8684676,
    "t": 2
  }, {
    "p": [-217, 53, -164],
    "s": [3, 31, 3],
    "c": 8684676,
    "t": 2,
    "bo": 1
  }, {
    "p": [-181, 53, -164],
    "s": [3, 31, 3],
    "c": 8684676,
    "t": 2,
    "bo": 1
  }, {
    "p": [-199, 81, -164],
    "s": [33, 3, 3],
    "c": 8684676,
    "t": 2,
    "bo": 1
  }, {
    "p": [-221, 131, -212],
    "s": [70, 3, 100],
    "l": 1,
    "r": [0, 0, 0.35],
    "c": 7894903,
    "t": 2
  }, {
    "p": [-186, 141, -212],
    "s": [7, 7, 108],
    "c": 8684676,
    "t": 2
  }, {
    "p": [-150, 131, -212],
    "s": [73, 3, 100],
    "l": 1,
    "r": [0, 0, -0.35],
    "c": 7894903,
    "t": 2
  }, {
    "p": [-149, 134, -212],
    "s": [73, 3, 100],
    "l": 1,
    "r": [0, 0, -0.35],
    "t": 5
  }, {
    "p": [-186, 148, -212],
    "s": [7, 3, 108],
    "t": 5
  }, {
    "p": [-165, 121, -166],
    "s": [4, 16, 4],
    "c": 8684676,
    "t": 2,
    "bo": 1
  }, {
    "p": [-207, 121, -166],
    "s": [4, 17, 4],
    "c": 8684676,
    "t": 2,
    "bo": 1
  }, {
    "p": [-186, 121, -212],
    "s": [125, 6, 94],
    "c": 8215901,
    "t": 10
  }, {
    "p": [-186, 127, -212],
    "s": [93, 6, 94],
    "c": 8215901,
    "t": 10
  }, {
    "p": [-186, 133, -212],
    "s": [60, 6, 94],
    "c": 8215901,
    "t": 10
  }, {
    "p": [-186, 139, -212],
    "s": [32, 4, 94],
    "c": 8215901,
    "t": 10
  }, {
    "p": [-135, 76, -236],
    "s": [9, 72, 20],
    "c": 5723991,
    "t": 11
  }, {
    "p": [-258, 51, -286],
    "s": [66, 58, 56],
    "c": 8029580,
    "t": 10,
    "bo": 1
  }, {
    "p": [-123, 91, -258],
    "s": [4, 30, 4],
    "c": 8684676,
    "t": 2,
    "bo": 1
  }, {
    "p": [-249, 91, -258],
    "s": [4, 30, 4],
    "c": 8684676,
    "t": 2
  }, {
    "p": [-207, 91, -258],
    "s": [4, 26, 4],
    "c": 8684676,
    "t": 2,
    "bo": 1
  }, {
    "p": [-165, 91, -258],
    "s": [4, 26, 4],
    "c": 8684676,
    "t": 2,
    "bo": 1
  }, {
    "p": [-207, 121, -258],
    "s": [4, 17, 4],
    "c": 8684676,
    "t": 2
  }, {
    "p": [-165, 121, -258],
    "s": [4, 17, 4],
    "c": 8684676,
    "t": 2
  }, {
    "p": [-226, 53, -261],
    "s": [4, 56, 4],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [-226, 77, -288],
    "s": [4, 4, 50],
    "c": 11513775,
    "t": 2
  }, {
    "p": [-226, 105, -288],
    "s": [4, 4, 50],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [-257, 118, -287],
    "s": [72, 4, 4],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [-257, 113, -303],
    "s": [68, 2, 32],
    "l": 1,
    "r": [-0.35, 0, 0],
    "c": 5723991,
    "t": 2
  }, {
    "p": [-257, 112, -267],
    "s": [68, 2, 40],
    "l": 1,
    "r": [0.35, 0, 0],
    "c": 5723991,
    "t": 2
  }, {
    "p": [-258, 109, -287],
    "s": [66, 3, 56],
    "c": 8029580,
    "t": 10
  }, {
    "p": [-257, 115, -303],
    "s": [68, 2, 33],
    "l": 1,
    "r": [-0.35, 0, 0],
    "t": 5
  }, {
    "p": [-257, 122, -287],
    "s": [72, 2, 4],
    "t": 5
  }, {
    "p": [-258, 112, -286],
    "s": [66, 4, 38],
    "c": 8029580,
    "t": 10
  }, {
    "p": [-258, 116, -287],
    "s": [66, 3, 21],
    "c": 8029580,
    "t": 10
  }, {
    "p": [-257, 114, -266],
    "s": [68, 2, 41],
    "l": 1,
    "r": [0.35, 0, 0],
    "t": 5
  }, {
    "p": [-225, 51, -271],
    "s": [2, 20, 2],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [-225, 51, -283],
    "s": [2, 20, 2],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [-225, 71, -277],
    "s": [2, 2, 14],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [-193, 51, -329],
    "s": [66, 38, 56],
    "c": 7110518,
    "t": 10,
    "bo": 1
  }, {
    "p": [-223, 53, -302],
    "s": [4, 42, 4],
    "c": 9013641,
    "t": 2,
    "bo": 1
  }, {
    "p": [-161, 53, -302],
    "s": [4, 42, 4],
    "c": 9013641,
    "t": 2,
    "bo": 1
  }, {
    "p": [-192, 87, -302],
    "s": [58, 8, 4],
    "c": 9013641,
    "t": 2,
    "bo": 1
  }, {
    "p": [-226, 53, -315],
    "s": [4, 56, 4],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [-192, 96, -327],
    "s": [68, 2, 57],
    "l": 1,
    "r": [0.17, 0, 0],
    "c": 5592405,
    "t": 2
  }, {
    "p": [-192, 98, -327],
    "s": [68, 2, 57],
    "l": 1,
    "r": [0.17, 0, 0],
    "t": 5
  }, {
    "p": [-193, 89, -329],
    "s": [66, 6, 56],
    "c": 7110518,
    "t": 10
  }, {
    "p": [-193, 92, -339],
    "s": [66, 3, 36],
    "c": 7110518,
    "t": 5
  }, {
    "p": [-193, 95, -347],
    "s": [66, 3, 20],
    "c": 7110518,
    "t": 10
  }, {
    "p": [-186, 51, -302],
    "s": [2, 20, 4],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [-174, 51, -302],
    "s": [2, 20, 4],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [-180, 71, -302],
    "s": [14, 2, 4],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [-216, 51, -254],
    "s": [19, 2, 12],
    "l": 1,
    "t": 5
  }, {
    "p": [-195, 51, -257],
    "s": [12, 2, 6],
    "l": 1,
    "t": 5
  }, {
    "p": [-185, 51, -254],
    "s": [8, 2, 12],
    "l": 1,
    "t": 5
  }, {
    "p": [-211, 51, -183],
    "s": [12, 2, 14],
    "l": 1,
    "t": 5
  }, {
    "p": [-201, 51, -179],
    "s": [8, 2, 6],
    "l": 1,
    "t": 5
  }, {
    "p": [-183, 51, -182],
    "s": [8, 2, 12],
    "l": 1,
    "t": 5
  }, {
    "p": [-197, 51, -62],
    "s": [56, 57, 80],
    "c": 8878432,
    "t": 10,
    "bo": 1
  }, {
    "p": [-224, 51, -101],
    "s": [4, 58, 4],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [-224, 51, -23],
    "s": [4, 58, 4],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [-170, 51, -23],
    "s": [4, 58, 4],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [-170, 51, -101],
    "s": [4, 58, 4],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [-197, 77, -101],
    "s": [50, 4, 4],
    "c": 11513775,
    "t": 2
  }, {
    "p": [-197, 105, -101],
    "s": [50, 4, 4],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [-197, 105, -62],
    "s": [58, 4, 74],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [-197, 121, -62],
    "s": [65, 6, 6],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [-197, 116, -84],
    "s": [63, 2, 43],
    "l": 1,
    "r": [-0.35, 0, 0],
    "c": 6710886,
    "t": 2
  }, {
    "p": [-197, 116, -40],
    "s": [63, 2, 44],
    "l": 1,
    "r": [0.35, 0, 0],
    "c": 6710886,
    "t": 2
  }, {
    "p": [-197, 118, -39],
    "s": [63, 2, 44],
    "l": 1,
    "r": [0.35, 0, 0],
    "t": 5
  }, {
    "p": [-197, 118, -85],
    "s": [63, 2, 43],
    "l": 1,
    "r": [-0.35, 0, 0],
    "t": 5
  }, {
    "p": [-197, 127, -62],
    "s": [65, 2, 6],
    "t": 5
  }, {
    "p": [-197, 109, -62],
    "s": [56, 3, 82],
    "c": 8878432,
    "t": 10
  }, {
    "p": [-186, 117, -212],
    "s": [122, 4, 96],
    "c": 8684676,
    "t": 2,
    "bo": 1
  }, {
    "p": [-197, 112, -62],
    "s": [56, 3, 66],
    "c": 8878432,
    "t": 10
  }, {
    "p": [-197, 115, -62],
    "s": [56, 4, 50],
    "c": 8878432,
    "t": 10
  }, {
    "p": [-197, 119, -62],
    "s": [56, 4, 28],
    "c": 8878432,
    "t": 10
  }, {
    "p": [-224, 51, -62],
    "s": [5, 71, 4],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [-170, 51, -62],
    "s": [5, 71, 4],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [-176, 92, -90],
    "s": [7, 39, 12],
    "c": 6250335,
    "t": 11
  }, {
    "p": [-225, 51, -36],
    "s": [2, 22, 2],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [-225, 51, -48],
    "s": [2, 22, 2],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [-225, 71, -42],
    "s": [2, 2, 10],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [-197, 51, 14],
    "s": [74, 72, 70],
    "c": 6320224,
    "t": 10,
    "bo": 1
  }, {
    "p": [-233, 51, -20],
    "s": [4, 73, 4],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [-233, 51, 48],
    "s": [4, 73, 4],
    "c": 7895160,
    "t": 2
  }, {
    "p": [-161, 51, 48],
    "s": [4, 73, 4],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [-161, 51, -20],
    "s": [4, 73, 4],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [-197, 53, 14],
    "s": [77, 12, 73],
    "c": 6250335,
    "t": 11
  }, {
    "p": [-160, 91, 14],
    "s": [2, 4, 64],
    "l": 1,
    "c": 7500402,
    "t": 2
  }, {
    "p": [-197, 120, 14],
    "s": [76, 4, 64],
    "c": 7500402,
    "t": 2,
    "bo": 1
  }, {
    "p": [-160, 66, -9],
    "s": [2, 20, 2],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [-160, 66, 3],
    "s": [2, 20, 2],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [-160, 84, -3],
    "s": [2, 2, 10],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [-197, 120, -20],
    "s": [68, 4, 4],
    "c": 7500402,
    "t": 2,
    "bo": 1
  }, {
    "p": [-197, 120, 48],
    "s": [68, 4, 4],
    "l": 1,
    "c": 7500402,
    "t": 2
  }, {
    "p": [-197, 136, 14],
    "s": [5, 5, 80],
    "c": 9868950,
    "t": 2
  }, {
    "p": [-219, 130, 14],
    "s": [42, 2, 77],
    "l": 1,
    "r": [0, 0, 0.35],
    "c": 5395026,
    "t": 2
  }, {
    "p": [-176, 130, 14],
    "s": [41, 2, 77],
    "l": 1,
    "r": [0, 0, -0.35],
    "c": 5395026,
    "t": 2
  }, {
    "p": [-197, 124, 14],
    "s": [74, 4, 70],
    "c": 6320224,
    "t": 10
  }, {
    "p": [-176, 132, 14],
    "s": [43, 2, 77],
    "l": 1,
    "r": [0, 0, -0.35],
    "t": 5
  }, {
    "p": [-219, 132, 14],
    "s": [44, 2, 77],
    "l": 1,
    "r": [0, 0, 0.35],
    "t": 5
  }, {
    "p": [-197, 141, 14],
    "s": [5, 2, 80],
    "t": 5
  }, {
    "p": [-197, 128, 14],
    "s": [53, 4, 70],
    "c": 6320224,
    "t": 10
  }, {
    "p": [-197, 136, 14],
    "s": [11, 3, 70],
    "c": 6320224,
    "t": 10
  }, {
    "p": [-197, 132, 14],
    "s": [31, 4, 70],
    "c": 6320224,
    "t": 10
  }, {
    "p": [-197, 91, -20],
    "s": [68, 4, 4],
    "c": 7500402,
    "t": 2
  }, {
    "p": [-281, 51, 64],
    "s": [96, 58, 80],
    "c": 7558742,
    "t": 10,
    "bo": 1
  }, {
    "p": [-282, 78, 25],
    "s": [88, 4, 4],
    "c": 9013641,
    "t": 2
  }, {
    "p": [-282, 120, 64],
    "s": [102, 7, 7],
    "l": 1,
    "c": 11513775,
    "t": 2
  }, {
    "p": [-282, 116, 43],
    "s": [100, 2, 48],
    "l": 1,
    "r": [-0.35, 0, 0],
    "c": 5723991,
    "t": 2
  }, {
    "p": [-282, 115, 87],
    "s": [100, 2, 49],
    "l": 1,
    "r": [0.35, 0, 0],
    "c": 5723991,
    "t": 2
  }, {
    "p": [-282, 118, 42],
    "s": [100, 2, 48],
    "l": 1,
    "r": [-0.35, 0, 0],
    "t": 5
  }, {
    "p": [-282, 117, 88],
    "s": [100, 2, 49],
    "l": 1,
    "r": [0.35, 0, 0],
    "t": 5
  }, {
    "p": [-282, 127, 64],
    "s": [102, 2, 7],
    "l": 1,
    "t": 5
  }, {
    "p": [-281, 109, 64],
    "s": [96, 4, 80],
    "c": 6903125,
    "t": 10
  }, {
    "p": [-281, 113, 64],
    "s": [96, 4, 58],
    "c": 6903125,
    "t": 10
  }, {
    "p": [-281, 117, 64],
    "s": [96, 4, 35],
    "c": 6903125,
    "t": 10
  }, {
    "p": [-281, 121, 64],
    "s": [96, 3, 15],
    "c": 6903125,
    "t": 10
  }, {
    "p": [-264, 51, 25],
    "s": [2, 22, 4],
    "c": 9013384,
    "t": 2,
    "bo": 1
  }, {
    "p": [-252, 51, 25],
    "s": [2, 22, 4],
    "c": 9013641,
    "t": 2,
    "bo": 1
  }, {
    "p": [-258, 71, 25],
    "s": [10, 2, 4],
    "c": 9539985,
    "t": 2,
    "bo": 1
  }, {
    "p": [-326, 58, -77],
    "s": [5, 7, 5],
    "c": 8223868,
    "t": 11
  }, {
    "p": [-326, 58, -61],
    "s": [5, 7, 5],
    "c": 8223868,
    "t": 11
  }, {
    "p": [-326, 58, -93],
    "s": [5, 7, 5],
    "c": 8223868,
    "t": 11
  }, {
    "p": [-326, 58, -109],
    "s": [5, 7, 5],
    "c": 8223868,
    "t": 11
  }, {
    "p": [-326, 58, -126],
    "s": [5, 7, 5],
    "c": 8223868,
    "t": 11
  }, {
    "p": [-326, 58, -143],
    "s": [5, 7, 5],
    "c": 8223868,
    "t": 11
  }, {
    "p": [-326, 58, -160],
    "s": [5, 7, 5],
    "c": 8223868,
    "t": 11
  }, {
    "p": [-326, 58, -177],
    "s": [5, 7, 5],
    "c": 8223868,
    "t": 11
  }, {
    "p": [-326, 58, -44],
    "s": [5, 7, 5],
    "c": 8223868,
    "t": 11
  }, {
    "p": [-326, 58, -27],
    "s": [5, 7, 5],
    "c": 8223868,
    "t": 11
  }, {
    "p": [-326, 58, -10],
    "s": [5, 7, 5],
    "c": 8223868,
    "t": 11
  }, {
    "p": [-326, 58, 7],
    "s": [5, 7, 5],
    "c": 8223868,
    "t": 11
  }, {
    "p": [-326, 58, 24],
    "s": [5, 7, 5],
    "c": 8223868,
    "t": 11
  }, {
    "p": [-326, 61, -79],
    "s": [2, 2, 205],
    "c": 13619151,
    "t": 2,
    "bo": 1
  }, {
    "p": [-120, 51, -159],
    "s": [4, 55, 4],
    "c": 9671571,
    "t": 2,
    "bo": 1
  }, {
    "p": [-24, 51, -159],
    "s": [4, 55, 4],
    "c": 9013641,
    "t": 2,
    "bo": 1
  }, {
    "p": [-24, 51, -265],
    "s": [4, 55, 4],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [-120, 51, -265],
    "s": [4, 55, 4],
    "c": 8026746,
    "t": 2,
    "bo": 1
  }, {
    "p": [-72, 51, -265],
    "s": [4, 72, 5],
    "c": 9539985,
    "t": 2,
    "bo": 1
  }, {
    "p": [-72, 51, -159],
    "s": [4, 72, 5],
    "c": 9211020,
    "t": 2,
    "bo": 1
  }, {
    "p": [-100, 114, -212],
    "s": [56, 3, 114],
    "l": 1,
    "r": [0, 0, 0.35],
    "c": 5395026,
    "t": 2
  }, {
    "p": [-72, 122, -212],
    "s": [6, 6, 119],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [-45, 114, -212],
    "s": [56, 3, 114],
    "l": 1,
    "r": [0, 0, -0.35],
    "c": 5395026,
    "t": 2
  }, {
    "p": [-72, 78, -265],
    "s": [92, 4, 4],
    "c": 7697781,
    "t": 2
  }, {
    "p": [-24, 78, -212],
    "s": [4, 4, 102],
    "c": 8355711,
    "t": 2
  }, {
    "p": [-72, 78, -159],
    "s": [92, 4, 4],
    "c": 9211020,
    "t": 2
  }, {
    "p": [-120, 78, -212],
    "s": [4, 4, 102],
    "l": 1,
    "c": 8553090,
    "t": 2
  }, {
    "p": [-72, 102, -159],
    "s": [92, 4, 4],
    "c": 9539985,
    "t": 2,
    "bo": 1
  }, {
    "p": [-72, 102, -265],
    "s": [92, 4, 4],
    "c": 9671571,
    "t": 2,
    "bo": 1
  }, {
    "p": [-24, 51, -212],
    "s": [5, 55, 4],
    "c": 8355711,
    "t": 2,
    "bo": 1
  }, {
    "p": [-24, 102, -212],
    "s": [4, 4, 102],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [-120, 102, -212],
    "s": [4, 4, 102],
    "c": 9013641,
    "t": 2,
    "bo": 1
  }, {
    "p": [-44, 117, -212],
    "s": [56, 3, 114],
    "l": 1,
    "r": [0, 0, -0.35],
    "t": 5
  }, {
    "p": [-101, 117, -212],
    "s": [56, 3, 114],
    "l": 1,
    "r": [0, 0, 0.35],
    "t": 5
  }, {
    "p": [-72, 128, -212],
    "s": [6, 2, 119],
    "t": 5
  }, {
    "p": [-111, 51, -265],
    "s": [2, 23, 4],
    "c": 11513775,
    "t": 2
  }, {
    "p": [-99, 51, -265],
    "s": [2, 23, 4],
    "c": 11513775,
    "t": 2
  }, {
    "p": [-105, 72, -265],
    "s": [10, 2, 4],
    "c": 11513775,
    "t": 2
  }, {
    "p": [-108, 51, -356],
    "s": [102, 60, 92],
    "c": 8217957,
    "t": 10,
    "bo": 1
  }, {
    "p": [-58, 53, -311],
    "s": [4, 59, 4],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [-158, 53, -311],
    "s": [4, 59, 4],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [-158, 53, -357],
    "s": [4, 55, 4],
    "c": 11513775,
    "t": 2
  }, {
    "p": [-124, 53, -311],
    "s": [4, 74, 5],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [-92, 53, -311],
    "s": [4, 75, 5],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [-108, 79, -311],
    "s": [96, 4, 4],
    "c": 11513775,
    "t": 2
  }, {
    "p": [-108, 108, -311],
    "s": [96, 4, 4],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [-108, 129, -356],
    "s": [6, 6, 105],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [-136, 121, -356],
    "s": [57, 3, 99],
    "l": 1,
    "r": [0, 0, 0.35],
    "c": 5855577,
    "t": 2
  }, {
    "p": [-58, 108, -358],
    "s": [4, 4, 90],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [-158, 108, -355],
    "s": [4, 4, 84],
    "l": 1,
    "c": 11513775,
    "t": 2
  }, {
    "p": [-137, 124, -356],
    "s": [57, 2, 99],
    "l": 1,
    "r": [0, 0, 0.35],
    "t": 5
  }, {
    "p": [-108, 135, -356],
    "s": [6, 2, 105],
    "t": 5
  }, {
    "p": [-79, 124, -356],
    "s": [57, 2, 99],
    "l": 1,
    "r": [0, 0, -0.35],
    "t": 5
  }, {
    "p": [-80, 121, -356],
    "s": [57, 3, 99],
    "l": 1,
    "r": [0, 0, -0.35],
    "c": 6052956,
    "t": 2
  }, {
    "p": [-108, 112, -356],
    "s": [102, 5, 92],
    "c": 8217957,
    "t": 10
  }, {
    "p": [-108, 117, -356],
    "s": [77, 5, 92],
    "c": 8217957,
    "t": 10
  }, {
    "p": [-108, 122, -356],
    "s": [49, 5, 92],
    "c": 8217957,
    "t": 10
  }, {
    "p": [-108, 127, -356],
    "s": [22, 5, 92],
    "c": 8217957,
    "t": 10
  }, {
    "p": [-148, 51, -311],
    "s": [2, 22, 4],
    "c": 11513775,
    "t": 2
  }, {
    "p": [-136, 51, -311],
    "s": [2, 22, 4],
    "c": 11513775,
    "t": 2
  }, {
    "p": [-142, 71, -311],
    "s": [10, 2, 4],
    "c": 11513775,
    "t": 2
  }, {
    "p": [-101, 51, -20],
    "s": [60, 62, 100],
    "c": 6973550,
    "t": 10,
    "bo": 1
  }, {
    "p": [-101, 130, -20],
    "s": [5, 5, 108],
    "c": 9868950,
    "t": 2
  }, {
    "p": [-130, 51, 29],
    "s": [4, 63, 4],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [-72, 51, 29],
    "s": [4, 63, 4],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [-72, 51, -71],
    "s": [4, 63, 4],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [-26, 51, -71],
    "s": [4, 70, 4],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [-26, 51, -121],
    "s": [4, 70, 4],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [-128, 51, -121],
    "s": [4, 70, 4],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [-78, 51, -121],
    "s": [4, 70, 5],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [-72, 51, -19],
    "s": [4, 63, 4],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [-101, 87, 29],
    "s": [54, 4, 4],
    "c": 7500402,
    "t": 2
  }, {
    "p": [-101, 110, 29],
    "s": [54, 4, 4],
    "c": 7500402,
    "t": 2,
    "bo": 1
  }, {
    "p": [-103, 91, -121],
    "s": [46, 4, 4],
    "l": 1,
    "c": 7500402,
    "t": 2
  }, {
    "p": [-52, 91, -121],
    "s": [48, 4, 4],
    "l": 1,
    "c": 7500402,
    "t": 2
  }, {
    "p": [-49, 91, -71],
    "s": [42, 4, 4],
    "c": 7500402,
    "t": 2
  }, {
    "p": [-52, 117, -121],
    "s": [48, 4, 4],
    "c": 7500402,
    "t": 2,
    "bo": 1
  }, {
    "p": [-103, 117, -121],
    "s": [46, 4, 4],
    "c": 7500402,
    "t": 2,
    "bo": 1
  }, {
    "p": [-101, 87, 5],
    "s": [62, 4, 44],
    "c": 7500402,
    "t": 2
  }, {
    "p": [-128, 91, -95],
    "s": [4, 4, 48],
    "l": 1,
    "c": 7500402,
    "t": 2
  }, {
    "p": [-26, 117, -96],
    "s": [4, 4, 46],
    "c": 7500402,
    "t": 2,
    "bo": 1
  }, {
    "p": [-26, 91, -96],
    "s": [4, 4, 46],
    "c": 7500402,
    "t": 2
  }, {
    "p": [-84, 122, -20],
    "s": [39, 2, 105],
    "l": 1,
    "r": [0, 0, -0.52],
    "c": 4737096,
    "t": 2
  }, {
    "p": [-118, 122, -20],
    "s": [39, 2, 105],
    "l": 1,
    "r": [0, 0, 0.53],
    "c": 4737096,
    "t": 2
  }, {
    "p": [-52, 117, -71],
    "s": [48, 4, 4],
    "c": 7500402,
    "t": 2,
    "bo": 1
  }, {
    "p": [-130, 51, -69],
    "s": [4, 63, 4],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [-130, 51, -19],
    "s": [5, 63, 4],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [-101, 114, -20],
    "s": [61, 4, 100],
    "c": 6973550,
    "t": 10,
    "bo": 1
  }, {
    "p": [-101, 118, -20],
    "s": [50, 4, 100],
    "c": 6973550,
    "t": 10
  }, {
    "p": [-101, 122, -20],
    "s": [35, 4, 100],
    "c": 6973550,
    "t": 10
  }, {
    "p": [-101, 126, -20],
    "s": [22, 4, 100],
    "c": 6973550,
    "t": 10
  }, {
    "p": [-101, 130, -20],
    "s": [9, 1, 100],
    "c": 6973550,
    "t": 5
  }, {
    "p": [-119, 124, -20],
    "s": [39, 2, 105],
    "l": 1,
    "r": [0, 0, 0.53],
    "t": 5
  }, {
    "p": [-83, 124, -20],
    "s": [39, 2, 105],
    "l": 1,
    "r": [0, 0, -0.52],
    "t": 5
  }, {
    "p": [-101, 135, -20],
    "s": [5, 2, 108],
    "t": 5
  }, {
    "p": [-77, 51, -96],
    "s": [104, 68, 52],
    "c": 6254184,
    "t": 10,
    "bo": 1
  }, {
    "p": [-128, 117, -95],
    "s": [4, 4, 48],
    "c": 7500402,
    "t": 2,
    "bo": 1
  }, {
    "p": [-77, 119, -96],
    "s": [104, 5, 52],
    "c": 6254184,
    "t": 10
  }, {
    "p": [-77, 129, -96],
    "s": [114, 5, 5],
    "l": 1,
    "c": 7500402,
    "t": 2
  }, {
    "p": [-77, 125, -112],
    "s": [108, 2, 31],
    "l": 1,
    "r": [-0.35, 0, 0],
    "c": 5723991,
    "t": 2
  }, {
    "p": [-77, 125, -80],
    "s": [108, 2, 31],
    "l": 1,
    "r": [0.35, 0, 0],
    "c": 5723991,
    "t": 2
  }, {
    "p": [-77, 127, -113],
    "s": [108, 2, 31],
    "l": 1,
    "r": [-0.35, 0, 0],
    "t": 5
  }, {
    "p": [-77, 127, -79],
    "s": [108, 2, 31],
    "l": 1,
    "r": [0.35, 0, 0],
    "t": 5
  }, {
    "p": [-77, 134, -96],
    "s": [114, 2, 5],
    "l": 1,
    "t": 5
  }, {
    "p": [-77, 124, -96],
    "s": [104, 4, 38],
    "c": 6254184,
    "t": 10
  }, {
    "p": [-77, 128, -96],
    "s": [104, 4, 16],
    "c": 6254184,
    "t": 10
  }, {
    "p": [-46, 65, -75],
    "s": [12, 77, 6],
    "c": 10658466,
    "t": 11
  }, {
    "p": [-25, 64, -102],
    "s": [2, 22, 2],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [-25, 64, -90],
    "s": [2, 22, 2],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [-25, 84, -96],
    "s": [2, 2, 10],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [-92, 53, -87],
    "s": [77, 12, 73],
    "c": 6250335,
    "t": 11
  }, {
    "p": [175, 66, -254],
    "s": [6, 41, 46],
    "c": 10983566,
    "t": 11,
    "bo": 1
  }, {
    "p": [175, 103, -334],
    "s": [6, 21, 27],
    "c": 10983566,
    "t": 11,
    "bo": 1
  }, {
    "p": [242, 66, -347],
    "s": [128, 62, 7],
    "c": 10983566,
    "t": 11,
    "bo": 1
  }, {
    "p": [267, 66, -236],
    "s": [78, 49, 9],
    "c": 10983566,
    "t": 11,
    "bo": 1
  }, {
    "p": [175, 66, -328],
    "s": [6, 37, 46],
    "c": 10983566,
    "t": 11,
    "bo": 1
  }, {
    "p": [183, 66, -212],
    "s": [38, 102, 38],
    "c": 10983566,
    "t": 11
  }, {
    "p": [239, 65, -259],
    "s": [125, 2, 38],
    "c": 5723991,
    "t": 11
  }, {
    "p": [240, 65, -292],
    "s": [123, 2, 28],
    "c": 6694952,
    "t": 5
  }, {
    "p": [-102, 66, 118],
    "s": [126, 38, 94],
    "c": 8215901,
    "t": 10,
    "bo": 1
  }, {
    "p": [-164, 66, 72],
    "s": [4, 38, 4],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [-40, 66, 72],
    "s": [4, 38, 4],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [-102, 66, 72],
    "s": [4, 62, 5],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [-102, 100, 72],
    "s": [120, 4, 4],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [-102, 126, 117],
    "s": [6, 6, 102],
    "c": 11513775,
    "t": 2
  }, {
    "p": [-67, 115, 117],
    "s": [71, 3, 99],
    "l": 1,
    "r": [0, 0, -0.35],
    "c": 5263440,
    "t": 2
  }, {
    "p": [-137, 115, 117],
    "s": [69, 3, 99],
    "l": 1,
    "r": [0, 0, 0.35],
    "c": 5263440,
    "t": 2
  }, {
    "p": [-137, 118, 117],
    "s": [71, 2, 99],
    "l": 1,
    "r": [0, 0, 0.35],
    "t": 5
  }, {
    "p": [-102, 132, 117],
    "s": [6, 2, 102],
    "t": 5
  }, {
    "p": [-66, 118, 117],
    "s": [71, 2, 99],
    "l": 1,
    "r": [0, 0, -0.35],
    "t": 5
  }, {
    "p": [-102, 104, 118],
    "s": [130, 6, 94],
    "c": 8215901,
    "t": 10,
    "bo": 1
  }, {
    "p": [-102, 110, 118],
    "s": [97, 5, 94],
    "c": 8215901,
    "t": 10
  }, {
    "p": [-102, 115, 118],
    "s": [70, 5, 94],
    "c": 8215901,
    "t": 10
  }, {
    "p": [-102, 120, 118],
    "s": [43, 5, 94],
    "c": 8215901,
    "t": 10
  }, {
    "p": [-102, 125, 118],
    "s": [17, 3, 94],
    "c": 8215901,
    "t": 10
  }, {
    "p": [-127, 66, 72],
    "s": [2, 21, 4],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [-139, 66, 72],
    "s": [2, 21, 4],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [-133, 85, 72],
    "s": [10, 2, 4],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [-194, 51, 77],
    "s": [56, 49, 65],
    "c": 8878432,
    "t": 10,
    "bo": 1
  }, {
    "p": [-179, 105, 59],
    "s": [39, 2, 105],
    "l": 1,
    "r": [0, 0, -0.52],
    "c": 4737096,
    "t": 2
  }, {
    "p": [-178, 107, 59],
    "s": [39, 2, 105],
    "l": 1,
    "r": [0, 0, -0.52],
    "t": 5
  }, {
    "p": [-167, 93, 60],
    "s": [4, 4, 22],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [76, 51, -141],
    "s": [84, 62, 142],
    "c": 8878432,
    "t": 10,
    "bo": 1
  }, {
    "p": [158, 62, -129],
    "s": [82, 50, 128],
    "c": 8217957,
    "t": 10,
    "bo": 1
  }, {
    "p": [-48, 92, 88],
    "s": [7, 34, 12],
    "c": 6710886,
    "t": 11
  }, {
    "p": [35, 66, -211],
    "s": [4, 48, 4],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [117, 66, -211],
    "s": [4, 48, 4],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [35, 66, -71],
    "s": [4, 48, 4],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [35, 66, -165],
    "s": [5, 69, 4],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [35, 66, -117],
    "s": [5, 69, 4],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [76, 66, -211],
    "s": [4, 48, 5],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [-197, 77, -62],
    "s": [58, 4, 74],
    "c": 11513775,
    "t": 2
  }, {
    "p": [76, 87, -211],
    "s": [78, 4, 4],
    "c": 7895160,
    "t": 2
  }, {
    "p": [76, 110, -211],
    "s": [78, 4, 4],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [35, 110, -141],
    "s": [4, 4, 136],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [35, 87, -141],
    "s": [4, 4, 136],
    "c": 7895160,
    "t": 2
  }, {
    "p": [76, 87, -71],
    "s": [78, 4, 4],
    "c": 7895160,
    "t": 2
  }, {
    "p": [76, 110, -71],
    "s": [78, 4, 4],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [76, 138, -141],
    "s": [102, 6, 6],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [76, 126, -179],
    "s": [92, 3, 81],
    "l": 1,
    "r": [-0.35, 0, 0],
    "c": 4605253,
    "t": 2
  }, {
    "p": [76, 126, -103],
    "s": [92, 3, 81],
    "l": 1,
    "r": [0.35, 0, 0],
    "c": 4605253,
    "t": 2
  }, {
    "p": [76, 129, -102],
    "s": [92, 2, 81],
    "l": 1,
    "r": [0.35, 0, 0],
    "t": 5
  }, {
    "p": [76, 144, -141],
    "s": [102, 2, 6],
    "l": 1,
    "t": 5
  }, {
    "p": [76, 114, -141],
    "s": [84, 20, 47],
    "c": 8878432,
    "t": 10
  }, {
    "p": [76, 134, -141],
    "s": [84, 5, 33],
    "c": 8878432,
    "t": 10
  }, {
    "p": [76, 129, -180],
    "s": [92, 2, 81],
    "l": 1,
    "r": [-0.35, 0, 0],
    "t": 5
  }, {
    "p": [-221, 134, -212],
    "s": [72, 3, 100],
    "l": 1,
    "r": [0, 0, 0.35],
    "t": 5
  }, {
    "p": [117, 110, -141],
    "s": [4, 4, 136],
    "l": 1,
    "c": 7895160,
    "t": 2
  }, {
    "p": [198, 66, -192],
    "s": [4, 47, 4],
    "c": 11513775,
    "t": 2
  }, {
    "p": [198, 66, -66],
    "s": [4, 47, 4],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [159, 84, -66],
    "s": [4, 51, 5],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [198, 66, -129],
    "s": [5, 47, 4],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [158, 66, -158],
    "s": [85, 17, 74],
    "c": 7235166,
    "t": 11
  }, {
    "p": [117, 87, -188],
    "s": [4, 4, 42],
    "c": 7895160,
    "t": 2
  }, {
    "p": [159, 134, -129],
    "s": [5, 5, 140],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [181, 124, -129],
    "s": [50, 2, 135],
    "l": 1,
    "r": [0, 0, -0.52],
    "c": 6908265,
    "t": 2
  }, {
    "p": [159, 109, -66],
    "s": [74, 4, 4],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [159, 83, -192],
    "s": [4, 51, 5],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [159, 109, -192],
    "s": [74, 4, 4],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [120, 66, -192],
    "s": [4, 47, 4],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [136, 126, -129],
    "s": [51, 2, 135],
    "l": 1,
    "r": [0, 0, 0.52],
    "t": 5
  }, {
    "p": [136, 124, -129],
    "s": [48, 2, 135],
    "l": 1,
    "r": [0, 0, 0.52],
    "c": 6908265,
    "t": 2
  }, {
    "p": [182, 126, -129],
    "s": [51, 2, 135],
    "l": 1,
    "r": [0, 0, -0.52],
    "t": 5
  }, {
    "p": [159, 139, -129],
    "s": [5, 2, 140],
    "t": 5
  }, {
    "p": [198, 109, -129],
    "s": [4, 4, 122],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [158, 112, -129],
    "s": [82, 5, 128],
    "l": 1,
    "c": 8217957,
    "t": 10
  }, {
    "p": [158, 117, -129],
    "s": [69, 4, 128],
    "l": 1,
    "c": 8217957,
    "t": 10
  }, {
    "p": [158, 121, -129],
    "s": [55, 4, 128],
    "l": 1,
    "c": 8217957,
    "t": 10
  }, {
    "p": [158, 125, -129],
    "s": [40, 4, 128],
    "l": 1,
    "c": 8217957,
    "t": 10
  }, {
    "p": [158, 129, -129],
    "s": [26, 4, 128],
    "l": 1,
    "c": 8217957,
    "t": 10
  }, {
    "p": [158, 133, -129],
    "s": [13, 4, 128],
    "l": 1,
    "c": 8217957,
    "t": 10
  }, {
    "p": [34, 63, -135],
    "s": [2, 22, 2],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [34, 63, -147],
    "s": [2, 22, 2],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [34, 83, -141],
    "s": [2, 2, 10],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [102, 64, -212],
    "s": [2, 22, 2],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [96, 84, -212],
    "s": [10, 2, 2],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [90, 64, -212],
    "s": [2, 22, 2],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [183, 118, -212],
    "s": [33, 102, 33],
    "c": 13812408,
    "t": 11
  }, {
    "p": [183, 219, -212],
    "s": [38, 7, 38],
    "c": 10983566,
    "t": 11
  }, {
    "p": [183, 256, -212],
    "s": [3, 3, 37],
    "c": 10983566,
    "t": 11
  }, {
    "p": [183, 227, -231],
    "s": [38, 39, 3],
    "l": 1,
    "r": [0.52, 0, 0],
    "c": 6908265,
    "t": 2
  }, {
    "p": [183, 227, -192],
    "s": [38, 39, 3],
    "l": 1,
    "r": [-0.52, 0, 0],
    "c": 6908265,
    "t": 2
  }, {
    "p": [203, 227, -212],
    "s": [3, 39, 38],
    "l": 1,
    "r": [0, 0, 0.52],
    "c": 6908265,
    "t": 2
  }, {
    "p": [163, 227, -212],
    "s": [3, 39, 38],
    "l": 1,
    "r": [0, 0, -0.52],
    "c": 6908265,
    "t": 2
  }, {
    "p": [183, 227, -212],
    "s": [37, 11, 29],
    "c": 10983566,
    "t": 11
  }, {
    "p": [183, 238, -212],
    "s": [37, 6, 23],
    "c": 10983566,
    "t": 11
  }, {
    "p": [183, 244, -212],
    "s": [37, 6, 16],
    "c": 10983566,
    "t": 11
  }, {
    "p": [183, 250, -212],
    "s": [37, 6, 9],
    "c": 10983566,
    "t": 11
  }, {
    "p": [183, 256, -212],
    "s": [37, 5, 3],
    "c": 10983566,
    "t": 11
  }, {
    "p": [183, 227, -212],
    "s": [31, 11, 37],
    "c": 10983566,
    "t": 11
  }, {
    "p": [183, 238, -212],
    "s": [24, 6, 37],
    "c": 10983566,
    "t": 11
  }, {
    "p": [183, 244, -212],
    "s": [17, 6, 37],
    "c": 10983566,
    "t": 11
  }, {
    "p": [183, 250, -212],
    "s": [10, 6, 37],
    "c": 10983566,
    "t": 11
  }, {
    "p": [183, 118, -212],
    "s": [36, 102, 10],
    "c": 9341833,
    "t": 2
  }, {
    "p": [183, 118, -212],
    "s": [11, 102, 36],
    "c": 9341833,
    "t": 2
  }, {
    "p": [183, 259, -212],
    "s": [3, 3, 41],
    "c": 5066061,
    "t": 2
  }, {
    "p": [183, 259, -212],
    "s": [40, 3, 3],
    "c": 5066061,
    "t": 2
  }, {
    "p": [161, 228, -212],
    "s": [2, 39, 38],
    "l": 1,
    "r": [0, 0, -0.52],
    "t": 5
  }, {
    "p": [205, 228, -212],
    "s": [2, 39, 38],
    "l": 1,
    "r": [0, 0, 0.52],
    "t": 5
  }, {
    "p": [183, 228, -233],
    "s": [38, 39, 2],
    "l": 1,
    "r": [0.52, 0, 0],
    "t": 5
  }, {
    "p": [183, 228, -190],
    "s": [38, 39, 2],
    "l": 1,
    "r": [-0.52, 0, 0],
    "t": 5
  }, {
    "p": [183, 262, -212],
    "s": [3, 2, 41],
    "t": 5
  }, {
    "p": [183, 262, -212],
    "s": [40, 2, 3],
    "t": 5
  }, {
    "p": [183, 162, -212],
    "s": [42, 7, 42],
    "c": 8220776,
    "bo": 1
  }, {
    "p": [183, 169, -212],
    "s": [42, 2, 42],
    "t": 5
  }, {
    "p": [183, 65, -212],
    "s": [40, 69, 40],
    "c": 8220776,
    "t": 11,
    "bo": 1
  }, {
    "p": [175, 65, -347],
    "s": [9, 68, 10],
    "c": 6050122,
    "t": 11,
    "bo": 1
  }, {
    "p": [175, 65, -237],
    "s": [9, 67, 10],
    "c": 6379345,
    "t": 11,
    "bo": 1
  }, {
    "p": [175, 120, -329],
    "s": [9, 5, 26],
    "c": 8220776,
    "t": 11,
    "bo": 1
  }, {
    "p": [199, 115, -236],
    "s": [39, 9, 12],
    "c": 6575952,
    "t": 11,
    "bo": 1
  }, {
    "p": [239, 120, -347],
    "s": [119, 9, 10],
    "c": 7563104,
    "t": 11,
    "bo": 1
  }, {
    "p": [303, 66, -304],
    "s": [6, 44, 80],
    "c": 10983566,
    "t": 11,
    "bo": 1
  }, {
    "p": [303, 66, -245],
    "s": [6, 40, 6],
    "c": 10983566,
    "t": 11,
    "bo": 1
  }, {
    "p": [287, 65, -292],
    "s": [29, 10, 49],
    "c": 9013641,
    "t": 2
  }, {
    "p": [271, 65, -292],
    "s": [3, 8, 24],
    "c": 9013641,
    "t": 2
  }, {
    "p": [265, 65, -292],
    "s": [3, 4, 24],
    "c": 9013641,
    "t": 2
  }, {
    "p": [268, 65, -292],
    "s": [3, 6, 24],
    "c": 9013641,
    "t": 2
  }, {
    "p": [273, 65, -316],
    "s": [3, 11, 3],
    "l": 1,
    "c": 7039851,
    "t": 2
  }, {
    "p": [273, 65, -268],
    "s": [3, 11, 3],
    "l": 1,
    "c": 7039851,
    "t": 2
  }, {
    "p": [234, 70, -260],
    "s": [7, 1, 25],
    "c": 3616550,
    "t": 5
  }, {
    "p": [234, 67, -273],
    "s": [7, 6, 1],
    "c": 3616550,
    "t": 5
  }, {
    "p": [234, 67, -247],
    "s": [7, 6, 1],
    "c": 3616550,
    "t": 5
  }, {
    "p": [239, 70, -324],
    "s": [7, 1, 25],
    "c": 3616550,
    "t": 5
  }, {
    "p": [207, 71, -324],
    "s": [1, 5, 25],
    "pe": 1,
    "c": 3616550,
    "t": 5
  }, {
    "p": [231, 71, -260],
    "s": [1, 5, 25],
    "pe": 1,
    "c": 3616550,
    "t": 5
  }, {
    "p": [239, 67, -311],
    "s": [7, 6, 1],
    "c": 3616550,
    "t": 5
  }, {
    "p": [239, 67, -337],
    "s": [7, 6, 1],
    "c": 3616550,
    "t": 5
  }, {
    "p": [210, 70, -324],
    "s": [7, 1, 25],
    "c": 3616550,
    "t": 5
  }, {
    "p": [210, 67, -311],
    "s": [7, 6, 1],
    "c": 3616550,
    "t": 5
  }, {
    "p": [210, 67, -337],
    "s": [7, 6, 1],
    "c": 3616550,
    "t": 5
  }, {
    "p": [236, 71, -324],
    "s": [1, 5, 25],
    "pe": 1,
    "c": 3616550,
    "t": 5
  }, {
    "p": [195, 66, -236],
    "s": [34, 52, 9],
    "c": 10983566,
    "t": 11,
    "bo": 1
  }, {
    "p": [303, 65, -347],
    "s": [9, 69, 10],
    "c": 5919310,
    "t": 11
  }, {
    "p": [303, 65, -236],
    "s": [9, 63, 12],
    "c": 6246729,
    "t": 11,
    "bo": 1
  }, {
    "p": [304, 66, -256],
    "s": [5, 1, 19],
    "c": 8220776,
    "t": 11
  }, {
    "p": [220, 66, -235],
    "s": [19, 1, 10],
    "c": 8220776,
    "t": 11
  }, {
    "p": [175, 65, -305],
    "s": [7, 34, 5],
    "c": 7694689,
    "t": 11,
    "bo": 1
  }, {
    "p": [175, 65, -279],
    "s": [7, 34, 5],
    "c": 7234139,
    "t": 11,
    "bo": 1
  }, {
    "p": [175, 99, -302],
    "s": [7, 5, 11],
    "c": 7233881,
    "t": 11,
    "bo": 1
  }, {
    "p": [175, 66, -292],
    "s": [7, 1, 21],
    "c": 8220776,
    "t": 11
  }, {
    "p": [336, 51, -302],
    "s": [58, 71, 58],
    "c": 6973550,
    "t": 10,
    "bo": 1
  }, {
    "p": [364, 66, -274],
    "s": [4, 56, 4],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [336, 66, -274],
    "s": [4, 65, 5],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [308, 66, -274],
    "s": [4, 56, 4],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [336, 92, -274],
    "s": [52, 4, 4],
    "c": 11513775,
    "t": 2
  }, {
    "p": [344, 64, -273],
    "s": [2, 22, 2],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [336, 130, -302],
    "s": [6, 6, 68],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [320, 127, -302],
    "s": [32, 2, 65],
    "l": 1,
    "r": [0, 0, 0.35],
    "c": 5855577,
    "t": 2
  }, {
    "p": [336, 118, -274],
    "s": [52, 4, 4],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [356, 64, -273],
    "s": [2, 22, 2],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [350, 84, -273],
    "s": [10, 2, 2],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [336, 122, -302],
    "s": [58, 3, 58],
    "c": 6973550,
    "t": 10
  }, {
    "p": [336, 125, -302],
    "s": [45, 3, 58],
    "c": 6973550,
    "t": 10
  }, {
    "p": [336, 128, -302],
    "s": [28, 3, 58],
    "c": 6973550,
    "t": 10
  }, {
    "p": [336, 131, -302],
    "s": [15, 3, 58],
    "c": 6973550,
    "t": 10
  }, {
    "p": [319, 129, -302],
    "s": [32, 2, 65],
    "l": 1,
    "r": [0, 0, 0.35],
    "t": 5
  }, {
    "p": [354, 129, -302],
    "s": [32, 2, 65],
    "l": 1,
    "r": [0, 0, -0.35],
    "t": 5
  }, {
    "p": [353, 127, -302],
    "s": [32, 2, 65],
    "l": 1,
    "r": [0, 0, -0.35],
    "c": 5855577,
    "t": 2
  }, {
    "p": [336, 136, -302],
    "s": [6, 2, 68],
    "t": 5
  }, {
    "p": [185, 84, -65],
    "s": [2, 20, 2],
    "l": 1,
    "c": 11513775,
    "t": 2
  }, {
    "p": [173, 84, -65],
    "s": [2, 20, 2],
    "l": 1,
    "c": 11513775,
    "t": 2
  }, {
    "p": [179, 102, -65],
    "s": [10, 2, 2],
    "l": 1,
    "c": 11513775,
    "t": 2
  }, {
    "p": [277, 51, -190],
    "s": [88, 63, 86],
    "c": 6254184,
    "t": 10,
    "bo": 1
  }, {
    "p": [320, 51, -232],
    "s": [4, 63, 4],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [281, 51, -110],
    "s": [106, 72, 80],
    "c": 8878432,
    "t": 10,
    "bo": 1
  }, {
    "p": [333, 66, -149],
    "s": [4, 58, 4],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [320, 51, -152],
    "s": [4, 63, 4],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [320, 51, -192],
    "s": [5, 77, 4],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [234, 51, -192],
    "s": [5, 77, 4],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [234, 51, -152],
    "s": [4, 63, 4],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [234, 51, -232],
    "s": [4, 63, 4],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [229, 66, -149],
    "s": [4, 58, 4],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [280, 66, 38],
    "s": [4, 65, 4],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [229, 66, -71],
    "s": [4, 58, 4],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [333, 66, -110],
    "s": [5, 72, 4],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [320, 88, -192],
    "s": [4, 4, 76],
    "c": 7895160,
    "t": 2
  }, {
    "p": [320, 110, -192],
    "s": [4, 4, 76],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [234, 88, -192],
    "s": [4, 4, 76],
    "c": 7895160,
    "t": 2
  }, {
    "p": [234, 110, -192],
    "s": [4, 4, 76],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [301, 110, -232],
    "s": [34, 4, 4],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [301, 88, -232],
    "s": [34, 4, 4],
    "l": 1,
    "c": 7895160,
    "t": 2
  }, {
    "p": [277, 127, -192],
    "s": [102, 5, 5],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [277, 119, -166],
    "s": [97, 2, 59],
    "l": 1,
    "r": [0.35, 0, 0],
    "c": 5395026,
    "t": 2
  }, {
    "p": [277, 121, -214],
    "s": [97, 2, 47],
    "l": 1,
    "r": [-0.35, 0, 0],
    "c": 5395026,
    "t": 2
  }, {
    "p": [277, 114, -190],
    "s": [88, 3, 86],
    "c": 6254184,
    "t": 10
  }, {
    "p": [277, 117, -190],
    "s": [88, 3, 68],
    "c": 6254184,
    "t": 10
  }, {
    "p": [277, 120, -190],
    "s": [88, 3, 50],
    "c": 6254184,
    "t": 10
  }, {
    "p": [277, 123, -190],
    "s": [88, 3, 30],
    "c": 6254184,
    "t": 10
  }, {
    "p": [277, 126, -190],
    "s": [88, 2, 16],
    "c": 6254184,
    "t": 10
  }, {
    "p": [277, 121, -165],
    "s": [97, 2, 59],
    "l": 1,
    "r": [0.35, 0, 0],
    "t": 5
  }, {
    "p": [277, 123, -215],
    "s": [97, 2, 47],
    "l": 1,
    "r": [-0.35, 0, 0],
    "t": 5
  }, {
    "p": [277, 132, -192],
    "s": [102, 2, 5],
    "t": 5
  }, {
    "p": [333, 93, -110],
    "s": [4, 4, 74],
    "c": 11513775,
    "t": 2
  }, {
    "p": [333, 120, -110],
    "s": [4, 4, 74],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [11, 137, -444],
    "s": [100, 5, 5],
    "c": 7895160,
    "t": 2
  }, {
    "p": [11, 142, -444],
    "s": [100, 2, 5],
    "t": 5
  }, {
    "p": [10, 128, -416],
    "s": [97, 2, 61],
    "l": 1,
    "r": [0.35, 0, 0],
    "c": 5395026,
    "t": 2
  }, {
    "p": [10, 130, -416],
    "s": [97, 2, 62],
    "l": 1,
    "r": [0.35, 0, 0],
    "t": 5
  }, {
    "p": [43, 69, -400],
    "s": [13, 70, 7],
    "c": 6381921,
    "t": 11
  }, {
    "p": [229, 66, -110],
    "s": [5, 72, 4],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [229, 93, -110],
    "s": [4, 4, 74],
    "c": 11513775,
    "t": 2
  }, {
    "p": [229, 120, -110],
    "s": [4, 4, 74],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [281, 120, -149],
    "s": [100, 4, 4],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [281, 120, -71],
    "s": [100, 4, 4],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [281, 93, -149],
    "s": [100, 4, 4],
    "l": 1,
    "c": 11513775,
    "t": 2
  }, {
    "p": [281, 137, -110],
    "s": [120, 5, 5],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [281, 131, -132],
    "s": [113, 2, 50],
    "l": 1,
    "r": [-0.35, 0, 0],
    "c": 6579300,
    "t": 2
  }, {
    "p": [281, 133, -133],
    "s": [113, 2, 50],
    "l": 1,
    "r": [-0.35, 0, 0],
    "t": 5
  }, {
    "p": [281, 131, -89],
    "s": [113, 2, 50],
    "l": 1,
    "r": [0.35, 0, 0],
    "c": 6579300,
    "t": 2
  }, {
    "p": [281, 133, -88],
    "s": [113, 2, 50],
    "l": 1,
    "r": [0.35, 0, 0],
    "t": 5
  }, {
    "p": [281, 142, -110],
    "s": [120, 2, 5],
    "t": 5
  }, {
    "p": [281, 124, -110],
    "s": [106, 4, 80],
    "c": 8878432,
    "t": 10
  }, {
    "p": [281, 128, -110],
    "s": [106, 3, 60],
    "c": 8878432,
    "t": 10
  }, {
    "p": [281, 131, -110],
    "s": [106, 4, 43],
    "c": 8878432,
    "t": 10
  }, {
    "p": [281, 135, -110],
    "s": [106, 3, 21],
    "c": 8878432,
    "t": 10
  }, {
    "p": [263, 51, -43],
    "s": [60, 62, 72],
    "c": 6973550,
    "t": 10,
    "bo": 1
  }, {
    "p": [263, 125, -40],
    "s": [71, 2, 70],
    "l": 1,
    "r": [0, 0, 0.35],
    "c": 6908265,
    "t": 2
  }, {
    "p": [262, 127, -40],
    "s": [71, 2, 70],
    "l": 1,
    "r": [0, 0, 0.35],
    "t": 5
  }, {
    "p": [281, 93, -71],
    "s": [100, 4, 4],
    "c": 11513775,
    "t": 2
  }, {
    "p": [292, 66, -68],
    "s": [4, 71, 4],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [292, 66, -8],
    "s": [4, 71, 4],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [234, 66, -8],
    "s": [4, 47, 4],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [234, 66, -68],
    "s": [4, 47, 4],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [263, 109, -8],
    "s": [54, 4, 4],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [234, 109, -38],
    "s": [4, 4, 56],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [292, 109, -38],
    "s": [4, 4, 56],
    "l": 1,
    "c": 11513775,
    "t": 2
  }, {
    "p": [262, 113, -43],
    "s": [59, 4, 72],
    "c": 6973550,
    "t": 10
  }, {
    "p": [267, 117, -43],
    "s": [50, 4, 72],
    "c": 6973550,
    "t": 10
  }, {
    "p": [272, 121, -43],
    "s": [38, 4, 72],
    "c": 6973550,
    "t": 10
  }, {
    "p": [277, 125, -38],
    "s": [28, 4, 62],
    "c": 6973550,
    "t": 10
  }, {
    "p": [283, 129, -38],
    "s": [17, 4, 62],
    "c": 6973550,
    "t": 10
  }, {
    "p": [288, 133, -38],
    "s": [6, 3, 62],
    "c": 6973550,
    "t": 10
  }, {
    "p": [292, 113, -37],
    "s": [2, 23, 61],
    "c": 6973550,
    "t": 10,
    "bo": 1
  }, {
    "p": [233, 84, -32],
    "s": [2, 20, 2],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [233, 84, -44],
    "s": [2, 20, 2],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [233, 102, -38],
    "s": [2, 2, 10],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [321, 66, -166],
    "s": [2, 20, 2],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [321, 66, -178],
    "s": [2, 20, 2],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [321, 84, -172],
    "s": [2, 2, 10],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [411, 66, -212],
    "s": [90, 38, 138],
    "c": 8215901,
    "t": 10,
    "bo": 1
  }, {
    "p": [413, 66, -6],
    "s": [90, 50, 88],
    "c": 8215901,
    "t": 10,
    "bo": 1
  }, {
    "p": [208, 66, 90],
    "s": [140, 80, 88],
    "c": 8215901,
    "t": 10,
    "bo": 1
  }, {
    "p": [20, 66, 96],
    "s": [116, 53, 80],
    "c": 9342330,
    "t": 10,
    "bo": 1
  }, {
    "p": [425, 51, -96],
    "s": [90, 71, 92],
    "c": 6973550,
    "t": 10,
    "bo": 1
  }, {
    "p": [334, 51, 80],
    "s": [110, 79, 86],
    "c": 6254184,
    "t": 10,
    "bo": 1
  }, {
    "p": [-37, 51, 57],
    "s": [4, 69, 4],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [20, 51, 57],
    "s": [4, 89, 5],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [20, 91, 57],
    "s": [110, 4, 4],
    "c": 7895160,
    "t": 2
  }, {
    "p": [20, 139, 96],
    "s": [5, 5, 92],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [-11, 130, 96],
    "s": [65, 2, 88],
    "l": 1,
    "r": [0, 0, 0.35],
    "c": 4737096,
    "t": 2
  }, {
    "p": [51, 130, 96],
    "s": [65, 2, 88],
    "l": 1,
    "r": [0, 0, -0.35],
    "c": 4737096,
    "t": 2
  }, {
    "p": [20, 144, 96],
    "s": [5, 2, 92],
    "t": 5
  }, {
    "p": [-12, 132, 96],
    "s": [65, 2, 88],
    "l": 1,
    "r": [0, 0, 0.35],
    "t": 5
  }, {
    "p": [52, 132, 96],
    "s": [65, 2, 88],
    "l": 1,
    "r": [0, 0, -0.35],
    "t": 5
  }, {
    "p": [20, 116, 57],
    "s": [110, 4, 4],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [-37, 91, 96],
    "s": [4, 4, 74],
    "c": 7895160,
    "t": 2
  }, {
    "p": [-37, 116, 96],
    "s": [4, 4, 74],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [20, 119, 96],
    "s": [113, 6, 80],
    "c": 9342330,
    "t": 10,
    "bo": 1
  }, {
    "p": [20, 125, 96],
    "s": [91, 4, 80],
    "c": 9342330,
    "t": 10
  }, {
    "p": [20, 129, 96],
    "s": [69, 4, 80],
    "c": 9342330,
    "t": 10
  }, {
    "p": [20, 133, 96],
    "s": [46, 4, 80],
    "c": 9342330,
    "t": 10
  }, {
    "p": [20, 137, 96],
    "s": [25, 4, 80],
    "c": 9342330,
    "t": 10
  }, {
    "p": [-15, 66, 57],
    "s": [2, 21, 4],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [-3, 66, 57],
    "s": [2, 21, 4],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [-9, 85, 57],
    "s": [10, 2, 4],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [367, 66, -144],
    "s": [4, 38, 4],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [367, 66, -212],
    "s": [5, 62, 4],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [367, 100, -212],
    "s": [4, 4, 132],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [377, 100, -144],
    "s": [16, 4, 4],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [412, 127, -212],
    "s": [106, 5, 5],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [412, 116, -248],
    "s": [98, 2, 75],
    "l": 1,
    "r": [-0.35, 0, 0],
    "c": 4605510,
    "t": 2
  }, {
    "p": [412, 118, -249],
    "s": [98, 2, 75],
    "l": 1,
    "r": [-0.35, 0, 0],
    "t": 5
  }, {
    "p": [412, 118, -174],
    "s": [98, 2, 77],
    "l": 1,
    "r": [0.35, 0, 0],
    "t": 5
  }, {
    "p": [412, 116, -175],
    "s": [98, 2, 77],
    "l": 1,
    "r": [0.35, 0, 0],
    "c": 4605510,
    "t": 2
  }, {
    "p": [412, 132, -212],
    "s": [106, 2, 5],
    "t": 5
  }, {
    "p": [411, 104, -212],
    "s": [90, 4, 138],
    "c": 8215901,
    "t": 10
  }, {
    "p": [411, 108, -212],
    "s": [90, 4, 117],
    "c": 8215901,
    "t": 10
  }, {
    "p": [411, 112, -212],
    "s": [90, 4, 94],
    "c": 8215901,
    "t": 10
  }, {
    "p": [411, 116, -212],
    "s": [90, 4, 73],
    "c": 8215901,
    "t": 10
  }, {
    "p": [411, 124, -212],
    "s": [90, 4, 29],
    "c": 8215901,
    "t": 10
  }, {
    "p": [411, 120, -212],
    "s": [90, 4, 51],
    "c": 8215901,
    "t": 10
  }, {
    "p": [411, 128, -212],
    "s": [90, 1, 11],
    "c": 8215901,
    "t": 10
  }, {
    "p": [366, 66, -237],
    "s": [2, 20, 2],
    "l": 1,
    "c": 11513775,
    "t": 2
  }, {
    "p": [366, 66, -249],
    "s": [2, 20, 2],
    "l": 1,
    "c": 11513775,
    "t": 2
  }, {
    "p": [366, 84, -243],
    "s": [2, 2, 10],
    "l": 1,
    "c": 11513775,
    "t": 2
  }, {
    "p": [381, 66, -141],
    "s": [4, 57, 4],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [381, 66, -51],
    "s": [4, 57, 4],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [381, 66, -96],
    "s": [5, 73, 4],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [381, 119, -96],
    "s": [4, 4, 86],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [427, 119, -96],
    "s": [88, 4, 94],
    "l": 1,
    "c": 11513775,
    "t": 2
  }, {
    "p": [427, 138, -96],
    "s": [108, 6, 6],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [427, 131, -121],
    "s": [102, 2, 52],
    "l": 1,
    "r": [-0.35, 0, 0],
    "c": 6052956,
    "t": 2
  }, {
    "p": [427, 131, -70],
    "s": [102, 2, 52],
    "l": 1,
    "r": [0.35, 0, 0],
    "c": 6052956,
    "t": 2
  }, {
    "p": [427, 133, -69],
    "s": [102, 2, 52],
    "l": 1,
    "r": [0.35, 0, 0],
    "t": 5
  }, {
    "p": [427, 133, -122],
    "s": [102, 2, 52],
    "l": 1,
    "r": [-0.35, 0, 0],
    "t": 5
  }, {
    "p": [427, 144, -96],
    "s": [108, 2, 6],
    "t": 5
  }, {
    "p": [425, 123, -96],
    "s": [90, 5, 91],
    "c": 6973550,
    "t": 10
  }, {
    "p": [425, 128, -96],
    "s": [90, 4, 69],
    "c": 6973550,
    "t": 10
  }, {
    "p": [425, 132, -96],
    "s": [90, 4, 47],
    "c": 6973550,
    "t": 10
  }, {
    "p": [425, 136, -96],
    "s": [90, 4, 25],
    "c": 6973550,
    "t": 10
  }, {
    "p": [369, 66, -49],
    "s": [4, 51, 4],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [369, 66, 35],
    "s": [4, 51, 4],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [369, 66, -7],
    "s": [5, 65, 4],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [369, 113, -7],
    "s": [4, 4, 80],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [376, 113, -49],
    "s": [10, 4, 4],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [333, 66, -71],
    "s": [4, 58, 4],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [388, 66, 38],
    "s": [4, 65, 4],
    "c": 11513775,
    "t": 2
  }, {
    "p": [334, 66, 38],
    "s": [4, 83, 5],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [334, 95, 38],
    "s": [104, 4, 4],
    "c": 11513775,
    "t": 2
  }, {
    "p": [334, 127, 38],
    "s": [104, 4, 4],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [280, 127, 49],
    "s": [4, 4, 18],
    "l": 1,
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [280, 95, 49],
    "s": [4, 4, 18],
    "c": 11513775,
    "t": 2
  }, {
    "p": [277, 66, 47],
    "s": [4, 81, 4],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [139, 66, 47],
    "s": [4, 81, 4],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [107, 66, -12],
    "s": [92, 19, 145],
    "c": 6250335,
    "t": 11
  }, {
    "p": [64, 85, 28],
    "s": [2, 38, 59],
    "pe": 1,
    "c": 6254184,
    "t": 10,
    "bo": 1
  }, {
    "p": [64, 85, -43],
    "s": [2, 38, 53],
    "pe": 1,
    "c": 6254184,
    "t": 10,
    "bo": 1
  }, {
    "p": [150, 85, -27],
    "s": [2, 38, 77],
    "pe": 1,
    "c": 6254184,
    "t": 10,
    "bo": 1
  }, {
    "p": [150, 85, 34],
    "s": [2, 38, 19],
    "pe": 1,
    "c": 6254184,
    "t": 10,
    "bo": 1
  }, {
    "p": [208, 66, 47],
    "s": [4, 104, 5],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [208, 112, 47],
    "s": [134, 4, 4],
    "l": 1,
    "c": 7895160,
    "t": 2
  }, {
    "p": [208, 143, 47],
    "s": [134, 4, 4],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [252, 66, 81],
    "s": [85, 17, 73],
    "c": 6250335
  }, {
    "p": [277, 143, 87],
    "s": [4, 4, 76],
    "l": 1,
    "c": 7895160,
    "t": 2
  }, {
    "p": [413, 130, -7],
    "s": [107, 5, 5],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [413, 124, -29],
    "s": [99, 2, 51],
    "l": 1,
    "r": [-0.35, 0, 0],
    "c": 5066061,
    "t": 2
  }, {
    "p": [413, 124, 16],
    "s": [99, 2, 54],
    "l": 1,
    "r": [0.35, 0, 0],
    "c": 5066061,
    "t": 2
  }, {
    "p": [413, 126, 17],
    "s": [99, 2, 54],
    "l": 1,
    "r": [0.35, 0, 0],
    "t": 5
  }, {
    "p": [413, 126, -30],
    "s": [99, 2, 51],
    "l": 1,
    "r": [-0.35, 0, 0],
    "t": 5
  }, {
    "p": [413, 135, -7],
    "s": [107, 2, 5],
    "t": 5
  }, {
    "p": [413, 117, -6],
    "s": [90, 3, 88],
    "c": 8215901,
    "t": 10
  }, {
    "p": [413, 120, -6],
    "s": [90, 3, 71],
    "c": 8215901,
    "t": 10
  }, {
    "p": [413, 123, -6],
    "s": [90, 3, 58],
    "c": 8215901,
    "t": 10
  }, {
    "p": [413, 126, -6],
    "s": [90, 3, 37],
    "c": 8215901,
    "t": 10
  }, {
    "p": [413, 129, -6],
    "s": [90, 3, 22],
    "c": 8215901,
    "t": 10
  }, {
    "p": [334, 149, 80],
    "s": [5, 5, 106],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [364, 140, 80],
    "s": [61, 2, 97],
    "l": 1,
    "r": [0, 0, -0.35],
    "c": 7039851,
    "t": 2
  }, {
    "p": [303, 140, 80],
    "s": [61, 2, 97],
    "l": 1,
    "r": [0, 0, 0.35],
    "c": 7039851,
    "t": 2
  }, {
    "p": [334, 154, 80],
    "s": [5, 2, 106],
    "t": 5
  }, {
    "p": [304, 143, 80],
    "s": [63, 2, 97],
    "l": 1,
    "r": [0, 0, 0.35],
    "t": 5
  }, {
    "p": [364, 142, 80],
    "s": [63, 2, 97],
    "l": 1,
    "r": [0, 0, -0.35],
    "t": 5
  }, {
    "p": [334, 130, 80],
    "s": [110, 5, 86],
    "c": 6254184,
    "t": 10
  }, {
    "p": [334, 135, 80],
    "s": [89, 4, 86],
    "c": 6254184,
    "t": 10
  }, {
    "p": [334, 139, 80],
    "s": [67, 4, 86],
    "c": 6254184,
    "t": 10
  }, {
    "p": [334, 143, 80],
    "s": [45, 4, 86],
    "c": 6254184,
    "t": 10
  }, {
    "p": [334, 147, 80],
    "s": [23, 4, 86],
    "c": 6254184,
    "t": 10
  }, {
    "p": [208, 169, 90],
    "s": [6, 6, 104],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [246, 158, 90],
    "s": [81, 2, 97],
    "l": 1,
    "r": [0, 0, -0.35],
    "c": 4605510,
    "t": 2
  }, {
    "p": [170, 159, 90],
    "s": [81, 2, 97],
    "l": 1,
    "r": [0, 0, 0.35],
    "c": 4605510,
    "t": 2
  }, {
    "p": [169, 161, 90],
    "s": [81, 2, 97],
    "l": 1,
    "r": [0, 0, 0.35],
    "t": 5
  }, {
    "p": [247, 160, 90],
    "s": [81, 2, 97],
    "l": 1,
    "r": [0, 0, -0.35],
    "t": 5
  }, {
    "p": [208, 175, 90],
    "s": [6, 2, 104],
    "t": 5
  }, {
    "p": [208, 147, 90],
    "s": [140, 3, 88],
    "c": 8215901,
    "t": 10
  }, {
    "p": [208, 150, 90],
    "s": [124, 4, 88],
    "c": 8215901,
    "t": 10
  }, {
    "p": [208, 154, 90],
    "s": [102, 4, 88],
    "c": 8215901,
    "t": 10
  }, {
    "p": [208, 158, 90],
    "s": [81, 4, 88],
    "c": 8215901,
    "t": 10
  }, {
    "p": [208, 162, 90],
    "s": [58, 4, 88],
    "c": 8215901,
    "t": 10
  }, {
    "p": [208, 166, 90],
    "s": [36, 4, 88],
    "c": 8215901,
    "t": 10
  }, {
    "p": [208, 170, 90],
    "s": [15, 3, 88],
    "c": 8215901,
    "t": 10
  }, {
    "p": [-72, 87, -45],
    "s": [4, 4, 48],
    "c": 7500402,
    "t": 2
  }, {
    "p": [-101, 110, 5],
    "s": [62, 4, 44],
    "c": 7500402,
    "t": 2,
    "bo": 1
  }, {
    "p": [368, 84, -22],
    "s": [2, 22, 2],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [368, 84, -34],
    "s": [2, 22, 2],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [368, 104, -28],
    "s": [2, 2, 10],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [179, 84, 47],
    "s": [2, 21, 4],
    "l": 1,
    "c": 11513775,
    "t": 2
  }, {
    "p": [167, 84, 47],
    "s": [2, 21, 4],
    "l": 1,
    "c": 11513775,
    "t": 2
  }, {
    "p": [173, 103, 47],
    "s": [10, 2, 4],
    "l": 1,
    "c": 11513775,
    "t": 2
  }, {
    "p": [107, 146, -9],
    "s": [101, 5, 5],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [107, 134, 26],
    "s": [93, 2, 74],
    "l": 1,
    "r": [0.35, 0, 0],
    "c": 4868682,
    "t": 2
  }, {
    "p": [150, 66, -64],
    "s": [4, 58, 4],
    "c": 7895160,
    "t": 2
  }, {
    "p": [151, 66, -9],
    "s": [3, 81, 4],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [150, 66, 44],
    "s": [4, 58, 4],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [107, 85, 50],
    "s": [84, 38, 19],
    "c": 6254184,
    "t": 10,
    "bo": 1
  }, {
    "p": [107, 85, -44],
    "s": [84, 38, 51],
    "c": 6254184,
    "t": 10,
    "bo": 1
  }, {
    "p": [64, 66, -2],
    "s": [5, 54, 2],
    "pe": 1,
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [64, 66, -16],
    "s": [5, 54, 2],
    "pe": 1,
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [64, 105, -9],
    "s": [5, 2, 12],
    "l": 1,
    "c": 7895160,
    "t": 2
  }, {
    "p": [150, 66, 11],
    "s": [4, 54, 2],
    "pe": 1,
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [150, 66, 25],
    "s": [4, 54, 2],
    "pe": 1,
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [150, 105, 18],
    "s": [4, 2, 12],
    "l": 1,
    "c": 7895160,
    "t": 2
  }, {
    "p": [150, 106, 18],
    "s": [2, 15, 13],
    "pe": 1,
    "c": 6254184,
    "t": 10,
    "bo": 1
  }, {
    "p": [64, 107, -9],
    "s": [2, 16, 15],
    "pe": 1,
    "c": 6254184,
    "t": 10
  }, {
    "p": [63, 123, -9],
    "s": [2, 24, 4],
    "c": 7895160,
    "t": 2
  }, {
    "p": [64, 85, -68],
    "s": [5, 39, 4],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [64, 85, 54],
    "s": [5, 39, 4],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [64, 120, -9],
    "s": [5, 4, 114],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [64, 120, 50],
    "s": [5, 4, 4],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [107, 135, -41],
    "s": [93, 2, 70],
    "l": 1,
    "r": [-0.35, 0, 0],
    "c": 4868682,
    "t": 2
  }, {
    "p": [150, 120, -10],
    "s": [4, 4, 104],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [107, 115, 10],
    "s": [85, 1, 71],
    "c": 6250335,
    "t": 2
  }, {
    "p": [107, 124, -9],
    "s": [88, 4, 122],
    "c": 6254184,
    "t": 10,
    "bo": 1
  }, {
    "p": [107, 136, 27],
    "s": [93, 2, 74],
    "l": 1,
    "r": [0.35, 0, 0],
    "t": 5
  }, {
    "p": [107, 151, -9],
    "s": [101, 2, 5],
    "l": 1,
    "t": 5
  }, {
    "p": [107, 137, -42],
    "s": [93, 2, 70],
    "l": 1,
    "r": [-0.35, 0, 0],
    "t": 5
  }, {
    "p": [107, 128, -9],
    "s": [88, 4, 104],
    "c": 6254184,
    "t": 10
  }, {
    "p": [107, 132, -9],
    "s": [88, 4, 82],
    "c": 6254184,
    "t": 10
  }, {
    "p": [107, 136, -9],
    "s": [88, 4, 60],
    "c": 6254184,
    "t": 10
  }, {
    "p": [107, 140, -9],
    "s": [88, 4, 38],
    "c": 6254184,
    "t": 10
  }, {
    "p": [107, 144, -9],
    "s": [88, 3, 16],
    "c": 6254184,
    "t": 10
  }, {
    "p": [50, 83, -9],
    "s": [22, 2, 88],
    "c": 7895160,
    "t": 2
  }, {
    "p": [41, 66, -51],
    "s": [2, 20, 2],
    "c": 7895160,
    "t": 2
  }, {
    "p": [41, 66, 33],
    "s": [2, 20, 2],
    "c": 7895160,
    "t": 2
  }, {
    "p": [92, 66, 40],
    "s": [2, 39, 2],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [80, 66, 40],
    "s": [2, 39, 2],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [121, 66, -18],
    "s": [2, 39, 2],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [133, 66, -18],
    "s": [2, 39, 2],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [127, 105, -18],
    "s": [14, 2, 2],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [86, 105, 40],
    "s": [14, 2, 2],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [10, 128, -471],
    "s": [97, 2, 59],
    "l": 1,
    "r": [-0.35, 0, 0],
    "c": 5395026,
    "t": 2
  }, {
    "p": [10, 130, -472],
    "s": [97, 2, 59],
    "l": 1,
    "r": [-0.35, 0, 0],
    "t": 5
  }, {
    "p": [10, 51, -444],
    "s": [92, 67, 107],
    "c": 6254184,
    "t": 10
  }, {
    "p": [10, 118, -444],
    "s": [92, 2, 107],
    "c": 6254184,
    "t": 10
  }, {
    "p": [10, 123, -444],
    "s": [92, 5, 75],
    "c": 6254184,
    "t": 10
  }, {
    "p": [10, 128, -444],
    "s": [92, 5, 49],
    "c": 6254184,
    "t": 10
  }, {
    "p": [10, 133, -444],
    "s": [92, 5, 22],
    "c": 6254184,
    "t": 10
  }, {
    "p": [55, 114, -444],
    "s": [4, 4, 107],
    "c": 11513775,
    "t": 2
  }, {
    "p": [71, 51, -393],
    "s": [4, 63, 4],
    "c": 11513775,
    "t": 2
  }, {
    "p": [207, 51, -393],
    "s": [4, 64, 4],
    "c": 11513775,
    "t": 2
  }, {
    "p": [116, 51, -393],
    "s": [4, 77, 5],
    "c": 11513775,
    "t": 2
  }, {
    "p": [71, 51, -445],
    "s": [4, 63, 4],
    "c": 11513775,
    "t": 2
  }, {
    "p": [71, 51, -495],
    "s": [4, 62, 4],
    "c": 11513775,
    "t": 2
  }, {
    "p": [139, 111, -393],
    "s": [132, 4, 4],
    "c": 11513775,
    "t": 2
  }, {
    "p": [71, 110, -444],
    "s": [4, 4, 98],
    "l": 1,
    "c": 11513775,
    "t": 2
  }, {
    "p": [139, 134, -443],
    "s": [7, 7, 121],
    "c": 11513775,
    "t": 2
  }, {
    "p": [101, 121, -443],
    "s": [79, 3, 113],
    "l": 1,
    "r": [0, 0, 0.35],
    "c": 4605510,
    "t": 2
  }, {
    "p": [100, 124, -443],
    "s": [79, 2, 113],
    "l": 1,
    "r": [0, 0, 0.35],
    "t": 5
  }, {
    "p": [139, 141, -443],
    "s": [7, 2, 121],
    "l": 1,
    "t": 5
  }, {
    "p": [178, 124, -443],
    "s": [78, 3, 113],
    "l": 1,
    "r": [0, 0, -0.35],
    "t": 5
  }, {
    "p": [139, 66, -444],
    "s": [136, 49, 104],
    "c": 9342330,
    "t": 10
  }, {
    "p": [139, 115, -444],
    "s": [107, 5, 104],
    "c": 9342330,
    "t": 10
  }, {
    "p": [139, 120, -444],
    "s": [83, 5, 104],
    "c": 9342330,
    "t": 10
  }, {
    "p": [139, 125, -444],
    "s": [55, 5, 104],
    "c": 9342330,
    "t": 10
  }, {
    "p": [139, 130, -444],
    "s": [28, 4, 104],
    "c": 9342330,
    "t": 10
  }, {
    "p": [161, 51, -393],
    "s": [4, 77, 5],
    "c": 11513775,
    "t": 2
  }, {
    "p": [214, 113, -385],
    "s": [48, 2, 70],
    "l": 1,
    "r": [0, 0, 0.52],
    "c": 6908265,
    "t": 2
  }, {
    "p": [213, 115, -385],
    "s": [48, 2, 70],
    "l": 1,
    "r": [0, 0, 0.52],
    "t": 5
  }, {
    "p": [233, 125, -386],
    "s": [5, 5, 71],
    "c": 11513775,
    "t": 2
  }, {
    "p": [233, 130, -386],
    "s": [5, 2, 71],
    "t": 5
  }, {
    "p": [55, 65, 13],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [55, 65, -64],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-65, 65, -64],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-65, 65, -52],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-72, 110, -45],
    "s": [4, 4, 48],
    "c": 7500402,
    "t": 2,
    "bo": 1
  }, {
    "p": [-130, 87, -44],
    "s": [4, 4, 46],
    "c": 7500402,
    "t": 2
  }, {
    "p": [-130, 110, -44],
    "s": [4, 4, 46],
    "c": 7500402,
    "t": 2,
    "bo": 1
  }, {
    "p": [28, 65, -95],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-88, 65, 36],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [28, 65, 50],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [28, 77, 50],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [146, 85, 35],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [60, 85, -36],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [60, 85, -28],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [-17, 65, -178],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-56, 65, -128],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-164, 52, -158],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-152, 52, -158],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-315, 52, -86],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-315, 52, -74],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-315, 52, 18],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-315, 52, 6],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-315, 64, 18],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-231, 52, -93],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-281, 52, -49],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-269, 52, -49],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-128, 52, -266],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-116, 52, -304],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-116, 64, -304],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-162, 65, -28],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-19, 65, -28],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [216, 83, 40],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [157, 83, -56],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [300, 83, -50],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [300, 83, -62],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [361, 83, 31],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [360, 65, -220],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [45, 65, -66],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [-55, 65, -66],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [-68, 65, 22],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [-68, 65, 14],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [-163, 65, 54],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [-165, 65, -38],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [-269, 52, -59],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [-317, 52, -64],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [-317, 52, -56],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [-317, 52, -173],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [-305, 52, 20],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [-184, 52, -204],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [-184, 52, -196],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [75, 71, -311],
    "s": [31, 3, 7],
    "c": 8220776
  }, {
    "p": [94, 66, -292],
    "s": [6, 7, 44],
    "c": 10983566,
    "t": 11
  }, {
    "p": [56, 66, -292],
    "s": [6, 7, 44],
    "c": 10983566,
    "t": 11
  }, {
    "p": [75, 66, -273],
    "s": [32, 7, 6],
    "c": 10983566,
    "t": 11
  }, {
    "p": [75, 66, -311],
    "s": [32, 7, 6],
    "c": 10983566,
    "t": 11
  }, {
    "p": [75, 71, -273],
    "s": [31, 3, 7],
    "c": 8220776
  }, {
    "p": [56, 71, -292],
    "s": [7, 3, 45],
    "c": 8220776,
    "t": 11
  }, {
    "p": [94, 71, -292],
    "s": [7, 3, 45],
    "c": 8220776
  }, {
    "p": [75, 66, -292],
    "s": [32, 1, 33],
    "c": 10983566
  }, {
    "p": [75, 66, -292],
    "s": [9, 23, 9],
    "c": 10983566,
    "t": 11
  }, {
    "p": [75, 77, -292],
    "s": [20, 3, 20],
    "c": 8220776,
    "t": 11
  }, {
    "p": [75, 86, -292],
    "s": [14, 3, 14],
    "c": 8220776,
    "t": 11
  }, {
    "p": [75, 74, -311],
    "s": [31, 1, 7],
    "l": 1,
    "t": 5
  }, {
    "p": [75, 74, -273],
    "s": [31, 1, 7],
    "l": 1,
    "t": 5
  }, {
    "p": [94, 74, -292],
    "s": [7, 1, 45],
    "l": 1,
    "t": 5
  }, {
    "p": [56, 74, -292],
    "s": [7, 1, 45],
    "l": 1,
    "t": 5
  }, {
    "p": [75, 80, -292],
    "s": [20, 1, 20],
    "l": 1,
    "t": 5
  }, {
    "p": [75, 89, -292],
    "s": [14, 1, 14],
    "l": 1,
    "t": 5
  }, {
    "p": [75, 67, -292],
    "s": [32, 2, 33],
    "c": 9165268,
    "o": 0.7000000000000001,
    "t": 5
  }, {
    "p": [63, 62, -565],
    "s": [173, 63, 128],
    "c": 8217957,
    "t": 10
  }, {
    "p": [351, 83, 34],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [296, 83, -25],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [296, 83, -17],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [375, 65, -139],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [325, 65, -202],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [325, 65, -210],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [206, 65, -227],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [206, 65, -220],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [-222, 52, -295],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [-17, 65, -190],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [157, 65, -201],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [157, 65, -213],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-1, 65, -362],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [11, 65, -362],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [23, 65, -362],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-1, 77, -363],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [77, 65, -362],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [89, 65, -362],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [135, 65, -362],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [135, 77, -363],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [104, 65, -301],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [65, 65, -218],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-11, 66, -365],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [145, 65, -365],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [152, 65, -365],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [102, 65, -291],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [147, 65, -198],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [55, 65, -215],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [-67, 65, -9],
    "s": [1, 18, 4],
    "l": 1,
    "r": [0, 0, 0.17],
    "c": 7895160,
    "t": 2
  }, {
    "p": [-31, 65, -28],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-31, 65, -16],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [39, 66, -35],
    "s": [1, 19, 5],
    "pe": 1,
    "v": 1,
    "c": 7895160,
    "t": 2
  }, {
    "p": [39, 66, -35],
    "s": [1, 19, 3],
    "i": 3,
    "t": 2,
    "d": 2
  }, {
    "p": [-161, 87, -309],
    "s": [4, 8, 10],
    "c": 9013641,
    "t": 2,
    "bo": 1
  }, {
    "p": [381, 91, -96],
    "s": [4, 4, 86],
    "c": 11513775,
    "t": 2
  }, {
    "p": [202, 82, -11],
    "s": [110, 2, 165],
    "l": 1,
    "t": 5
  }, {
    "p": [177, 121, -443],
    "s": [79, 3, 113],
    "l": 1,
    "r": [0, 0, -0.35],
    "c": 4605510,
    "t": 2
  }, {
    "p": [383, 65, 26],
    "s": [12, 70, 6],
    "c": 11293523
  }, {
    "p": [63, 121, -502],
    "s": [174, 4, 4],
    "c": 6381921,
    "t": 2
  }, {
    "p": [-22, 96, -502],
    "s": [4, 34, 4],
    "c": 6381921,
    "t": 2
  }, {
    "p": [63, 156, -568],
    "s": [6, 6, 145],
    "c": 6381921,
    "t": 2
  }, {
    "p": [18, 140, -568],
    "s": [97, 3, 138],
    "l": 1,
    "r": [0, 0, 0.35],
    "c": 6381921,
    "t": 2
  }, {
    "p": [108, 140, -568],
    "s": [102, 3, 138],
    "l": 1,
    "r": [0, 0, -0.35],
    "c": 6381921,
    "t": 2
  }, {
    "p": [63, 162, -568],
    "s": [6, 2, 145],
    "t": 5
  }, {
    "p": [109, 143, -568],
    "s": [102, 2, 138],
    "l": 1,
    "r": [0, 0, -0.35],
    "t": 5
  }, {
    "p": [17, 143, -568],
    "s": [97, 2, 138],
    "l": 1,
    "r": [0, 0, 0.35],
    "t": 5
  }, {
    "p": [93, 96, -502],
    "s": [4, 50, 4],
    "c": 6381921,
    "t": 2
  }, {
    "p": [63, 125, -565],
    "s": [173, 4, 128],
    "c": 8217957,
    "t": 10
  }, {
    "p": [63, 133, -565],
    "s": [131, 4, 128],
    "c": 8217957,
    "t": 10
  }, {
    "p": [63, 129, -565],
    "s": [153, 4, 128],
    "c": 8217957,
    "t": 10
  }, {
    "p": [63, 137, -565],
    "s": [109, 4, 128],
    "c": 8217957,
    "t": 10
  }, {
    "p": [63, 141, -565],
    "s": [86, 4, 128],
    "c": 8217957,
    "t": 10
  }, {
    "p": [63, 145, -565],
    "s": [65, 4, 128],
    "c": 8217957,
    "t": 10
  }, {
    "p": [63, 149, -565],
    "s": [43, 4, 128],
    "c": 8217957,
    "t": 10
  }, {
    "p": [63, 153, -565],
    "s": [22, 3, 128],
    "c": 8217957,
    "t": 10
  }, {
    "p": [-108, 107, -447],
    "s": [97, 2, 59],
    "l": 1,
    "r": [0.35, 0, 0],
    "c": 5395026,
    "t": 2
  }, {
    "p": [-108, 108, -446],
    "s": [97, 2, 59],
    "l": 1,
    "r": [0.35, 0, 0],
    "t": 5
  }, {
    "p": [-108, 116, -475],
    "s": [100, 5, 5],
    "c": 7895160,
    "t": 2
  }, {
    "p": [-108, 121, -475],
    "s": [100, 2, 5],
    "t": 5
  }, {
    "p": [10, 114, -392],
    "s": [94, 4, 4],
    "c": 11513775,
    "t": 2
  }, {
    "p": [55, 51, -392],
    "s": [4, 63, 4],
    "c": 11513775,
    "t": 2
  }, {
    "p": [-35, 51, -392],
    "s": [4, 63, 4],
    "c": 11513775,
    "t": 2
  }, {
    "p": [11, 51, -392],
    "s": [4, 63, 4],
    "c": 11513775,
    "t": 2
  }, {
    "p": [30, 96, -502],
    "s": [4, 52, 4],
    "c": 6381921,
    "t": 2
  }, {
    "p": [63, 109, -502],
    "s": [174, 4, 4],
    "c": 6381921,
    "t": 2
  }, {
    "p": [10, 120, -444],
    "s": [92, 3, 102],
    "c": 6254184,
    "t": 10
  }, {
    "p": [55, 51, -444],
    "s": [4, 86, 4],
    "c": 11513775,
    "t": 2
  }, {
    "p": [296, 66, -292],
    "s": [9, 19, 34],
    "c": 7891810,
    "t": 11
  }, {
    "p": [298, 101, -292],
    "s": [3, 9, 12],
    "c": 6051153,
    "t": 11,
    "bo": 1
  }, {
    "p": [298, 85, -301],
    "s": [4, 22, 6],
    "c": 6051153,
    "t": 11,
    "bo": 1
  }, {
    "p": [298, 85, -283],
    "s": [4, 23, 6],
    "c": 6051153,
    "t": 11,
    "bo": 1
  }, {
    "p": [300, 85, -292],
    "s": [1, 22, 23],
    "c": 5590860,
    "t": 11
  }, {
    "p": [293, 85, -297],
    "s": [1, 3, 1],
    "l": 1,
    "c": 9997922,
    "t": 5
  }, {
    "p": [294, 85, -301],
    "s": [1, 2, 1],
    "l": 1,
    "r": [0, -0.35, 0],
    "c": 9997922,
    "t": 5
  }, {
    "p": [293, 85, -306],
    "s": [1, 3, 1],
    "l": 1,
    "r": [0, 0.35, 0],
    "c": 9997922,
    "t": 5
  }, {
    "p": [294, 85, -288],
    "s": [1, 2, 1],
    "l": 1,
    "r": [0, -0.17, 0],
    "c": 9997922,
    "t": 5
  }, {
    "p": [293, 85, -283],
    "s": [1, 2, 1],
    "l": 1,
    "r": [0, 1.05, 0],
    "c": 9997922,
    "t": 5
  }, {
    "p": [294, 85, -278],
    "s": [1, 3, 1],
    "l": 1,
    "r": [0, 0.35, 0],
    "c": 9997922,
    "t": 5
  }, {
    "p": [296, 85, -292],
    "s": [1, 1, 3],
    "l": 1,
    "r": [0, 0, -0.35],
    "c": 12630166,
    "t": 5
  }, {
    "p": [297, 85, -292],
    "s": [3, 4, 4],
    "l": 1,
    "r": [0, 0, -0.35],
    "c": 12630166,
    "t": 5
  }, {
    "p": [297, 86, -293],
    "s": [3, 1, 1],
    "l": 1,
    "r": [0, 0, -0.35],
    "c": 0,
    "t": 5
  }, {
    "p": [297, 86, -291],
    "s": [3, 1, 1],
    "l": 1,
    "r": [0, 0, -0.35],
    "c": 0,
    "t": 5
  }, {
    "p": [-224, 53, -74],
    "s": [216, 0, 229],
    "i": 4,
    "l": 1,
    "en": 1.8,
    "t": 5
  }, {
    "p": [-277, 51, -77],
    "s": [104, 2, 202],
    "v": 1,
    "t": 5
  }, {
    "p": [-139, 51, -111],
    "s": [172, 2, 130],
    "v": 1,
    "t": 5
  }, {
    "p": [-211, 51, -183],
    "s": [12, 2, 14],
    "v": 1,
    "t": 5
  }, {
    "p": [-201, 51, -179],
    "s": [8, 2, 6],
    "v": 1,
    "t": 5
  }, {
    "p": [-183, 51, -182],
    "s": [8, 2, 12],
    "v": 1,
    "t": 5
  }, {
    "p": [22, 66, -48],
    "s": [210, 0, 258],
    "i": 4,
    "l": 1,
    "en": 1.8,
    "t": 5
  }, {
    "p": [-1, 64, 0],
    "s": [140, 2, 142],
    "v": 1,
    "t": 5
  }, {
    "p": [-100, 64, 50],
    "s": [58, 2, 42],
    "v": 1,
    "t": 5
  }, {
    "p": [-149, 53, 8],
    "s": [40, 13, 126],
    "v": 1,
    "t": 5
  }, {
    "p": [-54, 51, -143],
    "s": [58, 15, 42],
    "v": 1,
    "t": 5
  }, {
    "p": [5, 64, -123],
    "s": [60, 2, 104],
    "v": 1,
    "t": 5
  }, {
    "p": [-124, 51, -285],
    "s": [203, 2, 50],
    "v": 1,
    "t": 5
  }, {
    "p": [343, 64, -252],
    "s": [77, 2, 43],
    "v": 1,
    "t": 5
  }, {
    "p": [343, 64, -122],
    "s": [82, 2, 217],
    "v": 1,
    "t": 5
  }, {
    "p": [327, 64, -11],
    "s": [140, 20, 129],
    "v": 1,
    "t": 5
  }, {
    "p": [202, 82, -11],
    "s": [110, 2, 165],
    "v": 1,
    "t": 5
  }, {
    "p": [213, 64, -112],
    "s": [39, 20, 37],
    "v": 1,
    "t": 5
  }, {
    "p": [213, 64, -207],
    "s": [40, 2, 63],
    "v": 1,
    "t": 5
  }, {
    "p": [-131, 66, 50],
    "s": [119, 0, 210],
    "i": 4,
    "l": 1,
    "en": 1.8,
    "t": 5
  }, {
    "p": [74, 66, -271],
    "s": [214, 0, 223],
    "i": 4,
    "l": 1,
    "en": 1.8,
    "t": 5
  }, {
    "p": [80, 51, -272],
    "s": [226, 15, 194],
    "v": 1,
    "t": 5
  }, {
    "p": [80, 51, -272],
    "s": [226, 15, 194],
    "l": 1,
    "t": 5
  }, {
    "p": [-185, 51, -254],
    "s": [8, 2, 12],
    "v": 1,
    "t": 5
  }, {
    "p": [-195, 51, -257],
    "s": [12, 2, 6],
    "v": 1,
    "t": 5
  }, {
    "p": [-216, 51, -254],
    "s": [19, 2, 12],
    "v": 1,
    "t": 5
  }, {
    "p": [-195, 53, -304],
    "s": [201, 0, 97],
    "i": 4,
    "l": 1,
    "en": 1.8,
    "t": 5
  }, {
    "p": [-65, 53, -289],
    "s": [64, 13, 195],
    "i": 9,
    "t": 5
  }, {
    "p": [-149, 53, -78],
    "s": [145, 13, 46],
    "i": 9,
    "t": 5,
    "d": 1
  }, {
    "p": [-101, 53, -140],
    "s": [36, 13, 182],
    "i": 9,
    "t": 5
  }, {
    "p": [216, 66, -157],
    "s": [197, 18, 53],
    "i": 9,
    "t": 5,
    "d": 1
  }, {
    "p": [357, 66, -103],
    "s": [244, 18, 55],
    "i": 9,
    "t": 5,
    "d": 1
  }, {
    "p": [344, 66, -246],
    "s": [82, 0, 234],
    "i": 4,
    "l": 1,
    "en": 1.8,
    "t": 5
  }, {
    "p": [220, 66, -208],
    "s": [88, 0, 52],
    "i": 4,
    "l": 1,
    "en": 1.8,
    "t": 5
  }, {
    "p": [342, 84, 36],
    "s": [170, 0, 223],
    "i": 4,
    "l": 1,
    "en": 1.8,
    "t": 5
  }, {
    "p": [208, 84, -10],
    "s": [131, 0, 240],
    "i": 4,
    "l": 1,
    "en": 1.8,
    "t": 5
  }, {
    "p": [-72, 52, -212],
    "s": [98, 50, 108],
    "c": 8548950,
    "t": 10,
    "bo": 1
  }, {
    "p": [65, 77, -218],
    "s": [12, 1, 12],
    "l": 1,
    "t": 5
  }, {
    "p": [157, 77, -207],
    "s": [12, 1, 24],
    "l": 1,
    "t": 5
  }, {
    "p": [83, 77, -363],
    "s": [24, 1, 14],
    "l": 1,
    "t": 5
  }, {
    "p": [17, 77, -363],
    "s": [24, 1, 14],
    "l": 1,
    "t": 5
  }, {
    "p": [-1, 89, -363],
    "s": [12, 1, 12],
    "l": 1,
    "t": 5
  }, {
    "p": [135, 89, -363],
    "s": [12, 1, 12],
    "l": 1,
    "t": 5
  }, {
    "p": [104, 77, -301],
    "s": [12, 1, 12],
    "l": 1,
    "t": 5
  }, {
    "p": [-17, 77, -184],
    "s": [12, 1, 24],
    "l": 1,
    "t": 5
  }, {
    "p": [28, 77, -95],
    "s": [12, 1, 12],
    "l": 1,
    "t": 5
  }, {
    "p": [55, 77, -64],
    "s": [12, 1, 12],
    "l": 1,
    "t": 5
  }, {
    "p": [-31, 77, -22],
    "s": [12, 1, 24],
    "l": 1,
    "t": 5
  }, {
    "p": [-19, 77, -28],
    "s": [12, 1, 12],
    "l": 1,
    "t": 5
  }, {
    "p": [-65, 77, -58],
    "s": [12, 1, 24],
    "l": 1,
    "t": 5
  }, {
    "p": [28, 89, 50],
    "s": [12, 1, 12],
    "l": 1,
    "t": 5
  }, {
    "p": [-88, 77, 36],
    "s": [12, 1, 12],
    "l": 1,
    "t": 5
  }, {
    "p": [-162, 77, -28],
    "s": [12, 1, 12],
    "l": 1,
    "t": 5
  }, {
    "p": [-158, 64, -158],
    "s": [24, 1, 12],
    "l": 1,
    "t": 5
  }, {
    "p": [-275, 64, -49],
    "s": [24, 1, 12],
    "l": 1,
    "t": 5
  }, {
    "p": [-315, 64, 6],
    "s": [12, 1, 12],
    "l": 1,
    "t": 5
  }, {
    "p": [-315, 64, -80],
    "s": [12, 1, 24],
    "l": 1,
    "t": 5
  }, {
    "p": [-315, 76, 18],
    "s": [12, 1, 12],
    "l": 1,
    "t": 5
  }, {
    "p": [-231, 64, -93],
    "s": [12, 1, 12],
    "l": 1,
    "t": 5
  }, {
    "p": [-128, 64, -266],
    "s": [12, 1, 12],
    "l": 1,
    "t": 5
  }, {
    "p": [-116, 76, -304],
    "s": [12, 1, 12],
    "l": 1,
    "t": 5
  }, {
    "p": [216, 95, 40],
    "s": [12, 1, 12],
    "l": 1,
    "t": 5
  }, {
    "p": [157, 95, -56],
    "s": [12, 1, 12],
    "l": 1,
    "t": 5
  }, {
    "p": [361, 95, 31],
    "s": [12, 1, 12],
    "l": 1,
    "t": 5
  }, {
    "p": [300, 95, -50],
    "s": [12, 1, 12],
    "l": 1,
    "t": 5
  }, {
    "p": [360, 77, -220],
    "s": [12, 1, 12],
    "l": 1,
    "t": 5
  }, {
    "p": [-56, 77, -128],
    "s": [12, 1, 12],
    "l": 1,
    "t": 5
  }, {
    "p": [-282, 105, 25],
    "s": [88, 4, 4],
    "c": 8224125,
    "t": 2,
    "bo": 1
  }, {
    "p": [-282, 53, 25],
    "s": [5, 57, 5],
    "c": 9013641,
    "t": 2,
    "bo": 1
  }, {
    "p": [-236, 53, 25],
    "s": [4, 56, 4],
    "c": 8553090,
    "t": 2,
    "bo": 1
  }, {
    "p": [-328, 53, 25],
    "s": [4, 56, 4],
    "c": 9013641,
    "t": 2,
    "bo": 1
  }, {
    "p": [-234, 91, 14],
    "s": [2, 4, 64],
    "c": 7500402,
    "t": 2
  }, {
    "p": [76, 114, -188],
    "s": [84, 6, 43],
    "c": 8878432,
    "t": 10
  }, {
    "p": [76, 114, -94],
    "s": [84, 6, 43],
    "c": 8878432,
    "t": 10
  }, {
    "p": [76, 120, -101],
    "s": [84, 5, 29],
    "c": 8878432,
    "t": 10
  }, {
    "p": [76, 125, -108],
    "s": [84, 3, 16],
    "c": 8878432,
    "t": 10
  }, {
    "p": [76, 128, -112],
    "s": [84, 3, 7],
    "c": 8878432,
    "t": 10
  }, {
    "p": [76, 120, -181],
    "s": [84, 5, 29],
    "c": 8878432,
    "t": 10
  }, {
    "p": [76, 125, -175],
    "s": [84, 3, 16],
    "c": 8878432,
    "t": 10
  }, {
    "p": [76, 128, -170],
    "s": [84, 3, 7],
    "c": 8878432,
    "t": 10
  }, {
    "p": [-270, 51, -177],
    "s": [3, 20, 10],
    "i": 21,
    "l": 1,
    "r": [0, -1.57, 0]
  }, {
    "p": [-258, 51, 24],
    "s": [3, 20, 10],
    "i": 21,
    "l": 1,
    "r": [0, 1.57, 0]
  }, {
    "p": [-225, 51, -42],
    "s": [3, 20, 10],
    "i": 21,
    "l": 1,
    "r": [-3.14, 0, -3.14]
  }, {
    "p": [-160, 64, -3],
    "s": [3, 20, 10],
    "i": 21,
    "l": 1
  }, {
    "p": [-133, 65, 71],
    "s": [3, 20, 10],
    "i": 21,
    "l": 1,
    "r": [0, 1.57, 0]
  }, {
    "p": [34, 63, -141],
    "s": [3, 20, 10],
    "i": 21,
    "l": 1,
    "r": [-3.14, 0, -3.14]
  }, {
    "p": [-25, 64, -96],
    "s": [3, 20, 10],
    "i": 21,
    "l": 1
  }, {
    "p": [-9, 65, 56],
    "s": [3, 20, 10],
    "i": 21,
    "l": 1,
    "r": [0, 1.57, 0]
  }, {
    "p": [56, 85, -2],
    "s": [3, 20, 10],
    "i": 21,
    "l": 1,
    "r": [0, 1.57, 0]
  }, {
    "p": [157, 85, 11],
    "s": [3, 20, 10],
    "i": 21,
    "l": 1,
    "r": [0, -1.57, 0]
  }, {
    "p": [173, 83, 46],
    "s": [3, 20, 10],
    "i": 21,
    "l": 1,
    "r": [0, 1.57, 0]
  }, {
    "p": [86, 85, 40],
    "s": [3, 20, 10],
    "i": 21,
    "l": 1,
    "r": [0, 1.57, 0]
  }, {
    "p": [179, 82, -65],
    "s": [3, 20, 10],
    "i": 21,
    "l": 1,
    "r": [0, 1.57, 0]
  }, {
    "p": [233, 82, -38],
    "s": [3, 20, 10],
    "i": 21,
    "l": 1
  }, {
    "p": [368, 84, -28],
    "s": [3, 20, 10],
    "i": 21,
    "l": 1
  }, {
    "p": [96, 64, -212],
    "s": [3, 20, 10],
    "i": 21,
    "l": 1,
    "r": [0, 1.57, 0]
  }, {
    "p": [-105, 52, -266],
    "s": [3, 20, 10],
    "i": 21,
    "l": 1,
    "r": [0, 1.57, 0]
  }, {
    "p": [-142, 51, -310],
    "s": [3, 20, 10],
    "i": 21,
    "l": 1,
    "r": [0, -1.57, 0]
  }, {
    "p": [-180, 51, -301],
    "s": [3, 20, 10],
    "i": 21,
    "l": 1,
    "r": [0, -1.57, 0]
  }, {
    "p": [-225, 51, -277],
    "s": [3, 20, 10],
    "i": 21,
    "l": 1
  }, {
    "p": [366, 64, -243],
    "s": [3, 20, 10],
    "i": 21,
    "l": 1
  }, {
    "p": [350, 64, -273],
    "s": [3, 20, 10],
    "i": 21,
    "l": 1,
    "r": [0, 1.57, 0]
  }, {
    "p": [321, 64, -172],
    "s": [3, 20, 10],
    "i": 21,
    "l": 1,
    "r": [3.14, 0, 3.14]
  }, {
    "p": [-72, 104, -212],
    "s": [99, 8, 108],
    "c": 8548950,
    "t": 10
  }, {
    "p": [-72, 112, -212],
    "s": [65, 6, 108],
    "c": 8548950,
    "t": 10
  }, {
    "p": [-72, 118, -212],
    "s": [35, 6, 108],
    "c": 8548950,
    "t": 10
  }, {
    "p": [127, 85, -18],
    "s": [3, 20, 10],
    "i": 21,
    "l": 1,
    "r": [0, -1.57, 0]
  }, {
    "p": [-259, 85, 23],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [0, 1.57, 0]
  }, {
    "p": [-305, 85, 23],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [0, 1.57, 0]
  }, {
    "p": [-235, 70, 4],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [-3.14, 0, -3.14]
  }, {
    "p": [-226, 84, -44],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [-3.14, 0, -3.14]
  }, {
    "p": [-226, 84, -81],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [-3.14, 0, -3.14]
  }, {
    "p": [-271, 83, -176],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [0, -1.57, 0]
  }, {
    "p": [-308, 83, -176],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [0, -1.57, 0]
  }, {
    "p": [-228, 96, -164],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [0, -1.57, 0]
  }, {
    "p": [-145, 96, -164],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [0, -1.57, 0]
  }, {
    "p": [-197, 84, -103],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [0, 1.57, 0]
  }, {
    "p": [-102, 97, -123],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [0, 1.57, 0]
  }, {
    "p": [-130, 97, -96],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [-3.14, 0, -3.14]
  }, {
    "p": [-132, 92, 4],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [-3.14, 0, -3.14]
  }, {
    "p": [-159, 99, 14],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1
  }, {
    "p": [-168, 85, -44],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1
  }, {
    "p": [-50, 84, -157],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [0, -1.57, 0]
  }, {
    "p": [-22, 83, -185],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1
  }, {
    "p": [-24, 98, -97],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1
  }, {
    "p": [-224, 84, -278],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1
  }, {
    "p": [-187, 96, -260],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [0, 1.57, 0]
  }, {
    "p": [-204, 64, -300],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [0, -1.57, 0]
  }, {
    "p": [-141, 87, -309],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [0, -1.57, 0]
  }, {
    "p": [-76, 87, -309],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [0, -1.57, 0]
  }, {
    "p": [-49, 83, -267],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [0, 1.57, 0]
  }, {
    "p": [140, 88, -194],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [0, 1.57, 0]
  }, {
    "p": [56, 92, -213],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [0, 1.57, 0]
  }, {
    "p": [33, 92, -188],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [-3.14, 0, -3.14]
  }, {
    "p": [33, 92, -93],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [-3.14, 0, -3.14]
  }, {
    "p": [-73, 76, 70],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [0, 1.57, 0]
  }, {
    "p": [-70, 92, 5],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1
  }, {
    "p": [42, 97, 55],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [0, 1.57, 0]
  }, {
    "p": [242, 121, 45],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [0, 1.57, 0]
  }, {
    "p": [227, 100, -90],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [-3.14, 0, -3.14]
  }, {
    "p": [232, 92, -211],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [-3.14, 0, -3.14]
  }, {
    "p": [200, 88, -161],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1
  }, {
    "p": [308, 105, 36],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [0, 1.57, 0]
  }, {
    "p": [322, 98, -272],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [0, -1.57, 0]
  }, {
    "p": [367, 92, 13],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [3.14, 0, 3.14]
  }, {
    "p": [294, 116, -25],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1
  }, {
    "p": [335, 100, -92],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1
  }, {
    "p": [322, 92, -212],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1
  }, {
    "p": [379, 99, -118],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [3.14, 0, 3.14]
  }, {
    "p": [365, 78, -179],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [3.14, 0, 3.14]
  }, {
    "p": [175, 99, -281],
    "s": [7, 5, 9],
    "c": 6247502,
    "t": 11,
    "bo": 1
  }, {
    "p": [175, 103, -312],
    "s": [6, 10, 17],
    "c": 10983566,
    "t": 11,
    "bo": 1
  }, {
    "p": [166, 65, -337],
    "s": [7, 3, 4],
    "l": 1,
    "c": 4275000,
    "t": 5
  }, {
    "p": [165, 65, -348],
    "s": [4, 3, 7],
    "l": 1,
    "c": 4275000,
    "t": 5
  }, {
    "p": [175, 107, -246],
    "s": [6, 5, 12],
    "l": 1,
    "c": 10983566,
    "t": 11
  }, {
    "p": [175, 107, -265],
    "s": [6, 3, 14],
    "l": 1,
    "c": 10983566,
    "t": 11
  }, {
    "p": [175, 120, -244],
    "s": [9, 5, 4],
    "c": 6248017,
    "t": 11,
    "bo": 1
  }, {
    "p": [165, 65, -237],
    "s": [7, 3, 4],
    "l": 1,
    "c": 4275000,
    "t": 5
  }, {
    "p": [183, 65, -300],
    "s": [4, 3, 7],
    "l": 1,
    "c": 4275000,
    "t": 5
  }, {
    "p": [167, 65, -280],
    "s": [5, 2, 4],
    "l": 1,
    "c": 4275000,
    "t": 5
  }, {
    "p": [48, 64, -271],
    "s": [4, 3, 7],
    "l": 1,
    "c": 4275000,
    "t": 5
  }, {
    "p": [102, 64, -277],
    "s": [4, 3, 7],
    "l": 1,
    "c": 4275000,
    "t": 5
  }, {
    "p": [229, 64, -224],
    "s": [4, 3, 7],
    "l": 1,
    "c": 4275000,
    "t": 5
  }, {
    "p": [267, 129, -347],
    "s": [22, 3, 10],
    "c": 8220776,
    "t": 11,
    "bo": 1
  }, {
    "p": [214, 105, -236],
    "s": [4, 5, 9],
    "c": 10983566,
    "t": 11,
    "bo": 1
  }, {
    "p": [287, 115, -236],
    "s": [23, 5, 12],
    "c": 5918536,
    "t": 11,
    "bo": 1
  }, {
    "p": [237, 115, -236],
    "s": [30, 4, 9],
    "c": 7563360,
    "t": 11,
    "bo": 1
  }, {
    "p": [64, 64, -364],
    "s": [6, 3, 3],
    "l": 1,
    "c": 4275000,
    "t": 5
  }, {
    "p": [-20, 64, -328],
    "s": [4, 3, 7],
    "l": 1,
    "c": 4275000,
    "t": 5
  }, {
    "p": [175, 120, -355],
    "s": [9, 5, 6],
    "c": 8220776,
    "t": 11,
    "bo": 1
  }, {
    "p": [176, 77, -363],
    "s": [5, 31, 22],
    "c": 10983566,
    "t": 11,
    "bo": 1
  }, {
    "p": [130, 77, -371],
    "s": [90, 31, 4],
    "c": 10983566,
    "t": 11,
    "bo": 1
  }, {
    "p": [68, 77, -371],
    "s": [34, 24, 4],
    "c": 10983566,
    "t": 11,
    "bo": 1
  }, {
    "p": [12, 77, -371],
    "s": [78, 27, 4],
    "c": 10983566,
    "t": 11,
    "bo": 1
  }, {
    "p": [-28, 77, -345],
    "s": [5, 29, 58],
    "c": 10983566,
    "t": 11,
    "bo": 1
  }, {
    "p": [-44, 77, -315],
    "s": [27, 29, 4],
    "c": 10983566,
    "t": 11,
    "bo": 1
  }, {
    "p": [-28, 106, -327],
    "s": [5, 3, 14],
    "l": 1,
    "c": 10983566,
    "t": 11
  }, {
    "p": [-28, 106, -363],
    "s": [5, 2, 22],
    "l": 1,
    "c": 10983566,
    "t": 11
  }, {
    "p": [-36, 106, -315],
    "s": [15, 3, 4],
    "l": 1,
    "c": 10983566,
    "t": 11
  }, {
    "p": [69, 101, -371],
    "s": [16, 3, 4],
    "l": 1,
    "c": 10983566,
    "t": 11
  }, {
    "p": [177, 65, -359],
    "s": [9, 12, 24],
    "c": 6575952,
    "t": 11
  }, {
    "p": [64, 65, -372],
    "s": [220, 12, 8],
    "c": 6379602,
    "t": 11
  }, {
    "p": [-43, 51, -341],
    "s": [37, 26, 58],
    "c": 6576209,
    "t": 11
  }, {
    "p": [-29, 77, -317],
    "s": [9, 37, 10],
    "c": 6247759,
    "t": 11,
    "bo": 1
  }, {
    "p": [303, 110, -335],
    "s": [6, 4, 23],
    "c": 10983566,
    "t": 11,
    "bo": 1
  }, {
    "p": [291, 74, -313],
    "s": [7, 3, 4],
    "l": 1,
    "c": 4275000,
    "t": 5
  }, {
    "p": [294, 65, -246],
    "s": [4, 3, 7],
    "l": 1,
    "c": 4275000,
    "t": 5
  }, {
    "p": [303, 110, -270],
    "s": [6, 4, 24],
    "c": 6708310,
    "t": 11,
    "bo": 1
  }, {
    "p": [182, 65, -263],
    "s": [4, 3, 7],
    "l": 1,
    "c": 4275000,
    "t": 5
  }, {
    "p": [294, 65, -335],
    "s": [4, 3, 7],
    "l": 1,
    "c": 4275000,
    "t": 5
  }, {
    "p": [270, 65, -339],
    "s": [8, 3, 4],
    "l": 1,
    "c": 4275000,
    "t": 5
  }, {
    "p": [303, 123, -340],
    "s": [9, 6, 4],
    "c": 8220776,
    "t": 11,
    "bo": 1
  }, {
    "p": [227, 95, -236],
    "s": [2, 5, 9],
    "c": 10983566,
    "t": 11,
    "bo": 1
  }, {
    "p": [303, 95, -249],
    "s": [6, 5, 2],
    "c": 10983566,
    "t": 11,
    "bo": 1
  }, {
    "p": [303, 101, -263],
    "s": [6, 4, 2],
    "c": 10983566,
    "t": 11,
    "bo": 1
  }, {
    "p": [97, 104, -217],
    "s": [2, 2, 13],
    "l": 1,
    "c": 7895160,
    "t": 2
  }, {
    "p": [97, 97, -218],
    "s": [1, 6, 9],
    "l": 1,
    "c": 7895160,
    "t": 2
  }, {
    "p": [97, 103, -221],
    "s": [1, 1, 1],
    "l": 1,
    "c": 7895160,
    "t": 5
  }, {
    "p": [97, 103, -215],
    "s": [1, 1, 1],
    "l": 1,
    "c": 7895160,
    "t": 5
  }, {
    "p": [112, 64, -218],
    "s": [4, 3, 7],
    "l": 1,
    "c": 4275000,
    "t": 5
  }, {
    "p": [-96, 98, -271],
    "s": [2, 2, 13],
    "l": 1,
    "c": 7895160,
    "t": 2
  }, {
    "p": [-96, 91, -272],
    "s": [1, 6, 9],
    "l": 1,
    "c": 7895160,
    "t": 2
  }, {
    "p": [-96, 97, -275],
    "s": [1, 1, 1],
    "l": 1,
    "c": 7895160,
    "t": 5
  }, {
    "p": [-96, 97, -269],
    "s": [1, 1, 1],
    "l": 1,
    "c": 7895160,
    "t": 5
  }, {
    "p": [-8, 107, 52],
    "s": [2, 2, 17],
    "l": 1,
    "c": 7895160,
    "t": 2
  }, {
    "p": [-8, 100, 49],
    "s": [1, 6, 9],
    "l": 1,
    "c": 7895160,
    "t": 2
  }, {
    "p": [-8, 106, 46],
    "s": [1, 1, 1],
    "l": 1,
    "c": 7895160,
    "t": 5
  }, {
    "p": [-8, 106, 52],
    "s": [1, 1, 1],
    "l": 1,
    "c": 7895160,
    "t": 5
  }, {
    "p": [-213, 50, -197],
    "s": [4, 3, 7],
    "l": 1,
    "c": 3092271,
    "t": 5
  }, {
    "p": [-185, 50, -237],
    "s": [4, 3, 7],
    "l": 1,
    "c": 3092271,
    "t": 5
  }, {
    "p": [-199, 81, -260],
    "s": [33, 3, 3],
    "c": 8684676,
    "t": 2,
    "bo": 1
  }, {
    "p": [-181, 53, -260],
    "s": [3, 31, 3],
    "c": 8684676,
    "t": 2,
    "bo": 1
  }, {
    "p": [-217, 53, -260],
    "s": [3, 31, 3],
    "c": 8684676,
    "t": 2,
    "bo": 1
  }, {
    "p": [130, 108, -371],
    "s": [90, 1, 4],
    "l": 1,
    "t": 5
  }, {
    "p": [12, 104, -371],
    "s": [78, 1, 4],
    "l": 1,
    "t": 5
  }, {
    "p": [69, 104, -371],
    "s": [16, 1, 4],
    "l": 1,
    "t": 5
  }, {
    "p": [175, 125, -355],
    "s": [9, 1, 6],
    "l": 1,
    "t": 5
  }, {
    "p": [-28, 106, -343],
    "s": [5, 1, 18],
    "l": 1,
    "t": 5
  }, {
    "p": [-28, 108, -363],
    "s": [5, 1, 22],
    "l": 1,
    "t": 5
  }, {
    "p": [-28, 109, -327],
    "s": [5, 1, 14],
    "l": 1,
    "t": 5
  }, {
    "p": [-38, 109, -315],
    "s": [11, 1, 4],
    "l": 1,
    "t": 5
  }, {
    "p": [-50, 106, -315],
    "s": [13, 1, 4],
    "l": 1,
    "t": 5
  }, {
    "p": [176, 108, -361],
    "s": [5, 1, 25],
    "l": 1,
    "t": 5
  }, {
    "p": [175, 125, -329],
    "s": [9, 1, 26],
    "l": 1,
    "t": 5
  }, {
    "p": [175, 133, -347],
    "s": [9, 1, 10],
    "l": 1,
    "t": 5
  }, {
    "p": [175, 113, -312],
    "s": [6, 1, 17],
    "l": 1,
    "t": 5
  }, {
    "p": [175, 110, -265],
    "s": [6, 1, 14],
    "l": 1,
    "t": 5
  }, {
    "p": [175, 112, -245],
    "s": [6, 1, 14],
    "l": 1,
    "t": 5
  }, {
    "p": [303, 114, -267],
    "s": [6, 1, 18],
    "l": 1,
    "t": 5
  }, {
    "p": [303, 128, -236],
    "s": [9, 1, 12],
    "l": 1,
    "t": 5
  }, {
    "p": [199, 124, -236],
    "s": [39, 1, 12],
    "l": 1,
    "t": 5
  }, {
    "p": [175, 132, -236],
    "s": [9, 1, 12],
    "l": 1,
    "t": 5
  }, {
    "p": [303, 134, -347],
    "s": [9, 1, 10],
    "l": 1,
    "t": 5
  }, {
    "p": [292, 129, -347],
    "s": [13, 1, 10],
    "l": 1,
    "t": 5
  }, {
    "p": [211, 129, -347],
    "s": [63, 1, 10],
    "l": 1,
    "t": 5
  }, {
    "p": [300, 110, -292],
    "s": [7, 1, 12],
    "l": 1,
    "t": 5
  }, {
    "p": [300, 107, -301],
    "s": [8, 1, 6],
    "l": 1,
    "t": 5
  }, {
    "p": [157, 85, 11],
    "s": [10, 20, 1],
    "pe": 1,
    "v": 1,
    "c": 7895160,
    "t": 5
  }, {
    "p": [56, 85, -2],
    "s": [10, 20, 1],
    "pe": 1,
    "v": 1,
    "c": 7895160,
    "t": 5
  }, {
    "p": [303, 114, -333],
    "s": [6, 1, 19],
    "l": 1,
    "t": 5
  }, {
    "p": [303, 129, -340],
    "s": [9, 1, 4],
    "l": 1,
    "t": 5
  }, {
    "p": [300, 95, -62],
    "s": [12, 1, 12],
    "l": 1,
    "t": 5
  }, {
    "p": [296, 90, -25],
    "s": [6, 1, 6],
    "l": 1,
    "t": 5
  }, {
    "p": [296, 90, -17],
    "s": [6, 1, 6],
    "l": 1,
    "t": 5
  }, {
    "p": [351, 90, 34],
    "s": [6, 1, 6],
    "l": 1,
    "t": 5
  }, {
    "p": [375, 72, -139],
    "s": [6, 1, 6],
    "l": 1,
    "t": 5
  }, {
    "p": [325, 72, -210],
    "s": [6, 1, 6],
    "l": 1,
    "t": 5
  }, {
    "p": [325, 72, -202],
    "s": [6, 1, 6],
    "l": 1,
    "t": 5
  }, {
    "p": [102, 72, -291],
    "s": [6, 1, 6],
    "l": 1,
    "t": 5
  }, {
    "p": [147, 72, -198],
    "s": [6, 1, 6],
    "l": 1,
    "t": 5
  }, {
    "p": [152, 72, -365],
    "s": [6, 1, 6],
    "l": 1,
    "t": 5
  }, {
    "p": [145, 72, -365],
    "s": [6, 1, 6],
    "l": 1,
    "t": 5
  }, {
    "p": [45, 72, -66],
    "s": [6, 1, 6],
    "l": 1,
    "t": 5
  }, {
    "p": [-55, 72, -66],
    "s": [6, 1, 6],
    "l": 1,
    "t": 5
  }, {
    "p": [-68, 72, 14],
    "s": [6, 1, 6],
    "l": 1,
    "t": 5
  }, {
    "p": [-68, 72, 22],
    "s": [6, 1, 6],
    "l": 1,
    "t": 5
  }, {
    "p": [-163, 72, 54],
    "s": [6, 1, 6],
    "l": 1,
    "t": 5
  }, {
    "p": [-165, 72, -38],
    "s": [6, 1, 6],
    "l": 1,
    "t": 5
  }, {
    "p": [-317, 59, -173],
    "s": [6, 1, 6],
    "l": 1,
    "t": 5
  }, {
    "p": [-317, 59, -56],
    "s": [6, 1, 6],
    "l": 1,
    "t": 5
  }, {
    "p": [-317, 59, -64],
    "s": [6, 1, 6],
    "l": 1,
    "t": 5
  }, {
    "p": [-305, 59, 20],
    "s": [6, 1, 6],
    "l": 1,
    "t": 5
  }, {
    "p": [-269, 59, -59],
    "s": [6, 1, 6],
    "l": 1,
    "t": 5
  }, {
    "p": [-222, 59, -295],
    "s": [6, 1, 6],
    "l": 1,
    "t": 5
  }, {
    "p": [206, 72, -227],
    "s": [6, 1, 6],
    "l": 1,
    "t": 5
  }, {
    "p": [206, 72, -220],
    "s": [6, 1, 6],
    "l": 1,
    "t": 5
  }, {
    "p": [-205, 51, -258],
    "s": [3, 2, 4],
    "l": 1,
    "t": 5
  }, {
    "p": [-189, 51, -180],
    "s": [4, 2, 8],
    "l": 1,
    "t": 5
  }, {
    "p": [-189, 51, -180],
    "s": [4, 2, 8],
    "v": 1,
    "t": 5
  }, {
    "p": [61, 89, -2],
    "s": [1, 2, 1],
    "pe": 1,
    "c": 7895160,
    "t": 5
  }, {
    "p": [61, 99, -2],
    "s": [1, 2, 1],
    "pe": 1,
    "c": 7895160,
    "t": 5
  }, {
    "p": [-8, 109, 52],
    "s": [2, 1, 17],
    "l": 1,
    "c": "#ffffff",
    "t": 5
  }, {
    "p": [-96, 100, -271],
    "s": [2, 1, 13],
    "l": 1,
    "c": "#ffffff",
    "t": 5
  }, {
    "p": [97, 106, -217],
    "s": [2, 1, 13],
    "l": 1,
    "c": "#ffffff",
    "t": 5
  }, {
    "p": [-234, 95, 14],
    "s": [3, 25, 64],
    "v": 1,
    "c": 7500402,
    "t": 2
  }, {
    "p": [55, 72, -215],
    "s": [6, 1, 6],
    "l": 1,
    "t": 5
  }, {
    "p": [75, 90, -292],
    "s": [3, 16, 3],
    "c": 10983566,
    "t": 11
  }, {
    "p": [75, 99, -292],
    "s": [2, 3, 12],
    "c": 10983566,
    "t": 11
  }, {
    "p": [75, 102, -292],
    "s": [2, 1, 12],
    "l": 1,
    "t": 5
  }, {
    "p": [75, 106, -292],
    "s": [3, 1, 3],
    "l": 1,
    "t": 5
  }, {
    "p": [-276, 53, -16],
    "s": [24, 36, 24],
    "i": 23,
    "l": 1,
    "tm": 0
  }, {
    "p": [245, 67, -293],
    "s": [24, 36, 24],
    "i": 23,
    "l": 1,
    "tm": "1"
  }, {
    "p": [97, 97, -217],
    "s": [2, 16, 13],
    "v": 1,
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [-96, 91, -271],
    "s": [2, 16, 13],
    "v": 1,
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [-8, 100, 50],
    "s": [2, 16, 13],
    "v": 1,
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [238, 66, -292],
    "s": [114, 50, 95],
    "i": 14,
    "l": 1
  }, {
    "p": [-273, 53, -22],
    "s": [91, 50, 86],
    "i": 14,
    "l": 1
  }, {
    "p": [74, 66, -292],
    "s": [91, 50, 86],
    "i": 14,
    "l": 1
  }, {
    "p": [192, 84, -9],
    "s": [73, 50, 103],
    "i": 14,
    "l": 1
  }, {
    "p": [-199, 83, -212],
    "s": [36, 8, 96],
    "c": 8355711,
    "t": 11,
    "bo": 1
  }]
}, {
  "name": "Kanji",
  "ambInd": 2,
  "modURL": "",
  "terrainSeed": "",
  "terrainWidth": 3000,
  "terrainHeight": 3000,
  "terrainMntMlt": 1,
  "terrainMntCol": "#a0a0a0",
  "terrainGrsCol": "#4a6904",
  "terrainDrtCol": "#8c6835",
  "skyDome": true,
  "skyDomeCol0": "#071250",
  "skyDomeCol1": "#452e7d",
  "skyDomeCol2": "#2f3b7d",
  "zone": false,
  "zoneSize": 500,
  "zoneSpeed": 1,
  "zoneCol0": "#c542d9",
  "zoneCol1": "#c542d9",
  "zoneCol2": "#c542d9",
  "sizeMlt": 2,
  "shadowR": 4096,
  "ambient": 6184555,
  "light": 3358064,
  "sky": 0,
  "fog": 3551876,
  "fogD": 888.9947618183014,
  "dthY": -118.35524224550045,
  "modes": [0],
  "camPos": [-178, 50, -10],
  "spawns": [[-469, -27, -92, 0, 1], [-440, -27, -232, 0, 2], [-154, -7, -483, 0, 1], [3, -7, -477, 0, 2], [-12, -7, -320, 0], [70, -7, -215, 0, 1], [31, -27, -24, 0, 3], [-179, -15, 31, 0, 2], [-235, -7, -162, 0, 1], [-428, -8, -496, 0, 2], [-388, -8, -292, 0, 2]],
  "ambO": 0.7,
  "ambS": 5,
  "shadLength": 387,
  "shadWidth": 425,
  "objects": [{
    "p": [192, -708, 517],
    "s": [139, 784, 142],
    "l": 1,
    "c": "#b6b6b6",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-112, -712, 319],
    "s": [186, 710, 214],
    "r": [-3.14, 0, 3.14],
    "c": "#757575",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-207, -905, 765],
    "s": [218, 1089, 142],
    "l": 1,
    "c": "#b6b6b6",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-112, -2, 212],
    "s": [189, 2, 4],
    "c": "#4d4d4d",
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [-112, -2, 426],
    "s": [189, 2, 4],
    "c": "#4d4d4d",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-20, -2, 319],
    "s": [5, 2, 218],
    "c": "#4d4d4d",
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [-204, -2, 319],
    "s": [5, 2, 218],
    "c": "#4d4d4d",
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [192, 76, 517],
    "s": [142, 3, 145],
    "l": 1,
    "c": "#696969",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [308, -708, 191],
    "s": [139, 745, 142],
    "c": "#b6b6b6",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [308, 11, 191],
    "s": [100, 75, 106],
    "c": "#b6b6b6",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [308, 86, 191],
    "s": [106, 3, 111],
    "c": "#707070",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [308, 37, 191],
    "s": [145, 2, 147],
    "c": "#707070",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [300, -708, 467],
    "s": [158, 608, 142],
    "l": 1,
    "c": "#7d7d7d",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [0, 165, 368],
    "s": [143, 3, 146],
    "c": "#828282",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [559, -708, 21],
    "s": [158, 796, 139],
    "l": 1,
    "c": "#7d7d7d",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [308, -708, -55],
    "s": [139, 694, 142],
    "c": "#b6b6b6",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-865, -708, 375],
    "s": [139, 926, 142],
    "l": 1,
    "c": "#b6b6b6",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-633, -905, -887],
    "s": [145, 1088, 142],
    "l": 1,
    "c": "#e3e3e3",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [618, -708, 215],
    "s": [139, 945, 142],
    "l": 1,
    "c": "#b6b6b6",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [438, -708, 627],
    "s": [158, 858, 139],
    "l": 1,
    "c": "#7d7d7d",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-830, -905, 119],
    "s": [185, 965, 116],
    "l": 1,
    "c": "#f0f0f0",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-1107, -669, 30],
    "s": [139, 926, 142],
    "l": 1,
    "c": "#141414",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-496, -905, 789],
    "s": [145, 1202, 142],
    "l": 1,
    "c": "#b6b6b6",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [415, -905, 789],
    "s": [145, 1257, 142],
    "l": 1,
    "c": "#b6b6b6",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-82, -905, 1060],
    "s": [369, 1031, 142],
    "l": 1,
    "c": "#fcfcfc",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-707, -905, 586],
    "s": [225, 1010, 256],
    "l": 1,
    "c": "#222222",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [355, -905, -147],
    "s": [145, 1066, 142],
    "l": 1,
    "c": "#b6b6b6",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [0, -708, 368],
    "s": [139, 873, 142],
    "c": "#b6b6b6",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [484, -905, -475],
    "s": [208, 962, 214],
    "l": 1,
    "c": "#f2f2f2",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [889, -708, -261],
    "s": [171, 889, 259],
    "l": 1,
    "c": "#7d7d7d",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [547, -905, -486],
    "s": [145, 1257, 142],
    "l": 1,
    "c": "#484848",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [154, -905, -948],
    "s": [145, 1202, 142],
    "l": 1,
    "c": "#555454",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [504, -708, 72],
    "s": [158, 608, 142],
    "l": 1,
    "c": "#7d7d7d",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-943, -905, 716],
    "s": [145, 1292, 142],
    "l": 1,
    "c": "#b6b6b6",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-1007, -708, -410],
    "s": [158, 796, 139],
    "l": 1,
    "c": "#7d7d7d",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-791, -905, -1167],
    "s": [145, 1202, 142],
    "l": 1,
    "c": "#b6b6b6",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-165, -905, -1488],
    "s": [145, 1212, 142],
    "l": 1,
    "c": "#616161",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [276, -905, -739],
    "s": [145, 1034, 142],
    "l": 1,
    "c": "#b9b9b9",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [87, -708, -895],
    "s": [158, 731, 139],
    "l": 1,
    "c": "#acacac",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-700, -905, -818],
    "s": [145, 981, 142],
    "l": 1,
    "c": "#b6b6b6",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-111, -708, -1048],
    "s": [158, 796, 151],
    "l": 1,
    "c": "#7d7d7d",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-886, -708, -684],
    "s": [139, 926, 142],
    "l": 1,
    "c": "#4b4b4b",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-405, -708, -987],
    "s": [158, 680, 139],
    "l": 1,
    "c": "#acacac",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-224, -708, -1269],
    "s": [139, 876, 142],
    "l": 1,
    "c": "#343434",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-564, -708, -1215],
    "s": [158, 796, 139],
    "l": 1,
    "c": "#b4b4b4",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [500, -905, -912],
    "s": [145, 1285, 142],
    "l": 1,
    "c": "#b6b6b6",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [83, -905, -1262],
    "s": [145, 1112, 142],
    "l": 1,
    "c": "#7f7f7f",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-414, -905, -1447],
    "s": [145, 1068, 142],
    "l": 1,
    "c": "#ffffff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-592, -708, -1418],
    "s": [158, 1072, 139],
    "l": 1,
    "c": "#7d7d7d",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [242, -708, -1094],
    "s": [378, 796, 139],
    "l": 1,
    "c": "#6e6e6e",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [484, -708, -653],
    "s": [158, 915, 139],
    "l": 1,
    "c": "#6e6e6e",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-1217, -708, -567],
    "s": [158, 1166, 139],
    "l": 1,
    "c": "#7d7d7d",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-1275, -905, -1165],
    "s": [145, 1238, 142],
    "l": 1,
    "c": "#b6b6b6",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [991, -708, 134],
    "s": [171, 1133, 138],
    "l": 1,
    "c": "#7d7d7d",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [1380, -708, -70],
    "s": [171, 1084, 138],
    "l": 1,
    "c": "#7d7d7d",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [680, -708, 544],
    "s": [171, 1084, 138],
    "l": 1,
    "c": "#7d7d7d",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [376, -905, 1272],
    "s": [145, 1257, 142],
    "l": 1,
    "c": "#b6b6b6",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-1455, -905, -155],
    "s": [145, 1305, 142],
    "l": 1,
    "c": "#b6b6b6",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-1206, -905, 376],
    "s": [145, 1305, 142],
    "l": 1,
    "c": "#b6b6b6",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [355, 161, -147],
    "s": [151, 5, 147],
    "l": 1,
    "c": "#737373",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [263, 89, 144],
    "s": [1, 64, 1],
    "l": 1,
    "c": "#ffffff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-63, 168, 304],
    "s": [1, 40, 1],
    "l": 1,
    "c": "#ffffff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [48, 166, 315],
    "s": [27, 14, 22],
    "l": 1,
    "c": "#acacac",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-112, -2, 221],
    "s": [3, 8, 3],
    "l": 1,
    "c": "#696969",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [308, -14, -55],
    "s": [144, 4, 147],
    "c": "#696565",
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [-196, -2, 221],
    "s": [3, 8, 3],
    "l": 1,
    "c": "#696969",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-154, 6, 221],
    "s": [116, 54, 3],
    "l": 1,
    "c": "#343434",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-448, -905, -776],
    "s": [145, 943, 142],
    "c": "#828282",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-448, 38, -776],
    "s": [149, 4, 147],
    "c": "#616161",
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [928, -708, -443],
    "s": [171, 1084, 138],
    "l": 1,
    "c": "#ffffff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [92, 25, 318],
    "s": [36, 136, 3],
    "l": 1,
    "c": "#200028",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [100, 132, 315],
    "s": [3, 20, 3],
    "l": 1,
    "c": "#d200ff",
    "e": "#d200ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [84, 132, 315],
    "s": [3, 20, 3],
    "l": 1,
    "c": "#d200ff",
    "e": "#d200ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [92, 141, 315],
    "s": [17, 3, 3],
    "l": 1,
    "c": "#d200ff",
    "e": "#d200ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [92, 125, 315],
    "s": [17, 3, 3],
    "l": 1,
    "c": "#d200ff",
    "e": "#d200ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [100, 108, 315],
    "s": [3, 20, 3],
    "l": 1,
    "c": "#d200ff",
    "e": "#d200ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [83, 108, 315],
    "s": [3, 20, 3],
    "l": 1,
    "c": "#d200ff",
    "e": "#d200ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [92, 108, 315],
    "s": [17, 3, 3],
    "l": 1,
    "c": "#d200ff",
    "e": "#d200ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [92, 101, 315],
    "s": [21, 3, 3],
    "l": 1,
    "c": "#d200ff",
    "e": "#d200ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [92, 83, 315],
    "s": [3, 18, 3],
    "l": 1,
    "c": "#d200ff",
    "e": "#d200ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [91, 77, 315],
    "s": [19, 3, 3],
    "l": 1,
    "c": "#d200ff",
    "e": "#d200ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [100, 60, 315],
    "s": [3, 20, 3],
    "l": 1,
    "c": "#d200ff",
    "e": "#d200ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [91, 60, 315],
    "s": [19, 3, 3],
    "l": 1,
    "c": "#d200ff",
    "e": "#d200ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [91, 69, 315],
    "s": [19, 3, 3],
    "l": 1,
    "c": "#d200ff",
    "e": "#d200ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [100, 36, 315],
    "s": [3, 20, 3],
    "l": 1,
    "c": "#d200ff",
    "e": "#d200ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [91, 36, 315],
    "s": [21, 3, 3],
    "l": 1,
    "c": "#d200ff",
    "e": "#d200ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [77, 56, 322],
    "s": [22, 5, 4],
    "l": 1,
    "c": "#3e3e3e",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [77, 118, 322],
    "s": [22, 5, 4],
    "l": 1,
    "c": "#3e3e3e",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [55, 44, -833],
    "s": [17, 3, 4],
    "l": 1,
    "r": [0, 0, -0.52],
    "c": "#f000ff",
    "e": "#f000ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [46, 41, -833],
    "s": [3, 9, 4],
    "l": 1,
    "r": [0, 0, -0.52],
    "c": "#f000ff",
    "e": "#f000ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [55, 50, -833],
    "s": [3, 1, 4],
    "l": 1,
    "r": [0, 0, -0.52],
    "c": "#f000ff",
    "e": "#f000ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [56, 52, -833],
    "s": [3, 1, 4],
    "l": 1,
    "r": [0, 0, -0.52],
    "c": "#f000ff",
    "e": "#f000ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [78, 44, -833],
    "s": [17, 3, 4],
    "l": 1,
    "c": "#f000ff",
    "e": "#f000ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [98, 48, -833],
    "s": [17, 3, 4],
    "l": 1,
    "c": "#f000ff",
    "e": "#f000ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [98, 40, -833],
    "s": [17, 3, 4],
    "l": 1,
    "c": "#f000ff",
    "e": "#f000ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [105, 39, -833],
    "s": [3, 12, 4],
    "l": 1,
    "c": "#f000ff",
    "e": "#f000ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [121, 44, -833],
    "s": [17, 3, 4],
    "l": 1,
    "r": [0, 0, 0.52],
    "c": "#f000ff",
    "e": "#f000ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [118, 49, -833],
    "s": [3, 1, 4],
    "l": 1,
    "r": [0, 0, -0.52],
    "c": "#f000ff",
    "e": "#f000ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [86, 31, -836],
    "s": [107, 30, 4],
    "l": 1,
    "c": "#0012ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [48, 24, -842],
    "s": [5, 40, 5],
    "l": 1,
    "c": "#575757",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [125, 24, -842],
    "s": [5, 40, 5],
    "l": 1,
    "c": "#575757",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-1206, 106, 376],
    "s": [105, 498, 103],
    "l": 1,
    "c": "#b6b6b6",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-1206, 600, 376],
    "s": [5, 92, 6],
    "l": 1,
    "c": "#b6b6b6",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-63, 206, 304],
    "s": [3, 4, 3],
    "l": 1,
    "c": "#000000",
    "e": "#ff0000",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [263, 152, 144],
    "s": [3, 4, 3],
    "l": 1,
    "c": "#000000",
    "e": "#ff0000",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [92, 22, 318],
    "s": [41, 142, 1],
    "l": 1,
    "c": "#d200ff",
    "e": "#d200ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-830, 60, 120],
    "s": [191, 2, 121],
    "l": 1,
    "c": "#707070",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [87, 23, -895],
    "s": [161, 2, 144],
    "l": 1,
    "c": "#5a5a5a",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-360, 18, -711],
    "s": [4, 16, 4],
    "l": 1,
    "c": "#00ff2d",
    "e": "#00ff2d",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-360, 24, -711],
    "s": [16, 4, 4],
    "l": 1,
    "c": "#00ff2d",
    "e": "#00ff2d",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-360, 17, -711],
    "s": [7, 18, 1],
    "l": 1,
    "c": "#252a26",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-360, 23, -711],
    "s": [18, 6, 1],
    "l": 1,
    "c": "#252a26",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-373, 25, -711],
    "s": [8, 2, 1],
    "l": 1,
    "c": "#555555",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-592, 362, -1418],
    "s": [6, 163, 5],
    "l": 1,
    "c": "#7d7d7d",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-592, 526, -1418],
    "s": [6, 6, 5],
    "l": 1,
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-496, 210, 789],
    "s": [5, 204, 3],
    "l": 1,
    "c": "#b6b6b6",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [276, 129, -739],
    "s": [151, 3, 148],
    "l": 1,
    "c": "#898989",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [202, 58, -739],
    "s": [3, 56, 128],
    "l": 1,
    "c": "#434343",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [201, 55, -739],
    "s": [5, 3, 132],
    "l": 1,
    "c": "#575656",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-700, 76, -818],
    "s": [149, 3, 146],
    "l": 1,
    "c": "#787272",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-633, 183, -887],
    "s": [153, 3, 151],
    "l": 1,
    "c": "#8c8c8c",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-1275, 282, -1165],
    "s": [4, 169, 4],
    "l": 1,
    "c": "#b6b6b6",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-447, -24, -704],
    "s": [123, 53, 2],
    "l": 1,
    "c": "#505050",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-447, -26, -703],
    "s": [127, 2, 4],
    "l": 1,
    "c": "#525252",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-405, -28, -987],
    "s": [162, 4, 143],
    "l": 1,
    "c": "#7d7d7d",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-373, -9, -711],
    "s": [8, 3, 2],
    "l": 1,
    "c": "#555555",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-359, -53, -711],
    "s": [19, 61, 2],
    "l": 1,
    "c": "#555555",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-373, -35, -711],
    "s": [8, 3, 2],
    "l": 1,
    "c": "#555555",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-359, -56, -711],
    "s": [24, 66, 1],
    "l": 1,
    "c": "#00b3ff",
    "e": "#00b3ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [282, 98, -148],
    "s": [3, 55, 120],
    "l": 1,
    "c": "#3e3e3e",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [282, 98, -148],
    "s": [7, 2, 124],
    "l": 1,
    "c": "#525252",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-1, 87, 295],
    "s": [121, 57, 3],
    "l": 1,
    "c": "#393939",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-1, 86, 294],
    "s": [126, 2, 6],
    "l": 1,
    "c": "#555555",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [248, -80, 96],
    "s": [3, 112, 31],
    "l": 1,
    "c": "#000337",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [248, -83, 96],
    "s": [1, 117, 35],
    "l": 1,
    "c": "#00b3ff",
    "e": "#00b3ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [250, 6, 116],
    "s": [3, 5, 10],
    "l": 1,
    "c": "#181717",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [250, -61, 116],
    "s": [3, 5, 10],
    "l": 1,
    "c": "#181717",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [261, -53, -139],
    "s": [2, 27, 11],
    "c": "#001100",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [261, -50, -139],
    "s": [3, 1, 7],
    "c": "#0eff00",
    "e": "#0eff00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [261, -50, -136],
    "s": [3, 8, 1],
    "c": "#0eff00",
    "e": "#0eff00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [261, -43, -138],
    "s": [3, 1, 7],
    "r": [0.17, 0, 0],
    "c": "#0eff00",
    "e": "#0eff00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [261, -31, -138],
    "s": [3, 1, 7],
    "r": [0.35, 0, 0],
    "c": "#0eff00",
    "e": "#0eff00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [261, -34, -137],
    "s": [3, 1, 6],
    "r": [1.58, 0, 0],
    "c": "#0eff00",
    "e": "#0eff00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [261, -49, -129],
    "s": [1, 2, 10],
    "c": "#555555",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [261, -33, -129],
    "s": [1, 2, 10],
    "c": "#555555",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [261, -34, -142],
    "s": [3, 1, 6],
    "r": [1.58, 0, 0],
    "c": "#0eff00",
    "e": "#0eff00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [261, -54, -145],
    "s": [3, 29, 1],
    "c": "#0eff00",
    "e": "#0eff00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [261, -54, -133],
    "s": [3, 29, 1],
    "c": "#0eff00",
    "e": "#0eff00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [261, -26, -139],
    "s": [3, 1, 11],
    "c": "#0eff00",
    "e": "#0eff00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [261, -54, -139],
    "s": [3, 1, 11],
    "c": "#0eff00",
    "e": "#0eff00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [211, 132, -672],
    "s": [2, 64, 2],
    "l": 1,
    "c": "#ffffff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [211, 195, -672],
    "s": [3, 4, 3],
    "l": 1,
    "c": "#000000",
    "e": "#ff0000",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-74, -2, 229],
    "s": [23, 20, 22],
    "l": 1,
    "c": "#acacac",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-74, 18, 229],
    "s": [25, 1, 24],
    "l": 1,
    "c": "#666666",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [237, -53, -643],
    "s": [3, 164, 35],
    "l": 1,
    "c": "#181717",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [239, 78, -665],
    "s": [3, 6, 9],
    "l": 1,
    "c": "#343434",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [239, -18, -665],
    "s": [3, 6, 9],
    "l": 1,
    "c": "#343434",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [237, -58, -643],
    "s": [1, 173, 41],
    "l": 1,
    "c": "#bf00ff",
    "e": "#bf00ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-633, 111, -815],
    "s": [131, 59, 2],
    "l": 1,
    "c": "#413f3f",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-633, 109, -815],
    "s": [134, 2, 6],
    "l": 1,
    "c": "#555555",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [282, 89, 158],
    "s": [27, 14, 22],
    "l": 1,
    "c": "#acacac",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-1, 116, 293],
    "s": [118, 0, 53],
    "i": 11,
    "l": 1,
    "r": [1.57, 0, -3.14],
    "bb": 4
  }, {
    "p": [-154, 33, 219],
    "s": [110, 0, 49],
    "i": 11,
    "l": 1,
    "r": [1.57, 0, -3.14],
    "bb": 1
  }, {
    "p": [280, 126, -147],
    "s": [117, 0, 50],
    "i": 11,
    "l": 1,
    "r": [1.57, 0, 1.57],
    "bb": 3
  }, {
    "p": [200, 85, -739],
    "s": [126, 0, 56],
    "i": 11,
    "l": 1,
    "r": [1.57, 0, 1.57],
    "bb": 2
  }, {
    "p": [-447, 2, -702],
    "s": [120, 0, 50],
    "i": 11,
    "l": 1,
    "r": [1.57, 0, 0],
    "bb": 2
  }, {
    "p": [-633, 140, -813],
    "s": [127, 0, 55],
    "i": 11,
    "l": 1,
    "r": [1.57, 0, 0],
    "bb": 1
  }, {
    "p": [-674, -66, -721],
    "s": [3, 142, 35],
    "l": 1,
    "c": "#000000",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-674, 42, -743],
    "s": [3, 6, 9],
    "l": 1,
    "c": "#343434",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-674, -54, -743],
    "s": [3, 6, 9],
    "l": 1,
    "c": "#343434",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-674, -71, -721],
    "s": [1, 150, 39],
    "l": 1,
    "c": "#00ff2d",
    "e": "#00ff2d",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [6, -4, -834],
    "s": [8, 3, 2],
    "l": 1,
    "c": "#555555",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-7, -48, -834],
    "s": [19, 61, 2],
    "l": 1,
    "c": "#555555",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [7, -30, -834],
    "s": [8, 3, 2],
    "l": 1,
    "c": "#555555",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-7, -51, -834],
    "s": [22, 66, 1],
    "l": 1,
    "c": "#00b3ff",
    "e": "#00b3ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [16, 44, -860],
    "s": [4, 3, 17],
    "l": 1,
    "r": [-0.52, 0, -1.57],
    "c": "#f000ff",
    "e": "#f000ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [18, 46, -854],
    "s": [4, 9, 3],
    "l": 1,
    "r": [-0.52, 0, -3.14],
    "c": "#f000ff",
    "e": "#f000ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [19, 50, -859],
    "s": [4, 1, 3],
    "l": 1,
    "r": [-0.52, -0.05, 0.08],
    "c": "#f000ff",
    "e": "#f000ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [17, 44, -879],
    "s": [4, 3, 17],
    "l": 1,
    "c": "#f000ff",
    "e": "#f000ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [17, 48, -903],
    "s": [4, 3, 17],
    "l": 1,
    "c": "#f000ff",
    "e": "#f000ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [17, 40, -903],
    "s": [4, 3, 17],
    "l": 1,
    "c": "#f000ff",
    "e": "#f000ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [17, 39, -910],
    "s": [4, 12, 3],
    "l": 1,
    "c": "#f000ff",
    "e": "#f000ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [17, 44, -926],
    "s": [4, 3, 17],
    "l": 1,
    "r": [-0.44, 0, -1.57],
    "c": "#f000ff",
    "e": "#f000ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [19, 51, -925],
    "s": [4, 1, 3],
    "l": 1,
    "r": [0, 0, -3.14],
    "c": "#f000ff",
    "e": "#f000ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [20, 31, -891],
    "s": [4, 30, 107],
    "l": 1,
    "c": "#0012ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [26, 24, -853],
    "s": [5, 40, 5],
    "l": 1,
    "c": "#575757",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [26, 24, -930],
    "s": [5, 40, 5],
    "l": 1,
    "c": "#575757",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [19, 53, -860],
    "s": [4, 1, 3],
    "l": 1,
    "r": [-0.52, -0.05, 0.08],
    "c": "#f000ff",
    "e": "#f000ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-1275, 451, -1165],
    "s": [6, 8, 6],
    "l": 1,
    "c": "#fc0000",
    "e": "#ff0000",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-496, 413, 789],
    "s": [6, 6, 5],
    "l": 1,
    "c": "#056100",
    "e": "#056100",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-449, -905, 1613],
    "s": [209, 1548, 142],
    "l": 1,
    "c": "#b6b6b6",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [1746, -905, 2165],
    "s": [209, 1714, 142],
    "l": 1,
    "c": "#b6b6b6",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [484, 57, -475],
    "s": [217, 4, 220],
    "l": 1,
    "c": "#a0a0a0",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [237, -25, 190],
    "s": [3, 54, 121],
    "l": 1,
    "c": "#434343",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [235, 2, 191],
    "s": [115, 0, 50],
    "i": 11,
    "l": 1,
    "r": [1.57, 0, 1.57],
    "bb": 1
  }, {
    "p": [242, 55, 160],
    "s": [17, 3, 4],
    "l": 1,
    "r": [-0.43, -1.57, 0],
    "c": "#f000ff",
    "e": "#f000ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [242, 54, 153],
    "s": [3, 9, 4],
    "l": 1,
    "r": [-0.43, -1.57, 0],
    "c": "#f000ff",
    "e": "#f000ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [242, 60, 159],
    "s": [3, 1, 4],
    "l": 1,
    "r": [-0.43, -1.57, 0],
    "c": "#f000ff",
    "e": "#f000ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [242, 57, 182],
    "s": [13, 3, 4],
    "l": 1,
    "r": [0, -1.57, 0],
    "c": "#f000ff",
    "e": "#f000ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [242, 61, 205],
    "s": [17, 3, 4],
    "l": 1,
    "r": [0, -1.57, 0],
    "c": "#f000ff",
    "e": "#f000ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [242, 53, 205],
    "s": [17, 3, 4],
    "l": 1,
    "r": [0, -1.57, 0],
    "c": "#f000ff",
    "e": "#f000ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [242, 52, 212],
    "s": [3, 12, 4],
    "l": 1,
    "r": [0, -1.57, 0],
    "c": "#f000ff",
    "e": "#f000ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [242, 55, 231],
    "s": [17, 3, 4],
    "l": 1,
    "r": [-0.61, -1.57, 0],
    "c": "#f000ff",
    "e": "#f000ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [242, 62, 227],
    "s": [3, 2, 4],
    "l": 1,
    "r": [1.57, -1.48, 1.57],
    "c": "#f000ff",
    "e": "#f000ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [245, 44, 193],
    "s": [107, 30, 4],
    "l": 1,
    "r": [0, -1.57, 0],
    "c": "#0012ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [251, 37, 155],
    "s": [5, 40, 5],
    "l": 1,
    "r": [0, -1.57, 0],
    "c": "#575757",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [251, 37, 232],
    "s": [5, 40, 5],
    "l": 1,
    "r": [0, -1.57, 0],
    "c": "#575757",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [242, 62, 157],
    "s": [3, 1, 4],
    "l": 1,
    "r": [-0.43, -1.57, 0],
    "c": "#f000ff",
    "e": "#f000ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-32, -708, -1854],
    "s": [158, 1320, 139],
    "l": 1,
    "c": "#7d7d7d",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [154, 78, -877],
    "s": [129, 55, 2],
    "l": 1,
    "c": "#323232",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [154, 105, -875],
    "s": [130, 0, 53],
    "i": 11,
    "l": 1,
    "r": [1.57, 0, 0],
    "bb": 4
  }, {
    "p": [290, 171, -207],
    "s": [4, 39, 9],
    "l": 1,
    "c": "#ff003b",
    "e": "#ff003b",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [290, 171, -191],
    "s": [4, 39, 9],
    "l": 1,
    "c": "#ff003b",
    "e": "#ff003b",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [290, 180, -177],
    "s": [4, 21, 10],
    "l": 1,
    "c": "#ff003b",
    "e": "#ff003b",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [290, 201, -143],
    "s": [4, 9, 24],
    "l": 1,
    "c": "#ff003b",
    "e": "#ff003b",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [290, 171, -88],
    "s": [4, 9, 24],
    "l": 1,
    "c": "#ff003b",
    "e": "#ff003b",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [290, 186, -116],
    "s": [4, 9, 24],
    "l": 1,
    "c": "#ff003b",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [290, 187, -199],
    "s": [4, 8, 7],
    "l": 1,
    "c": "#ff003b",
    "e": "#ff003b",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [290, 171, -170],
    "s": [4, 9, 24],
    "l": 1,
    "c": "#ff003b",
    "e": "#ff003b",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [290, 201, -170],
    "s": [4, 9, 24],
    "l": 1,
    "c": "#ff003b",
    "e": "#ff003b",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [290, 180, -163],
    "s": [4, 21, 10],
    "l": 1,
    "c": "#ff003b",
    "e": "#ff003b",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [290, 171, -143],
    "s": [4, 30, 9],
    "l": 1,
    "c": "#ff003b",
    "e": "#ff003b",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [290, 171, -96],
    "s": [4, 39, 8],
    "l": 1,
    "c": "#ff003b",
    "e": "#ff003b",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [290, 171, -116],
    "s": [4, 9, 24],
    "l": 1,
    "c": "#ff003b",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [290, 201, -116],
    "s": [4, 9, 24],
    "l": 1,
    "c": "#ff003b",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [290, 179, -124],
    "s": [4, 22, 8],
    "l": 1,
    "c": "#ff003b",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [282, 53, -148],
    "s": [3, 33, 123],
    "l": 1,
    "c": "#282828",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [282, 6, -148],
    "s": [3, 33, 123],
    "l": 1,
    "c": "#282828",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-1, 41, 296],
    "s": [114, 36, 2],
    "l": 1,
    "c": "#282828",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [282, -40, -148],
    "s": [3, 33, 123],
    "l": 1,
    "c": "#282828",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [282, -87, -148],
    "s": [3, 33, 123],
    "l": 1,
    "c": "#282828",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [282, -133, -148],
    "s": [3, 33, 123],
    "l": 1,
    "c": "#282828",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [282, -177, -148],
    "s": [3, 33, 123],
    "l": 1,
    "c": "#282828",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [282, -223, -148],
    "s": [3, 33, 123],
    "l": 1,
    "c": "#282828",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [282, -269, -148],
    "s": [3, 33, 123],
    "l": 1,
    "c": "#282828",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-1, -4, 296],
    "s": [114, 36, 2],
    "l": 1,
    "c": "#f5e14c",
    "e": "#f5e14c",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-1, -50, 296],
    "s": [114, 36, 2],
    "l": 1,
    "c": "#282828",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-1, -97, 296],
    "s": [114, 36, 2],
    "l": 1,
    "c": "#282828",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-1, -145, 296],
    "s": [114, 36, 2],
    "l": 1,
    "c": "#f5e14c",
    "e": "#f5e14c",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-1, -193, 296],
    "s": [114, 36, 2],
    "l": 1,
    "c": "#282828",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-1, -241, 296],
    "s": [114, 36, 2],
    "l": 1,
    "c": "#282828",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-1, -289, 296],
    "s": [114, 36, 2],
    "l": 1,
    "c": "#282828",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [238, -68, 192],
    "s": [3, 33, 119],
    "l": 1,
    "c": "#282828",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [238, -111, 192],
    "s": [3, 33, 119],
    "l": 1,
    "c": "#282828",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [238, -154, 192],
    "s": [3, 33, 119],
    "l": 1,
    "c": "#f5e14c",
    "e": "#f5e14c",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [238, -197, 192],
    "s": [3, 33, 119],
    "l": 1,
    "c": "#282828",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [238, -240, 192],
    "s": [3, 33, 119],
    "l": 1,
    "c": "#282828",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [238, -282, 192],
    "s": [3, 33, 119],
    "l": 1,
    "c": "#282828",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [238, -324, 192],
    "s": [3, 33, 119],
    "l": 1,
    "c": "#282828",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [238, -276, -54],
    "s": [3, 59, 119],
    "l": 1,
    "c": "#b6b6b6",
    "t": 3,
    "ts": 0,
    "td": 0
  }, {
    "p": [282, -312, -148],
    "s": [3, 33, 123],
    "l": 1,
    "c": "#282828",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-448, -71, -705],
    "s": [122, 36, 2],
    "l": 1,
    "c": "#282828",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-448, -116, -705],
    "s": [122, 36, 2],
    "l": 1,
    "c": "#282828",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-448, -162, -705],
    "s": [122, 36, 2],
    "l": 1,
    "c": "#f5e14c",
    "e": "#f5e14c",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-448, -209, -705],
    "s": [122, 36, 2],
    "l": 1,
    "c": "#282828",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-448, -256, -705],
    "s": [122, 36, 2],
    "l": 1,
    "c": "#282828",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-448, -304, -705],
    "s": [122, 36, 2],
    "l": 1,
    "c": "#282828",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-448, -351, -705],
    "s": [122, 36, 2],
    "l": 1,
    "c": "#282828",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-110, 31, -972],
    "s": [137, 46, 2],
    "l": 1,
    "c": "#282828",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-110, -26, -972],
    "s": [137, 46, 2],
    "l": 1,
    "c": "#282828",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-110, -84, -972],
    "s": [137, 46, 2],
    "l": 1,
    "c": "#282828",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-110, -141, -972],
    "s": [137, 46, 2],
    "l": 1,
    "c": "#f5e14c",
    "e": "#f5e14c",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-110, -198, -972],
    "s": [137, 46, 2],
    "l": 1,
    "c": "#282828",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-110, -256, -972],
    "s": [137, 46, 2],
    "l": 1,
    "c": "#282828",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-110, -314, -972],
    "s": [137, 46, 2],
    "l": 1,
    "c": "#282828",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-110, -373, -972],
    "s": [137, 46, 2],
    "l": 1,
    "c": "#282828",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-110, -430, -972],
    "s": [137, 46, 2],
    "l": 1,
    "c": "#282828",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-110, -486, -972],
    "s": [137, 46, 2],
    "l": 1,
    "c": "#282828",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [203, 0, -738],
    "s": [3, 46, 121],
    "l": 1,
    "c": "#282828",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [203, -56, -738],
    "s": [3, 46, 121],
    "l": 1,
    "c": "#f5e14c",
    "e": "#f5e14c",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [203, -114, -738],
    "s": [3, 46, 121],
    "l": 1,
    "c": "#282828",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [203, -174, -738],
    "s": [3, 46, 121],
    "l": 1,
    "c": "#282828",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [203, -234, -738],
    "s": [3, 46, 121],
    "l": 1,
    "c": "#282828",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [156, 142, -877],
    "s": [122, 42, 3],
    "l": 1,
    "c": "#282828",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [156, 192, -877],
    "s": [122, 42, 3],
    "l": 1,
    "c": "#282828",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [156, 243, -877],
    "s": [122, 42, 3],
    "l": 1,
    "c": "#f5e14c",
    "e": "#f5e14c",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [613, 221, 217],
    "s": [7, 118, 4],
    "l": 1,
    "c": "#aaaaaa",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-215, -88, -985],
    "s": [3, 164, 35],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#181717",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-193, -48, -985],
    "s": [3, 6, 9],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#343434",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-193, 42, -985],
    "s": [3, 6, 9],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#343434",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-215, -91, -985],
    "s": [1, 170, 40],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#f000ff",
    "e": "#f000ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-170, 88, -986],
    "s": [4, 39, 9],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#fffb00",
    "e": "#fffb00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-154, 88, -986],
    "s": [4, 39, 9],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#fffb00",
    "e": "#fffb00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-106, 118, -986],
    "s": [4, 9, 24],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#fffb00",
    "e": "#fffb00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-51, 88, -986],
    "s": [4, 9, 24],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#fffb00",
    "e": "#fffb00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-79, 103, -986],
    "s": [4, 9, 24],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#fffb00",
    "e": "#fffb00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-162, 104, -986],
    "s": [4, 8, 7],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#fffb00",
    "e": "#fffb00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-133, 88, -986],
    "s": [4, 9, 24],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#fffb00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-133, 118, -986],
    "s": [4, 9, 24],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#fffb00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-126, 97, -986],
    "s": [4, 21, 10],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#fffb00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-106, 88, -986],
    "s": [4, 30, 9],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#fffb00",
    "e": "#fffb00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-59, 88, -986],
    "s": [4, 39, 8],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#fffb00",
    "e": "#fffb00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-79, 88, -986],
    "s": [4, 9, 24],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#fffb00",
    "e": "#fffb00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-79, 118, -986],
    "s": [4, 9, 24],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#fffb00",
    "e": "#fffb00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-87, 96, -986],
    "s": [4, 22, 8],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#fffb00",
    "e": "#fffb00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-140, 97, -986],
    "s": [4, 21, 10],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#fffb00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [86, -31, -825],
    "s": [137, 46, 2],
    "l": 1,
    "c": "#282828",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [86, -86, -825],
    "s": [137, 46, 2],
    "l": 1,
    "c": "#282828",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [86, -142, -825],
    "s": [137, 46, 2],
    "l": 1,
    "c": "#f5e14c",
    "e": "#f5e14c",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [86, -199, -825],
    "s": [137, 46, 2],
    "l": 1,
    "c": "#282828",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [86, -257, -825],
    "s": [137, 46, 2],
    "l": 1,
    "c": "#282828",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [62, 74, -1031],
    "s": [2, 64, 2],
    "l": 1,
    "c": "#ffffff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [432, -644, -454],
    "s": [59, 688, 173],
    "l": 1,
    "c": "#f2f2f2",
    "t": 3,
    "ts": 0,
    "td": 0
  }, {
    "p": [479, 37, 22],
    "s": [3, 41, 121],
    "l": 1,
    "c": "#282828",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [479, -12, 22],
    "s": [3, 41, 121],
    "l": 1,
    "c": "#f5e14c",
    "e": "#f5e14c",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [479, -62, 22],
    "s": [3, 41, 121],
    "l": 1,
    "c": "#282828",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [479, -113, 22],
    "s": [3, 41, 121],
    "l": 1,
    "c": "#282828",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [426, -278, 74],
    "s": [3, 59, 121],
    "l": 1,
    "c": "#b6b6b6",
    "t": 3,
    "ts": 0,
    "td": 0
  }, {
    "p": [-376, -8, -778],
    "s": [4, 37, 121],
    "l": 1,
    "c": "#282828",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-376, -56, -778],
    "s": [4, 37, 121],
    "l": 1,
    "c": "#282828",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-376, -103, -778],
    "s": [4, 37, 121],
    "l": 1,
    "c": "#282828",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-376, -151, -778],
    "s": [4, 37, 121],
    "l": 1,
    "c": "#282828",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-376, -199, -778],
    "s": [4, 37, 121],
    "l": 1,
    "c": "#282828",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-376, -247, -778],
    "s": [4, 37, 121],
    "l": 1,
    "c": "#282828",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-376, -294, -778],
    "s": [4, 37, 121],
    "l": 1,
    "c": "#282828",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-795, 25, 373],
    "s": [3, 67, 124],
    "l": 1,
    "c": "#282828",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [246, 10, 96],
    "s": [2, 3, 18],
    "l": 1,
    "c": "#ff0086",
    "e": "#ff0086",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [246, -2, 96],
    "s": [2, 3, 18],
    "l": 1,
    "c": "#ff0086",
    "e": "#ff0086",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [246, -18, 97],
    "s": [2, 3, 18],
    "l": 1,
    "r": [-0.17, 0, 0],
    "c": "#ff0086",
    "e": "#ff0086",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [246, -8, 100],
    "s": [2, 3, 20],
    "l": 1,
    "r": [1.57, 0, 0],
    "c": "#ff0086",
    "e": "#ff0086",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [246, 18, 96],
    "s": [2, 2, 8],
    "l": 1,
    "c": "#ff0086",
    "e": "#ff0086",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [246, -39, 96],
    "s": [2, 3, 18],
    "l": 1,
    "r": [-0.52, 0, 0],
    "c": "#ff0086",
    "e": "#ff0086",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [246, -30, 95],
    "s": [2, 2, 8],
    "l": 1,
    "c": "#ff0086",
    "e": "#ff0086",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [246, -40, 101],
    "s": [2, 3, 14],
    "l": 1,
    "r": [1.57, 0, 0],
    "c": "#ff0086",
    "e": "#ff0086",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [246, -58, 96],
    "s": [2, 3, 18],
    "l": 1,
    "c": "#ff0086",
    "e": "#ff0086",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [246, -69, 101],
    "s": [2, 7, 3],
    "l": 1,
    "r": [0.17, 0, 0],
    "c": "#ff0086",
    "e": "#ff0086",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-674, 41, -728],
    "s": [4, 18, 2],
    "l": 1,
    "c": "#feff00",
    "e": "#feff00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-674, 41, -714],
    "s": [4, 18, 2],
    "l": 1,
    "c": "#feff00",
    "e": "#feff00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-674, 41, -721],
    "s": [4, 2, 16],
    "l": 1,
    "c": "#feff00",
    "e": "#feff00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-674, 46, -723],
    "s": [4, 11, 1],
    "l": 1,
    "c": "#feff00",
    "e": "#feff00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-674, 46, -719],
    "s": [4, 11, 1],
    "l": 1,
    "c": "#feff00",
    "e": "#feff00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-674, 56, -715],
    "s": [5, 3, 5],
    "l": 1,
    "c": "#ffffff",
    "e": "#ffffff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-674, 59, -721],
    "s": [5, 3, 17],
    "l": 1,
    "c": "#ffffff",
    "e": "#ffffff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-674, 62, -721],
    "s": [5, 3, 13],
    "l": 1,
    "c": "#ffffff",
    "e": "#ffffff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-674, 46, -733],
    "s": [4, 10, 2],
    "l": 1,
    "c": "#feff00",
    "e": "#feff00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-674, 46, -730],
    "s": [4, 2, 4],
    "l": 1,
    "c": "#feff00",
    "e": "#feff00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-674, 54, -730],
    "s": [4, 2, 4],
    "l": 1,
    "c": "#feff00",
    "e": "#feff00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-674, 19, -714],
    "s": [4, 3, 21],
    "l": 1,
    "r": [1.57, 0, 0],
    "c": "#feff00",
    "e": "#feff00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-674, 11, -722],
    "s": [4, 3, 16],
    "l": 1,
    "r": [3.14, 0, 0],
    "c": "#feff00",
    "e": "#feff00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-674, 21, -718],
    "s": [4, 3, 9],
    "l": 1,
    "r": [-2.97, 0, 0],
    "c": "#feff00",
    "e": "#feff00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-674, 25, -727],
    "s": [4, 2, 4],
    "l": 1,
    "r": [2.09, 0, 0],
    "c": "#feff00",
    "e": "#feff00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-674, 27, -730],
    "s": [4, 2, 4],
    "l": 1,
    "r": [2.09, 0, 0],
    "c": "#feff00",
    "e": "#feff00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-674, -8, -721],
    "s": [4, 4, 21],
    "l": 1,
    "r": [3.14, 0, 0],
    "c": "#feff00",
    "e": "#feff00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-674, -38, -716],
    "s": [4, 3, 21],
    "l": 1,
    "r": [1.4, 0, 0],
    "c": "#feff00",
    "e": "#feff00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-674, -38, -725],
    "s": [4, 3, 22],
    "l": 1,
    "r": [1.57, 0, 0],
    "c": "#feff00",
    "e": "#feff00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-674, -44, -728],
    "s": [4, 3, 11],
    "l": 1,
    "r": [-2.79, 0, 0],
    "c": "#feff00",
    "e": "#feff00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-359, -1, -711],
    "s": [6, 1, 3],
    "l": 1,
    "c": "#fff000",
    "e": "#fff000",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-360, -6, -711],
    "s": [10, 2, 3],
    "l": 1,
    "r": [0, 0, 0.35],
    "c": "#fff000",
    "e": "#fff000",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-354, -6, -711],
    "s": [7, 2, 3],
    "l": 1,
    "r": [0, 0, 1.92],
    "c": "#fff000",
    "e": "#fff000",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-358, -20, -711],
    "s": [12, 2, 3],
    "l": 1,
    "r": [0, 0, 1.57],
    "c": "#fff000",
    "e": "#fff000",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-361, -39, -711],
    "s": [12, 2, 3],
    "l": 1,
    "r": [0, 0, 1.57],
    "c": "#fff000",
    "e": "#fff000",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-355, -45, -711],
    "s": [2, 8, 3],
    "l": 1,
    "r": [0, 0, 1.4],
    "c": "#fff000",
    "e": "#fff000",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [216, -2, 258],
    "s": [24, 4, 4],
    "l": 1,
    "r": [0, 0, -0.01],
    "c": "#ffffff",
    "e": "#ffffff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [219, 4, 258],
    "s": [4, 20, 4],
    "l": 1,
    "r": [0, 0, -0.35],
    "c": "#ffe100",
    "e": "#ffe100",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [215, 4, 258],
    "s": [4, 16, 4],
    "l": 1,
    "r": [0, 0, -0.19],
    "c": "#ffe100",
    "e": "#ffe100",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [215, -5, 258],
    "s": [37, 31, 2],
    "l": 1,
    "c": "#e31a1a",
    "e": "#e31a1a",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [215, -8, 258],
    "s": [42, 36, 1],
    "l": 1,
    "c": "#4d4d4d",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [238, 18, 258],
    "s": [3, 4, 4],
    "l": 1,
    "c": "#4d4d4d",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [238, 1, 258],
    "s": [3, 4, 4],
    "l": 1,
    "c": "#4d4d4d",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-399, -613, -917],
    "s": [123, 570, 2],
    "l": 1,
    "c": "#b6b6b6",
    "t": 3,
    "ts": 0,
    "td": 0
  }, {
    "p": [-204, 59, -984],
    "s": [4, 21, 5],
    "l": 1,
    "r": [-1.57, 0, 1.57],
    "c": "#fffb00",
    "e": "#fffb00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-208, 47, -984],
    "s": [4, 3, 9],
    "l": 1,
    "r": [-1.57, 0.7, 1.57],
    "c": "#fffb00",
    "e": "#fffb00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-214, 12, -984],
    "s": [4, 21, 5],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#fffb00",
    "e": "#fffb00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-214, -6, -984],
    "s": [4, 5, 17],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#fffb00",
    "e": "#fffb00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-220, -40, -984],
    "s": [4, 23, 4],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#fffb00",
    "e": "#fffb00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-225, -23, -984],
    "s": [4, 21, 4],
    "l": 1,
    "r": [1.57, 0, -1.57],
    "c": "#fffb00",
    "e": "#fffb00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-216, -30, -984],
    "s": [4, 9, 4],
    "l": 1,
    "r": [1.57, 0, -1.57],
    "c": "#fffb00",
    "e": "#fffb00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-214, -49, -984],
    "s": [4, 5, 22],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#fffb00",
    "e": "#fffb00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-214, -74, -984],
    "s": [4, 13, 5],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#fffb00",
    "e": "#fffb00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-7, 4, -832],
    "s": [11, 3, 2],
    "l": 1,
    "c": "#ff0086",
    "e": "#ff0086",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-7, -1, -832],
    "s": [5, 2, 2],
    "l": 1,
    "c": "#ff0086",
    "e": "#ff0086",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-4, -21, -832],
    "s": [2, 12, 2],
    "l": 1,
    "c": "#ff0086",
    "e": "#ff0086",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-6, -19, -832],
    "s": [9, 2, 2],
    "l": 1,
    "c": "#ff0086",
    "e": "#ff0086",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-6, -13, -832],
    "s": [13, 3, 2],
    "l": 1,
    "c": "#ff0086",
    "e": "#ff0086",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-7, -31, -832],
    "s": [13, 3, 2],
    "l": 1,
    "c": "#ff0086",
    "e": "#ff0086",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-5, -37, -832],
    "s": [5, 2, 2],
    "l": 1,
    "r": [0, 0, 0.7],
    "c": "#ff0086",
    "e": "#ff0086",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-698, -113, -746],
    "s": [118, 0, 55],
    "i": 11,
    "l": 1,
    "r": [1.57, 0, 0],
    "bb": 1
  }, {
    "p": [-699, -753, -747],
    "s": [61, 600, 2],
    "l": 1,
    "c": "#b6b6b6",
    "t": 3,
    "ts": 0,
    "td": 0
  }, {
    "p": [-380, -708, -1581],
    "s": [111, 1315, 102],
    "l": 1,
    "c": "#7d7d7d",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-1491, -708, -1083],
    "s": [111, 1276, 102],
    "l": 1,
    "c": "#7d7d7d",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [295, 51, -240],
    "s": [3, 100, 35],
    "l": 1,
    "c": "#181717",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [297, 117, -218],
    "s": [3, 6, 9],
    "l": 1,
    "c": "#343434",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [297, 81, -218],
    "s": [3, 6, 9],
    "l": 1,
    "c": "#343434",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [295, 48, -240],
    "s": [1, 106, 41],
    "l": 1,
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [295, 137, -241],
    "s": [4, 4, 22],
    "l": 1,
    "c": "#ffe100",
    "e": "#ffe100",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [297, 130, -245],
    "s": [4, 3, 8],
    "l": 1,
    "r": [0.87, 0, 0],
    "c": "#ffe100",
    "e": "#ffe100",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [295, 106, -241],
    "s": [4, 17, 5],
    "l": 1,
    "c": "#ffe100",
    "e": "#ffe100",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [295, 65, -241],
    "s": [4, 4, 20],
    "l": 1,
    "r": [-0.35, 0, 0],
    "c": "#ffe100",
    "e": "#ffe100",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [295, 74, -246],
    "s": [4, 3, 8],
    "l": 1,
    "r": [0.52, 0, 0],
    "c": "#ffe100",
    "e": "#ffe100",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [295, 89, -241],
    "s": [4, 4, 22],
    "l": 1,
    "c": "#ffe100",
    "e": "#ffe100",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [237, 70, -638],
    "s": [4, 20, 5],
    "l": 1,
    "r": [-0.79, 0, 0],
    "c": "#fffb00",
    "e": "#fffb00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [237, 89, -643],
    "s": [4, 5, 23],
    "l": 1,
    "c": "#fffb00",
    "e": "#fffb00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [237, 31, -648],
    "s": [4, 25, 5],
    "l": 1,
    "c": "#fffb00",
    "e": "#fffb00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [237, 44, -636],
    "s": [4, 5, 9],
    "l": 1,
    "r": [-0.17, 0, 0],
    "c": "#fffb00",
    "e": "#fffb00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [237, 4, -653],
    "s": [4, 22, 5],
    "l": 1,
    "r": [0.96, 0, 0],
    "c": "#fffb00",
    "e": "#fffb00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [237, 0, -639],
    "s": [4, 5, 11],
    "l": 1,
    "r": [0.96, 0, 0],
    "c": "#fffb00",
    "e": "#fffb00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [237, -28, -643],
    "s": [4, 5, 23],
    "l": 1,
    "c": "#fffb00",
    "e": "#fffb00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [216, 2, 258],
    "s": [29, 10, 5],
    "l": 1,
    "r": [0, 0, -0.01],
    "c": "#ffffff",
    "e": "#ffffff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [297, 44, -51],
    "s": [3, 129, 35],
    "l": 1,
    "c": "#181717",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [299, 140, -73],
    "s": [3, 6, 9],
    "l": 1,
    "c": "#343434",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [299, 72, -73],
    "s": [3, 6, 9],
    "l": 1,
    "c": "#343434",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [297, 40, -51],
    "s": [1, 136, 41],
    "l": 1,
    "c": "#bf00ff",
    "e": "#bf00ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [297, 132, -46],
    "s": [4, 20, 5],
    "l": 1,
    "r": [-0.79, 0, 0],
    "c": "#fffb00",
    "e": "#fffb00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [297, 151, -51],
    "s": [4, 5, 23],
    "l": 1,
    "c": "#fffb00",
    "e": "#fffb00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [297, 93, -56],
    "s": [4, 25, 5],
    "l": 1,
    "c": "#fffb00",
    "e": "#fffb00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [297, 106, -44],
    "s": [4, 5, 9],
    "l": 1,
    "r": [-0.17, 0, 0],
    "c": "#fffb00",
    "e": "#fffb00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [297, 66, -61],
    "s": [4, 22, 5],
    "l": 1,
    "r": [0.96, 0, 0],
    "c": "#fffb00",
    "e": "#fffb00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [297, 62, -47],
    "s": [4, 5, 11],
    "l": 1,
    "r": [0.96, 0, 0],
    "c": "#fffb00",
    "e": "#fffb00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [192, -59, 446],
    "s": [116, 118, 2],
    "l": 1,
    "c": "#b6b6b6",
    "t": 3,
    "ts": 0,
    "td": 0
  }, {
    "p": [192, -201, 446],
    "s": [116, 118, 2],
    "l": 1,
    "c": "#b6b6b6",
    "t": 3,
    "ts": 0,
    "td": 0
  }, {
    "p": [192, -347, 446],
    "s": [116, 118, 2],
    "l": 1,
    "c": "#b6b6b6",
    "t": 3,
    "ts": 0,
    "td": 0
  }, {
    "p": [426, -182, 74],
    "s": [3, 59, 121],
    "l": 1,
    "c": "#b6b6b6",
    "t": 3,
    "ts": 0,
    "td": 0
  }, {
    "p": [426, -369, 74],
    "s": [3, 59, 121],
    "l": 1,
    "c": "#b6b6b6",
    "t": 3,
    "ts": 0,
    "td": 0
  }, {
    "p": [192, -501, 446],
    "s": [116, 118, 2],
    "l": 1,
    "c": "#b6b6b6",
    "t": 3,
    "ts": 0,
    "td": 0
  }, {
    "p": [-737, -414, 119],
    "s": [3, 448, 57],
    "l": 1,
    "c": "#b6b6b6",
    "t": 3,
    "ts": 0,
    "td": 0
  }, {
    "p": [-795, 122, 373],
    "s": [3, 67, 124],
    "l": 1,
    "c": "#282828",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-795, -75, 373],
    "s": [3, 67, 124],
    "l": 1,
    "c": "#282828",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-795, -176, 373],
    "s": [3, 67, 124],
    "l": 1,
    "c": "#f5e14c",
    "e": "#f5e14c",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-795, -284, 373],
    "s": [3, 67, 124],
    "l": 1,
    "c": "#282828",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [404, -455, -653],
    "s": [3, 651, 59],
    "l": 1,
    "c": "#b6b6b6",
    "t": 3,
    "ts": 0,
    "td": 0
  }, {
    "p": [403, 84, -639],
    "s": [3, 29, 30],
    "l": 1,
    "c": "#f5e14c",
    "e": "#f5e14c",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [403, -95, -666],
    "s": [3, 29, 29],
    "l": 1,
    "c": "#f5e14c",
    "e": "#f5e14c",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [402, -36, -638],
    "s": [1, 29, 29],
    "l": 1,
    "c": "#f5e14c",
    "e": "#f5e14c",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-736, -144, 104],
    "s": [2, 28, 26],
    "l": 1,
    "c": "#f5e14c",
    "e": "#f5e14c",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-220, -709, -1198],
    "s": [61, 839, 2],
    "l": 1,
    "c": "#b6b6b6",
    "t": 3,
    "ts": 0,
    "td": 0
  }, {
    "p": [-234, 70, -1197],
    "s": [28, 29, 3],
    "l": 1,
    "c": "#f5e14c",
    "e": "#f5e14c",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-234, -231, -1197],
    "s": [28, 29, 3],
    "l": 1,
    "c": "#f5e14c",
    "e": "#f5e14c",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [238, -184, -54],
    "s": [3, 59, 119],
    "l": 1,
    "c": "#b6b6b6",
    "t": 3,
    "ts": 0,
    "td": 0
  }, {
    "p": [238, -95, -54],
    "s": [3, 59, 119],
    "l": 1,
    "c": "#b6b6b6",
    "t": 3,
    "ts": 0,
    "td": 0
  }, {
    "p": [-114, -78, 213],
    "s": [163, 58, 2],
    "l": 1,
    "c": "#757575",
    "t": 3,
    "ts": 0,
    "td": 0
  }, {
    "p": [-114, -164, 213],
    "s": [163, 58, 2],
    "l": 1,
    "c": "#757575",
    "t": 3,
    "ts": 0,
    "td": 0
  }, {
    "p": [-114, -253, 213],
    "s": [163, 58, 2],
    "l": 1,
    "c": "#757575",
    "t": 3,
    "ts": 0,
    "td": 0
  }, {
    "p": [-114, -345, 213],
    "s": [163, 58, 2],
    "l": 1,
    "c": "#757575",
    "t": 3,
    "ts": 0,
    "td": 0
  }, {
    "p": [888, -644, -266],
    "s": [173, 781, 178],
    "l": 1,
    "c": "#f2f2f2",
    "t": 3,
    "ts": 0,
    "td": 0
  }, {
    "p": [176, -29, 445],
    "s": [26, 28, 1],
    "l": 1,
    "c": "#f5e14c",
    "e": "#f5e14c",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [147, -286, 445],
    "s": [27, 28, 1],
    "l": 1,
    "c": "#f5e14c",
    "e": "#f5e14c",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [236, 0, 445],
    "s": [26, 28, 1],
    "l": 1,
    "c": "#f5e14c",
    "e": "#f5e14c",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [549, -182, 216],
    "s": [3, 387, 117],
    "l": 1,
    "c": "#b6b6b6",
    "t": 3,
    "ts": 0,
    "td": 0
  }, {
    "p": [466, -646, -444],
    "s": [173, 681, 121],
    "l": 1,
    "c": "#f2f2f2",
    "t": 3,
    "ts": 0,
    "td": 0
  }, {
    "p": [537, -644, -454],
    "s": [59, 688, 173],
    "l": 1,
    "c": "#f2f2f2",
    "t": 3,
    "ts": 0,
    "td": 0
  }, {
    "p": [-376, -346, -778],
    "s": [4, 37, 121],
    "l": 1,
    "c": "#282828",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-70, -78, 212],
    "s": [28, 28, 1],
    "l": 1,
    "c": "#f5e14c",
    "e": "#f5e14c",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-160, -134, 212],
    "s": [28, 28, 1],
    "l": 1,
    "c": "#f5e14c",
    "e": "#f5e14c",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [418, -75, -368],
    "s": [29, 29, 3],
    "l": 1,
    "c": "#f5e14c",
    "e": "#f5e14c",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [549, -194, -368],
    "s": [29, 29, 3],
    "l": 1,
    "c": "#f5e14c",
    "e": "#f5e14c",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [549, -13, -368],
    "s": [29, 29, 3],
    "l": 1,
    "c": "#f5e14c",
    "e": "#f5e14c",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [448, -255, -368],
    "s": [29, 29, 3],
    "l": 1,
    "c": "#f5e14c",
    "e": "#f5e14c",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [380, -107, -399],
    "s": [3, 29, 29],
    "l": 1,
    "c": "#f5e14c",
    "e": "#f5e14c",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [380, -227, -457],
    "s": [3, 29, 29],
    "l": 1,
    "c": "#f5e14c",
    "e": "#f5e14c",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [380, -77, -488],
    "s": [3, 29, 29],
    "l": 1,
    "c": "#f5e14c",
    "e": "#f5e14c",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-353, -224, -917],
    "s": [28, 29, 3],
    "l": 1,
    "c": "#f5e14c",
    "e": "#f5e14c",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-353, -75, -917],
    "s": [28, 29, 3],
    "l": 1,
    "c": "#f5e14c",
    "e": "#f5e14c",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-385, -613, -987],
    "s": [120, 568, 57],
    "l": 1,
    "c": "#b6b6b6",
    "t": 3,
    "ts": 0,
    "td": 0
  }, {
    "p": [-326, -194, -974],
    "s": [3, 29, 29],
    "l": 1,
    "c": "#f5e14c",
    "e": "#f5e14c",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-683, -272, -746],
    "s": [28, 29, 1],
    "l": 1,
    "c": "#f5e14c",
    "e": "#f5e14c",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-130, -48, 212],
    "s": [28, 28, 1],
    "l": 1,
    "c": "#f5e14c",
    "e": "#f5e14c",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [296, -667, 394],
    "s": [116, 538, 2],
    "l": 1,
    "c": "#b6b6b6",
    "t": 3,
    "ts": 0,
    "td": 0
  }, {
    "p": [252, -188, 393],
    "s": [27, 28, 1],
    "l": 1,
    "c": "#f5e14c",
    "e": "#f5e14c",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [310, -246, 393],
    "s": [27, 28, 1],
    "l": 1,
    "c": "#f5e14c",
    "e": "#f5e14c",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [279, -366, 393],
    "s": [27, 28, 1],
    "l": 1,
    "c": "#f5e14c",
    "e": "#f5e14c",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [424, -340, 30],
    "s": [3, 29, 29],
    "l": 1,
    "c": "#f5e14c",
    "e": "#f5e14c",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [424, -277, 90],
    "s": [3, 29, 29],
    "l": 1,
    "c": "#f5e14c",
    "e": "#f5e14c",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [424, -182, 90],
    "s": [3, 29, 29],
    "l": 1,
    "c": "#f5e14c",
    "e": "#f5e14c",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [237, -95, -9],
    "s": [3, 28, 28],
    "l": 1,
    "c": "#f5e14c",
    "e": "#f5e14c",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [237, -154, -99],
    "s": [3, 28, 28],
    "l": 1,
    "c": "#f5e14c",
    "e": "#f5e14c",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [548, 87, 172],
    "s": [3, 29, 29],
    "l": 1,
    "c": "#f5e14c",
    "e": "#f5e14c",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [548, 149, 172],
    "s": [3, 29, 29],
    "l": 1,
    "c": "#f5e14c",
    "e": "#f5e14c",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [548, 149, 233],
    "s": [3, 29, 29],
    "l": 1,
    "c": "#f5e14c",
    "e": "#f5e14c",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [548, -64, 172],
    "s": [3, 29, 29],
    "l": 1,
    "c": "#f5e14c",
    "e": "#f5e14c",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [86, -318, -825],
    "s": [137, 46, 2],
    "l": 1,
    "c": "#282828",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [86, -385, -825],
    "s": [137, 46, 2],
    "l": 1,
    "c": "#282828",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [203, -301, -738],
    "s": [3, 46, 121],
    "l": 1,
    "c": "#282828",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [403, 145, -666],
    "s": [3, 29, 30],
    "l": 1,
    "c": "#f5e14c",
    "e": "#f5e14c",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-926, -719, -405],
    "s": [3, 781, 116],
    "l": 1,
    "c": "#b6b6b6",
    "t": 3,
    "ts": 0,
    "td": 0
  }, {
    "p": [-150, -629, -287],
    "s": [170, 602, 40],
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-220, -29, -327],
    "s": [52, 2, 40],
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-215, -19, -207],
    "s": [40, 2, 40],
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-140, -629, -237],
    "s": [110, 652, 20],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-105, -15, -205],
    "s": [40, 2, 44],
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-193, -629, -257],
    "s": [4, 612, 20],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-270, -629, -287],
    "s": [50, 659, 40],
    "c": "#585858",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-150, -629, -322],
    "s": [90, 652, 30],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-4, -629, -414],
    "s": [58, 622, 154],
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-110, -27, -272],
    "s": [10, 50, 10],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-190, -27, -272],
    "s": [10, 50, 10],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-190, -29, -304],
    "s": [10, 52, 6],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-110, -29, -304],
    "s": [10, 52, 6],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-70, -27, -272],
    "s": [10, 50, 10],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-149, -27, -272],
    "s": [10, 50, 10],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-149, -29, -304],
    "s": [10, 52, 6],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-115, 22, -302],
    "s": [161, 1, 71],
    "c": "#4a4a4a",
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [-84, -629, -437],
    "s": [102, 622, 107],
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-170, -629, -397],
    "s": [70, 652, 100],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-115, 23, -302],
    "s": [159, 50, 71],
    "c": "#ffffff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-165, 23, -342],
    "s": [60, 50, 10],
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-275, -629, -432],
    "s": [60, 659, 170],
    "c": "#585858",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-165, 22, -342],
    "s": [61, 1, 10],
    "c": "#4a4a4a",
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [-275, 30, -392],
    "s": [61, 1, 251],
    "c": "#4a4a4a",
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [-370, -629, -277],
    "s": [150, 659, 20],
    "c": "#585858",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-300, -20, -297],
    "s": [10, 50, 20],
    "c": "#585858",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-275, 31, -392],
    "s": [60, 95, 250],
    "c": "#ffffff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-165, 71, -342],
    "s": [63, 3, 7],
    "c": "#4a4a4a",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-84, 71, -302],
    "s": [225, 3, 73],
    "c": "#4a4a4a",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-237, -629, -285],
    "s": [4, 613, 36],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-240, -29, -305],
    "s": [10, 13, 4],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-465, -629, -277],
    "s": [40, 602, 20],
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-370, 30, -277],
    "s": [151, 1, 21],
    "c": "#4a4a4a",
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [-375, 31, -277],
    "s": [140, 50, 20],
    "c": "#ffffff",
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [-180, -29, -185],
    "s": [110, 52, 4],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-81, -629, -215],
    "s": [8, 652, 64],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-155, 23, -215],
    "s": [159, 1, 65],
    "c": "#4a4a4a",
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [-202, -629, -85],
    "s": [162, 616, 197],
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-395, -629, -137],
    "s": [200, 602, 220],
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-490, -27, -242],
    "s": [10, 40, 10],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-440, -27, -242],
    "s": [10, 40, 10],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-469, -27, -258],
    "s": [4, 1, 30],
    "l": 1,
    "c": "#ffffff",
    "t": 2,
    "ts": 0,
    "td": 0
  }, {
    "p": [-487, -629, -277],
    "s": [4, 605, 20],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-461, -27, -258],
    "s": [4, 1, 30],
    "l": 1,
    "c": "#ffffff",
    "t": 2,
    "ts": 0,
    "td": 0
  }, {
    "p": [-470, -27, -122],
    "s": [50, 40, 50],
    "c": "#ffffff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-365, -27, -222],
    "s": [140, 40, 50],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-440, -29, -201],
    "s": [10, 50, 10],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-490, -27, -202],
    "s": [10, 40, 10],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-432, -29, -192],
    "s": [10, 50, 10],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-490, -27, -152],
    "s": [10, 40, 10],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-450, -29, -152],
    "s": [10, 50, 10],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-440, -29, -144],
    "s": [10, 50, 10],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-440, -29, -100],
    "s": [10, 50, 10],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-450, -29, -92],
    "s": [10, 50, 10],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-490, -27, -92],
    "s": [10, 40, 10],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-490, -27, -32],
    "s": [10, 40, 10],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-390, -29, -102],
    "s": [10, 50, 10],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-340, -27, -112],
    "s": [90, 40, 169],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-390, -29, -142],
    "s": [10, 50, 10],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-390, -29, -192],
    "s": [10, 50, 10],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-395, 13, -137],
    "s": [200, 124, 220],
    "c": "#ffffff",
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [-260, 23, -225],
    "s": [51, 1, 85],
    "c": "#4a4a4a",
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [-181, -17, -28],
    "s": [122, 18, 110],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-181, -629, -15],
    "s": [80, 629, 80],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-370, -629, -7],
    "s": [150, 602, 40],
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-181, -629, -93],
    "s": [40, 630, 20],
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-221, -13, -93],
    "s": [40, 14, 20],
    "i": 9,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-141, -13, -93],
    "s": [40, 14, 20],
    "i": 9,
    "t": 5,
    "d": 2,
    "ts": 0,
    "td": 0
  }, {
    "p": [-303, -600, 15],
    "s": [144, 588, 4],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-335, -629, -25],
    "s": [80, 619, 4],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-5, -629, -297],
    "s": [60, 622, 80],
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-40, -629, -305],
    "s": [50, 652, 64],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [14, -629, -247],
    "s": [22, 654, 20],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-16, -29, -247],
    "s": [38, 22, 20],
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-12, -7, -332],
    "s": [6, 30, 10],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [22, -7, -332],
    "s": [6, 30, 10],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [22, -7, -302],
    "s": [6, 30, 10],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-5, 22, -287],
    "s": [61, 1, 101],
    "c": "#4a4a4a",
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [-51, 22, -252],
    "s": [31, 1, 31],
    "l": 1,
    "c": "#4a4a4a",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-5, 23, -287],
    "s": [61, 65, 101],
    "c": "#ffffff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-51, 23, -252],
    "s": [31, 48, 31],
    "l": 1,
    "c": "#ffffff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [0, -7, -242],
    "s": [6, 30, 10],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-32, -7, -242],
    "s": [6, 30, 10],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-410, -629, 15],
    "s": [70, 604, 4],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-447, -629, -5],
    "s": [4, 604, 44],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-225, -629, -503],
    "s": [40, 622, 112],
    "c": "#ffffff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-225, -600, -349],
    "s": [40, 584, 4],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-225, -16, -349],
    "s": [40, 1, 4],
    "c": "#4a4a4a",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-237, -16, -285],
    "s": [4, 1, 36],
    "c": "#4a4a4a",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-240, -16, -305],
    "s": [10, 1, 4],
    "c": "#4a4a4a",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-275, -629, -557],
    "s": [60, 638, 4],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-275, 9, -557],
    "s": [60, 1, 4],
    "c": "#4a4a4a",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [25, -629, -118],
    "s": [100, 602, 200],
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-465, -27, -257],
    "s": [4, 1, 30],
    "l": 1,
    "c": "#aaa3a3",
    "t": 2,
    "ts": 0,
    "td": 0
  }, {
    "p": [-18, -7, -226],
    "s": [4, 1, 30],
    "l": 1,
    "r": [0, 0.17, 0],
    "c": "#aaa1a1",
    "t": 2,
    "ts": 0,
    "td": 0
  }, {
    "p": [-10, -7, -228],
    "s": [4, 1, 30],
    "l": 1,
    "r": [0, 0.17, 0],
    "c": "#caaaaa",
    "t": 2,
    "ts": 0,
    "td": 0
  }, {
    "p": [-14, -7, -226],
    "s": [4, 1, 30],
    "l": 1,
    "r": [0, 0.17, 0],
    "c": "#ffffff",
    "t": 2,
    "ts": 0,
    "td": 0
  }, {
    "p": [-170, -629, -467],
    "s": [70, 622, 40],
    "c": "#ffffff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-170, -629, -524],
    "s": [70, 652, 74],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-170, 22, -454],
    "s": [71, 1, 215],
    "c": "#4a4a4a",
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [-170, 23, -454],
    "s": [70, 50, 214],
    "c": "#ffffff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-170, 71, -454],
    "s": [73, 3, 217],
    "c": "#4a4a4a",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-49, -629, -361],
    "s": [32, 636, 48],
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-165, -629, -342],
    "s": [60, 651, 10],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-11, -629, -447],
    "s": [41, 636, 44],
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-55, -7, -489],
    "s": [160, 1, 4],
    "c": "#4a4a4a",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [25, -7, -414],
    "s": [4, 1, 154],
    "c": "#4a4a4a",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-12, -7, -278],
    "s": [6, 30, 10],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-50, -629, -255],
    "s": [30, 652, 36],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [8, 7, -447],
    "s": [4, 1, 46],
    "l": 1,
    "c": "#4a4a4a",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-34, 7, -361],
    "s": [4, 1, 49],
    "l": 1,
    "c": "#4a4a4a",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-106, 7, -361],
    "s": [4, 1, 48],
    "l": 1,
    "c": "#4a4a4a",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-88, -629, -101],
    "s": [66, 616, 164],
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [25, -27, -195],
    "s": [100, 20, 46],
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-40, -629, -138],
    "s": [30, 652, 170],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [80, -629, -167],
    "s": [10, 652, 10],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [30, -7, -213],
    "s": [10, 30, 10],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-20, -27, -167],
    "s": [10, 50, 10],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [26, -27, -167],
    "s": [10, 50, 10],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [55, -629, -223],
    "s": [60, 652, 10],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [55, -27, -167],
    "s": [40, 20, 10],
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [55, -27, -121],
    "s": [40, 20, 82],
    "i": 9,
    "t": 5,
    "d": 3,
    "ts": 0,
    "td": 0
  }, {
    "p": [3, -27, -147],
    "s": [56, 20, 50],
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [26, -7, -127],
    "s": [10, 31, 10],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-20, -7, -127],
    "s": [10, 31, 10],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [33, -27, -126],
    "s": [4, 23, 92],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [80, -629, -127],
    "s": [10, 652, 10],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [77, -629, -101],
    "s": [4, 624, 42],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [77, -629, -147],
    "s": [4, 624, 30],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-20, -27, -58],
    "s": [10, 50, 10],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-289, 23, -103],
    "s": [13, 1, 160],
    "c": "#4a4a4a",
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [-181, 2, -21],
    "s": [30, 1, 4],
    "c": "#282828",
    "e": "#ffffff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-164, 2, -21],
    "s": [4, 1, 68],
    "c": "#282828",
    "e": "#ffffff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-198, 2, -21],
    "s": [4, 1, 68],
    "c": "#282828",
    "e": "#ffffff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-141, 1, -28],
    "s": [42, 2, 110],
    "c": "#282828",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-181, 1, -69],
    "s": [38, 2, 28],
    "c": "#282828",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-181, 2, -39],
    "s": [30, 1, 32],
    "c": "#282828",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-181, 2, -3],
    "s": [30, 1, 32],
    "c": "#282828",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-150, -14, 27],
    "s": [2, 17, 4],
    "i": 3,
    "c": "#ab1212",
    "t": 5,
    "d": 1
  }, {
    "p": [15, -629, -14],
    "s": [140, 652, 10],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-88, -629, -17],
    "s": [66, 618, 4],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-181, -17, 31],
    "s": [155, 1, 24],
    "t": 12,
    "ts": 0,
    "td": 0
  }, {
    "p": [-181, -17, 44],
    "s": [154, 2, 2],
    "c": "#464646",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-120, -17, 15],
    "s": [2, 2, 56],
    "c": "#464646",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-180, -17, 26],
    "s": [2, 2, 34],
    "c": "#464646",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-113, -17, 0],
    "s": [19, 1, 34],
    "t": 12,
    "ts": 0,
    "td": 0
  }, {
    "p": [-113, -17, -14],
    "s": [18, 2, 2],
    "c": "#464646",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-113, -16, 2],
    "s": [19, 1, 30],
    "v": 1,
    "t": 12,
    "ts": 0,
    "td": 0
  }, {
    "p": [-14, -8, -227],
    "s": [17, 1, 20],
    "v": 1,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [15, 23, -118],
    "s": [141, 2, 221],
    "c": "#4a4a4a",
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [15, 25, -118],
    "s": [140, 75, 219],
    "c": "#ffffff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-180, 24, -215],
    "s": [208, 161, 64],
    "c": "#ffffff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-180, -7, -175],
    "s": [110, 192, 16],
    "c": "#ffffff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-180, 25, -167],
    "s": [93, 150, 1],
    "c": "#5f5f5f",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-180, 25, -166],
    "s": [10, 160, 2],
    "c": "#ffffff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-155, 25, -166],
    "s": [40, 10, 2],
    "c": "#ffffff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-205, 25, -166],
    "s": [40, 10, 2],
    "c": "#ffffff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-205, 75, -166],
    "s": [40, 10, 2],
    "c": "#ffffff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-155, 75, -166],
    "s": [40, 10, 2],
    "c": "#ffffff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-205, 125, -166],
    "s": [40, 10, 2],
    "c": "#ffffff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-155, 125, -166],
    "s": [40, 10, 2],
    "c": "#ffffff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-205, 175, -166],
    "s": [40, 10, 2],
    "c": "#ffffff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-155, 175, -166],
    "s": [40, 10, 2],
    "c": "#ffffff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-155, 135, -167],
    "s": [40, 40, 2],
    "c": "#ffffff",
    "e": "#f5e14c",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-205, 85, -167],
    "s": [40, 40, 2],
    "c": "#ffffff",
    "e": "#f5e14c",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-230, 25, -166],
    "s": [10, 160, 2],
    "c": "#ffffff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-130, 25, -166],
    "s": [10, 160, 2],
    "c": "#ffffff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-180, 23, -175],
    "s": [111, 3, 21],
    "c": "#4a4a4a",
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [-180, 185, -175],
    "s": [112, 3, 22],
    "c": "#4a4a4a",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-180, 185, -215],
    "s": [212, 3, 66],
    "c": "#4a4a4a",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [80, -629, -213],
    "s": [10, 652, 10],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-225, -7, -557],
    "s": [40, 1, 4],
    "c": "#4a4a4a",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-275, 125, -392],
    "s": [62, 3, 253],
    "c": "#4a4a4a",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-375, 81, -277],
    "s": [143, 3, 22],
    "c": "#4a4a4a",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-465, -28, -258],
    "s": [17, 1, 30],
    "v": 1,
    "c": "#8e2e2e",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [77, -629, -190],
    "s": [4, 622, 36],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-140, -7, -482],
    "s": [10, 30, 10],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-140, -7, -452],
    "s": [10, 30, 10],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-200, -7, -482],
    "s": [10, 30, 10],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-200, -7, -452],
    "s": [10, 30, 10],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [80, -629, -24],
    "s": [10, 652, 10],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [23, -629, -23],
    "s": [10, 652, 10],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [3, -27, -120],
    "s": [56, 20, 4],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-225, -7, -449],
    "s": [40, 1, 4],
    "c": "#4a4a4a",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-396, 113, -250],
    "s": [110, 48, 4],
    "c": "#000337",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-396, 160, -250],
    "s": [112, 2, 5],
    "l": 1,
    "c": "#00b3ff",
    "e": "#00b3ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-396, 111, -250],
    "s": [112, 2, 5],
    "l": 1,
    "c": "#00b3ff",
    "e": "#00b3ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-452, 111, -250],
    "s": [2, 51, 5],
    "l": 1,
    "c": "#00b3ff",
    "e": "#00b3ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-341, 111, -250],
    "s": [2, 51, 5],
    "l": 1,
    "c": "#00b3ff",
    "e": "#00b3ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-408, 122, -250],
    "s": [9, 9, 5],
    "l": 1,
    "c": "#ffffff",
    "e": "#ffffff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-419, 122, -250],
    "s": [9, 9, 5],
    "l": 1,
    "c": "#ffffff",
    "e": "#ffffff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-438, 132, -250],
    "s": [9, 9, 5],
    "l": 1,
    "r": [0, 0, -0.87],
    "c": "#ffffff",
    "e": "#ffffff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-419, 125, -250],
    "s": [3, 3, 6],
    "l": 1,
    "c": "#ff5a00",
    "e": "#ff5a00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-408, 125, -250],
    "s": [3, 3, 6],
    "l": 1,
    "c": "#00ff0f",
    "e": "#00ff0f",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-436, 134, -250],
    "s": [3, 3, 6],
    "l": 1,
    "r": [0, 0, -0.87],
    "c": "#ff5a00",
    "e": "#ff5a00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-436, 122, -250],
    "s": [2, 47, 6],
    "l": 1,
    "r": [0, 0, -0.87],
    "c": "#ffe100",
    "e": "#ffe100",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-444, 145, -250],
    "s": [2, 47, 6],
    "l": 1,
    "r": [0, 0, -1.57],
    "c": "#ffe100",
    "e": "#ffe100",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-387, 142, -250],
    "s": [2, 12, 6],
    "l": 1,
    "r": [0, 0, -1.05],
    "c": "#ffffff",
    "e": "#ffffff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-372, 139, -251],
    "s": [3, 14, 7],
    "l": 1,
    "r": [0, 0, 1.57],
    "c": "#ffffff",
    "e": "#ffffff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-362, 139, -250],
    "s": [3, 14, 6],
    "l": 1,
    "r": [0, 0, -1.57],
    "c": "#ffffff",
    "e": "#ffffff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-347, 142, -250],
    "s": [2, 12, 6],
    "l": 1,
    "r": [0, 0, 1.05],
    "c": "#ffffff",
    "e": "#ffffff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-380, 128, -251],
    "s": [5, 5, 7],
    "l": 1,
    "c": "#ffffff",
    "e": "#ff00ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-354, 128, -251],
    "s": [5, 5, 7],
    "l": 1,
    "c": "#ffffff",
    "e": "#ff00ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-421, 115, -250],
    "s": [54, 2, 5],
    "l": 1,
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-420, 156, -250],
    "s": [54, 2, 5],
    "l": 1,
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-448, 115, -250],
    "s": [2, 43, 5],
    "l": 1,
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-393, 115, -250],
    "s": [2, 43, 5],
    "l": 1,
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-371, 127, -250],
    "s": [5, 3, 6],
    "l": 1,
    "r": [0, 0, 1.57],
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-360, 127, -250],
    "s": [5, 3, 6],
    "l": 1,
    "r": [0, 0, 1.57],
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-363, 124, -250],
    "s": [3, 8, 6],
    "l": 1,
    "r": [0, 0, 1.57],
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-371, 84, -278],
    "s": [22, 14, 8],
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-330, 84, -278],
    "s": [22, 15, 8],
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-331, 87, -278],
    "s": [60, 4, 4],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-307, 87, -290],
    "s": [4, 4, 20],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-307, 105, -319],
    "s": [4, 4, 30],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-301, 109, -332],
    "s": [15, 23, 4],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-307, 71, -302],
    "s": [5, 1, 5],
    "c": "#ffffff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-307, 95, -302],
    "s": [5, 1, 5],
    "c": "#ffffff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-307, 104, -325],
    "s": [5, 6, 1],
    "c": "#ffffff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-303, 62, -29],
    "s": [1, 2, 10],
    "c": "#1f1f1f",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-303, 52, -7],
    "s": [3, 2, 6],
    "l": 1,
    "c": "#fffb00",
    "e": "#fffb00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-303, 59, -7],
    "s": [2, 16, 1],
    "l": 1,
    "r": [-0.96, 0, 0],
    "c": "#ffffff",
    "e": "#ffffff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-303, 58, -11],
    "s": [2, 11, 1],
    "l": 1,
    "r": [-1.31, 0, 0],
    "c": "#ffffff",
    "e": "#ffffff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-303, 47, -11],
    "s": [4, 5, 15],
    "l": 1,
    "c": "#ffffff",
    "e": "#ffffff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-303, 41, 2],
    "s": [3, 30, 1],
    "l": 1,
    "c": "#181717",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-303, 41, -24],
    "s": [3, 30, 1],
    "l": 1,
    "c": "#181717",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-303, 71, -11],
    "s": [3, 1, 27],
    "l": 1,
    "c": "#181717",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-303, 40, -11],
    "s": [3, 1, 27],
    "l": 1,
    "c": "#181717",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-303, 45, -29],
    "s": [1, 2, 10],
    "c": "#1f1f1f",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-303, 41, -11],
    "s": [1, 30, 25],
    "c": "#2a8586",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-303, 52, -13],
    "s": [4, 1, 9],
    "l": 1,
    "c": "#ff7800",
    "e": "#ff7800",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-303, 45, -11],
    "s": [3, 2, 9],
    "l": 1,
    "c": "#ffffff",
    "e": "#ffffff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-303, 52, -14],
    "s": [2, 2, 3],
    "l": 1,
    "c": "#fffb00",
    "e": "#fffb00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-303, 52, -11],
    "s": [2, 2, 2],
    "l": 1,
    "c": "#68ff00",
    "e": "#68ff00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-303, 54, -10],
    "s": [3, 6, 3],
    "l": 1,
    "c": "#fffb00",
    "e": "#fffb00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-303, 53, -10],
    "s": [4, 9, 1],
    "l": 1,
    "c": "#ff9600",
    "e": "#ff9600",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-303, 63, -5],
    "s": [3, 6, 2],
    "l": 1,
    "r": [0.7, 0, 0],
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-303, 64, -9],
    "s": [3, 4, 2],
    "l": 1,
    "r": [0.09, 0, 0],
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-303, 60, -3],
    "s": [3, 3, 2],
    "l": 1,
    "r": [1.14, 0, 0],
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-446, 44, -278],
    "s": [4, 1, 1],
    "c": "#372d2d",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-446, 59, -278],
    "s": [4, 1, 1],
    "c": "#372d2d",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-456, 41, -278],
    "s": [1, 23, 2],
    "l": 1,
    "c": "#ff00e0",
    "e": "#d200ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-448, 41, -278],
    "s": [1, 23, 2],
    "l": 1,
    "c": "#ff00e0",
    "e": "#d200ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-452, 41, -278],
    "s": [7, 1, 2],
    "l": 1,
    "c": "#ff00e0",
    "e": "#d200ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-452, 63, -278],
    "s": [7, 1, 2],
    "l": 1,
    "c": "#ff00e0",
    "e": "#d200ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-452, 42, -278],
    "s": [7, 21, 1],
    "c": "#120216",
    "e": "#010903",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-452, 60, -278],
    "s": [5, 1, 2],
    "l": 1,
    "c": "#ff00e0",
    "e": "#d200ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-453, 59, -278],
    "s": [1, 3, 2],
    "l": 1,
    "c": "#ff00e0",
    "e": "#d200ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-451, 59, -278],
    "s": [1, 3, 2],
    "l": 1,
    "c": "#ff00e0",
    "e": "#d200ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-452, 52, -278],
    "s": [1, 6, 2],
    "l": 1,
    "c": "#ff00e0",
    "e": "#d200ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-451, 57, -278],
    "s": [3, 1, 2],
    "l": 1,
    "r": [0, 0, 0.7],
    "c": "#ff00e0",
    "e": "#d200ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-453, 57, -278],
    "s": [3, 1, 2],
    "l": 1,
    "r": [0, 0, -0.7],
    "c": "#ff00e0",
    "e": "#d200ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-452, 54, -278],
    "s": [5, 1, 2],
    "l": 1,
    "c": "#ff00e0",
    "e": "#d200ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-450, 46, -278],
    "s": [1, 4, 2],
    "l": 1,
    "c": "#ff00e0",
    "e": "#d200ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-452, 46, -278],
    "s": [1, 5, 2],
    "l": 1,
    "c": "#ff00e0",
    "e": "#d200ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-452, 49, -278],
    "s": [5, 1, 2],
    "l": 1,
    "c": "#ff00e0",
    "e": "#d200ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-453, 45, -278],
    "s": [3, 1, 2],
    "l": 1,
    "c": "#ff00e0",
    "e": "#d200ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-454, 44, -278],
    "s": [1, 1, 2],
    "l": 1,
    "c": "#ff00e0",
    "e": "#d200ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-451, 44, -278],
    "s": [1, 1, 2],
    "l": 1,
    "c": "#ff00e0",
    "e": "#d200ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-452, 43, -278],
    "s": [3, 1, 2],
    "l": 1,
    "c": "#ff00e0",
    "e": "#d200ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-454, 43, -278],
    "s": [1, 1, 2],
    "l": 1,
    "c": "#ff00e0",
    "e": "#d200ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-451, 45, -278],
    "s": [1, 1, 2],
    "l": 1,
    "c": "#ff00e0",
    "e": "#d200ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-55, 30, -11],
    "s": [4, 1, 1],
    "c": "#372d2d",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-55, 45, -11],
    "s": [4, 1, 1],
    "c": "#372d2d",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-65, 27, -11],
    "s": [1, 23, 2],
    "l": 1,
    "c": "#ff00e0",
    "e": "#d200ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-57, 27, -11],
    "s": [1, 23, 2],
    "l": 1,
    "c": "#ff00e0",
    "e": "#d200ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-61, 27, -11],
    "s": [7, 1, 2],
    "l": 1,
    "c": "#ff00e0",
    "e": "#d200ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-61, 49, -11],
    "s": [7, 1, 2],
    "l": 1,
    "c": "#ff00e0",
    "e": "#d200ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-61, 28, -11],
    "s": [7, 21, 1],
    "c": "#120216",
    "e": "#010903",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-61, 46, -11],
    "s": [5, 1, 2],
    "l": 1,
    "c": "#ff00e0",
    "e": "#d200ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-62, 45, -11],
    "s": [1, 3, 2],
    "l": 1,
    "c": "#ff00e0",
    "e": "#d200ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-60, 45, -11],
    "s": [1, 3, 2],
    "l": 1,
    "c": "#ff00e0",
    "e": "#d200ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-61, 38, -11],
    "s": [1, 6, 2],
    "l": 1,
    "c": "#ff00e0",
    "e": "#d200ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-60, 43, -11],
    "s": [3, 1, 2],
    "l": 1,
    "r": [0, 0, 0.7],
    "c": "#ff00e0",
    "e": "#d200ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-62, 43, -11],
    "s": [3, 1, 2],
    "l": 1,
    "r": [0, 0, -0.7],
    "c": "#ff00e0",
    "e": "#d200ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-61, 40, -11],
    "s": [5, 1, 2],
    "l": 1,
    "c": "#ff00e0",
    "e": "#d200ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-61, 32, -11],
    "s": [1, 5, 2],
    "l": 1,
    "c": "#ff00e0",
    "e": "#d200ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-61, 35, -11],
    "s": [5, 1, 2],
    "l": 1,
    "c": "#ff00e0",
    "e": "#d200ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-62, 31, -11],
    "s": [3, 1, 2],
    "l": 1,
    "c": "#ff00e0",
    "e": "#d200ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-60, 30, -11],
    "s": [1, 1, 2],
    "l": 1,
    "c": "#ff00e0",
    "e": "#d200ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-61, 29, -11],
    "s": [3, 1, 2],
    "l": 1,
    "c": "#ff00e0",
    "e": "#d200ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-63, 29, -11],
    "s": [1, 1, 2],
    "l": 1,
    "c": "#ff00e0",
    "e": "#d200ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-60, 31, -11],
    "s": [1, 1, 2],
    "l": 1,
    "c": "#ff00e0",
    "e": "#d200ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [15, -22, 19],
    "s": [1, 164, 35],
    "c": "#181717",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [15, -21, 34],
    "s": [3, 161, 1],
    "l": 1,
    "c": "#bf00ff",
    "e": "#bf00ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [15, -21, 4],
    "s": [2, 161, 1],
    "l": 1,
    "c": "#bf00ff",
    "e": "#bf00ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [15, -20, 19],
    "s": [2, 1, 29],
    "l": 1,
    "c": "#bf00ff",
    "e": "#bf00ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [15, 139, 19],
    "s": [3, 1, 29],
    "l": 1,
    "c": "#bf00ff",
    "e": "#bf00ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [16, 58, -6],
    "s": [1, 3, 16],
    "c": "#101010",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [15, 131, 18],
    "s": [4, 1, 17],
    "l": 1,
    "c": "#fffb00",
    "e": "#fffb00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [15, 130, 18],
    "s": [3, 3, 19],
    "l": 1,
    "c": "#ffffff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [15, 123, 18],
    "s": [4, 1, 14],
    "l": 1,
    "c": "#fffb00",
    "e": "#fffb00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [15, 122, 18],
    "s": [3, 3, 16],
    "l": 1,
    "c": "#ffffff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [15, 114, 18],
    "s": [4, 1, 21],
    "l": 1,
    "c": "#fffb00",
    "e": "#fffb00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [15, 113, 18],
    "s": [3, 3, 23],
    "l": 1,
    "c": "#ffffff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [15, 114, 18],
    "s": [4, 17, 1],
    "l": 1,
    "c": "#fffb00",
    "e": "#fffb00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [15, 114, 18],
    "s": [3, 17, 3],
    "l": 1,
    "c": "#ffffff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [15, 103, 18],
    "s": [3, 3, 19],
    "l": 1,
    "r": [0.17, 0, 0],
    "c": "#ffffff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [15, 104, 18],
    "s": [4, 1, 17],
    "l": 1,
    "r": [0.17, 0, 0],
    "c": "#fffb00",
    "e": "#fffb00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [15, 95, 17],
    "s": [4, 13, 1],
    "l": 1,
    "r": [-0.52, 0, 0],
    "c": "#fffb00",
    "e": "#fffb00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [15, 95, 16],
    "s": [3, 12, 3],
    "l": 1,
    "r": [-0.52, 0, 0],
    "c": "#ffffff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [15, 94, 18],
    "s": [4, 1, 21],
    "l": 1,
    "c": "#fffb00",
    "e": "#fffb00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [15, 93, 18],
    "s": [3, 3, 23],
    "l": 1,
    "c": "#ffffff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [15, 81, 14],
    "s": [4, 13, 1],
    "l": 1,
    "r": [0.17, 0, 0],
    "c": "#fffb00",
    "e": "#fffb00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [15, 80, 14],
    "s": [3, 15, 3],
    "l": 1,
    "r": [0.17, 0, 0],
    "c": "#ffffff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [15, 74, 18],
    "s": [4, 1, 13],
    "l": 1,
    "c": "#fffb00",
    "e": "#fffb00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [15, 73, 18],
    "s": [3, 3, 15],
    "l": 1,
    "c": "#ffffff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [15, 69, 18],
    "s": [4, 1, 20],
    "l": 1,
    "c": "#fffb00",
    "e": "#fffb00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [15, 68, 18],
    "s": [3, 3, 22],
    "l": 1,
    "c": "#ffffff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [15, 54, 17],
    "s": [4, 18, 1],
    "l": 1,
    "r": [-0.52, 0, 0],
    "c": "#fffb00",
    "e": "#fffb00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [15, 53, 18],
    "s": [3, 19, 3],
    "l": 1,
    "r": [-0.52, 0, 0],
    "c": "#ffffff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [15, 30, 18],
    "s": [4, 16, 1],
    "l": 1,
    "c": "#fffb00",
    "e": "#fffb00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [15, 29, 18],
    "s": [3, 18, 3],
    "l": 1,
    "c": "#ffffff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [15, 7, 27],
    "s": [4, 26, 1],
    "l": 1,
    "r": [-0.7, 0, 0],
    "c": "#fffb00",
    "e": "#fffb00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [15, 6, 27],
    "s": [3, 28, 3],
    "l": 1,
    "r": [-0.7, 0, 0],
    "c": "#ffffff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [15, 6, 10],
    "s": [4, 19, 1],
    "l": 1,
    "r": [0.52, 0, 0],
    "c": "#fffb00",
    "e": "#fffb00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [15, 5, 9],
    "s": [3, 22, 3],
    "l": 1,
    "r": [0.52, 0, 0],
    "c": "#ffffff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [15, -10, 18],
    "s": [4, 1, 23],
    "l": 1,
    "r": [0.35, 0, 0],
    "c": "#fffb00",
    "e": "#fffb00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [15, -11, 18],
    "s": [3, 3, 25],
    "l": 1,
    "r": [0.35, 0, 0],
    "c": "#ffffff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [15, -4, 18],
    "s": [4, 9, 1],
    "l": 1,
    "r": [0.17, 0, 0],
    "c": "#fffb00",
    "e": "#fffb00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [15, -5, 18],
    "s": [3, 11, 3],
    "l": 1,
    "r": [0.17, 0, 0],
    "c": "#ffffff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [16, -10, -6],
    "s": [1, 3, 16],
    "c": "#101010",
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [-170, -38, -585],
    "s": [1, 164, 35],
    "c": "#181717",
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [-170, -37, -570],
    "s": [3, 161, 1],
    "l": 1,
    "c": "#bf00ff",
    "e": "#bf00ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-170, -37, -600],
    "s": [2, 161, 1],
    "l": 1,
    "c": "#bf00ff",
    "e": "#bf00ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-170, -36, -585],
    "s": [2, 1, 29],
    "l": 1,
    "c": "#bf00ff",
    "e": "#bf00ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-170, 123, -585],
    "s": [3, 1, 29],
    "l": 1,
    "c": "#bf00ff",
    "e": "#bf00ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-169, 45, -561],
    "s": [1, 3, 16],
    "c": "#101010",
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [-170, 115, -586],
    "s": [4, 1, 17],
    "l": 1,
    "c": "#fffb00",
    "e": "#fffb00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-170, 114, -586],
    "s": [3, 3, 19],
    "l": 1,
    "c": "#ffffff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-170, 107, -586],
    "s": [4, 1, 14],
    "l": 1,
    "c": "#fffb00",
    "e": "#fffb00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-170, 106, -586],
    "s": [3, 3, 16],
    "l": 1,
    "c": "#ffffff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-170, 98, -586],
    "s": [4, 1, 21],
    "l": 1,
    "c": "#fffb00",
    "e": "#fffb00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-170, 97, -586],
    "s": [3, 3, 23],
    "l": 1,
    "c": "#ffffff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-170, 98, -586],
    "s": [4, 17, 1],
    "l": 1,
    "c": "#fffb00",
    "e": "#fffb00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-170, 98, -586],
    "s": [3, 17, 3],
    "l": 1,
    "c": "#ffffff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-170, 87, -586],
    "s": [3, 3, 19],
    "l": 1,
    "r": [0.17, 0, 0],
    "c": "#ffffff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-170, 88, -586],
    "s": [4, 1, 17],
    "l": 1,
    "r": [0.17, 0, 0],
    "c": "#fffb00",
    "e": "#fffb00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-170, 79, -587],
    "s": [4, 13, 1],
    "l": 1,
    "r": [-0.52, 0, 0],
    "c": "#fffb00",
    "e": "#fffb00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-170, 79, -588],
    "s": [3, 12, 3],
    "l": 1,
    "r": [-0.52, 0, 0],
    "c": "#ffffff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-170, 78, -586],
    "s": [4, 1, 21],
    "l": 1,
    "c": "#fffb00",
    "e": "#fffb00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-170, 77, -586],
    "s": [3, 3, 23],
    "l": 1,
    "c": "#ffffff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-170, 65, -590],
    "s": [4, 13, 1],
    "l": 1,
    "r": [0.17, 0, 0],
    "c": "#fffb00",
    "e": "#fffb00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-170, 65, -590],
    "s": [4, 7, 1],
    "l": 1,
    "r": [0.87, 0, 0],
    "c": "#fffb00",
    "e": "#fffb00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-170, 64, -590],
    "s": [3, 15, 3],
    "l": 1,
    "r": [0.17, 0, 0],
    "c": "#ffffff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-170, 65, -590],
    "s": [3, 8, 3],
    "l": 1,
    "r": [0.87, 0, 0],
    "c": "#ffffff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-170, 58, -586],
    "s": [4, 1, 13],
    "l": 1,
    "c": "#fffb00",
    "e": "#fffb00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-170, 57, -586],
    "s": [3, 3, 15],
    "l": 1,
    "c": "#ffffff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-170, 53, -586],
    "s": [4, 1, 20],
    "l": 1,
    "c": "#fffb00",
    "e": "#fffb00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-170, 52, -586],
    "s": [3, 3, 22],
    "l": 1,
    "c": "#ffffff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-170, 38, -587],
    "s": [4, 18, 1],
    "l": 1,
    "r": [-0.52, 0, 0],
    "c": "#fffb00",
    "e": "#fffb00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-170, 37, -586],
    "s": [3, 19, 3],
    "l": 1,
    "r": [-0.52, 0, 0],
    "c": "#ffffff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-170, 14, -586],
    "s": [4, 16, 1],
    "l": 1,
    "c": "#fffb00",
    "e": "#fffb00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-170, 13, -586],
    "s": [3, 18, 3],
    "l": 1,
    "c": "#ffffff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-170, -9, -577],
    "s": [4, 26, 1],
    "l": 1,
    "r": [-0.7, 0, 0],
    "c": "#fffb00",
    "e": "#fffb00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-170, -10, -577],
    "s": [3, 28, 3],
    "l": 1,
    "r": [-0.7, 0, 0],
    "c": "#ffffff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-170, -10, -594],
    "s": [4, 19, 1],
    "l": 1,
    "r": [0.52, 0, 0],
    "c": "#fffb00",
    "e": "#fffb00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-170, -11, -595],
    "s": [3, 22, 3],
    "l": 1,
    "r": [0.52, 0, 0],
    "c": "#ffffff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-170, -26, -586],
    "s": [4, 1, 23],
    "l": 1,
    "r": [0.35, 0, 0],
    "c": "#fffb00",
    "e": "#fffb00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-170, -27, -586],
    "s": [3, 3, 25],
    "l": 1,
    "r": [0.35, 0, 0],
    "c": "#ffffff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-170, -20, -586],
    "s": [4, 9, 1],
    "l": 1,
    "r": [0.17, 0, 0],
    "c": "#fffb00",
    "e": "#fffb00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-170, -21, -586],
    "s": [3, 11, 3],
    "l": 1,
    "r": [0.17, 0, 0],
    "c": "#ffffff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-169, -26, -561],
    "s": [1, 3, 16],
    "c": "#101010",
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [-306, 37, -503],
    "s": [1, 7, 5],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-306, 36, -506],
    "s": [2, 9, 1],
    "c": "#cfcfcf",
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [-306, 36, -499],
    "s": [2, 9, 7],
    "c": "#cfcfcf",
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [-306, 36, -504],
    "s": [2, 1, 3],
    "c": "#cfcfcf",
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [-306, 44, -504],
    "s": [2, 1, 3],
    "c": "#cfcfcf",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-306, 52, -503],
    "s": [1, 7, 5],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-306, 51, -506],
    "s": [2, 9, 1],
    "c": "#cfcfcf",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-306, 51, -499],
    "s": [2, 9, 7],
    "c": "#cfcfcf",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-306, 51, -504],
    "s": [2, 1, 3],
    "c": "#cfcfcf",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-306, 59, -504],
    "s": [2, 1, 3],
    "c": "#cfcfcf",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-305, 40, -492],
    "s": [2, 1, 7],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [-305, 55, -492],
    "s": [2, 1, 7],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-305, -6, -488],
    "s": [2, 62, 1],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [-275, 124, -478],
    "s": [31, 16, 33],
    "c": "#ffffff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-275, 131, -484],
    "s": [8, 37, 8],
    "c": "#bfbbbb",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-275, 131, -484],
    "s": [2, 158, 2],
    "c": "#ffffff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-275, 289, -484],
    "s": [4, 7, 3],
    "l": 1,
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-275, 131, -474],
    "s": [1, 74, 1],
    "c": "#ffffff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-275, 97, -392],
    "s": [61, 20, 251],
    "c": "#4a4a4a",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-275, 81, -392],
    "s": [61, 8, 251],
    "c": "#4a4a4a",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-395, 95, -137],
    "s": [201, 27, 221],
    "c": "#4a4a4a",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-395, 134, -137],
    "s": [203, 4, 223],
    "c": "#4a4a4a",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-275, 202, -473],
    "s": [4, 7, 4],
    "i": 16,
    "l": 1,
    "r": [0.35, 0, 0]
  }, {
    "p": [-196, -11, -329],
    "s": [1, 7, 5],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-196, -12, -332],
    "s": [2, 9, 1],
    "c": "#cfcfcf",
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [-196, -12, -325],
    "s": [2, 9, 7],
    "c": "#cfcfcf",
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [-196, -12, -330],
    "s": [2, 1, 3],
    "c": "#cfcfcf",
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [-196, -4, -330],
    "s": [2, 1, 3],
    "c": "#cfcfcf",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-196, -8, -330],
    "s": [2, 1, 3],
    "c": "#cfcfcf",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-196, 4, -329],
    "s": [1, 7, 5],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-196, 3, -332],
    "s": [2, 9, 1],
    "c": "#cfcfcf",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-196, 3, -325],
    "s": [2, 9, 7],
    "c": "#cfcfcf",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-196, 3, -330],
    "s": [2, 1, 3],
    "c": "#cfcfcf",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-196, 11, -330],
    "s": [2, 1, 3],
    "c": "#cfcfcf",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-196, 7, -330],
    "s": [2, 1, 3],
    "c": "#cfcfcf",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-195, -8, -318],
    "s": [2, 1, 7],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [-195, 7, -318],
    "s": [2, 1, 7],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-195, -54, -314],
    "s": [2, 62, 1],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [-206, 66, -430],
    "s": [7, 1, 5],
    "c": "#ffffff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-207, -100, -400],
    "s": [4, 105, 4],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-202, -7, -371],
    "s": [14, 4, 54],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-207, 1, -417],
    "s": [4, 4, 30],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-202, 5, -430],
    "s": [14, 73, 4],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [-207, -9, -400],
    "s": [5, 1, 5],
    "c": "#ffffff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-207, 13, -430],
    "s": [5, 1, 5],
    "c": "#ffffff",
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [-207, -8, -380],
    "s": [5, 6, 1],
    "l": 1,
    "c": "#ffffff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-207, 0, -414],
    "s": [5, 6, 1],
    "l": 1,
    "c": "#ffffff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-248, 5, -385],
    "s": [14, 127, 3],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [-225, 1, -417],
    "s": [32, 4, 5],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-243, 1, -427],
    "s": [4, 4, 87],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-243, 0, -436],
    "s": [5, 6, 1],
    "l": 1,
    "c": "#ffffff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-243, 0, -399],
    "s": [5, 6, 1],
    "l": 1,
    "c": "#ffffff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-243, 13, -385],
    "s": [5, 1, 4],
    "l": 1,
    "c": "#ffffff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-243, 57, -385],
    "s": [5, 1, 4],
    "c": "#ffffff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-243, 119, -385],
    "s": [5, 1, 4],
    "c": "#ffffff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-241, -5, -480],
    "s": [10, 11, 20],
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-241, -8, -480],
    "s": [9, 11, 19],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-243, 0, -465],
    "s": [5, 6, 1],
    "c": "#ffffff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-241, -7, -491],
    "s": [4, 7, 4],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-170, 38, -454],
    "s": [71, 20, 215],
    "c": "#4a4a4a",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-200, -26, -336],
    "s": [10, 11, 20],
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-200, -29, -336],
    "s": [9, 11, 19],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-150, 15, -307],
    "s": [72, 2, 2],
    "c": "#ca2f00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-66, 20, -307],
    "s": [2, 2, 64],
    "c": "#ca2f00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-118, -14, -249],
    "s": [125, 5, 3],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [-178, -9, -248],
    "s": [5, 201, 5],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-211, 28, -242],
    "s": [61, 5, 17],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [-243, 23, -253],
    "s": [10, 17, 20],
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-230, 27, -242],
    "s": [1, 7, 18],
    "c": "#ffffff",
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [-192, 27, -242],
    "s": [1, 7, 18],
    "c": "#ffffff",
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [-168, -15, -242],
    "s": [1, 7, 18],
    "c": "#ffffff",
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [-123, -15, -242],
    "s": [1, 7, 18],
    "c": "#ffffff",
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [-80, -15, -242],
    "s": [1, 7, 18],
    "c": "#ffffff",
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [-178, 0, -242],
    "s": [6, 1, 18],
    "c": "#ffffff",
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [-178, 21, -242],
    "s": [6, 1, 18],
    "c": "#ffffff",
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [-178, 44, -242],
    "s": [6, 1, 18],
    "c": "#ffffff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-178, 106, -242],
    "s": [6, 1, 18],
    "c": "#ffffff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-195, 25, -296],
    "s": [4, 1, 1],
    "c": "#372d2d",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-195, 40, -296],
    "s": [4, 1, 1],
    "c": "#372d2d",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-205, 22, -296],
    "s": [1, 23, 2],
    "l": 1,
    "c": "#ff00e0",
    "e": "#d200ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-197, 22, -296],
    "s": [1, 23, 2],
    "l": 1,
    "c": "#ff00e0",
    "e": "#d200ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-201, 22, -296],
    "s": [7, 1, 2],
    "l": 1,
    "c": "#ff00e0",
    "e": "#d200ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-201, 44, -296],
    "s": [7, 1, 2],
    "l": 1,
    "c": "#ff00e0",
    "e": "#d200ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-201, 23, -296],
    "s": [7, 21, 1],
    "c": "#120216",
    "e": "#010903",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-201, 41, -296],
    "s": [5, 1, 2],
    "l": 1,
    "c": "#ff00e0",
    "e": "#d200ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-202, 40, -296],
    "s": [1, 3, 2],
    "l": 1,
    "c": "#ff00e0",
    "e": "#d200ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-200, 40, -296],
    "s": [1, 3, 2],
    "l": 1,
    "c": "#ff00e0",
    "e": "#d200ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-201, 33, -296],
    "s": [1, 6, 2],
    "l": 1,
    "c": "#ff00e0",
    "e": "#d200ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-200, 38, -296],
    "s": [3, 1, 2],
    "l": 1,
    "r": [0, 0, 0.7],
    "c": "#ff00e0",
    "e": "#d200ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-202, 38, -296],
    "s": [3, 1, 2],
    "l": 1,
    "r": [0, 0, -0.7],
    "c": "#ff00e0",
    "e": "#d200ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-201, 35, -296],
    "s": [5, 1, 2],
    "l": 1,
    "c": "#ff00e0",
    "e": "#d200ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-203, 34, -296],
    "s": [3, 1, 2],
    "l": 1,
    "r": [0, 0, -0.7],
    "c": "#ff00e0",
    "e": "#d200ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-199, 34, -296],
    "s": [3, 1, 2],
    "l": 1,
    "r": [0, 0, 0.52],
    "c": "#ff00e0",
    "e": "#d200ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-199, 27, -296],
    "s": [1, 4, 2],
    "l": 1,
    "c": "#ff00e0",
    "e": "#d200ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-201, 27, -296],
    "s": [1, 5, 2],
    "l": 1,
    "c": "#ff00e0",
    "e": "#d200ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-201, 30, -296],
    "s": [5, 1, 2],
    "l": 1,
    "c": "#ff00e0",
    "e": "#d200ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-202, 28, -296],
    "s": [3, 1, 2],
    "l": 1,
    "c": "#ff00e0",
    "e": "#d200ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-202, 26, -296],
    "s": [3, 1, 2],
    "l": 1,
    "c": "#ff00e0",
    "e": "#d200ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-203, 25, -296],
    "s": [1, 1, 2],
    "l": 1,
    "c": "#ff00e0",
    "e": "#d200ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-200, 25, -296],
    "s": [1, 1, 2],
    "l": 1,
    "c": "#ff00e0",
    "e": "#d200ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-201, 24, -296],
    "s": [3, 1, 2],
    "l": 1,
    "c": "#ff00e0",
    "e": "#d200ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-203, 24, -296],
    "s": [1, 1, 2],
    "l": 1,
    "c": "#ff00e0",
    "e": "#d200ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-200, 26, -296],
    "s": [1, 1, 2],
    "l": 1,
    "c": "#ff00e0",
    "e": "#d200ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-42, 9, -370],
    "s": [10, 11, 20],
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-42, 6, -370],
    "s": [9, 11, 19],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-42, 9, -349],
    "s": [5, 4, 27],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-42, 6, -350],
    "s": [6, 8, 1],
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-4, 24, -456],
    "s": [25, 21, 25],
    "c": "#acacac",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-4, 45, -456],
    "s": [28, 1, 28],
    "c": "#666666",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-4, 23, -456],
    "s": [28, 1, 28],
    "c": "#666666",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [7, 8, -445],
    "s": [2, 15, 2],
    "c": "#666666",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [7, 8, -467],
    "s": [2, 15, 2],
    "c": "#666666",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-15, 7, -445],
    "s": [2, 16, 2],
    "c": "#666666",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-15, 8, -467],
    "s": [2, 15, 2],
    "c": "#666666",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [7, 9, -456],
    "s": [1, 1, 22],
    "c": "#666666",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-15, 9, -456],
    "s": [1, 1, 22],
    "c": "#666666",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-4, 9, -445],
    "s": [20, 1, 1],
    "c": "#666666",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-4, 9, -467],
    "s": [20, 1, 1],
    "c": "#666666",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [5, 46, -447],
    "s": [5, 3, 5],
    "c": "#666666",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [0, -7, -489],
    "s": [50, 30, 1],
    "pe": 1,
    "c": "#4a4a4a",
    "t": 12,
    "ts": 0,
    "td": 0
  }, {
    "p": [25, -7, -464],
    "s": [1, 30, 50],
    "pe": 1,
    "c": "#4a4a4a",
    "t": 12,
    "ts": 0,
    "td": 0
  }, {
    "p": [-26, -7, -489],
    "s": [2, 31, 2],
    "l": 1,
    "c": "#4a4a4a",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [25, -7, -489],
    "s": [2, 31, 2],
    "l": 1,
    "c": "#4a4a4a",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [25, -7, -439],
    "s": [2, 31, 2],
    "l": 1,
    "c": "#4a4a4a",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-110, -7, -489],
    "s": [50, 30, 1],
    "pe": 1,
    "c": "#4a4a4a",
    "t": 12,
    "ts": 0,
    "td": 0
  }, {
    "p": [-134, -7, -489],
    "s": [2, 31, 2],
    "l": 1,
    "c": "#4a4a4a",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-84, -7, -489],
    "s": [2, 31, 2],
    "l": 1,
    "c": "#4a4a4a",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [25, -7, -338],
    "s": [2, 31, 2],
    "l": 1,
    "c": "#4a4a4a",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [25, -7, -364],
    "s": [1, 30, 50],
    "pe": 1,
    "c": "#4a4a4a",
    "t": 12,
    "ts": 0,
    "td": 0
  }, {
    "p": [25, -7, -390],
    "s": [2, 31, 2],
    "l": 1,
    "c": "#4a4a4a",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-225, 65, -508],
    "s": [44, 2, 2],
    "c": "#ca2f00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-225, 60, -508],
    "s": [44, 2, 2],
    "c": "#ca2f00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-66, 22, -338],
    "s": [2, 55, 2],
    "c": "#ca2f00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-150, 18, -307],
    "s": [72, 2, 2],
    "c": "#ca2f00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-244, 27, -346],
    "s": [2, 20, 2],
    "c": "#ca2f00",
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [-275, 27, -346],
    "s": [60, 2, 2],
    "c": "#ca2f00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-306, 27, -349],
    "s": [2, 2, 8],
    "c": "#ca2f00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-306, -9, -352],
    "s": [2, 36, 2],
    "c": "#ca2f00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-84, 38, -302],
    "s": [223, 20, 72],
    "c": "#4a4a4a",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-25, 17, -299],
    "s": [23, 2, 55],
    "c": "#ca2f00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-25, 13, -299],
    "s": [23, 2, 55],
    "c": "#ca2f00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-34, 13, -247],
    "s": [2, 2, 49],
    "c": "#ca2f00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-34, 17, -247],
    "s": [2, 2, 49],
    "c": "#ca2f00",
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [15, 99, -118],
    "s": [141, 4, 221],
    "c": "#4a4a4a",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [15, 62, -118],
    "s": [141, 25, 221],
    "c": "#4a4a4a",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-180, 94, -215],
    "s": [212, 29, 66],
    "c": "#4a4a4a",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-180, 141, -215],
    "s": [212, 12, 66],
    "c": "#4a4a4a",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-31, 101, -33],
    "s": [31, 23, 33],
    "c": "#4a4a4a",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-31, 106, -40],
    "s": [8, 37, 8],
    "c": "#bfbbbb",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-31, 106, -40],
    "s": [2, 158, 2],
    "c": "#ffffff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-31, 264, -40],
    "s": [4, 7, 3],
    "l": 1,
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-31, 106, -30],
    "s": [1, 74, 1],
    "c": "#ffffff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-181, -13, -105],
    "s": [120, 17, 4],
    "c": "#ffffff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-289, -29, -103],
    "s": [12, 52, 160],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [-18, -27, -86],
    "s": [4, 4, 39],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-22, -27, -85],
    "s": [4, 4, 39],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-19, -23, -86],
    "s": [4, 4, 39],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-8, -7, -128],
    "s": [12, 12, 12],
    "i": 8
  }, {
    "p": [29, -27, -86],
    "s": [3, 2, 8],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [25, -27, -86],
    "s": [3, 2, 8],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [28, -25, -86],
    "s": [3, 2, 8],
    "r": [0, 0.17, 0],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [20, -27, -34],
    "s": [12, 12, 12],
    "i": 8
  }, {
    "p": [71, -27, -22],
    "s": [4, 7, 4],
    "i": 16
  }, {
    "p": [73, -27, -55],
    "s": [4, 7, 4],
    "i": 16,
    "l": 1
  }, {
    "p": [76, -7, -175],
    "s": [4, 7, 4],
    "i": 16,
    "l": 1
  }, {
    "p": [54, -7, -212],
    "s": [12, 12, 12],
    "i": 8
  }, {
    "p": [21, -7, -212],
    "s": [3, 2, 8],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [21, -5, -213],
    "s": [3, 2, 8],
    "r": [0, 0.17, 0],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-22, -7, -215],
    "s": [4, 7, 4],
    "i": 16,
    "l": 1
  }, {
    "p": [82, 20, -114],
    "s": [2, 2, 191],
    "c": "#ca2f00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [82, 16, -114],
    "s": [2, 2, 191],
    "c": "#ca2f00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [62, -27, -21],
    "s": [4, 16, 1],
    "l": 1,
    "r": [0.17, 0, 0],
    "c": "#ffffff",
    "t": 2,
    "ts": 0,
    "td": 0
  }, {
    "p": [56, -27, -21],
    "s": [4, 16, 1],
    "l": 1,
    "r": [0.17, 0, 0],
    "c": "#ffffff",
    "t": 2,
    "ts": 0,
    "td": 0
  }, {
    "p": [-234, -17, -207],
    "s": [1, 19, 23],
    "c": "#8c8c8c",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-234, 4, -207],
    "s": [1, 1, 1],
    "c": "#ffffff",
    "e": "#ff0000",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-234, 4, -206],
    "s": [1, 1, 1],
    "c": "#8c8c8c",
    "e": "#ffffff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-234, -17, -195],
    "s": [2, 19, 1],
    "c": "#bbbbbb",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-234, -17, -219],
    "s": [2, 19, 1],
    "c": "#bbbbbb",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-234, 2, -207],
    "s": [2, 1, 25],
    "c": "#bbbbbb",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-234, -17, -207],
    "s": [2, 19, 1],
    "c": "#bbbbbb",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-244, 17, -228],
    "s": [21, 2, 82],
    "c": "#ca2f00",
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [-244, 21, -228],
    "s": [21, 2, 82],
    "c": "#ca2f00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-178, 17, -177],
    "s": [111, 2, 23],
    "c": "#ca2f00",
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [-178, 21, -177],
    "s": [111, 2, 23],
    "c": "#ca2f00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-235, 17, -177],
    "s": [3, 2, 23],
    "c": "#ca2f00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-235, 21, -177],
    "s": [3, 2, 23],
    "c": "#ca2f00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-244, 17, -274],
    "s": [2, 114, 2],
    "c": "#ca2f00",
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [-244, 17, -271],
    "s": [2, 2, 4],
    "c": "#ca2f00",
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [-245, 21, -270],
    "s": [2, 114, 2],
    "c": "#ca2f00",
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [-235, 0, -207],
    "s": [1, 6, 29],
    "c": "#4a4a4a",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-181, 4, -105],
    "s": [120, 1, 4],
    "c": "#4a4a4a",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-293, -95, -93],
    "s": [4, 158, 3],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-293, 63, -84],
    "s": [4, 3, 21],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-293, 66, -75],
    "s": [4, 74, 3],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-81, -14, -181],
    "s": [5, 66, 4],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [-64, 46, -181],
    "s": [29, 6, 4],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [-56, 52, -181],
    "s": [8, 54, 4],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-81, 11, -183],
    "s": [6, 1, 9],
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [-81, 44, -183],
    "s": [6, 1, 9],
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [-56, 54, -181],
    "s": [9, 1, 5],
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-56, 97, -181],
    "s": [9, 1, 5],
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-282, -10, -171],
    "s": [2, 34, 2],
    "c": "#4a4a4a",
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [-237, -14, -171],
    "s": [2, 38, 2],
    "c": "#4a4a4a",
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [-250, -2, -183],
    "s": [12, 10, 4],
    "c": "#b32c2c",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-261, -2, -183],
    "s": [6, 10, 4],
    "c": "#b32c2c",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-262, -13, -183],
    "s": [1, 12, 3],
    "c": "#ffffff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-254, -1, -182],
    "s": [2, 1, 3],
    "c": "#ffffff",
    "e": "#ff0000",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-262, -1, -182],
    "s": [2, 1, 3],
    "c": "#ffffff",
    "e": "#ff0000",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-244, 47, -311],
    "s": [2, 2, 72],
    "c": "#ca2f00",
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [-56, 20, -14],
    "s": [2, 2, 12],
    "c": "#ca2f00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-55, 16, -16],
    "s": [3, 2, 8],
    "c": "#ca2f00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-55, -17, -13],
    "s": [3, 33, 2],
    "c": "#ca2f00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [12, 16, -19],
    "s": [131, 2, 2],
    "c": "#ca2f00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [12, 20, -19],
    "s": [134, 2, 2],
    "c": "#ca2f00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-56, -17, -9],
    "s": [2, 37, 2],
    "c": "#ca2f00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-90, -19, -9],
    "s": [70, 2, 2],
    "c": "#ca2f00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-90, -19, -13],
    "s": [70, 2, 2],
    "c": "#ca2f00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-180, 188, -215],
    "s": [148, 18, 53],
    "c": "#ffffff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-320, 138, -71],
    "s": [45, 16, 86],
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-232, 3, 20],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-130, 3, 8],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-130, 3, -4],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-293, 37, -130],
    "s": [3, 7, 5],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-293, 36, -133],
    "s": [4, 9, 1],
    "c": "#cfcfcf",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-293, 36, -126],
    "s": [4, 9, 7],
    "c": "#cfcfcf",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-293, 36, -131],
    "s": [4, 1, 3],
    "c": "#cfcfcf",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-293, 44, -131],
    "s": [4, 1, 3],
    "c": "#cfcfcf",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-293, 52, -130],
    "s": [3, 7, 5],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-293, 51, -133],
    "s": [4, 9, 1],
    "c": "#cfcfcf",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-293, 51, -126],
    "s": [4, 9, 7],
    "c": "#cfcfcf",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-293, 51, -131],
    "s": [4, 1, 3],
    "c": "#cfcfcf",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-293, 59, -131],
    "s": [4, 1, 3],
    "c": "#cfcfcf",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-295, 53, -108],
    "s": [2, 1, 30],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-295, 38, -109],
    "s": [2, 1, 33],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-139, 5, -368],
    "s": [12, 70, 2],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [-139, 59, -453],
    "s": [14, 3, 33],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [-139, 62, -468],
    "s": [14, 14, 3],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [-134, 67, -468],
    "s": [5, 1, 4],
    "c": "#ffffff",
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [-134, 55, -438],
    "s": [5, 1, 4],
    "c": "#ffffff",
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [-134, 26, -438],
    "s": [5, 1, 4],
    "c": "#ffffff",
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [-170, 74, -512],
    "s": [70, 15, 72],
    "c": "#ffffff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-136, 19, -237],
    "s": [119, 4, 21],
    "c": "#4a4a4a",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-136, -24, -237],
    "s": [119, 24, 21],
    "c": "#4a4a4a",
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [-180, -18, -177],
    "s": [111, 18, 21],
    "c": "#4a4a4a",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-386, 10, -113],
    "s": [2, 2, 176],
    "c": "#ca2f00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-336, 6, -26],
    "s": [98, 2, 2],
    "c": "#ca2f00",
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [-386, 6, -113],
    "s": [2, 2, 176],
    "c": "#ca2f00",
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [-416, 5, -192],
    "s": [46, 2, 2],
    "c": "#ca2f00",
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [-440, 5, -230],
    "s": [2, 2, 78],
    "c": "#ca2f00",
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [-416, 10, -192],
    "s": [46, 2, 2],
    "c": "#ca2f00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-440, 10, -230],
    "s": [2, 2, 78],
    "c": "#ca2f00",
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [-434, -27, -133],
    "s": [3, 2, 8],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-438, -27, -133],
    "s": [3, 2, 8],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-435, -25, -133],
    "s": [3, 2, 8],
    "r": [0, 0.17, 0],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-439, -27, -33],
    "s": [12, 12, 12],
    "i": 8
  }, {
    "p": [-489, -27, -230],
    "s": [12, 12, 12],
    "i": 8
  }, {
    "p": [-492, -27, -43],
    "s": [4, 7, 4],
    "i": 16
  }, {
    "p": [-448, -27, -244],
    "s": [4, 7, 4],
    "i": 16
  }, {
    "p": [-432, -15, -148],
    "s": [4, 7, 4],
    "i": 16,
    "l": 1
  }, {
    "p": [-189, 18, -277],
    "s": [2, 2, 64],
    "c": "#ca2f00",
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [-189, 15, -277],
    "s": [2, 2, 64],
    "c": "#ca2f00",
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [-230, 203, -215],
    "s": [34, 20, 45],
    "c": "#4a4a4a",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-230, 218, -222],
    "s": [8, 37, 8],
    "c": "#bfbbbb",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-230, 218, -222],
    "s": [2, 158, 2],
    "c": "#ffffff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-230, 376, -222],
    "s": [4, 7, 3],
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-69, 20, -307],
    "s": [2, 2, 64],
    "c": "#ca2f00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-69, 22, -338],
    "s": [2, 55, 2],
    "c": "#ca2f00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-246, 38, -435],
    "s": [9, 1, 1],
    "c": "#372d2d",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-246, 55, -435],
    "s": [9, 1, 1],
    "c": "#372d2d",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-241, 36, -435],
    "s": [1, 22, 2],
    "l": 1,
    "c": "#00ff2d",
    "e": "#00ff2d",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-234, 37, -435],
    "s": [13, 20, 1],
    "c": "#021606",
    "e": "#010903",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-227, 36, -435],
    "s": [1, 22, 2],
    "l": 1,
    "c": "#00ff2d",
    "e": "#00ff2d",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-234, 36, -435],
    "s": [14, 1, 2],
    "l": 1,
    "c": "#00ff2d",
    "e": "#00ff2d",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-234, 57, -435],
    "s": [14, 1, 2],
    "l": 1,
    "c": "#00ff2d",
    "e": "#00ff2d",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-231, 54, -435],
    "s": [5, 1, 2],
    "l": 1,
    "c": "#00ff2d",
    "e": "#00ff2d",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-232, 52, -435],
    "s": [5, 1, 2],
    "l": 1,
    "r": [0, 0, 0.7],
    "c": "#00ff2d",
    "e": "#00ff2d",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-231, 47, -435],
    "s": [5, 1, 2],
    "l": 1,
    "c": "#00ff2d",
    "e": "#00ff2d",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-229, 38, -435],
    "s": [1, 6, 2],
    "l": 1,
    "c": "#00ff2d",
    "e": "#00ff2d",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-232, 40, -435],
    "s": [1, 3, 2],
    "l": 1,
    "r": [0, 0, 1.22],
    "c": "#00ff2d",
    "e": "#00ff2d",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-232, 42, -435],
    "s": [1, 4, 2],
    "l": 1,
    "r": [0, 0, 0.7],
    "c": "#00ff2d",
    "e": "#00ff2d",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-235, 39, -435],
    "s": [1, 4, 2],
    "l": 1,
    "r": [0, 0, -0.17],
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-238, 39, -435],
    "s": [1, 4, 2],
    "l": 1,
    "r": [0, 0, -0.17],
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-236, 39, -435],
    "s": [2, 1, 2],
    "l": 1,
    "r": [0, 0, -0.17],
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-237, 42, -435],
    "s": [2, 1, 2],
    "l": 1,
    "r": [0, 0, -0.17],
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-237, 43, -435],
    "s": [4, 1, 2],
    "l": 1,
    "r": [0, 0, -0.17],
    "c": "#fffe00",
    "e": "#fff000",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-237, 44, -435],
    "s": [1, 4, 2],
    "l": 1,
    "r": [0, 0, 0.18],
    "c": "#002dff",
    "e": "#0000ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-237, 50, -435],
    "s": [3, 1, 2],
    "l": 1,
    "c": "#ffffff",
    "e": "#ffffff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-237, 53, -435],
    "s": [3, 1, 2],
    "l": 1,
    "c": "#ffffff",
    "e": "#ffffff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-236, 50, -435],
    "s": [1, 3, 2],
    "l": 1,
    "c": "#ffffff",
    "e": "#ffffff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-239, 50, -435],
    "s": [1, 4, 2],
    "l": 1,
    "c": "#ffffff",
    "e": "#ffffff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-238, 54, -435],
    "s": [3, 1, 2],
    "l": 1,
    "c": "#ff8700",
    "e": "#553200",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-236, 54, -435],
    "s": [1, 1, 2],
    "l": 1,
    "c": "#ff8700",
    "e": "#553200",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-232, 33, -435],
    "s": [1, 3, 1],
    "l": 1,
    "c": "#372d2d",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-236, 33, -435],
    "s": [1, 3, 1],
    "l": 1,
    "c": "#372d2d",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-234, 33, -435],
    "s": [8, 1, 2],
    "l": 1,
    "c": "#000de8",
    "e": "#004aff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-234, 25, -435],
    "s": [4, 1, 2],
    "l": 1,
    "c": "#000de8",
    "e": "#004aff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-238, 21, -435],
    "s": [1, 13, 2],
    "l": 1,
    "c": "#000de8",
    "e": "#004aff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-230, 21, -435],
    "s": [1, 13, 2],
    "l": 1,
    "c": "#000de8",
    "e": "#004aff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-234, 22, -435],
    "s": [7, 11, 1],
    "l": 1,
    "c": "#000337",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-234, 31, -435],
    "s": [3, 1, 2],
    "l": 1,
    "c": "#000de8",
    "e": "#004aff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-234, 29, -435],
    "s": [3, 1, 2],
    "l": 1,
    "c": "#000de8",
    "e": "#004aff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-236, 29, -435],
    "s": [1, 3, 2],
    "l": 1,
    "c": "#000de8",
    "e": "#004aff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-234, 27, -435],
    "s": [5, 1, 2],
    "l": 1,
    "c": "#000de8",
    "e": "#004aff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-234, 21, -435],
    "s": [8, 1, 2],
    "l": 1,
    "c": "#000de8",
    "e": "#004aff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-234, 23, -435],
    "s": [1, 4, 2],
    "l": 1,
    "c": "#000de8",
    "e": "#004aff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-234, 23, -435],
    "s": [6, 1, 2],
    "l": 1,
    "c": "#000de8",
    "e": "#004aff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-238, 39, -435],
    "s": [1, 1, 2],
    "l": 1,
    "r": [0, 0, -0.17],
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-340, -39, -112],
    "s": [91, 27, 170],
    "c": "#4a4a4a",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-338, 10, -26],
    "s": [94, 2, 2],
    "c": "#ca2f00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-469, -27, -122],
    "s": [51, 15, 52],
    "c": "#4a4a4a",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-429, -27, -145],
    "s": [12, 12, 12],
    "i": 8
  }, {
    "p": [-391, -27, -81],
    "s": [12, 12, 12],
    "i": 8
  }, {
    "p": [-491, -27, -161],
    "s": [4, 7, 4],
    "i": 16
  }, {
    "p": [-447, -27, -42],
    "s": [3, 2, 8],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-451, -27, -42],
    "s": [3, 2, 8],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-448, -25, -42],
    "s": [3, 2, 8],
    "r": [0, 0.17, 0],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-389, -28, -53],
    "s": [4, 4, 39],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-393, -28, -52],
    "s": [4, 4, 39],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-390, -24, -53],
    "s": [4, 4, 39],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-365, -27, -221],
    "s": [143, 14, 50],
    "c": "#4a4a4a",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-412, 12, -75],
    "s": [2, 1, 21],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-412, 11, -75],
    "s": [1, 3, 20],
    "c": "#ffffff",
    "e": "#f5e14c",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-412, 12, -151],
    "s": [2, 1, 21],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-412, 11, -151],
    "s": [1, 3, 20],
    "c": "#ffffff",
    "e": "#f5e14c",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-466, 12, -209],
    "s": [2, 1, 21],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-466, 11, -209],
    "s": [1, 3, 20],
    "c": "#ffffff",
    "e": "#f5e14c",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-385, -12, -148],
    "s": [1, 27, 82],
    "c": "#ffffff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-365, -13, -220],
    "s": [142, 28, 47],
    "c": "#ffffff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [25, -27, -112],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [13, -27, -112],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [25, -15, -112],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-450, -27, -32],
    "s": [10, 40, 10],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-376, -714, 368],
    "s": [162, 796, 139],
    "c": "#6b6b6b",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-477, -714, 271],
    "s": [139, 732, 161],
    "c": "#b6b6b6",
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [-376, 82, 368],
    "s": [167, 3, 142],
    "l": 1,
    "c": "#555555",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-477, 18, 271],
    "s": [145, 3, 165],
    "l": 1,
    "c": "#696969",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-292, 50, 333],
    "s": [22, 4, 2],
    "l": 1,
    "c": "#3e3e3e",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-292, 2, 333],
    "s": [22, 4, 2],
    "l": 1,
    "c": "#3e3e3e",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-280, 2, 333],
    "s": [2, 69, 2],
    "l": 1,
    "c": "#3e3e3e",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-267, -9, 333],
    "s": [25, 83, 5],
    "l": 1,
    "c": "#000000",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-267, 69, 330],
    "s": [18, 2, 1],
    "l": 1,
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-263, 65, 330],
    "s": [6, 2, 1],
    "l": 1,
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-273, 62, 330],
    "s": [6, 2, 1],
    "l": 1,
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-263, 62, 330],
    "s": [10, 2, 1],
    "l": 1,
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-266, 55, 330],
    "s": [2, 7, 1],
    "l": 1,
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-273, 57, 330],
    "s": [2, 10, 1],
    "l": 1,
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-261, 55, 330],
    "s": [2, 7, 1],
    "l": 1,
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-267, 48, 330],
    "s": [18, 2, 1],
    "l": 1,
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-275, 35, 330],
    "s": [2, 10, 1],
    "l": 1,
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-259, 34, 330],
    "s": [2, 11, 1],
    "l": 1,
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-267, 41, 330],
    "s": [9, 2, 1],
    "l": 1,
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-267, 34, 330],
    "s": [2, 17, 1],
    "l": 1,
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-267, 28, 330],
    "s": [17, 2, 1],
    "l": 1,
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-267, 24, 330],
    "s": [14, 2, 1],
    "l": 1,
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-267, 14, 330],
    "s": [2, 14, 1],
    "l": 1,
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-267, 17, 330],
    "s": [14, 2, 1],
    "l": 1,
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-260, -1, 330],
    "s": [2, 12, 1],
    "l": 1,
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-261, 6, 330],
    "s": [6, 2, 1],
    "l": 1,
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-263, -4, 330],
    "s": [2, 13, 1],
    "l": 1,
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-262, -2, 330],
    "s": [7, 2, 1],
    "l": 1,
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-271, 9, 330],
    "s": [10, 2, 1],
    "l": 1,
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-271, 4, 330],
    "s": [4, 2, 1],
    "l": 1,
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-268, 3, 330],
    "s": [2, 8, 1],
    "l": 1,
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-267, -1, 330],
    "s": [2, 2, 1],
    "l": 1,
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-271, -1, 330],
    "s": [2, 2, 1],
    "l": 1,
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-275, -1, 330],
    "s": [2, 2, 1],
    "l": 1,
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-269, -5, 330],
    "s": [2, 7, 1],
    "l": 1,
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-273, -6, 330],
    "s": [2, 8, 1],
    "l": 1,
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-267, -12, 332],
    "s": [28, 89, 1],
    "l": 1,
    "c": "#00ff69",
    "e": "#00ff69",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-267, 45, 330],
    "s": [18, 2, 1],
    "l": 1,
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-274, 3, 330],
    "s": [2, 8, 1],
    "l": 1,
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-307, 84, 307],
    "s": [2, 76, 2],
    "l": 1,
    "c": "#aaaaaa",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-307, 160, 307],
    "s": [3, 4, 3],
    "l": 1,
    "c": "#000000",
    "e": "#ff0000",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-410, -13, 180],
    "s": [2, 27, 11],
    "l": 1,
    "c": "#001100",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-410, -10, 180],
    "s": [3, 1, 7],
    "l": 1,
    "c": "#0eff00",
    "e": "#0eff00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-410, -10, 183],
    "s": [3, 8, 1],
    "l": 1,
    "c": "#0eff00",
    "e": "#0eff00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-410, -3, 181],
    "s": [3, 1, 7],
    "l": 1,
    "r": [0.17, 0, 0],
    "c": "#0eff00",
    "e": "#0eff00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-410, 9, 181],
    "s": [3, 1, 7],
    "l": 1,
    "r": [0.35, 0, 0],
    "c": "#0eff00",
    "e": "#0eff00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-410, 6, 182],
    "s": [3, 1, 6],
    "l": 1,
    "r": [1.58, 0, 0],
    "c": "#0eff00",
    "e": "#0eff00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-410, -9, 190],
    "s": [1, 2, 7],
    "l": 1,
    "c": "#555555",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-410, 7, 190],
    "s": [1, 2, 8],
    "l": 1,
    "c": "#555555",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-410, 6, 177],
    "s": [3, 1, 6],
    "l": 1,
    "r": [1.58, 0, 0],
    "c": "#0eff00",
    "e": "#0eff00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-410, -15, 180],
    "s": [1, 30, 13],
    "l": 1,
    "c": "#0eff00",
    "e": "#0eff00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-413, 23, 244],
    "s": [3, 42, 99],
    "l": 1,
    "c": "#5f5f5f",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-415, 20, 204],
    "s": [3, 47, 3],
    "l": 1,
    "c": "#696969",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-415, 20, 281],
    "s": [3, 47, 3],
    "l": 1,
    "c": "#696969",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-340, 84, 314],
    "s": [40, 19, 22],
    "l": 1,
    "c": "#989898",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-353, 26, 297],
    "s": [104, 50, 3],
    "l": 1,
    "c": "#252525",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-353, 26, 297],
    "s": [106, 3, 8],
    "l": 1,
    "c": "#4b4b4b",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-353, 52, 295],
    "s": [103, 0, 47],
    "i": 11,
    "l": 1,
    "r": [1.57, 0, -3.14],
    "bb": 3
  }, {
    "p": [-411, 44, 244],
    "s": [96, 0, 40],
    "i": 11,
    "l": 1,
    "r": [1.57, 0, -1.57],
    "bb": 2
  }, {
    "p": [-454, 41, 195],
    "s": [17, 3, 4],
    "l": 1,
    "r": [-3.14, 0, -2.62],
    "c": "#f000ff",
    "e": "#f000ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-445, 38, 195],
    "s": [3, 9, 4],
    "l": 1,
    "r": [-3.14, 0, -2.62],
    "c": "#f000ff",
    "e": "#f000ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-450, 45, 195],
    "s": [3, 1, 4],
    "l": 1,
    "r": [-3.14, 0, -2.62],
    "c": "#f000ff",
    "e": "#f000ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-449, 48, 195],
    "s": [3, 1, 4],
    "l": 1,
    "r": [-3.14, 0, -2.62],
    "c": "#f000ff",
    "e": "#f000ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-474, 41, 195],
    "s": [17, 3, 4],
    "l": 1,
    "r": [3.14, 0, 3.14],
    "c": "#f000ff",
    "e": "#f000ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-497, 45, 195],
    "s": [17, 3, 4],
    "l": 1,
    "r": [3.14, 0, 3.14],
    "c": "#f000ff",
    "e": "#f000ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-497, 37, 195],
    "s": [17, 3, 4],
    "l": 1,
    "r": [3.14, 0, 3.14],
    "c": "#f000ff",
    "e": "#f000ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-504, 36, 195],
    "s": [3, 12, 4],
    "l": 1,
    "r": [3.14, 0, 3.14],
    "c": "#f000ff",
    "e": "#f000ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-520, 41, 195],
    "s": [17, 3, 4],
    "l": 1,
    "r": [3.14, 0, 2.62],
    "c": "#f000ff",
    "e": "#f000ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-520, 49, 195],
    "s": [3, 1, 4],
    "l": 1,
    "r": [-3.14, 0, -2.19],
    "c": "#f000ff",
    "e": "#f000ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-485, 28, 198],
    "s": [107, 30, 4],
    "l": 1,
    "r": [3.14, 0, 3.14],
    "c": "#0012ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-447, 21, 204],
    "s": [5, 40, 5],
    "l": 1,
    "r": [3.14, 0, 3.14],
    "c": "#575757",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-524, 21, 204],
    "s": [5, 40, 5],
    "l": 1,
    "r": [3.14, 0, 3.14],
    "c": "#575757",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-352, -20, 298],
    "s": [89, 36, 2],
    "l": 1,
    "c": "#282828",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-352, -66, 298],
    "s": [89, 36, 2],
    "l": 1,
    "c": "#282828",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-352, -114, 298],
    "s": [89, 36, 2],
    "l": 1,
    "c": "#f5e14c",
    "e": "#f5e14c",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-352, -163, 298],
    "s": [89, 36, 2],
    "l": 1,
    "c": "#282828",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-352, -212, 298],
    "s": [89, 36, 2],
    "l": 1,
    "c": "#f5e14c",
    "e": "#f5e14c",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-352, -264, 298],
    "s": [89, 36, 2],
    "l": 1,
    "c": "#282828",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-445, -260, 190],
    "s": [56, 268, 1],
    "l": 1,
    "c": "#b6b6b6",
    "t": 3,
    "ts": 0,
    "td": 0
  }, {
    "p": [-511, -260, 190],
    "s": [56, 268, 1],
    "l": 1,
    "c": "#b6b6b6",
    "t": 3,
    "ts": 0,
    "td": 0
  }, {
    "p": [-526, -50, 190],
    "s": [26, 28, 2],
    "l": 1,
    "c": "#f5e14c",
    "e": "#f5e14c",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-352, -326, 298],
    "s": [89, 36, 2],
    "l": 1,
    "c": "#282828",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-728, -707, -127],
    "s": [186, 744, 214],
    "r": [-3.14, 0, 3.14],
    "c": "#757575",
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [-776, -900, -59],
    "s": [145, 1034, 142],
    "l": 1,
    "c": "#b6b6b6",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-642, 44, -83],
    "s": [4, 50, 112],
    "l": 1,
    "c": "#000337",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-645, 37, -37],
    "s": [4, 58, 4],
    "l": 1,
    "c": "#434343",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-645, 37, -127],
    "s": [4, 58, 4],
    "l": 1,
    "c": "#434343",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-642, 41, -83],
    "s": [1, 56, 118],
    "l": 1,
    "c": "#00b3ff",
    "e": "#00b3ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-776, 134, -59],
    "s": [150, 4, 149],
    "l": 1,
    "c": "#616161",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-715, 4, 36],
    "s": [3, 122, 33],
    "l": 1,
    "c": "#181717",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-717, 102, 15],
    "s": [3, 6, 9],
    "l": 1,
    "c": "#343434",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-717, 30, 15],
    "s": [3, 6, 9],
    "l": 1,
    "c": "#343434",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-715, 0, 36],
    "s": [1, 129, 39],
    "l": 1,
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-648, -72, -257],
    "s": [3, 100, 35],
    "l": 1,
    "c": "#181717",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-650, -6, -235],
    "s": [3, 6, 9],
    "l": 1,
    "c": "#343434",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-650, -42, -235],
    "s": [3, 6, 9],
    "l": 1,
    "c": "#343434",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-648, -74, -257],
    "s": [1, 104, 40],
    "l": 1,
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-660, 57, -221],
    "s": [17, 3, 6],
    "l": 1,
    "r": [-3.14, 0, -2.62],
    "c": "#f000ff",
    "e": "#f000ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-652, 52, -221],
    "s": [3, 12, 6],
    "l": 1,
    "r": [-3.14, 0, -2.62],
    "c": "#f000ff",
    "e": "#f000ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-657, 62, -221],
    "s": [3, 1, 6],
    "l": 1,
    "r": [-3.14, 0, -2.62],
    "c": "#f000ff",
    "e": "#f000ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-656, 65, -221],
    "s": [3, 1, 6],
    "l": 1,
    "r": [-3.14, 0, -2.62],
    "c": "#f000ff",
    "e": "#f000ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-682, 57, -221],
    "s": [17, 3, 6],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#f000ff",
    "e": "#f000ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-706, 61, -221],
    "s": [17, 3, 6],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#f000ff",
    "e": "#f000ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-705, 53, -221],
    "s": [17, 3, 6],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#f000ff",
    "e": "#f000ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-712, 52, -221],
    "s": [3, 12, 6],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#f000ff",
    "e": "#f000ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-729, 56, -221],
    "s": [17, 3, 6],
    "l": 1,
    "r": [3.14, 0, 2.62],
    "c": "#f000ff",
    "e": "#f000ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-728, 63, -221],
    "s": [3, 1, 6],
    "l": 1,
    "r": [-3.14, 0, -2.62],
    "c": "#f000ff",
    "e": "#f000ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-691, 44, -221],
    "s": [107, 30, 4],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#0012ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-653, 37, -221],
    "s": [5, 7, 4],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#575757",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-729, 37, -221],
    "s": [5, 7, 4],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#575757",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-636, -19, -125],
    "s": [3, 43, 183],
    "l": 1,
    "c": "#282828",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-636, -75, -125],
    "s": [3, 43, 183],
    "l": 1,
    "c": "#282828",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-636, -132, -125],
    "s": [3, 43, 183],
    "l": 1,
    "c": "#282828",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-640, 69, -49],
    "s": [2, 3, 23],
    "l": 1,
    "c": "#ff0086",
    "e": "#ff0086",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-640, 63, -43],
    "s": [2, 3, 17],
    "l": 1,
    "r": [-0.87, 0, 0],
    "c": "#ff0086",
    "e": "#ff0086",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-640, 78, -50],
    "s": [2, 2, 7],
    "l": 1,
    "r": [0.87, 0, 0],
    "c": "#ff0086",
    "e": "#ff0086",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-640, 68, -115],
    "s": [2, 3, 23],
    "l": 1,
    "c": "#ff0086",
    "e": "#ff0086",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-640, 77, -114],
    "s": [2, 2, 8],
    "l": 1,
    "r": [-0.35, 0, 0],
    "c": "#ff0086",
    "e": "#ff0086",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-640, 64, -81],
    "s": [2, 3, 20],
    "l": 1,
    "c": "#ff0086",
    "e": "#ff0086",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-640, 73, -81],
    "s": [2, 3, 20],
    "l": 1,
    "c": "#ff0086",
    "e": "#ff0086",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-640, 68, -91],
    "s": [2, 3, 21],
    "l": 1,
    "r": [1.57, 0, 0],
    "c": "#ff0086",
    "e": "#ff0086",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-640, 60, -115],
    "s": [2, 2, 8],
    "l": 1,
    "c": "#ff0086",
    "e": "#ff0086",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-714, 114, 45],
    "s": [2, 19, 3],
    "l": 1,
    "r": [-1.57, 0, 0],
    "c": "#00ff69",
    "e": "#00ff69",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-714, 98, 39],
    "s": [2, 19, 3],
    "l": 1,
    "r": [-0.7, 0, 0],
    "c": "#00ff69",
    "e": "#00ff69",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-714, 120, 41],
    "s": [2, 12, 2],
    "l": 1,
    "r": [-1.57, 0, 0],
    "c": "#00ff69",
    "e": "#00ff69",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-714, 80, 38],
    "s": [2, 3, 17],
    "l": 1,
    "r": [-1.57, 0, 0],
    "c": "#00ff69",
    "e": "#00ff69",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-714, 58, 45],
    "s": [2, 19, 3],
    "l": 1,
    "r": [-1.4, 0, 0],
    "c": "#00ff69",
    "e": "#00ff69",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-714, 54, 43],
    "s": [2, 3, 17],
    "l": 1,
    "r": [-1.57, 0, 0],
    "c": "#00ff69",
    "e": "#00ff69",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-714, 47, 43],
    "s": [2, 17, 3],
    "l": 1,
    "r": [-1.57, 0, 0],
    "c": "#00ff69",
    "e": "#00ff69",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-714, 25, 44],
    "s": [2, 17, 3],
    "l": 1,
    "r": [-1.57, 0, 0],
    "c": "#00ff69",
    "e": "#00ff69",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-714, 32, 40],
    "s": [2, 10, 3],
    "l": 1,
    "r": [-1.57, 0, 0],
    "c": "#00ff69",
    "e": "#00ff69",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-714, 25, 44],
    "s": [2, 17, 3],
    "l": 1,
    "r": [-2.27, 0, 0],
    "c": "#00ff69",
    "e": "#00ff69",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-648, 14, -258],
    "s": [4, 4, 22],
    "l": 1,
    "c": "#ffe100",
    "e": "#ffe100",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-646, 7, -262],
    "s": [4, 3, 8],
    "l": 1,
    "r": [0.87, 0, 0],
    "c": "#ffe100",
    "e": "#ffe100",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-648, -22, -258],
    "s": [4, 17, 5],
    "l": 1,
    "c": "#ffe100",
    "e": "#ffe100",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-648, -58, -258],
    "s": [4, 4, 20],
    "l": 1,
    "r": [-0.35, 0, 0],
    "c": "#ffe100",
    "e": "#ffe100",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-648, -49, -263],
    "s": [4, 3, 8],
    "l": 1,
    "r": [0.52, 0, 0],
    "c": "#ffe100",
    "e": "#ffe100",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-648, -36, -258],
    "s": [4, 4, 22],
    "l": 1,
    "c": "#ffe100",
    "e": "#ffe100",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-927, -958, -289],
    "s": [145, 1202, 142],
    "l": 1,
    "c": "#969696",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-927, 244, -289],
    "s": [148, 4, 146],
    "l": 1,
    "c": "#707070",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-854, -772, -290],
    "s": [3, 989, 116],
    "l": 1,
    "c": "#b6b6b6",
    "t": 3,
    "ts": 0,
    "td": 0
  }, {
    "p": [-852, 158, -334],
    "s": [1, 29, 28],
    "l": 1,
    "c": "#f5e14c",
    "e": "#f5e14c",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-852, 97, -276],
    "s": [1, 29, 28],
    "l": 1,
    "c": "#f5e14c",
    "e": "#f5e14c",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-852, -52, -276],
    "s": [1, 29, 28],
    "l": 1,
    "c": "#f5e14c",
    "e": "#f5e14c",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-852, -52, -335],
    "s": [1, 29, 28],
    "l": 1,
    "c": "#f5e14c",
    "e": "#f5e14c",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-852, -143, -304],
    "s": [1, 29, 28],
    "l": 1,
    "c": "#f5e14c",
    "e": "#f5e14c",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-852, -353, -305],
    "s": [1, 29, 28],
    "l": 1,
    "c": "#f5e14c",
    "e": "#f5e14c",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-854, -772, -290],
    "s": [3, 989, 116],
    "l": 1,
    "c": "#b6b6b6",
    "t": 3,
    "ts": 0,
    "td": 0
  }, {
    "p": [-836, -868, -520],
    "s": [145, 1034, 142],
    "c": "#828282",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-787, -748, -572],
    "s": [158, 757, 139],
    "c": "#7d7d7d",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-836, 166, -520],
    "s": [152, 4, 150],
    "l": 1,
    "c": "#919191",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-716, 13, -576],
    "s": [3, 47, 111],
    "l": 1,
    "c": "#484848",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-718, 9, -534],
    "s": [3, 53, 4],
    "l": 1,
    "c": "#696969",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-718, 9, -617],
    "s": [3, 53, 4],
    "l": 1,
    "c": "#696969",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-763, 93, -521],
    "s": [3, 60, 128],
    "c": "#3c3c3c",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-763, 90, -521],
    "s": [7, 3, 131],
    "l": 1,
    "c": "#393939",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-714, 37, -576],
    "s": [109, 0, 45],
    "i": 11,
    "l": 1,
    "r": [1.57, 0, -1.57],
    "bb": 3
  }, {
    "p": [-761, 123, -521],
    "s": [128, 0, 61],
    "i": 11,
    "l": 1,
    "r": [1.57, 0, -1.57],
    "bb": 4
  }, {
    "p": [-779, 145, -581],
    "s": [2, 76, 2],
    "l": 1,
    "c": "#aaaaaa",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-779, 221, -581],
    "s": [3, 4, 3],
    "l": 1,
    "c": "#000000",
    "e": "#ff0000",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-763, 45, -520],
    "s": [3, 37, 121],
    "l": 1,
    "c": "#282828",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-708, -83, -573],
    "s": [3, 37, 121],
    "l": 1,
    "c": "#282828",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-708, -129, -573],
    "s": [3, 37, 121],
    "l": 1,
    "c": "#282828",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-708, -175, -573],
    "s": [3, 37, 121],
    "l": 1,
    "c": "#282828",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-708, -221, -573],
    "s": [3, 37, 121],
    "l": 1,
    "c": "#282828",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-708, -268, -573],
    "s": [3, 37, 121],
    "l": 1,
    "c": "#282828",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-708, -37, -573],
    "s": [3, 37, 121],
    "l": 1,
    "c": "#282828",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-763, -4, -520],
    "s": [3, 37, 121],
    "l": 1,
    "c": "#282828",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-763, -51, -520],
    "s": [3, 37, 121],
    "l": 1,
    "c": "#282828",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-763, -99, -520],
    "s": [3, 37, 121],
    "l": 1,
    "c": "#282828",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-763, -149, -520],
    "s": [3, 37, 121],
    "l": 1,
    "c": "#282828",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-763, -197, -520],
    "s": [3, 37, 121],
    "l": 1,
    "c": "#282828",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-763, -246, -520],
    "s": [3, 37, 121],
    "l": 1,
    "c": "#282828",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-763, -295, -520],
    "s": [3, 37, 121],
    "l": 1,
    "c": "#282828",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-776, 49, -615],
    "s": [3, 112, 31],
    "l": 1,
    "c": "#000337",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-776, 46, -615],
    "s": [1, 118, 36],
    "l": 1,
    "c": "#00b3ff",
    "e": "#00b3ff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-776, 135, -595],
    "s": [3, 5, 10],
    "l": 1,
    "c": "#181717",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-776, 68, -595],
    "s": [3, 5, 10],
    "l": 1,
    "c": "#181717",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-774, 139, -615],
    "s": [2, 3, 18],
    "l": 1,
    "c": "#ff0086",
    "e": "#ff0086",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-774, 127, -615],
    "s": [2, 3, 18],
    "l": 1,
    "c": "#ff0086",
    "e": "#ff0086",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-774, 111, -614],
    "s": [2, 3, 18],
    "l": 1,
    "r": [-0.17, 0, 0],
    "c": "#ff0086",
    "e": "#ff0086",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-774, 121, -611],
    "s": [2, 3, 20],
    "l": 1,
    "r": [1.57, 0, 0],
    "c": "#ff0086",
    "e": "#ff0086",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-774, 147, -615],
    "s": [2, 2, 8],
    "l": 1,
    "c": "#ff0086",
    "e": "#ff0086",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-774, 90, -615],
    "s": [2, 3, 18],
    "l": 1,
    "r": [-0.52, 0, 0],
    "c": "#ff0086",
    "e": "#ff0086",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-774, 99, -616],
    "s": [2, 2, 8],
    "l": 1,
    "c": "#ff0086",
    "e": "#ff0086",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-774, 89, -610],
    "s": [2, 3, 14],
    "l": 1,
    "r": [1.57, 0, 0],
    "c": "#ff0086",
    "e": "#ff0086",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-774, 71, -615],
    "s": [2, 3, 18],
    "l": 1,
    "c": "#ff0086",
    "e": "#ff0086",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-774, 60, -610],
    "s": [2, 7, 3],
    "l": 1,
    "r": [0.17, 0, 0],
    "c": "#ff0086",
    "e": "#ff0086",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-776, 30, -426],
    "s": [3, 122, 33],
    "l": 1,
    "c": "#181717",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-776, 128, -447],
    "s": [3, 6, 9],
    "l": 1,
    "c": "#343434",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-776, 56, -447],
    "s": [3, 6, 9],
    "l": 1,
    "c": "#343434",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-776, 27, -426],
    "s": [1, 127, 37],
    "l": 1,
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-775, 140, -417],
    "s": [2, 19, 3],
    "l": 1,
    "r": [-1.57, 0, 0],
    "c": "#00ff69",
    "e": "#00ff69",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-775, 124, -423],
    "s": [2, 19, 3],
    "l": 1,
    "r": [-0.7, 0, 0],
    "c": "#00ff69",
    "e": "#00ff69",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-775, 146, -421],
    "s": [2, 12, 2],
    "l": 1,
    "r": [-1.57, 0, 0],
    "c": "#00ff69",
    "e": "#00ff69",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-775, 106, -424],
    "s": [2, 3, 17],
    "l": 1,
    "r": [-1.57, 0, 0],
    "c": "#00ff69",
    "e": "#00ff69",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-775, 84, -417],
    "s": [2, 19, 3],
    "l": 1,
    "r": [-1.4, 0, 0],
    "c": "#00ff69",
    "e": "#00ff69",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-775, 80, -419],
    "s": [2, 3, 17],
    "l": 1,
    "r": [-1.57, 0, 0],
    "c": "#00ff69",
    "e": "#00ff69",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-775, 73, -419],
    "s": [2, 17, 3],
    "l": 1,
    "r": [-1.57, 0, 0],
    "c": "#00ff69",
    "e": "#00ff69",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-775, 51, -418],
    "s": [2, 17, 3],
    "l": 1,
    "r": [-1.57, 0, 0],
    "c": "#00ff69",
    "e": "#00ff69",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-775, 58, -422],
    "s": [2, 10, 3],
    "l": 1,
    "r": [-1.57, 0, 0],
    "c": "#00ff69",
    "e": "#00ff69",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-775, 51, -418],
    "s": [2, 17, 3],
    "l": 1,
    "r": [-2.27, 0, 0],
    "c": "#00ff69",
    "e": "#00ff69",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-448, 43, -706],
    "s": [128, 42, 6],
    "l": 1,
    "c": "#1b1b1b",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-404, 58, -704],
    "s": [20, 2, 4],
    "l": 1,
    "r": [0, 0, -0.87],
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-394, 59, -703],
    "s": [20, 2, 3],
    "l": 1,
    "r": [0, 0, -2.27],
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-400, 67, -703],
    "s": [23, 2, 3],
    "l": 1,
    "r": [0, 0, 3.14],
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-400, 75, -703],
    "s": [2, 11, 3],
    "l": 1,
    "r": [0, 0, 3.14],
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-428, 53, -704],
    "s": [7, 2, 5],
    "l": 1,
    "r": [0, 0, 3.14],
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-428, 59, -704],
    "s": [10, 2, 6],
    "l": 1,
    "r": [0, 0, 3.14],
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-426, 75, -703],
    "s": [2, 18, 3],
    "l": 1,
    "r": [0, 0, -2.79],
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-427, 73, -703],
    "s": [20, 2, 3],
    "l": 1,
    "r": [0, 0, -2.79],
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-429, 67, -703],
    "s": [20, 2, 3],
    "l": 1,
    "r": [0, 0, -2.79],
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-456, 76, -703],
    "s": [2, 20, 3],
    "l": 1,
    "r": [0, 0, 2.8],
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-454, 73, -703],
    "s": [15, 2, 2],
    "l": 1,
    "r": [0, 0, -3.05],
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-462, 68, -704],
    "s": [2, 15, 5],
    "l": 1,
    "r": [0, 0, -3.13],
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-456, 57, -703],
    "s": [2, 5, 3],
    "l": 1,
    "r": [0, 0, -3.14],
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-463, 54, -703],
    "s": [12, 2, 3],
    "l": 1,
    "r": [0, 0, 2.97],
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-468, 74, -703],
    "s": [9, 2, 3],
    "l": 1,
    "r": [0, 0, 2.79],
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-492, 74, -703],
    "s": [2, 11, 4],
    "l": 1,
    "r": [0, 0, -3.14],
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-497, 74, -703],
    "s": [2, 11, 4],
    "l": 1,
    "r": [0, 0, -3.14],
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-501, 69, -703],
    "s": [2, 6, 4],
    "l": 1,
    "r": [0, 0, -3.14],
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-495, 70, -703],
    "s": [12, 2, 4],
    "l": 1,
    "r": [0, 0, -3.14],
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-489, 69, -703],
    "s": [2, 6, 4],
    "l": 1,
    "r": [0, 0, -3.14],
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-495, 75, -703],
    "s": [14, 2, 4],
    "l": 1,
    "r": [0, 0, -3.14],
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-495, 54, -703],
    "s": [2, 8, 3],
    "l": 1,
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-495, 55, -703],
    "s": [14, 2, 3],
    "l": 1,
    "r": [0, 0, -3.14],
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-448, 41, -706],
    "s": [131, 2, 9],
    "l": 1,
    "c": "#000000",
    "e": "#ff0000",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-448, 85, -706],
    "s": [131, 2, 9],
    "l": 1,
    "c": "#000000",
    "e": "#ff0000",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-513, 41, -706],
    "s": [2, 46, 9],
    "l": 1,
    "c": "#000000",
    "e": "#ff0000",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-384, 41, -706],
    "s": [3, 46, 9],
    "l": 1,
    "c": "#000000",
    "e": "#ff0000",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [250, -10, -43],
    "s": [3, 48, 113],
    "l": 1,
    "c": "#434343",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [248, 14, -43],
    "s": [110, 0, 46],
    "i": 11,
    "l": 1,
    "r": [1.57, 0, 1.57],
    "bb": 2
  }, {
    "p": [-81, -24, -204],
    "s": [9, 24, 45],
    "c": "#4a4a4a",
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [-289, 26, -49],
    "s": [10, 11, 20],
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-289, 23, -49],
    "s": [9, 11, 19],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [308, -706, -398],
    "s": [139, 873, 142],
    "c": "#616161",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [268, -708, -357],
    "s": [123, 763, 135],
    "r": [-3.14, 0, 3.14],
    "c": "#a0a0a0",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [308, 167, -398],
    "s": [143, 3, 146],
    "c": "#575757",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [213, 63, -353],
    "s": [4, 50, 112],
    "l": 1,
    "c": "#000337",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [211, 112, -353],
    "s": [2, 2, 112],
    "l": 1,
    "c": "#000de8",
    "e": "#004aff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [211, 62, -353],
    "s": [2, 2, 112],
    "l": 1,
    "c": "#000de8",
    "e": "#004aff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [211, 62, -409],
    "s": [2, 52, 2],
    "l": 1,
    "c": "#000de8",
    "e": "#004aff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [211, 62, -297],
    "s": [2, 52, 2],
    "l": 1,
    "c": "#000de8",
    "e": "#004aff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [216, 57, -307],
    "s": [4, 58, 4],
    "l": 1,
    "c": "#434343",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [216, 57, -397],
    "s": [4, 58, 4],
    "l": 1,
    "c": "#434343",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [267, 55, -356],
    "s": [126, 2, 137],
    "l": 1,
    "r": [-3.14, 0, 3.14],
    "c": "#4d4d4d",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [254, -3, -495],
    "s": [3, 164, 35],
    "l": 1,
    "c": "#181717",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [256, 37, -473],
    "s": [3, 6, 9],
    "l": 1,
    "c": "#343434",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [256, 127, -473],
    "s": [3, 6, 9],
    "l": 1,
    "c": "#343434",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [254, -6, -495],
    "s": [1, 170, 42],
    "l": 1,
    "c": "#0eff00",
    "e": "#0eff00",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [213, 40, -276],
    "s": [4, 16, 4],
    "l": 1,
    "c": "#00ff2d",
    "e": "#00ff2d",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [213, 39, -276],
    "s": [1, 18, 6],
    "l": 1,
    "c": "#252a26",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [213, 45, -276],
    "s": [1, 6, 17],
    "l": 1,
    "c": "#252a26",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [213, 47, -287],
    "s": [1, 2, 5],
    "l": 1,
    "c": "#252a26",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [205, -7, -355],
    "s": [3, 56, 125],
    "c": "#5a5a5a",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [203, -10, -356],
    "s": [5, 3, 128],
    "l": 1,
    "c": "#575656",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [308, 103, -326],
    "s": [113, 55, 3],
    "l": 1,
    "c": "#3c3c3c",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [308, 102, -326],
    "s": [119, 2, 8],
    "l": 1,
    "c": "#5c5c5c",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [213, 46, -276],
    "s": [4, 4, 15],
    "l": 1,
    "c": "#00ff2d",
    "e": "#00ff2d",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [290, 57, -295],
    "s": [2, 23, 2],
    "l": 1,
    "c": "#373737",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [270, -18, -275],
    "s": [41, 1, 19],
    "l": 1,
    "c": "#646464",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [290, 79, -285],
    "s": [3, 3, 27],
    "l": 1,
    "c": "#373737",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [290, -17, -275],
    "s": [1, 96, 1],
    "l": 1,
    "c": "#505050",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [250, -17, -275],
    "s": [1, 97, 1],
    "l": 1,
    "c": "#505050",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [250, 79, -285],
    "s": [3, 3, 27],
    "l": 1,
    "c": "#373737",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [250, 57, -295],
    "s": [2, 23, 2],
    "l": 1,
    "c": "#373737",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [270, -18, -265],
    "s": [43, 2, 1],
    "l": 1,
    "c": "#e84d4d",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [270, -18, -285],
    "s": [43, 2, 1],
    "l": 1,
    "c": "#e84d4d",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [249, -18, -275],
    "s": [1, 2, 19],
    "l": 1,
    "c": "#e84d4d",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [291, -18, -275],
    "s": [1, 2, 19],
    "l": 1,
    "c": "#e84d4d",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [249, -16, -265],
    "s": [1, 11, 1],
    "l": 1,
    "c": "#e84d4d",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [291, -16, -265],
    "s": [1, 11, 1],
    "l": 1,
    "c": "#e84d4d",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [291, -16, -285],
    "s": [1, 11, 1],
    "l": 1,
    "c": "#e84d4d",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [249, -16, -285],
    "s": [1, 11, 1],
    "l": 1,
    "c": "#e84d4d",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [270, -16, -265],
    "s": [1, 11, 1],
    "l": 1,
    "c": "#e84d4d",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [270, -16, -285],
    "s": [1, 11, 1],
    "l": 1,
    "c": "#e84d4d",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [270, -5, -265],
    "s": [44, 1, 2],
    "l": 1,
    "c": "#e84d4d",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [270, -5, -285],
    "s": [44, 1, 2],
    "l": 1,
    "c": "#e84d4d",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [249, -16, -275],
    "s": [1, 11, 1],
    "l": 1,
    "c": "#e84d4d",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [291, -16, -275],
    "s": [1, 11, 1],
    "l": 1,
    "c": "#e84d4d",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [291, -5, -275],
    "s": [2, 1, 18],
    "l": 1,
    "c": "#e84d4d",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [249, -5, -275],
    "s": [2, 1, 18],
    "l": 1,
    "c": "#e84d4d",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [308, 131, -324],
    "s": [108, 0, 50],
    "i": 11,
    "l": 1,
    "r": [1.57, 0, 0],
    "bb": 1
  }, {
    "p": [203, 21, -355],
    "s": [120, 0, 53],
    "i": 11,
    "l": 1,
    "r": [1.57, 0, 1.57],
    "bb": 4
  }, {
    "p": [271, 27, -286],
    "s": [104, 0, 42],
    "i": 11,
    "l": 1,
    "r": [1.57, 0, 0],
    "bb": 2
  }, {
    "p": [270, 4, -288],
    "s": [106, 45, 3],
    "c": "#3c3c3c",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [268, -43, -289],
    "s": [104, 36, 2],
    "l": 1,
    "c": "#282828",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [268, -88, -289],
    "s": [104, 36, 2],
    "l": 1,
    "c": "#f5e14c",
    "e": "#f5e14c",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [268, -133, -289],
    "s": [104, 36, 2],
    "l": 1,
    "c": "#282828",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [268, -179, -289],
    "s": [104, 36, 2],
    "l": 1,
    "c": "#282828",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [268, -226, -289],
    "s": [104, 36, 2],
    "l": 1,
    "c": "#282828",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [268, -273, -289],
    "s": [104, 36, 2],
    "l": 1,
    "c": "#282828",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [268, -319, -289],
    "s": [104, 36, 2],
    "l": 1,
    "c": "#282828",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [268, -365, -289],
    "s": [104, 36, 2],
    "l": 1,
    "c": "#282828",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [205, -67, -356],
    "s": [3, 47, 117],
    "l": 1,
    "c": "#282828",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [205, -124, -356],
    "s": [3, 47, 117],
    "l": 1,
    "c": "#282828",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [205, -182, -356],
    "s": [3, 47, 117],
    "l": 1,
    "c": "#282828",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [205, -243, -356],
    "s": [3, 47, 117],
    "l": 1,
    "c": "#282828",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [253, 131, -502],
    "s": [4, 3, 24],
    "l": 1,
    "r": [1.74, 0, 0],
    "c": "#ff004a",
    "e": "#ff004a",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [253, 119, -495],
    "s": [4, 3, 19],
    "l": 1,
    "r": [-0.01, 0, 0],
    "c": "#ff004a",
    "e": "#ff004a",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [253, 119, -487],
    "s": [4, 9, 3],
    "l": 1,
    "r": [-0.01, 0, 0],
    "c": "#ff004a",
    "e": "#ff004a",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [253, 101, -495],
    "s": [4, 3, 21],
    "l": 1,
    "r": [-0.01, 0, 0],
    "c": "#ff004a",
    "e": "#ff004a",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [253, 91, -497],
    "s": [4, 3, 12],
    "l": 1,
    "r": [0.51, 0, 0],
    "c": "#ff004a",
    "e": "#ff004a",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [253, 57, -494],
    "s": [4, 12, 3],
    "l": 1,
    "r": [-0.01, 0, 0],
    "c": "#ff004a",
    "e": "#ff004a",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [253, 73, -495],
    "s": [4, 3, 19],
    "l": 1,
    "r": [-0.01, 0, 0],
    "c": "#ff004a",
    "e": "#ff004a",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [253, 23, -486],
    "s": [4, 16, 3],
    "l": 1,
    "r": [-0.01, 0, 0],
    "c": "#ff004a",
    "e": "#ff004a",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [253, 23, -502],
    "s": [4, 16, 3],
    "l": 1,
    "r": [-0.01, 0, 0],
    "c": "#ff004a",
    "e": "#ff004a",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [253, 23, -494],
    "s": [4, 3, 19],
    "l": 1,
    "r": [-0.01, 0, 0],
    "c": "#ff004a",
    "e": "#ff004a",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [253, 36, -494],
    "s": [4, 3, 19],
    "l": 1,
    "r": [-0.01, 0, 0],
    "c": "#ff004a",
    "e": "#ff004a",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [253, 32, -494],
    "s": [4, 12, 3],
    "l": 1,
    "r": [-0.01, 0, 0],
    "c": "#ff004a",
    "e": "#ff004a",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [211, 62, -397],
    "s": [2, 16, 1],
    "l": 1,
    "c": "#000de8",
    "e": "#004aff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [211, 69, -398],
    "s": [2, 1, 20],
    "l": 1,
    "c": "#000de8",
    "e": "#004aff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [211, 73, -393],
    "s": [2, 1, 11],
    "l": 1,
    "r": [0.7, 0, 0],
    "c": "#000de8",
    "e": "#004aff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [211, 76, -394],
    "s": [2, 2, 16],
    "l": 1,
    "r": [0.35, 0, 0],
    "c": "#000de8",
    "e": "#004aff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [211, 80, -393],
    "s": [2, 4, 18],
    "l": 1,
    "r": [0.35, 0, 0],
    "c": "#000de8",
    "e": "#004aff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [211, 82, -394],
    "s": [2, 4, 12],
    "l": 1,
    "c": "#000de8",
    "e": "#004aff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [211, 81, -390],
    "s": [2, 4, 7],
    "l": 1,
    "r": [0.87, 0, 0],
    "c": "#000de8",
    "e": "#004aff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [211, 83, -401],
    "s": [2, 12, 2],
    "l": 1,
    "c": "#000de8",
    "e": "#004aff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [211, 92, -394],
    "s": [2, 7, 2],
    "l": 1,
    "c": "#000de8",
    "e": "#004aff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [211, 91, -394],
    "s": [2, 9, 2],
    "l": 1,
    "r": [-1.05, 0, 0],
    "c": "#000de8",
    "e": "#004aff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [211, 97, -395],
    "s": [2, 5, 6],
    "l": 1,
    "r": [0.52, 0, 0],
    "c": "#000de8",
    "e": "#004aff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [211, 100, -399],
    "s": [2, 1, 10],
    "l": 1,
    "r": [0.69, 0, 0],
    "c": "#000de8",
    "e": "#004aff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [211, 101, -397],
    "s": [2, 1, 11],
    "l": 1,
    "r": [0.35, 0, 0],
    "c": "#000de8",
    "e": "#004aff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [210, 99, -394],
    "s": [1, 1, 2],
    "l": 1,
    "r": [0.52, 0, 0],
    "c": "#e80000",
    "e": "#ff0000",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [211, 75, -378],
    "s": [2, 26, 3],
    "l": 1,
    "c": "#e80000",
    "e": "#ff0000",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [211, 89, -375],
    "s": [2, 3, 9],
    "l": 1,
    "c": "#e80000",
    "e": "#ff0000",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [211, 80, -372],
    "s": [2, 3, 12],
    "l": 1,
    "r": [1.05, 0, 0],
    "c": "#e80000",
    "e": "#ff0000",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [211, 96, -371],
    "s": [2, 3, 9],
    "l": 1,
    "r": [-0.87, 0, 0],
    "c": "#e80000",
    "e": "#ff0000",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [211, 76, -352],
    "s": [2, 24, 3],
    "l": 1,
    "c": "#e80000",
    "e": "#ff0000",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [211, 94, -354],
    "s": [2, 3, 14],
    "l": 1,
    "c": "#e80000",
    "e": "#ff0000",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [211, 85, -357],
    "s": [2, 3, 14],
    "l": 1,
    "c": "#e80000",
    "e": "#ff0000",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [211, 95, -360],
    "s": [2, 5, 3],
    "l": 1,
    "r": [-0.35, 0, 0],
    "c": "#e80000",
    "e": "#ff0000",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [211, 83, -360],
    "s": [2, 12, 3],
    "l": 1,
    "c": "#e80000",
    "e": "#ff0000",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [211, 76, -363],
    "s": [2, 12, 3],
    "l": 1,
    "r": [0.35, 0, 0],
    "c": "#e80000",
    "e": "#ff0000",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [211, 76, -333],
    "s": [2, 25, 3],
    "l": 1,
    "c": "#e80000",
    "e": "#ff0000",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [211, 76, -344],
    "s": [2, 9, 3],
    "l": 1,
    "r": [0.52, 0, 0],
    "c": "#e80000",
    "e": "#ff0000",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [211, 87, -342],
    "s": [2, 9, 3],
    "l": 1,
    "c": "#e80000",
    "e": "#ff0000",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [211, 95, -342],
    "s": [2, 5, 3],
    "l": 1,
    "r": [-0.35, 0, 0],
    "c": "#e80000",
    "e": "#ff0000",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [211, 93, -342],
    "s": [2, 12, 3],
    "l": 1,
    "r": [2.27, 0, 0],
    "c": "#e80000",
    "e": "#ff0000",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [211, 97, -322],
    "s": [2, 3, 9],
    "l": 1,
    "c": "#e80000",
    "e": "#ff0000",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [211, 83, -321],
    "s": [2, 14, 3],
    "l": 1,
    "c": "#e80000",
    "e": "#ff0000",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [211, 75, -326],
    "s": [2, 11, 3],
    "l": 1,
    "r": [0.52, 0, 0],
    "c": "#e80000",
    "e": "#ff0000",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [211, 79, -309],
    "s": [2, 22, 3],
    "l": 1,
    "c": "#e80000",
    "e": "#ff0000",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [211, 95, -311],
    "s": [2, 3, 9],
    "l": 1,
    "c": "#e80000",
    "e": "#ff0000",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [211, 76, -311],
    "s": [2, 3, 9],
    "l": 1,
    "c": "#e80000",
    "e": "#ff0000",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-81, 19, -204],
    "s": [9, 4, 45],
    "c": "#4a4a4a",
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [-181, -17, 18],
    "s": [154, 2, 2],
    "c": "#464646",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-165, 38, -342],
    "s": [61, 20, 9],
    "c": "#4a4a4a",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-121, -629, -361],
    "s": [32, 636, 48],
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-64, 7, -361],
    "s": [4, 1, 49],
    "l": 1,
    "c": "#4a4a4a",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-49, 7, -384],
    "s": [34, 1, 4],
    "l": 1,
    "c": "#4a4a4a",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-121, 7, -384],
    "s": [34, 1, 4],
    "l": 1,
    "c": "#4a4a4a",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-124, -5, -437],
    "s": [22, 11, 8],
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-124, -7, -437],
    "s": [21, 11, 6],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-105, -4, -437],
    "s": [22, 4, 4],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-100, -7, -437],
    "s": [1, 8, 6],
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-96, -8, -437],
    "s": [4, 4, 4],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-30, 7, -447],
    "s": [4, 1, 46],
    "l": 1,
    "c": "#4a4a4a",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-11, 7, -426],
    "s": [34, 1, 4],
    "l": 1,
    "c": "#4a4a4a",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-11, 7, -468],
    "s": [34, 1, 4],
    "l": 1,
    "c": "#4a4a4a",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-32, -8, -432],
    "s": [2, 15, 4],
    "i": 3,
    "c": "#ab1212",
    "t": 5,
    "d": 2
  }, {
    "p": [-85, -27, -345],
    "s": [40, 20, 77],
    "i": 9,
    "t": 5,
    "d": 3,
    "ts": 0,
    "td": 0
  }, {
    "p": [-215, -27, -247],
    "s": [40, 10, 40],
    "i": 9,
    "t": 5,
    "d": 1,
    "ts": 0,
    "td": 0
  }, {
    "p": [-160, -17, -207],
    "s": [70, 4, 40],
    "i": 9,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-329, -27, -5],
    "s": [92, 14, 36],
    "i": 9,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-181, 3, -28],
    "s": [120, 50, 108],
    "i": 14,
    "l": 1
  }, {
    "p": [-375, -8, -358],
    "s": [137, 50, 99],
    "i": 14,
    "l": 1
  }, {
    "p": [-55, -7, -436],
    "s": [154, 50, 98],
    "i": 14,
    "l": 1
  }, {
    "p": [0, -7, -367],
    "s": [24, 36, 24],
    "i": 23,
    "l": 1,
    "tm": 0
  }, {
    "p": [-414, -27, -57],
    "s": [24, 36, 24],
    "i": 23,
    "l": 1,
    "tm": "1"
  }, {
    "p": [-119, -7, -386],
    "s": [2, 15, 4],
    "i": 3,
    "c": "#ab1212",
    "t": 5,
    "d": 3
  }, {
    "p": [-242, -14, -6],
    "s": [2, 18, 4],
    "i": 3,
    "c": "#ab1212",
    "t": 5,
    "d": 2
  }, {
    "p": [-221, 1, -28],
    "s": [42, 2, 110],
    "c": "#282828",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-181, 1, 20],
    "s": [38, 2, 14],
    "c": "#282828",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-103, -17, 15],
    "s": [2, 2, 60],
    "c": "#464646",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-259, -17, 31],
    "s": [2, 2, 28],
    "c": "#464646",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-128, 3, -74],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-232, 3, 8],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-35, -27, -36],
    "s": [40, 14, 34],
    "i": 9,
    "t": 5,
    "d": 2,
    "ts": 0,
    "td": 0
  }, {
    "p": [-214, -14, 27],
    "s": [2, 17, 4],
    "i": 3,
    "c": "#ab1212",
    "t": 5,
    "d": 1
  }, {
    "p": [-81, -10, -117],
    "s": [10, 11, 20],
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-81, -13, -117],
    "s": [9, 11, 19],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-81, -10, -72],
    "s": [10, 11, 20],
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-81, -13, -72],
    "s": [9, 11, 19],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-81, -10, -111],
    "s": [5, 4, 69],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-81, -13, -92],
    "s": [6, 8, 1],
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-81, -13, -140],
    "s": [6, 8, 1],
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-217, -11, -162],
    "s": [22, 11, 8],
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-217, -13, -162],
    "s": [21, 11, 6],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-176, -11, -162],
    "s": [22, 11, 8],
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-176, -13, -162],
    "s": [21, 11, 6],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-205, -13, -162],
    "s": [1, 8, 6],
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-188, -13, -162],
    "s": [1, 8, 6],
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-163, -13, -162],
    "s": [1, 8, 6],
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-129, -14, -162],
    "s": [4, 8, 4],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-133, -13, -162],
    "s": [1, 8, 6],
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-260, -629, -225],
    "s": [50, 652, 84],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [-277, -14, -177],
    "s": [6, 9, 1],
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-259, -14, -171],
    "s": [44, 36, 1],
    "c": "#ffffff",
    "t": 12,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [-260, -27, -225],
    "s": [51, 27, 85],
    "c": "#4a4a4a",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-277, -10, -157],
    "s": [10, 11, 20],
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-277, -13, -157],
    "s": [9, 11, 19],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-277, -10, -115],
    "s": [10, 11, 20],
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-277, -13, -115],
    "s": [9, 11, 19],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-277, -10, -150],
    "s": [5, 4, 65],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-277, -13, -136],
    "s": [6, 8, 1],
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-246, -13, -183],
    "s": [1, 12, 3],
    "c": "#ffffff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-250, -13, -183],
    "s": [1, 12, 3],
    "c": "#ffffff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-242, -17, 31],
    "s": [2, 2, 24],
    "c": "#464646",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-181, -16, 31],
    "s": [155, 1, 24],
    "v": 1,
    "t": 12,
    "ts": 0,
    "td": 0
  }, {
    "p": [-303, -12, 15],
    "s": [144, 2, 4],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-81, -14, -143],
    "s": [5, 4, 5],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-133, -13, -113],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-145, -13, -113],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-140, -1, -113],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-171, -10, -162],
    "s": [78, 4, 4],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-57, 13, -81],
    "s": [3, 7, 5],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-57, 12, -84],
    "s": [4, 9, 1],
    "c": "#cfcfcf",
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [-57, 12, -82],
    "s": [4, 1, 3],
    "c": "#cfcfcf",
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [-57, 20, -82],
    "s": [4, 1, 3],
    "c": "#cfcfcf",
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [-57, 28, -81],
    "s": [3, 7, 5],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-57, 27, -84],
    "s": [4, 9, 1],
    "c": "#cfcfcf",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-57, 27, -77],
    "s": [4, 9, 7],
    "c": "#cfcfcf",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-57, 27, -82],
    "s": [4, 1, 3],
    "c": "#cfcfcf",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-57, 35, -82],
    "s": [4, 1, 3],
    "c": "#cfcfcf",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-55, 16, -70],
    "s": [2, 1, 7],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [-55, 31, -71],
    "s": [2, 1, 7],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-55, 16, -66],
    "s": [2, 88, 1],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [-55, 32, -68],
    "s": [2, 72, 1],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-57, 12, -77],
    "s": [4, 9, 7],
    "c": "#cfcfcf",
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [-180, 3, -27],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-180, 3, -15],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-180, 15, -21],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-180, 1, -21],
    "s": [2, 27, 13],
    "l": 1,
    "c": "#282828",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-180, 0, -21],
    "s": [2, 16, 25],
    "l": 1,
    "c": "#282828",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-180, 3, -21],
    "s": [13, 25, 2],
    "l": 1,
    "c": "#282828",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-180, -14, -21],
    "s": [12, 29, 24],
    "l": 1,
    "c": "#ffffff",
    "t": 12,
    "ts": 0,
    "td": 0
  }, {
    "p": [-180, 15, -21],
    "s": [12, 12, 12],
    "c": "#ffffff",
    "t": 12,
    "ts": 0,
    "td": 0
  }, {
    "p": [-180, 8, -18],
    "s": [14, 3, 2],
    "l": 1,
    "c": "#8e8e8e",
    "t": 11,
    "ts": 0,
    "td": 0
  }, {
    "p": [-180, 8, -16],
    "s": [14, 3, 2],
    "l": 1,
    "c": "#d2cfcf",
    "t": 11,
    "ts": 0,
    "td": 0
  }, {
    "p": [-180, 9, -17],
    "s": [15, 1, 1],
    "l": 1,
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-66, -14, -182],
    "s": [25, 61, 3],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-375, -38, -387],
    "s": [140, 30, 200],
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-465, -38, -407],
    "s": [40, 30, 40],
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-447, -38, -337],
    "s": [4, 33, 100],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-487, -638, -357],
    "s": [4, 633, 140],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-375, -38, -469],
    "s": [140, 44, 38],
    "c": "#ffffff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-325, -38, -431],
    "s": [40, 44, 38],
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-345, -38, -410],
    "s": [82, 46, 4],
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-455, -38, -457],
    "s": [20, 30, 60],
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-434, -38, -497],
    "s": [62, 30, 20],
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-477, -638, -429],
    "s": [24, 633, 4],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-467, -638, -469],
    "s": [4, 633, 76],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-437, -638, -509],
    "s": [64, 633, 4],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-359, 6, -557],
    "s": [108, 1, 4],
    "c": "#4a4a4a",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-413, -8, -497],
    "s": [2, 14, 4],
    "i": 3,
    "c": "#ab1212",
    "t": 5,
    "d": 2
  }, {
    "p": [-437, -5, -509],
    "s": [64, 1, 4],
    "c": "#4a4a4a",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-467, -5, -469],
    "s": [4, 1, 76],
    "c": "#4a4a4a",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-477, -5, -429],
    "s": [24, 1, 4],
    "c": "#4a4a4a",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-487, -5, -357],
    "s": [4, 1, 140],
    "c": "#4a4a4a",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-447, -5, -337],
    "s": [4, 1, 100],
    "c": "#4a4a4a",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-344, 8, -410],
    "s": [84, 1, 4],
    "c": "#4a4a4a",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-412, 6, -535],
    "s": [4, 1, 48],
    "c": "#4a4a4a",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-403, -38, -501],
    "s": [4, 33, 20],
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-403, -5, -501],
    "s": [4, 1, 20],
    "c": "#4a4a4a",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-317, -7, -408],
    "s": [2, 16, 4],
    "i": 3,
    "c": "#ab1212",
    "t": 5,
    "d": 1
  }, {
    "p": [-359, -638, -523],
    "s": [108, 644, 70],
    "c": "#ffffff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-412, 6, -535],
    "s": [1, 30, 44],
    "pe": 1,
    "c": "#4a4a4a",
    "t": 12,
    "ts": 0,
    "td": 0
  }, {
    "p": [-414, 7, -557],
    "s": [2, 31, 2],
    "l": 1,
    "c": "#4a4a4a",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-412, 6, -513],
    "s": [2, 31, 2],
    "l": 1,
    "c": "#4a4a4a",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-390, 6, -557],
    "s": [46, 30, 1],
    "pe": 1,
    "c": "#4a4a4a",
    "t": 12,
    "ts": 0,
    "td": 0
  }, {
    "p": [-366, 6, -557],
    "s": [2, 31, 2],
    "l": 1,
    "c": "#4a4a4a",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-467, -4, -486],
    "s": [1, 30, 46],
    "pe": 1,
    "c": "#4a4a4a",
    "t": 12,
    "ts": 0,
    "td": 0
  }, {
    "p": [-454, -4, -509],
    "s": [26, 30, 1],
    "pe": 1,
    "c": "#4a4a4a",
    "t": 12,
    "ts": 0,
    "td": 0
  }, {
    "p": [-467, -4, -509],
    "s": [2, 31, 2],
    "l": 1,
    "c": "#4a4a4a",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-467, -4, -463],
    "s": [2, 31, 2],
    "l": 1,
    "c": "#4a4a4a",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-441, -4, -509],
    "s": [2, 31, 2],
    "l": 1,
    "c": "#4a4a4a",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-505, -26, -405],
    "s": [19, 1, 50],
    "c": "#646464",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-495, -26, -405],
    "s": [1, 2, 50],
    "c": "#e84d4d",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-515, -26, -405],
    "s": [1, 2, 50],
    "c": "#e84d4d",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-505, -26, -430],
    "s": [21, 2, 1],
    "c": "#e84d4d",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-505, -26, -380],
    "s": [21, 2, 1],
    "c": "#e84d4d",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-505, -25, -429],
    "s": [1, 48, 1],
    "c": "#505050",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-505, -25, -381],
    "s": [1, 48, 1],
    "c": "#505050",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-505, -24, -430],
    "s": [4, 2, 1],
    "c": "#e84d4d",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-505, -24, -380],
    "s": [4, 2, 1],
    "c": "#e84d4d",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-487, -4, -381],
    "s": [2, 26, 2],
    "c": "#666666",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-496, 22, -381],
    "s": [22, 2, 2],
    "c": "#666666",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-487, -4, -429],
    "s": [2, 26, 2],
    "c": "#666666",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-496, 22, -429],
    "s": [22, 2, 2],
    "c": "#666666",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-487, -4, -381],
    "s": [4, 1, 4],
    "c": "#666666",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-487, -4, -429],
    "s": [4, 1, 4],
    "c": "#666666",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-311, 5, -302],
    "s": [1, 8, 6],
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-304, 7, -302],
    "s": [10, 123, 4],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-307, 32, -302],
    "s": [5, 1, 5],
    "c": "#ffffff",
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [-310, 8, -498],
    "s": [10, 11, 15],
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-310, 5, -498],
    "s": [9, 11, 14],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-317, 8, -498],
    "s": [36, 4, 4],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-324, 6, -498],
    "s": [1, 7, 6],
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-381, 18, -454],
    "s": [4, 7, 4],
    "i": 16,
    "l": 1
  }, {
    "p": [-361, 7, -557],
    "s": [4, 7, 4],
    "i": 16,
    "l": 1
  }, {
    "p": [-365, -8, -429],
    "s": [40, 14, 34],
    "i": 9,
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-440, -7, -370],
    "s": [10, 11, 20],
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-440, -10, -370],
    "s": [9, 11, 19],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-440, -7, -328],
    "s": [10, 11, 20],
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-440, -10, -328],
    "s": [9, 11, 19],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-440, -7, -351],
    "s": [5, 4, 43],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-440, -10, -349],
    "s": [6, 8, 1],
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-275, -27, -327],
    "s": [60, 19, 40],
    "i": 9,
    "t": 5,
    "d": 2,
    "ts": 0,
    "td": 0
  }, {
    "p": [-275, -7, -536],
    "s": [60, 13, 38],
    "i": 9,
    "t": 5,
    "d": 2,
    "ts": 0,
    "td": 0
  }, {
    "p": [-467, -27, -337],
    "s": [36, 19, 100],
    "i": 9,
    "t": 5,
    "d": 3,
    "ts": 0,
    "td": 0
  }, {
    "p": [-120, -14, -29],
    "s": [2, 18, 4],
    "i": 3,
    "c": "#ab1212",
    "t": 5
  }, {
    "p": [-169, 25, -469],
    "s": [65, 14, 49],
    "i": 12,
    "l": 1
  }, {
    "p": [-83, 29, -301],
    "s": [218, 21, 64],
    "i": 12,
    "l": 1
  }, {
    "p": [-429, 6, -469],
    "s": [30, 30, 34],
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-429, 36, -468],
    "s": [32, 2, 36],
    "c": "#4a4a4a",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-414, 6, -469],
    "s": [1, 19, 23],
    "c": "#8c8c8c",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-414, 27, -470],
    "s": [1, 1, 1],
    "c": "#ffffff",
    "e": "#ff0000",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-414, 27, -468],
    "s": [1, 1, 3],
    "c": "#8c8c8c",
    "e": "#ffffff",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-414, 6, -457],
    "s": [2, 19, 1],
    "c": "#bbbbbb",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-414, 6, -481],
    "s": [2, 19, 1],
    "c": "#bbbbbb",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-414, 25, -469],
    "s": [2, 1, 25],
    "c": "#bbbbbb",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-414, 6, -469],
    "s": [2, 19, 1],
    "c": "#bbbbbb",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-375, -6, -404],
    "s": [22, 11, 8],
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-375, -9, -404],
    "s": [21, 11, 6],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-339, -6, -404],
    "s": [22, 11, 8],
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-339, -9, -404],
    "s": [21, 11, 6],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-359, -6, -405],
    "s": [21, 4, 4],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-357, -9, -405],
    "s": [1, 8, 6],
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-365, -38, -448],
    "s": [40, 46, 4],
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-365, 8, -448],
    "s": [40, 1, 4],
    "c": "#4a4a4a",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-415, 6, -451],
    "s": [60, 1, 4],
    "l": 1,
    "c": "#4a4a4a",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-429, 6, -487],
    "s": [32, 1, 4],
    "l": 1,
    "c": "#4a4a4a",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-396, 23, -542],
    "s": [25, 21, 25],
    "c": "#acacac",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-396, 44, -542],
    "s": [28, 1, 28],
    "c": "#666666",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-396, 22, -542],
    "s": [28, 1, 28],
    "c": "#666666",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-385, 7, -531],
    "s": [2, 15, 2],
    "c": "#666666",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-385, 5, -531],
    "s": [3, 2, 3],
    "c": "#666666",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-385, 7, -553],
    "s": [2, 15, 2],
    "c": "#666666",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-385, 5, -553],
    "s": [3, 2, 3],
    "c": "#666666",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-407, 7, -531],
    "s": [2, 15, 2],
    "c": "#666666",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-407, 5, -531],
    "s": [3, 2, 3],
    "c": "#666666",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-407, 7, -553],
    "s": [2, 15, 2],
    "c": "#666666",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-407, 5, -553],
    "s": [3, 2, 3],
    "c": "#666666",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-385, 8, -542],
    "s": [1, 1, 22],
    "c": "#666666",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-407, 8, -542],
    "s": [1, 1, 22],
    "c": "#666666",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-396, 8, -531],
    "s": [20, 1, 1],
    "c": "#666666",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-396, 8, -553],
    "s": [20, 1, 1],
    "c": "#666666",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-387, 45, -533],
    "s": [5, 3, 5],
    "c": "#666666",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-444, 6, -469],
    "s": [2, 1, 32],
    "l": 1,
    "c": "#4a4a4a",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-379, 6, -456],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-367, 6, -456],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-385, -7, -302],
    "s": [22, 11, 8],
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-385, -9, -302],
    "s": [21, 11, 6],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-344, 7, -302],
    "s": [22, 11, 8],
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-344, 3, -302],
    "s": [21, 11, 6],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-365, -5, -302],
    "s": [20, 5, 4],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-364, -9, -302],
    "s": [1, 10, 6],
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-330, -38, -296],
    "s": [50, 44, 22],
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-321, 7, -302],
    "s": [24, 5, 4],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-357, 0, -302],
    "s": [5, 12, 4],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-330, 6, -306],
    "s": [50, 1, 4],
    "l": 1,
    "c": "#4a4a4a",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-354, 6, -297],
    "s": [4, 1, 22],
    "l": 1,
    "c": "#4a4a4a",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-372, -8, -360],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-372, -8, -348],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-372, -11, -354],
    "s": [2, 16, 25],
    "l": 1,
    "c": "#282828",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-372, -8, -354],
    "s": [13, 13, 2],
    "l": 1,
    "c": "#282828",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-372, -8, -354],
    "s": [12, 12, 24],
    "l": 1,
    "c": "#ffffff",
    "t": 12,
    "ts": 0,
    "td": 0
  }, {
    "p": [-372, -3, -351],
    "s": [14, 3, 2],
    "l": 1,
    "c": "#8e8e8e",
    "t": 11,
    "ts": 0,
    "td": 0
  }, {
    "p": [-372, -3, -349],
    "s": [14, 3, 2],
    "l": 1,
    "c": "#d2cfcf",
    "t": 11,
    "ts": 0,
    "td": 0
  }, {
    "p": [-372, -2, -350],
    "s": [15, 1, 1],
    "l": 1,
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-38, -7, -459],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-38, -7, -447],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-38, -10, -453],
    "s": [2, 16, 25],
    "l": 1,
    "c": "#282828",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-38, -7, -453],
    "s": [13, 13, 2],
    "l": 1,
    "c": "#282828",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-38, -7, -453],
    "s": [12, 12, 24],
    "l": 1,
    "c": "#ffffff",
    "t": 12,
    "ts": 0,
    "td": 0
  }, {
    "p": [-38, -2, -450],
    "s": [14, 3, 2],
    "l": 1,
    "c": "#8e8e8e",
    "t": 11,
    "ts": 0,
    "td": 0
  }, {
    "p": [-38, -2, -448],
    "s": [14, 3, 2],
    "l": 1,
    "c": "#d2cfcf",
    "t": 11,
    "ts": 0,
    "td": 0
  }, {
    "p": [-38, -1, -449],
    "s": [15, 1, 1],
    "l": 1,
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-127, 15, -7],
    "s": [4, 7, 4],
    "i": 16,
    "l": 1
  }, {
    "p": [-356, -8, -292],
    "s": [2, 14, 4],
    "i": 3,
    "c": "#ab1212",
    "t": 5,
    "d": 2
  }, {
    "p": [-139, 5, -438],
    "s": [14, 54, 3],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0,
    "bo": 1
  }, {
    "p": [-340, 8, -498],
    "s": [10, 11, 15],
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-340, 5, -498],
    "s": [9, 11, 14],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-170, 21, -468],
    "s": [21, 1, 2],
    "c": "#878383",
    "t": 5,
    "ts": 0,
    "td": 0
  }, {
    "p": [-170, 20, -468],
    "s": [20, 3, 1],
    "c": "#ffffff",
    "e": "#f5e14c",
    "t": 5,
    "ts": 0,
    "td": 0
  }]
}];
for (var i = 0; i < maps.length; ++i) {
  for (var x = 0; x < maps[i].objects.length; ++x) {
    maps[i].objects[x].i = config.prefabIDS[maps[i].objects[x].i || maps[i].objects[x].id || 0];
    maps[i].objects[x].t = config.textureIDS[maps[i].objects[x].t || (maps[i].objects[x].i == "LADDER" ? 2 : 0)];
  }
}
module.exports.maps = maps;

// MAP MANAGER:
module.exports.manager = function (RENDER, PARTICLES, UTILS, config) {
  // INIT:
  this.manager = new (require(/*! ./objects.js */"./objects.js").manager)(RENDER, UTILS, config);
  this.maps = maps;
  this.modes = modes;
  this.rotationModes = rotationModes;
  this.spawns = [];
  this.lastGen = null;
  this.terrain = null;
  this.zone = null;
  this.deathY = config.deathY;
  var tmpObj;
  var tmpObj2; // SET MAPS:
  this.setMaps = function (mps) {
    this.maps = mps || maps;
  };

  // GET RANDOM MAP:
  this.getRandomMap = function () {
    return UTILS.randInt(0, this.maps.length - 1);
  };

  // GENERATE:
  var lastMod = "";
  this.generate = function (index, mode, force) {
    var tmpMap = this.maps[index];

    // CONFIG CHANGES
    if (tmpMap.dthY && UTILS.isNumber(tmpMap.dthY)) {
      this.deathY = tmpMap.dthY;
    }

    // UPDATE UI:
    if (RENDER) {
      try {
        mapInfo.innerHTML = mode.alias + "_" + tmpMap.name;
        gameMessage.innerHTML = specGameMessage.innerHTML = "";
        curGameInfo.innerHTML = mode.name + "<div style='color:rgba(255,255,255,0.6)'>on " + tmpMap.name + "</div>" + (tmpMap.creator ? "<div style='color:#fff'>" + "<span style='color:rgba(255,255,255,0.6)'>by</span> " + tmpMap.creator + "</div>" : "");
        specGameInfo.innerHTML = mode.name;
      } catch (e) {}
    }

    // LOAD MOD:
    if (RENDER && lastMod != tmpMap.modURL) {
      lastMod = tmpMap.modURL;
      if (lastMod && lastMod != "") {
        loadModPack(lastMod, true);
      }
    }

    // INIT & RESET:
    var tmpIndx = index;
    if (force || this.lastGen !== tmpIndx) {
      this.lastGen = tmpIndx;
      this.manager.removeAll();
      if (RENDER) {
        RENDER.init(tmpMap);
      }
      if (PARTICLES) {
        PARTICLES.reset();
        RENDER.scene.add(PARTICLES.ExplosionManager);
      }
      ;

      // TERRAIN:
      if (tmpMap.terrainSeed && tmpMap.terrainWidth && tmpMap.terrainHeight) {
        this.terrain = Terrain.fromConfig(tmpMap);
        this.terrain.rotation.x = -Math.PI / 2;
        if (RENDER) {
          RENDER.scene.add(this.terrain);
        }
      } else {
        this.terrain = null;
      }

      // ZONE:
      if (tmpMap.zone && tmpMap.zoneSize && tmpMap.zoneSpeed) {
        this.zone = Zone.fromConfig(tmpMap, RENDER);
        if (RENDER) {
          RENDER.scene.add(this.zone);
        }
      } else {
        this.zone = null;
      }

      // MAP SIZE:
      var lowX = 0;
      var highX = 0;
      var lowZ = 0;
      var highZ = 0;

      // OBJECTS:
      for (var i = 0; i < tmpMap.objects.length; ++i) {
        tmpObj = tmpMap.objects[i];
        var tX = tmpObj.p[0];
        var tY = tmpObj.p[1];
        var tZ = tmpObj.p[2];
        if (!(tmpObj.l || tmpObj.col) && tmpObj.i == "CUBE") {
          if (tX - tmpObj.s[0] < lowX) {
            lowX = tX - tmpObj.s[0];
          }
          if (tX + tmpObj.s[0] > highX) {
            highX = tX + tmpObj.s[0];
          }
          if (tZ - tmpObj.s[2] < lowZ) {
            lowZ = tZ - tmpObj.s[2];
          }
          if (tZ + tmpObj.s[2] > highZ) {
            highZ = tZ + tmpObj.s[2];
          }
        }
        if (tmpObj.i == "CUBE") {
          var hasBase = 1;
          var amb = 0;
          for (var x = 0; x < tmpMap.objects.length; ++x) {
            tmpObj2 = tmpMap.objects[x];
            if (tmpObj2.i == "CUBE" && tmpObj != tmpObj2 && tY <= tmpObj2.p[1] + tmpObj2.s[1] && tY >= tmpObj2.p[1] && tX + tmpObj.s[0] / 2 < tmpObj2.p[0] + tmpObj2.s[0] / 2 && tX - tmpObj.s[0] / 2 > tmpObj2.p[0] - tmpObj2.s[0] / 2 && tZ + tmpObj.s[2] / 2 < tmpObj2.p[2] + tmpObj2.s[2] / 2 && tZ - tmpObj.s[2] / 2 > tmpObj2.p[2] - tmpObj2.s[2] / 2) {
              hasBase = 0;
              break;
            }
          }
          this.manager.addBlock(tX, tY, tZ, tmpObj.s[0], tmpObj.s[2], tmpObj.s[1], [1, 1, 1, hasBase, 1, 1], {
            src: tmpObj.t.toLowerCase() + "_" + (tmpObj.t == "GRASS" ? 1 : 0),
            colr: tmpObj.c,
            emissive: tmpObj.e || 0,
            opacity: tmpObj.o != 1 && tmpObj.o != undefined ? tmpObj.o : 1,
            transparent: tmpObj.o != 1 && tmpObj.o != undefined ? true : false,
            penetrable: tmpObj.pe,
            health: tmpObj.h || tmpObj.hp,
            amb: tmpMap.nAmb ? null : config.ambientVal,
            yR: tmpObj.r ? tmpObj.r[0] : 0,
            xR: tmpObj.r ? tmpObj.r[1] : 0,
            zR: tmpObj.r ? tmpObj.r[2] : 0,
            noCol: tmpObj.l || tmpObj.col,
            isBorder: tmpObj.bo,
            noVis: tmpObj.v,
            movT: tmpObj.ts != undefined ? tmpObj.ts / 10000 : tmpObj.ts,
            movD: tmpObj.td
          });
        } else {
          if (tmpObj.i == "OBJECTIVE") {
            this.manager.addObjective(tX, tY, tZ, tmpObj.s[0], tmpObj.s[2], tmpObj.s[1]);
          } else {
            if (tmpObj.i == "FLAG") {
              this.manager.addFlag(tX, tY, tZ, parseInt(tmpObj.tm || 0) + 1);
            } else {
              if (tmpObj.i == "WEAPON_PICKUP") {
                this.manager.addWeapon(tX, tY, tZ, tmpObj.r ? tmpObj.r[2] : 0, tmpObj.r ? tmpObj.r[0] : 0, tmpObj.r ? tmpObj.r[1] : 0, parseInt(tmpObj.w || tmpObj.wid || 0), WEAPONS[parseInt(tmpObj.w || tmpObj.wid || 0)], tmpObj.wr);
              } else {
                if (tmpObj.i == "PARTICLES") {
                  if (PARTICLES) {
                    var tmpPr = PARTICLES.prefabs[parseInt(tmpObj.pr || 0)];
                    tmpPr.count = Math.round((tmpObj.s[0] + tmpObj.s[2] + tmpObj.s[1]) / tmpPr.cnt);
                    PARTICLES.area(tX, tY, tZ, tmpObj.s[0], tmpObj.s[1], tmpObj.s[2], tmpPr);
                  }
                } else {
                  if (tmpObj.i == "PLANE" || tmpObj.i == "BILLBOARD") {
                    this.manager.addPlane(tX, tY, tZ, tmpObj.s[2] / 2, tmpObj.s[0] / 2, {
                      src: tmpObj.i == "BILLBOARD" ? "pubs/b_" + (tmpObj.bb || UTILS.randInt(1, config.billboardCnt)) : tmpObj.t.toLowerCase() + "_0",
                      emissive: tmpObj.e || 0,
                      noise: tmpObj.en || 0,
                      opacity: tmpObj.o != 1 && tmpObj.o != undefined ? tmpObj.o : 1,
                      penetrable: tmpObj.pe,
                      health: tmpObj.h || tmpObj.hp,
                      colr: tmpObj.c,
                      col: !(tmpObj.l || tmpObj.col),
                      noVis: tmpObj.v,
                      side: tmpObj.i == "BILLBOARD" ? 2 : 0,
                      movT: tmpObj.ts != undefined ? tmpObj.ts / 10000 : tmpObj.ts,
                      movD: tmpObj.td
                    }, tmpObj.r ? tmpObj.r[2] : 0, (tmpObj.r ? tmpObj.r[0] : 0) - Math.PI / 2, tmpObj.r ? tmpObj.r[1] : 0);
                  } else {
                    if (tmpObj.i == "RAMP") {
                      this.manager.addRamp(tX, tY, tZ, tmpObj.s[0], tmpObj.s[1], tmpObj.s[2], (tmpObj.d || 0) * Math.PI / 2, tmpObj.b, tmpObj.t ? tmpObj.t.toLowerCase() + "_0" : "grey_0", tmpObj.v, tmpObj.c, config.ambScale, tmpObj.ts != undefined ? tmpObj.ts / 10000 : tmpObj.ts, tmpObj.td);
                    } else {
                      if (tmpObj.i == "SCORE_ZONE") {
                        this.manager.addScoreZone(tX, tY, tZ, tmpObj.s[0], tmpObj.s[2], tmpObj.s[1], tmpObj.sp || 1);
                      } else {
                        if (tmpObj.i == "DEATH_ZONE") {
                          this.manager.addDeathZone(tX, tY, tZ, tmpObj.s[0], tmpObj.s[2], tmpObj.s[1]);
                        } else {
                          if (tmpObj.i == "CHECK_POINT") {
                            this.manager.addCheckPoint(tX, tY, tZ, tmpObj.s[0], tmpObj.s[2], tmpObj.s[1], tmpObj.su || false, tmpObj.d || 0);
                          } else {
                            if (tmpObj.i == "TELEPORTER") {
                              this.manager.addTeleporter(tX, tY, tZ, tmpObj.s[0], tmpObj.s[2], tmpObj.s[1], parseInt(tmpObj.ch || 0), parseInt(tmpObj.n || 0), tmpObj.m != undefined ? true : false);
                            } else {
                              if (tmpObj.i == "LADDER") {
                                this.manager.addLadder(tX, tY, tZ, tmpObj.s[1], (tmpObj.d || 0) * Math.PI / 2, tmpObj.v, tmpObj.t ? tmpObj.t.toLowerCase() + "_0" : "floor_0", tmpObj.c);
                              } else {
                                this.manager.addMesh(tX, tY, tZ, tmpObj.r, tmpObj.s[0] / 2, tmpObj.s[1] / 2, tmpObj.s[2] / 2, tmpObj.i.toLowerCase(), tmpObj.l || tmpObj.col, tmpObj.c);
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }

      // ADD NOISE PLANES:
      this.manager.addNoisePlanes();

      // SHADOW SCALE:
      tmpMap.shadLength = Math.round(Math.abs(highX - lowX) / 2.5);
      tmpMap.shadWidth = Math.round(Math.abs(highZ - lowZ) / 2.5);
      if (RENDER) {
        RENDER.updateLightMap(tmpMap);
      }

      // BAKE AMBIENT OCCLUSION:
      this.manager.aoOpac = 1;
      if (RENDER) {
        var colData;
        var ambOcScale = config.ambScale;
        for (var i = 0; i < this.manager.objects.length; ++i) {
          tmpObj = this.manager.objects[i];
          if (!tmpObj.noVis && !tmpObj.complexMesh && !tmpObj.health) {
            for (var x = i + 1; x < this.manager.objects.length; ++x) {
              tmpObj2 = this.manager.objects[x];
              if (!tmpObj2.noVis && !tmpObj2.health && !tmpObj2.complexMesh && this.manager.collision(tmpObj, tmpObj2, 0)) {
                colData = UTILS.boxIntersection(tmpObj, tmpObj2, "x", "z", [Math.PI, 0, Math.PI / 2, -Math.PI / 2]);
                if (colData) {
                  for (var c = 0; c < colData.length; ++c) {
                    if (colData[c].dontUse) {
                      continue;
                    }
                    var cInts = UTILS.getIntersection(tmpObj, tmpObj2, "y");
                    var tmpL = ambOcScale * (tmpObj.aoMlt || 1) * (tmpObj2.aoMlt || 1);
                    for (var s = 0; s < 2; s++) {
                      var tmpD = (colData[c].d + Math.PI / 2 * s) % (Math.PI * 2);
                      tmpL = Math.min(tmpL, this.manager.limitAmb(ambOcScale, colData[c], tmpD, "x", "z", tmpObj, tmpObj2));
                    }
                    for (var s = 0; s < 2; s++) {
                      var tmpD = (colData[c].d + Math.PI / 2 * s) % (Math.PI * 2);
                      this.manager.addAmbient(colData[c].x + tmpL * Math.cos(tmpD), cInts.y, colData[c].z + tmpL * Math.sin(tmpD), -tmpD + Math.PI, 0, 0, cInts.height, tmpL + config.ambOff, 1);
                      if (tmpD == Math.PI / 2 || tmpD == -Math.PI / 2 || tmpD == Math.PI * 1.5) {
                        var tmpDat = UTILS.limitRect(colData[c].z + tmpL * Math.sin(tmpD), cInts.y + tmpL + cInts.height + config.ambOff, tmpL, tmpL, 0, [tmpObj, tmpObj2], "z", "y");
                        this.manager.addAmbient(colData[c].x + tmpL * Math.cos(tmpD), tmpDat.y, tmpDat.z, -tmpD + Math.PI, Math.PI, 0, tmpDat.length, tmpDat.height, 0, [tmpObj, tmpObj2], "g1-" + s + "-" + c, [colData[c].x, cInts.y + cInts.height, colData[c].z]);
                        tmpDat = UTILS.limitRect(colData[c].z + tmpL * Math.sin(tmpD), cInts.y - tmpL - cInts.height - config.ambOff, tmpL, tmpL, 0, [tmpObj, tmpObj2], "z", "y");
                        this.manager.addAmbient(colData[c].x + tmpL * Math.cos(tmpD), tmpDat.y, tmpDat.z, -tmpD + Math.PI, 0, 0, tmpDat.length, tmpDat.height, 0, [tmpObj, tmpObj2], "g2-" + s + "-" + c, [colData[c].x, cInts.y - cInts.height, colData[c].z]);
                      } else {
                        var tmpDat = UTILS.limitRect(colData[c].x + tmpL * Math.cos(tmpD), cInts.y + tmpL + cInts.height + config.ambOff, tmpL, tmpL, 0, [tmpObj, tmpObj2], "x", "y");
                        this.manager.addAmbient(tmpDat.x, tmpDat.y, colData[c].z + tmpL * Math.sin(tmpD), -tmpD + Math.PI, Math.PI, 0, tmpDat.width, tmpDat.height, 0, [tmpObj, tmpObj2], "g1-" + s + "-" + c, [colData[c].x, cInts.y + cInts.height, colData[c].z]);
                        tmpDat = UTILS.limitRect(colData[c].x + tmpL * Math.cos(tmpD), cInts.y - tmpL - cInts.height - config.ambOff, tmpL, tmpL, 0, [tmpObj, tmpObj2], "x", "y");
                        this.manager.addAmbient(tmpDat.x, tmpDat.y, colData[c].z + tmpL * Math.sin(tmpD), -tmpD + Math.PI, 0, 0, tmpDat.width, tmpDat.height, 0, [tmpObj, tmpObj2], "g2-" + s + "-" + c, [colData[c].x, cInts.y - cInts.height, colData[c].z]);
                      }
                    }
                  }
                }
                colData = UTILS.boxIntersection(tmpObj, tmpObj2, "z", "y", [Math.PI, 0, -Math.PI / 2, Math.PI / 2]);
                if (colData) {
                  for (var c = 0; c < colData.length; ++c) {
                    if (colData[c].dontUse) {
                      continue;
                    }
                    var cInts = UTILS.getIntersection(tmpObj, tmpObj2, "x");
                    var tmpL = ambOcScale * (tmpObj.aoMlt || 1) * (tmpObj2.aoMlt || 1);
                    for (var s = 0; s < 2; s++) {
                      var tmpD = colData[c].d + Math.PI / 2 * (s ? 0 : 1);
                      tmpL = Math.min(tmpL, this.manager.limitAmb(ambOcScale, colData[c], -tmpD + Math.PI / 2, "z", "y", tmpObj, tmpObj2));
                    }
                    for (var s = 0; s < 2; s++) {
                      var tmpD = colData[c].d + Math.PI / 2 * (s ? 0 : 1);
                      this.manager.addAmbient(cInts.x, colData[c].y + tmpL * Math.cos(tmpD), colData[c].z + tmpL * Math.sin(tmpD), 0, tmpD, -Math.PI / 2, cInts.width, tmpL + config.ambOff, 1);
                      var tmpDat = UTILS.limitRect(cInts.x + cInts.width + tmpL + config.ambOff, colData[c].z + tmpL * Math.sin(tmpD), tmpL, tmpL, 0, [tmpObj, tmpObj2], "x", "z");
                      this.manager.addAmbient(tmpDat.x, colData[c].y + tmpL * Math.cos(tmpD), colData[c].z + tmpL * Math.sin(tmpD), Math.PI, tmpD == Math.PI ? tmpD : -tmpD % Math.PI, tmpD == Math.PI * 1.5 ? 0 : -Math.PI / 2, tmpD == Math.PI * 1.5 ? tmpL : tmpDat.length, tmpD == Math.PI * 1.5 ? tmpDat.length : tmpL, 0, [tmpObj, tmpObj2], "g3-" + s + "-" + c, [cInts.x + cInts.width, colData[c].y, colData[c].z]);
                      tmpDat = UTILS.limitRect(cInts.x - cInts.width - tmpL - config.ambOff, colData[c].z + tmpL * Math.sin(tmpD), tmpL, tmpL, Math.PI / 2, [tmpObj, tmpObj2], "x", "z");
                      this.manager.addAmbient(tmpDat.x, colData[c].y + tmpL * Math.cos(tmpD), colData[c].z + tmpL * Math.sin(tmpD), Math.PI, -tmpD % Math.PI, tmpD == Math.PI || tmpD == Math.PI * 1.5 ? Math.PI / 2 : Math.PI, tmpD == Math.PI || tmpD == Math.PI * 1.5 ? tmpDat.width : tmpL, tmpD == Math.PI || tmpD == Math.PI * 1.5 ? tmpL : tmpDat.width, 0, [tmpObj, tmpObj2], "g4-" + s + "-" + c, [cInts.x - cInts.width, colData[c].y, colData[c].z]);
                    }
                  }
                }
                colData = UTILS.boxIntersection(tmpObj, tmpObj2, "x", "y", [Math.PI, 0, -Math.PI / 2, Math.PI / 2]);
                if (colData) {
                  for (var c = 0; c < colData.length; ++c) {
                    if (colData[c].dontUse) {
                      continue;
                    }
                    var cInts = UTILS.getIntersection(tmpObj, tmpObj2, "z");
                    var tmpL = ambOcScale * (tmpObj.aoMlt || 1) * (tmpObj2.aoMlt || 1);
                    for (var s = 0; s < 2; s++) {
                      var tmpD = colData[c].d + Math.PI / 2 * (s ? 0 : 1);
                      tmpL = Math.min(tmpL, this.manager.limitAmb(ambOcScale, colData[c], -tmpD + Math.PI / 2, "x", "y", tmpObj, tmpObj2));
                    }
                    for (var s = 0; s < 2; s++) {
                      var tmpD = colData[c].d + Math.PI / 2 * (s ? 0 : 1);
                      this.manager.addAmbient(colData[c].x + tmpL * Math.sin(tmpD), colData[c].y + tmpL * Math.cos(tmpD), cInts.z, Math.PI / 2, tmpD, -Math.PI / 2, cInts.length, tmpL + config.ambOff, 1);
                      if (tmpD == Math.PI || tmpD == 0) {
                        var tmpDat = UTILS.limitRect(colData[c].z + tmpL * Math.sin(tmpD), cInts.z + cInts.length + tmpL + config.ambOff, tmpL, tmpL, Math.PI / 2, [tmpObj, tmpObj2], "x", "z");
                        this.manager.addAmbient(colData[c].x + tmpL * Math.sin(tmpD), colData[c].y + tmpL * Math.cos(tmpD), tmpDat.z, Math.PI / 2, tmpD, -Math.PI / 2, tmpDat.length, tmpDat.width, 0, [tmpObj, tmpObj2], "g5-" + s + "-" + c, [colData[c].x, colData[c].y, cInts.z + cInts.length]);
                        tmpDat = UTILS.limitRect(colData[c].z + tmpL * Math.sin(tmpD), cInts.z - cInts.length - tmpL - config.ambOff, tmpL, tmpL, Math.PI / 2, [tmpObj, tmpObj2], "x", "z");
                        this.manager.addAmbient(colData[c].x + tmpL * Math.sin(tmpD), colData[c].y + tmpL * Math.cos(tmpD), tmpDat.z, Math.PI / 2, tmpD, Math.PI, tmpDat.width, tmpDat.length, 0, [tmpObj, tmpObj2], "g6-" + s + "-" + c, [colData[c].x, colData[c].y, cInts.z - cInts.length]);
                      } else {
                        var tmpDat = UTILS.limitRect(colData[c].x + tmpL * Math.sin(tmpD), cInts.z + cInts.length + tmpL + config.ambOff, tmpL, tmpL, Math.PI / 2, [tmpObj, tmpObj2], "x", "z");
                        this.manager.addAmbient(tmpDat.x, colData[c].y + tmpL * Math.cos(tmpD), tmpDat.z, Math.PI / 2, tmpD, -Math.PI / 2, tmpDat.length, tmpDat.width, 0, [tmpObj, tmpObj2], "g5-" + s + "-" + c, [colData[c].x, colData[c].y, cInts.z + cInts.length]);
                        tmpDat = UTILS.limitRect(colData[c].x + tmpL * Math.sin(tmpD), cInts.z - cInts.length - tmpL - config.ambOff, tmpL, tmpL, Math.PI / 2, [tmpObj, tmpObj2], "x", "z");
                        this.manager.addAmbient(tmpDat.x, colData[c].y + tmpL * Math.cos(tmpD), tmpDat.z, Math.PI / 2, tmpD, Math.PI, tmpDat.width, tmpDat.length, 0, [tmpObj, tmpObj2], "g6-" + s + "-" + c, [colData[c].x, colData[c].y, cInts.z - cInts.length]);
                      }
                    }
                  }
                }
              }
            }
          }
        }
        this.manager.addPendingAOs();
      }

      // SPAWNS:
      this.spawns.length = 0;
      for (var i = 0; i < tmpMap.spawns.length; ++i) {
        this.spawns.push({
          x: tmpMap.spawns[i][0],
          y: tmpMap.spawns[i][1],
          z: tmpMap.spawns[i][2],
          team: tmpMap.spawns[i][3],
          dir: parseInt(tmpMap.spawns[i][4]) || 0
        });
      }

      // ADD ALL THE GROUPED MESHES:
      if (RENDER) {
        RENDER.addMeshGroups();
      }
    }
    this.manager.resetAll();
  };
};